export default {
  'studio.business_bank_setting.title1': '個人／事業者情報',
  'studio.business_bank_setting.guide1': 'ゲームのレーティング<br/>審査時に必要です！',
  'studio.business_bank_setting.guide1_1': '下記の資料を必ず準備してください。',
  'studio.business_bank_setting.guide1_2': '個人(事業者登録のない)：住民登録謄本またはパスポート',
  'studio.business_bank_setting.guide1_4': '事業者(個人／法人)：事業者登録証',
  'studio.business_bank_setting.title2': '銀行情報',
  'studio.business_bank_setting.guide2': '入力した口座情報に<br/>商品の販売代金が精算されます！',
  'studio.business_bank_setting.bank_component_guide2_1': '通帳のコピーを準備して関連情報を作成してください。',
  'studio.business_bank_setting.group_settings': 'グループ設定',
  'studio.business_bank_setting.group_history': '管理履歴',
  'studio.business_bank_setting.group_discontinue': 'グループ削除',
  'studio.business_bank_setting.guide2_1': 'なぜ個人／事業者情報が必要なのでしょうか？ ',
  'studio.business_bank_setting.guide2_2':
    'ゲームのリリース前にレーティングの審査を受けるには、個人／事業者情報を受け取る必要があります。<br/>審査には最大で3営業日を所要するため、前もって申請しておくことをお勧めします。',
  'studio.business_bank_setting.guide2_3': '証票資料はどこに使用されるのでしょうか？',
  'studio.business_bank_setting.guide2_4': '入力した情報が実際に書類と一致するか確認するために使用されます。',
  'studio.business_bank_setting.guide2_5': 'ゲーム制作(配給)業の届出番号とは何でしょうか？',
  'studio.business_bank_setting.guide2_6':
    '大韓民国で消費者に対してオンラインで商品を販売するためには、通信販売業の届出を行わなければなりません！<br/>こちらは選択事項のため、該当しなければ入力しなくても構いません！',
  'studio.business_bank_setting.guide2_7': '通信販売業の届出番号とは何でしょうか？',
  'studio.business_bank_setting.guide2_8':
    '大韓民国で消費者に対してオンラインで商品を販売するためには、通信販売業の届出を行わなければなりません！<br/>こちらは選択事項のため、該当しなければ入力しなくても構いません！',
  'studio.business_bank_setting.guide2_9': '事業者登録番号／TAX ID',
  'studio.business_bank_setting.guide2_10':
    '当社の事業者登録番号あるいはTAX IDを入力できます。<br/>事業者登録番号とTAX IDのうち一つは必ず入力しなければなりません。',
  'studio.business_bank_setting.guide2_11': '大韓民国ゲーム制作(配給)業の届出番号とは何でしょうか？',
  'studio.business_bank_setting.guide2_12':
    '大韓民国で消費者に対してオンラインで商品を販売するためには、通信販売業の届出を行わなければなりません！<br/>こちらは選択事項のため、該当しなければ入力しなくても構いません！',
  'studio.business_bank_setting.guide2_13': '大韓民国通信販売業の届出番号とは何でしょうか？',
  'studio.business_bank_setting.guide2_14':
    '大韓民国で消費者に対してオンラインで商品を販売するためには、通信販売業の届出を行わなければなりません！<br/>こちらは選択事項のため、該当しなければ入力しなくても構いません！',
  'studio.business_bank_setting.guide2_15': '大韓民国事業者登録証の番号とは何でしょうか？',
  'studio.business_bank_setting.guide2_16':
    '大韓民国で消費者に対してオンラインで商品を販売するためには、通信販売業の届出を行わなければなりません！<br/>こちらは選択事項のため、該当しなければ入力しなくても構いません！',
  'studio.business_bank_setting.guide2_17': '表示例',
  'studio.business_bank_setting.in_review_guide1': '審査中です',
  'studio.business_bank_setting.in_review_guide1_1':
    '審査は約3営業日かかり、状況によって変動する場合があります。<br/>審査が完了したらEメール、通知でご案内いたします。 ',
  'studio.business_bank_setting.btn_details': '審査内訳',
  'studio.business_bank_setting.btn_info': '提出内容',
  'studio.business_bank_setting.in_review_guide2': '審査中です',
  'studio.business_bank_setting.in_review_guide2_1':
    '審査は約3営業日かかり、状況によって変動する場合があります。<br/>審査が完了したらEメール、通知でご案内いたします。',
  'studio.business_bank_setting.reject1': '審査がリジェクトされました',
  'studio.business_bank_setting.reject2': '画像が正しく添付されていません。<br/>確認してから再度添付してください。',
  'studio.business_bank_setting.btn_modify': '修正',
  'studio.business_bank_setting.business_info1': '国・地域',
  'studio.business_bank_setting.business_info2': '代表者氏名',
  'studio.business_bank_setting.business_info3': '代表者の生年月日',
  'studio.business_bank_setting.business_info4': '事業者登録番号',
  'studio.business_bank_setting.business_info5': '種類',
  'studio.business_bank_setting.business_info6': '事業者名',
  'studio.business_bank_setting.business_info7': '代表取締役名',
  'studio.business_bank_setting.bank_info1': '国',
  'studio.business_bank_setting.bank_info2': '銀行名 ',
  'studio.business_bank_setting.bank_info3': '口座名義',
  'studio.business_bank_setting.bank_info4': '口座番号',
  'studio.business_bank_setting.bank_info5': 'SWIFT CODE',
  'studio.business_bank_setting.individual.question1': '事業者登録証をお持ちですか？',
  'studio.business_bank_setting.individual.question1_msg1': '必須の値をチェックしてください。',
  'studio.business_bank_setting.individual.select_y': 'はい、持っています。',
  'studio.business_bank_setting.individual.select_n': 'いいえ、ありません。',
  'studio.business_bank_setting.license_yn_select_req_msg': '事業者登録証の保有有無を選択してください。',
  'studio.business_bank_setting.individual.quide1': 'なぜ個人／事業者情報が必要なのでしょうか？ ',
  'studio.business_bank_setting.individual.quide2':
    'ゲームのリリース前にレーティングの審査を受けるには、個人／事業者情報を受け取る必要があります。<br/>審査には最大で3営業日を所要するため、前もって申請しておくことをお勧めします。',
  'studio.business_bank_setting.individual.quide3': '証票資料はどこに使用されるのでしょうか？',
  'studio.business_bank_setting.individual.quide4': '入力した情報が実際に書類と一致するか確認するために使用されます。',
  'studio.business_bank_setting.individual.question2': 'お住いの国・地域を選択してください。',
  'studio.business_bank_setting.individual.question2_checkmsg': '私は現在税金を納めていると同じ国を選択しました',
  'studio.business_bank_setting.individual.input_name': '代表者氏名',
  'studio.business_bank_setting.individual.input_name_place_holder': '代表者の氏名を入力してください',
  'studio.business_bank_setting.individual.input_name_msg1': '代表者の氏名を入力してください。',
  'studio.common.def_key.exceed': '{length}文字を超えることはできません。 ',
  'studio.business_bank_setting.individual.select_gender': '代表者のお名前',
  'studio.business_bank_setting.individual.select_gender_male': '男性',
  'studio.business_bank_setting.individual.select_gender_female': '女性',
  'studio.business_bank_setting.individual.select_birth': '代表者の生年月日',
  'studio.business_bank_setting.individual.select_birth_place_holder': 'YYYY-MM-DD',
  'studio.business_bank_setting.individual.select_birth_msg1': '代表者の生年月日を入力してください。',
  'studio.business_bank_setting.individual.select_mobile_no': '代表者の連絡先',
  'studio.business_bank_setting.individual.select_mobile_no_place_holder': '電話番号を入力してください',
  'studio.business_bank_setting.individual.select_mobile_no_msg1': '電話番号を入力してください。',
  'studio.common.def_key.number_only_y': '数字のみ入力してください。 ',
  'studio.business_bank_setting.individual.select_ceo_email': '代表者のメールアドレス',
  'studio.business_bank_setting.individual.select_ceo_email_place_holder': '代表者のメールアドレスを入力してください',
  'studio.business_bank_setting.individual.select_ceo_email_msg1': '代表者のメールアドレスを入力してください。',
  'studio.business_bank_setting.individual.select_ceo_email_msg2': 'メールアドレスの形式が正しくありません。',
  'studio.business_bank_setting.individual.question3': '納税国・地域を選択してください',
  'studio.business_bank_setting.individual.question3_msg1': '売上が発生する場合、選択した国を基準に税金の処理を行います。',
  'studio.business_bank_setting.individual.info_view_b_adress': '代表者住所',
  'studio.business_bank_setting.individual.info_global_adress_no': '郵便番号',
  'studio.business_bank_setting.individual.info_global_adress_no_place_holder': '郵便番号',
  'studio.business_bank_setting.individual.info_global_adress_no_required_n': '郵便番号を検索してください。',
  'studio.business_bank_setting.individual.info_global_o_adress_place_holder': '住所を入力してください',
  'studio.business_bank_setting.individual.info_global_o_adress_msg1': '住所を入力してください。',
  'studio.business_bank_setting.individual.info_global_o_adress_detail_place_holder': '住所の詳細を入力してください',
  'studio.business_bank_setting.individual.info_global_o_adress_detail_msg1': '住所の詳細を入力してください。',
  'studio.business_bank_setting.individual.upload_resident': '住民登録謄本',
  'studio.business_bank_setting.individual.upload_guide': '{info}以下',
  'studio.business_bank_setting.individual.upload_resident_guide': '住民登録謄本を添付してください',
  'studio.business_bank_setting.individual.btn_attach': 'ファイル検索',
  'studio.business_bank_setting.individual.info_global_street_place_holder': '通りの名前を入力してください',
  'studio.business_bank_setting.individual.info_global_street_required_n': '通りの名前を入力してください。',
  'studio.business_bank_setting.individual.info_global_building_place_holder': '建物名を入力してください',
  'studio.business_bank_setting.individual.info_global_building_required_n': '建物名を入力してください。',
  'studio.business_bank_setting.individual.info_global_city_place_holder': '都市名を入力してください',
  'studio.business_bank_setting.individual.info_global_city_required_n': '都市名を入力してください。',
  'studio.business_bank_setting.individual.info_global_county_place_holder': '道・市・郡を入力してください',
  'studio.business_bank_setting.individual.info_global_county_required_n': '道・市・郡を入力してください。',
  'studio.business_bank_setting.individual.review_officer_info': '審査担当者情報',
  'studio.business_bank_setting.individual.review_officer_info_name': '氏名',
  'studio.business_bank_setting.individual.review_officer_info_name_place_holder': '名前を入力してください',
  'studio.business_bank_setting.individual.review_officer_info_name_msg2': '名前を入力してください。',
  'studio.business_bank_setting.individual.review_officer_info_mobile_no': '連絡先',
  'studio.business_bank_setting.individual.review_officer_info_mobile_no_place_holder': '連絡先を入力してください',
  'studio.business_bank_setting.individual.review_officer_info_mobile_no_msg1': '連絡先を入力してください。',
  'studio.business_bank_setting.individual.review_officer_info_email': 'Eメール',
  'studio.business_bank_setting.individual.review_officer_info_email_place_holder': 'メールアドレスを入力してください',
  'studio.business_bank_setting.individual.review_officer_info_email_msg1': 'メールアドレスの形式が正しくありません。',
  'studio.business_bank_setting.individual.review_officer_info_email_msg2': 'メールアドレスを入力してください。',
  'studio.business_bank_setting.individual.settlement_officer_info': '契約／精算担当者情報',
  'studio.business_bank_setting.individual.settlement_officer_info_guide1':
    '契約および精算と関連する審査情報を確認するグループのメイン担当者の情報を入力してください',
  'studio.business_bank_setting.individual.settlement_officer_info_name': '氏名',
  'studio.business_bank_setting.individual.settlement_officer_info_name_msg2': '名前を入力してください。',
  'studio.business_bank_setting.individual.settlement_officer_info_name_place_holder': '名前を入力してください',
  'studio.business_bank_setting.individual.settlement_officer_info_mobile_no': '連絡先',
  'studio.business_bank_setting.individual.settlement_officer_info_mobile_no_place_holder': '連絡先を入力してください',
  'studio.business_bank_setting.individual.settlement_officer_info_mobile_no_msg1': '連絡先を入力してください。',
  'studio.business_bank_setting.individual.settlement_officer_info_email': 'Eメール',
  'studio.business_bank_setting.individual.settlement_officer_info_email_place_holder': 'メールアドレスを入力してください',
  'studio.business_bank_setting.individual.settlement_officer_info_email_msg1': 'メールアドレスの形式が正しくありません。',
  'studio.business_bank_setting.individual.settlement_officer_info_email_msg2': 'メールアドレスを入力してください。',
  'studio.business_bank_setting.individual.info_view_o_adress': '事業者所在地',
  'studio.business_bank_setting.individual.question4': '事業者登録番号(個人／法人)',
  'studio.business_bank_setting.individual.question4_place_holder': '事業者登録番号を入力してください',
  'studio.business_bank_setting.individual.enter_no_msg1': '事業者登録番号を入力してください。',
  'studio.business_bank_setting.individual.enter_no_msg3': 'エラーが発生しました<br/> しばらくしてから再度お試しください。',
  'studio.business_bank_setting.individual.enter_no_msg4': '照会できない事業者登録番号です。 ',
  'studio.business_bank_setting.individual.info_view_b_name': '事業者名',
  'studio.business_bank_setting.individual.info_view_b_name_place_holder': '事業者名を入力してください',
  'studio.business_bank_setting.individual.info_view_r_name': '代表取締役名',
  'studio.business_bank_setting.individual.info_view_r_name_kr_place_holder': '代表取締役名を入力してください',
  'studio.business_bank_setting.individual.info_view_b_type': '業態',
  'studio.business_bank_setting.individual.info_view_b_type_place_holder': '業態を入力してください',
  'studio.business_bank_setting.individual.info_view_b_items': '種目',
  'studio.business_bank_setting.individual.info_view_b_items_place_holder': '種目を入力してください',
  'studio.business_bank_setting.individual.info_view_adress': '事業者住所',
  'studio.business_bank_setting.individual.info_view_adress_place_holder': '事業者の住所を入力してください',
  'studio.business_bank_setting.individual.question5': '事業者連絡先',
  'studio.business_bank_setting.individual.question5_kr_place_holder': '事業者の連絡先を入力してください',
  'studio.business_bank_setting.individual.select_enter_kr_no_msg1': '事業者の連絡先を入力してください。',
  'studio.business_bank_setting.individual.b_email': '事業者のメールアドレス',
  'studio.business_bank_setting.individual.b_email_place_holder': 'メールアドレスを入力してください',
  'studio.business_bank_setting.individual.b_email_msg1': 'メールアドレスを入力してください。',
  'studio.business_bank_setting.individual.b_email_msg2': 'メールアドレスの形式が正しくありません。',
  'studio.business_bank_setting.individual.upload_buisiness': '事業者登録証',
  'studio.business_bank_setting.individual.upload_buisiness_guide': '事業者登録証を添付してください',
  'studio.business_bank_setting.individual.upload_buisiness_req_msg': '事業者登録証を添付してください。',
  'studio.business_bank_setting.individual.biz_reg_num': '事業者登録番号(個人／法人)',
  'studio.business_bank_setting.individual.biz_reg_num_place_holder': '事業者登録番号を入力してください',
  'studio.business_bank_setting.individual.biz_reg_num_required': '事業者登録番号を入力してください。',
  'studio.business_bank_setting.individual.enter_no_msg5':
    'エラーが発生しました<br/>しばらくしてから再度お試しください。<br/>事業者情報を手動で入力する場合は[手動入力]をクリックしてください。',
  'studio.business_bank_setting.individual.enter_no_msg5_manual': '手動入力',
  'studio.business_bank_setting.individual.enter_no_msg5_close': '後で',
  'studio.business_bank_setting.individual.info_view_no': '事業者登録番号',
  'studio.business_bank_setting.individual.info_view_no_place_holder': '事業者登録番号を入力してください',
  'studio.business_bank_setting.individual.info_view_type': '種類',
  'studio.business_bank_setting.individual.info_view_type1': '個人事業者',
  'studio.business_bank_setting.individual.info_view_type2': '法人事業者',
  'studio.business_bank_setting.individual.manual_info_view_no_required': '事業者登録番号を入力してください。',
  'studio.business_bank_setting.individual.manual_info_view_b_name_required': '事業者名を入力してください。',
  'studio.business_bank_setting.individual.manual_info_view_r_name_kr_required': '代表取締役名を入力してください。',
  'studio.business_bank_setting.individual.manual_info_view_b_type_required': '業態を入力してください。',
  'studio.business_bank_setting.individual.manual_info_view_b_items_required': '種目を入力してください。',
  'studio.business_bank_setting.individual.manual_info_view_adress_required': '事業者の住所を入力してください。',
  'studio.business_bank_setting.individual.question6': 'ゲームの種類選択',
  'studio.business_bank_setting.individual.question6_guide':
    'ゲームの開発と配給の両方を行っている場合は仲介事業者(パブリッシング)を選択してください。',
  'studio.business_bank_setting.individual.question6_select1': 'ゲームデベロッパー',
  'studio.business_bank_setting.individual.question6_select2': '仲介事業者(パブリッシング)',
  'studio.business_bank_setting.individual.question6_select3': '該当事項なし',
  'studio.business_bank_setting.individual.question7': '追加情報選択',
  'studio.business_bank_setting.individual.question7_guide':
    '他にも提出する情報がある場合は、下記の内容を読んで選択してください。ない場合は選択しなくても構いません。',
  'studio.business_bank_setting.individual.question7_select1': 'ゲーム制作(配給)業',
  'studio.business_bank_setting.individual.question7_select2': '通信販売業',
  'studio.business_bank_setting.individual.game_production_no_guide': 'ゲーム制作(配給)業の登録証を添付してください',
  'studio.business_bank_setting.individual.game_production_no_place_holder': 'ゲーム制作(配給)業の届出番号を入力してください',
  'studio.business_bank_setting.individual.game_production_no_msg1': 'ゲーム制作(配給)業の届出番号を入力してください。',
  'studio.business_bank_setting.individual.telecom_sales_no_guide': '通信販売業登録証を添付してください',
  'studio.business_bank_setting.individual.telecom_sales_no_place_holder': '通信販売業の届出番号を入力してください',
  'studio.business_bank_setting.individual.telecom_sales_no_msg1': '通信販売業の届出番号を入力してください。',
  'studio.common.popup_case_save_btn': '保存',
  'studio.business_bank_setting.individual.btn_save_alert1':
    '作成した情報を基準に審査をリクエストします。<br/>最大で1〜3営業日かかる場合があります。<br/><br/>審査が完了したらメール、通知で<br/>お知らせいたします。',
  'studio.common.popup_case_cf_btn': '確認',
  'studio.common.popup_case_cancel_btn': 'キャンセル',
  'studio.business_bank_setting.individual.btn_save_alert2': '審査リクエストが完了しました。 ',
  'studio.business_bank_setting.individual.btn_save_alert3':
    'すでに個人／事業者情報を審査中です。<br/>審査をリクエストした内容を再度ご確認ください。',
  'studio.business_bank_setting.individual.settlement_officer_info_name_msg1': '{length}文字を超えることはできません。 ',
  'studio.business_bank_setting.individual.info_view': '事業者情報',
  'studio.business_bank_setting.individual.info_view_b_name_msg1': '事業者名を入力してください',
  'studio.business_bank_setting.individual.info_view_b_name_msg2': '{length}文字を超えることはできません。 ',
  'studio.business_bank_setting.individual.info_view_r_name_non_kr_place_holder': '2名以上の場合は“, “で区切って記入してください',
  'studio.business_bank_setting.individual.info_view_r_name_non_kr_msg1': '2名以上の場合は“, “で区切って記入してください。',
  'studio.business_bank_setting.individual.info_view_r_name_msg2': '{length}文字を超えることはできません。 ',
  'studio.business_bank_setting.individual.question5_non_kr_place_holder': '電話番号を入力してください',
  'studio.business_bank_setting.individual.select_enter_non_kr_no_msg1': '電話番号を入力してください。',
  'studio.business_bank_setting.individual.info_global_adress_no_msg1': '郵便番号を入力してください。',
  'studio.business_bank_setting.individual.info_global_o_adress': '住所',
  'studio.business_bank_setting.individual.info_global_o_adress_msg2': '住所を入力してください。',
  'studio.business_bank_setting.individual.info_global_o_adress_msg3': '{length}文字を超えることはできません。 ',
  'studio.business_bank_setting.individual.info_global_o_adress_detail': '住所の詳細',
  'studio.business_bank_setting.individual.info_global_o_adress_detail_msg2': '{length}文字を超えることはできません。 ',
  'studio.business_bank_setting.individual.busuness_no': '事業者登録番号',
  'studio.business_bank_setting.individual.busuness_no_place_holder': '事業者登録番号を入力してください',
  'studio.business_bank_setting.individual.busuness_no_msg1': '事業者登録番号を入力してください。',
  'studio.business_bank_setting.individual.info_view_tax': 'TAX ID',
  'studio.business_bank_setting.individual.info_view_tax_place_holder': 'TAX IDを入力してください（任意）',
  'studio.business_bank_setting.individual.info_view_tax_msg1': 'TAX IDを入力してください。',
  'studio.business_bank_setting.individual.info_global_o_adress_box_place_holder1': '郡、省',
  'studio.business_bank_setting.individual.info_global_o_adress_box_place_holder2': '市、区',
  'studio.business_bank_setting.individual.info_global_street': '通りの名前',
  'studio.business_bank_setting.individual.info_global_street_msg1': '通りの名前を入力してください。',
  'studio.business_bank_setting.individual.info_global_street_msg2': '{length}文字を超えることはできません。 ',
  'studio.business_bank_setting.individual.info_global_building': '建物名',
  'studio.business_bank_setting.individual.info_global_building_msg1': '建物名を入力してください。',
  'studio.business_bank_setting.individual.info_global_building_msg2': '{length}文字を超えることはできません。 ',
  'studio.business_bank_setting.individual.info_global_city': '都市名',
  'studio.business_bank_setting.individual.info_global_city_msg1': '都市名を入力してください。',
  'studio.business_bank_setting.individual.info_global_city_msg2': '{length}文字を超えることはできません。 ',
  'studio.business_bank_setting.individual.info_global_county': '道・市・郡',
  'studio.business_bank_setting.individual.info_global_county_msg1': '道・市・郡を入力してください。',
  'studio.business_bank_setting.individual.info_global_county_msg2': '{length}文字を超えることはできません。 ',
  'studio.business_bank_setting.individual.question6_select1_kr': '大韓民国ゲーム制作(配給)業',
  'studio.business_bank_setting.individual.question6_select2_kr': '大韓民国通信販売業',
  'studio.business_bank_setting.individual.question6_select3_kr': '大韓民国事業者登録証',
  'studio.business_bank_setting.individual.game_production_no_kr_guide': '大韓民国ゲーム制作(配給)業の登録証を添付してください',
  'studio.business_bank_setting.individual.game_production_no_place_holder_kr': '大韓民国ゲーム制作(配給)業の届出番号を入力してください',
  'studio.business_bank_setting.individual.game_production_no_msg1_kr': '大韓民国ゲーム制作(配給)業の届出番号を入力してください。',
  'studio.business_bank_setting.individual.telecom_sales_no_kr_guide': '大韓民国通信販売業登録証を添付してください',
  'studio.business_bank_setting.individual.telecom_sales_no_place_holder_kr': '大韓民国通信販売業の届出番号を入力してください',
  'studio.business_bank_setting.individual.telecom_sales_no_msg1_kr': '大韓民国通信販売業の届出番号を入力してください。',
  'studio.business_bank_setting.individual.game_business_no_kr_guide': '大韓民国事業者登録証を添付してください ',
  'studio.business_bank_setting.individual.game_business_no_place_holder_kr': '大韓民国事業者登録証の番号を入力してください',
  'studio.business_bank_setting.individual.game_business_no_msg1_kr': '大韓民国事業者登録証の番号を入力してください。',
  'studio.business_bank_setting.account.question1': '銀行所在国・地域',
  'studio.business_bank_setting.account.question2': '口座情報',
  'studio.business_bank_setting.account.question3_place_holder': '銀行を選択してください',
  'studio.business_bank_setting.account.question3_msg1': '銀行を選択してください。',
  'studio.business_bank_setting.account.question4_place_holder': '口座番号を入力してください',
  'studio.business_bank_setting.account.question4_msg1': '口座の番号を入力してください。',
  'studio.business_bank_setting.account.question5_place_holder': '口座名義を入力してください',
  'studio.business_bank_setting.account.question5_msg1': '口座名義を入力してください。',
  'studio.business_bank_setting.account.question5_btn': '口座名義確認',
  'studio.business_bank_setting.account.question6': '通帳コピー',
  'studio.business_bank_setting.account.upload_guide': '{info}以下のみ添付可能',
  'studio.business_bank_setting.account.question6_guide': '通帳のコピーを添付してください ',
  'studio.business_bank_setting.account.btn_attach': 'ファイル検索',
  'studio.business_bank_setting.account.question5_btn_msg2':
    'エラーが発生しました。<br/>しばらくしてから再度お試しください。<br/>口座情報を手動で入力する場合は[手動入力]をクリックしてください。',
  'studio.business_bank_setting.account.question5_btn_msg2_btn1': '手動入力',
  'studio.business_bank_setting.account.question5_btn_msg2_btn2': '後で',
  'studio.business_bank_setting.account.question5_btn_msg3': '誤った情報です。',
  'studio.business_bank_setting.account.question5_btn_msg4': '口座名義の情報が一致しています。 ',
  'studio.business_bank_setting.account.question5_btn_msg4_retry_btn': '再照会',
  'studio.business_bank_setting.info_review_req_btn': '審査リクエスト',
  'studio.business_bank_setting.account.btn_save_alert1':
    '作成した情報を基準に審査をリクエストします。<br/>最大で5営業日かかる場合があります。<br/><br/>審査が完了したらメールまたは別途通知を差し上げます。',
  'studio.business_bank_setting.account.btn_save_alert2': '口座名義の情報照会を完了してください。',
  'studio.business_bank_setting.account.question3': '銀行情報',
  'studio.business_bank_setting.account.question3_usa_place_holder': '銀行名を入力してください',
  'studio.business_bank_setting.account.question3_usa_msg1': '銀行名を入力してください。',
  'studio.business_bank_setting.account.question7': '支店名',
  'studio.business_bank_setting.account.question7_usa_place_holder': '支店名を入力してください（任意）',
  'studio.business_bank_setting.account.question7_usa_msg1': '支店名を入力してください。',
  'studio.business_bank_setting.account.question8': '銀行の住所',
  'studio.business_bank_setting.account.question8_usa_place_holder': '銀行の住所を入力してください',
  'studio.business_bank_setting.account.question8_usa_msg1': '銀行の住所を入力してください。',
  'studio.business_bank_setting.account.question9': 'SWIFT CODE',
  'studio.business_bank_setting.account.question9_usa_place_holder': 'SWIFT CODEを入力してください',
  'studio.business_bank_setting.account.question9_usa_msg1': 'SWIFT CODEを入力してください。',
  'studio.business_bank_setting.account.question10': 'routing No',
  'studio.business_bank_setting.account.question10_usa_place_holder': 'routing Noを入力してください',
  'studio.business_bank_setting.account.question10_usa_msg1': 'routing Noを入力してください。',
  'studio.business_bank_setting.account.question4': '口座番号',
  'studio.business_bank_setting.account.question5': '口座名義',
  'studio.business_bank_setting.account.question5_place_holder1': '氏名',
  'studio.business_bank_setting.account.question5_msg11': '名前を入力してください。',
  'studio.business_bank_setting.account.question5_place_holder2': '姓',
  'studio.business_bank_setting.account.question5_msg12': '姓を入力してください',
  'studio.business_bank_setting.account.question11': 'IBAN CODE',
  'studio.business_bank_setting.account.question11_eu_place_holder': 'IBAN CODEを入力してください ',
  'studio.business_bank_setting.account.question10_eu_msg1': 'IBAN CODEを入力してください。 ',
  'studio.business_bank_setting.account.question12': 'CC CODE',
  'studio.business_bank_setting.account.question12_ca_place_holder': 'CC CODEを入力してください',
  'studio.business_bank_setting.account.question12_ca_msg1': 'CC CODEを入力してください。',
  'studio.business_bank_setting.list_name': '個人／事業者情報の審査内訳',
  'studio.business_bank_setting.list_title1': '状態',
  'studio.business_bank_setting.list_title2': '個人／事業者のタイプ',
  'studio.business_bank_setting.list_title3': '代表者名／事業者名',
  'studio.business_bank_setting.list_title4': 'リクエスト日',
  'studio.business_bank_setting.list_title5': '完了日',
  'studio.business_bank_setting.list_no_data': '照会の内訳がありません',
  'studio.business_bank_setting.account_list_name': '銀行情報の審査内訳',
  'studio.business_bank_setting.account_list_title1': '状態',
  'studio.business_bank_setting.account_list_title2': '銀行名',
  'studio.business_bank_setting.account_list_title3': '口座番号',
  'studio.business_bank_setting.account_list_title4': 'リクエスト日',
  'studio.business_bank_setting.account_list_title5': '完了日',
  'studio.business_bank_setting.account_list_no_data': '照会の内訳がありません',
  'studio.gnb.common_language_ko': '한국어',
  'studio.gnb.common_language_us': 'English (US)',
  'studio.gnb.common_language_zh_cn': '简体中文',
  'studio.gnb.common_language_zh_tw': '繁體中文',
  'studio.gnb.common_language_ja': '日本語',
  'studio.gnb.common_product_key': '商品キー',
  'studio.gnb.common_1depth_product_home': '商品のホーム',
  'studio.gnb.common_2depth_plan': 'リリース状況',
  'studio.gnb.common_1depth_product_management': '商品ページ管理',
  'studio.gnb.common_2depth_setting': '商品設定',
  'studio.gnb.common_2depth_product_page': '商品ページ',
  'studio.gnb.common_2depth_sale': '購入条件',
  'studio.gnb.common_2depth_early_access': '早期アクセスのテキスト設定',
  'studio.gnb.common_2depth_price': '価格',
  'studio.gnb.common_2depth_discount': '割引',
  'studio.gnb.common_1depth_product_data': '商品データ管理',
  'studio.gnb.common_2depth_build': 'ビルド管理',
  'studio.gnb.common_2depth_execution': '起動設定',
  'studio.gnb.common_2depth_tier_review': 'レーティングおよびビルド審査',
  'studio.gnb.common_2depth_condition': '商品規約',
  'studio.gnb.common_2depth_stats': 'スタッツ',
  'studio.gnb.common_2depth_ranking': 'ランキング',
  'studio.gnb.common_2depth_challenges': 'チャレンジミッション',
  'studio.gnb.common_2depth_cloud': 'クラウドセーブ',
  'studio.gnb.common_2depth_match': 'マッチメイク',
  'studio.gnb.common_1depth_marketing': '商品マーケティング管理',
  'studio.gnb.common_2depth_banner': 'バナー画像',
  'studio.gnb.common_1depth_in_app_purchase': 'ゲーム内ショップ',
  'studio.gnb.common_2depth_in_app_setting': 'ゲーム内決済設定',
  'studio.gnb.common_2depth_in_app_shop': 'ゲーム内ショップ',
  'studio.gnb.common_2depth_in_app_product': 'ゲーム内商品',
  'studio.gnb.common_2depth_in_app_discount': 'ゲーム内割引商品',
  'studio.gnb.common_2depth_in_app_payment_history': 'ゲーム内決済履歴',
  'studio.lnb.common_1depth_studio_group': 'Studioグループ',
  'studio.lnb.common_2depth_studio_home': 'ホーム',
  'studio.lnb.common_2depth_product_management': 'プロジェクト・商品管理',
  'studio.lnb.common_2depth_collection': 'コレクション',
  'studio.lnb.common_2depth_store_community': 'ストアコミュニティ',
  'studio.lnb.common_2depth_studio_metrics': '指標',
  'studio.lnb.common_2depth_studio_settlement': '精算',
  'studio.lnb.common_2depth_member_management': 'メンバー管理',
  'studio.lnb.common_2depth_business_info': '事業者・銀行情報',
  'studio.lnb.common_2depth_game_check': 'ゲームメンテナンス',
  'studio.lnb.common_1depth_studio_support': 'サポート',
  'studio.lnb.common_2depth_creator_news': 'お知らせ＆その他',
  'studio.lnb.common_2depth_creator_benefit': 'クリエイター特典',
  'studio.lnb.common_2depth_creator_community': 'クリエイターコミュニティ',
  'studio.lnb.common_2depth_team_community': 'チームコミュニティ',
  'studio.lnb.common_2depth_discord': 'Discordチャンネル',
  'studio.lnb.common_2depth_studio_dev_guide': '開発者ガイド',
  'studio.lnb.common_2depth_studio_noti': 'Studioのお知らせ',
  'studio.common.popup_case_a': 'A.保存有無の確認ポップアップ',
  'studio.common.popup_case_a_without_saving': '修正された内容があります。<br/>保存しないで移動しますか？',
  'studio.common.popup_case_a_without_saving_exit_btn': '閉じる',
  'studio.common.popup_case_b': 'B.エラー発生案内ポップアップ',
  'studio.common.popup_case_b_error_retry': '更新するか、再度お試しください。',
  'studio.common.popup_case_c': 'C.保存完了および適用方法の案内ポップアップ',
  'studio.common.popup_case_c_plan': '保存が完了しました。<br/>リリースから適用してください。',
  'studio.common.popup_case_d': 'D.保存完了案内ポップアップ',
  'studio.common.popup_case_d_complete_save': '保存が完了しました。 ',
  'studio.common.popup_case_e': 'E.保存完了およびクライアントテストの案内ポップアップ',
  'studio.common.popup_case_e_after_testing': '保存が完了しました。<br/>PCクライアントテスト後にLiveに適用してください。',
  'studio.common.popup_case_f': 'D.削除完了案内ポップアップ',
  'studio.common.popup_case_f_complete_del': '削除が完了しました。 ',
  'studio.common.popup_case_g_not_view': '照会権限がありません。<br/>グループ管理者にお問い合わせください。',
  'studio.common.popup_case_h_not_edit': '編集権限がありません。<br/>グループ管理者にお問い合わせください。',
  'studio.common.live_apply_btn': 'LIVE適用',
  'studio.common.popup_case_i_release_guide': '適用するには「RELEASE」を入力してください。',
  'studio.common.popup_case_i_release_place_holder': 'RELEASE',
  'studio.common.popup_case_i_release_msg1': '大文字で「RELEASE」と入力してください。',
  'studio.common.popup_case_apply_btn': '適用',
  'studio.ai_translation.title1_settings': '多言語設定',
  'studio.ai_translation.base_lang': '基準言語',
  'studio.ai_translation.base_lang_tool_tip':
    '現在設定している言語がAI翻訳の基準言語になります。<br/>グループ代表者のみ、グループホームの言語ボタンをクリックして変更可能です。',
  'studio.ai_translation.base_lang_en': '英語',
  'studio.ai_translation.base_lang_ja': '日本語',
  'studio.ai_translation.base_lang_zh_cn': '中国語(簡体字)',
  'studio.ai_translation.base_lang_zh_tw': '中国語(繁体字)',
  'studio.ai_translation.progress_wait_msg': 'AI翻訳中です。<br/>少々お待ちください。 ',
  'studio.ai_translation.all_btn': 'AI全体翻訳',
  'studio.common.popup_case_ai_overwrite':
    'すでに入力済みの内容があります。<br/>全体の内容にAI翻訳を適用しますか？<br/>翻訳時、既存の内容は上書されます。',
  'studio.common.popup_case_translation_in_progress_btn': '翻訳実行',
  'studio.common.popup_case_ai_not_entered': '多言語設定に入力されていない内容があります。<br/>多言語入力後にリリースが可能になります。',
  'studio.common.popup_case_ai_modified': '多言語設定の対象項目が修正されました。<br/>多言語を修正せず、このまま保存しますか？',
  'studio.ai_translation.title2_product': '商品名',
  'studio.ai_translation.title3_creator': 'クリエイター名',
  'studio.ai_translation.title4_distributor': 'パブリッシャー名',
  'studio.ai_translation.title5_tagline': '一言紹介文',
  'studio.ai_translation.title6_product_des': '商品説明',
  'studio.ai_translation.title7_absence': '接頭タグ',
  'studio.ai_translation.title8_link': 'リンク',
  'studio.ai_translation.title9_terms': '規約内容',
  'studio.ai_translation.title10_early': '早期アクセス案内',
  'studio.ai_translation.title11_option': '起動オプション{optionNo}',
  'studio.prj_prod.this_prod.stt_product_page_upcoming': '商品ページオープン予定',
  'studio.prj_prod.this_prod.stt_product_page_released': '商品ページオープン',
  'studio.prj_prod.this_prod.stt_product_page_withdrawn': '商品ページオープン中断',
  'studio.prj_prod.this_prod.stt_pre_order_period': '事前購入中',
  'studio.prj_prod.this_prod.stt_official_released': '正式リリース',
  'studio.prj_prod.this_prod.stt_release_sale_suspended': '販売中断',
  'studio.prj_prod.this_prod.stt_del_req_completed': '削除リクエスト',
  'studio.prj_prod.this_prod.stt_del_req_rejected': '削除リクエストのリジェクト',
  'studio.prj_prod.this_prod.stt_restriction_display_user_report': '展示ペナルティ(ユーザー通報)',
  'studio.prj_prod.this_prod.stt_restriction_install': '起動ペナルティ',
  'studio.prj_prod.this_prod.stt_restriction_for_sales': '購入ペナルティ',
  'studio.prj_prod.this_prod.stt_restriction_display_operator_stove': '展示ペナルティ',
  'studio.prj_prod_mngmt.review_restricted_case': '審議ペナルティ',
  'studio.prj_prod.status_in_review': '審査中',
  'studio.prj_prod.status_review_completed': '審査完了',
  'studio.prj_prod.this_prod.stt_restriction_for_collection': 'コレクション購入ペナルティ',
  'studio.prj_prod.this_prod.stt_product_page_review_requested': '商品ページ審査リクエスト',
  'studio.prj_prod.this_prod.stt_product_page_in_review': '商品ページ審査中',
  'studio.prj_prod.this_prod.stt_product_page_in_review_declined': '商品ページ審査リジェクト',
  'studio.prj_prod.this_prod.stt_product_page_in_review_approved': '商品ページ審査完了',
  'studio.prj_prod.this_prod.stt_product_page_display_suspended': '商品ページ展示中断',
  'studio.prj_prod.this_prod.stt_product_page_display_resumed': '商品ページ展示再開',
  'studio.prj_prod.this_prod.stt_product_deletion_request': '商品削除リクエスト',
  'studio.prj_prod.this_prod.stt_product_deletion_declined': '商品削除リクエストのリジェクト',
  'studio.prj_prod.this_prod.stt_price_review_requested': '価格審査リクエスト',
  'studio.prj_prod.this_prod.stt_price_in_review': '価格審査中',
  'studio.prj_prod.this_prod.stt_price_review_declined': '価格審査リジェクト',
  'studio.prj_prod.this_prod.stt_price_review_approved': '価格審査完了',
  'studio.prj_prod.this_prod.stt_build_rating_review_requested': 'ビルドおよびレーティングの審査リクエスト',
  'studio.prj_prod.this_prod.stt_build_rating_in_review': 'ビルドおよびレーティングの審査中',
  'studio.prj_prod.this_prod.stt_build_rating_review_approved': 'ビルドおよびレーティングの審査完了',
  'studio.prj_prod.this_prod.stt_build_rating_review_declined': 'ビルドおよびレーティングの審査リジェクト',
  'studio.prj_prod.this_prod.stt_release_review_requested': '正式リリースの審査リクエスト',
  'studio.prj_prod.this_prod.stt_release_in_review': '正式リリースの審査中',
  'studio.prj_prod.this_prod.stt_release_declined': '正式リリースの審査リジェクト',
  'studio.prj_prod.this_prod.stt_release_approved': '正式リリースの審査完了',
  'studio.prj_prod.this_prod.stt_release_upcoming': 'リリース待機',
  'studio.prj_prod.this_prod.stt_pre_order_started': '事前購入開始',
  'studio.prj_prod.this_prod.stt_pre_order_ended': '事前購入終了',
  'studio.prj_prod.this_prod.stt_release_sale_resumed': '販売再開',
  'studio.loading_ui.msg': '処理中です。<br/>少々お待ちください。',
  'studio.page_not_found.msg1': 'ホームに戻る',
  'studio.page_not_found.msg2': '前のページ',
  'studio.page_not_found.msg3': '指定されたページが見つかりません。',
  'studio.page_not_found.msg4': '前の画面へ戻り、再度お試しください。 ',
  'studio.page_not_found.home_dir_btn': '5秒後に前のページに戻ります。 ',
  'studio.stu_logged_in.pre_grp_join.nickname': 'Studioニックネーム',
  'studio.stu_logged_in.pre_grp_join.btn_my_info': 'プロフィール',
  'studio.stu_logged_in.pre_grp_join.btn_logout': 'ログアウト',
  'studio.stu_logged_in.pre_grp_join.create_grp_msg1': 'グループ代表の場合',
  'studio.stu_logged_in.pre_grp_join.create_grp_msg2': '新しいグループを作成',
  'studio.stu_logged_in.pre_grp_join.btn_create_new_grp': '新しいグループを作成',
  'studio.stu_logged_in.pre_grp_join.create_grp_guide1': 'グループ名を入力してください。 ',
  'studio.stu_logged_in.pre_grp_join.create_grp_guide2':
    'Studioでグループを管理する用途に使用されるため、デベロッパーあるいはパブリッシャーの名前を入力してください。グループ名はいつでも修正できます。',
  'studio.stu_logged_in.pre_grp_join.create_grp_name_place_holder': 'グループ名を入力してください',
  'studio.stu_logged_in.pre_grp_join.create_grp_val_msg2': 'グループ名を入力してください。 ',
  'studio.stu_logged_in.pre_grp_join.create_grp_val_msg3': '同じ名前のグループが存在しています。違うグループ名を入力してください。',
  'studio.stu_logged_in.pre_grp_join.btn_create_grp': '作成',
  'studio.stu_logged_in.pre_grp_join.create_over_10grp_msg': 'グループは最大で10個まで作成できます。',
  'studio.stu_logged_in.pre_grp_join.grp_join_stt_msg1': 'グループのメンバーの場合',
  'studio.stu_logged_in.pre_grp_join.grp_join_stt_msg2': 'グループ加入状態を確認する',
  'studio.stu_logged_in.pre_grp_join.grp_join_stt_msg3':
    'グループの招待コードを受け取って加入をリクエストしましたか？<br/>該当のグループの代表者が承認するとグループ空間に移動できるようになります。<br/>グループ加入状態を確認してください。',
  'studio.stu_logged_in.pre_grp_join.btn_chk_grp_join_stt': '加入状態を確認する',
  'studio.stu_logged_in.pre_grp_join.invitation_expired_msg1': '加入の招待コードが期限切れです。',
  'studio.stu_logged_in.pre_grp_join.invitation_expired_msg2': 'グループ代表者に再度シェアをしてもらい、加入を申請してください。',
  'studio.stu_logged_in.pre_grp_join.grp_join_req_done_msg1': 'グループ加入申請をしました。',
  'studio.stu_logged_in.pre_grp_join.grp_join_req_done_msg2': '加入状態で承認の有無を確認してください。',
  'studio.stu_logged_in.pre_grp_join.grp_join_req_accepted_msg': 'グループの加入が承認されました。',
  'studio.stu_logged_in.pre_grp_join.grp_go_to_grp_pg_guide': 'グループページに移動します。',
  'studio.stu_logged_in.pre_grp_join.btn_go_to_grp_pg': 'グループ移動',
  'studio.stu_logged_in.pre_grp_join.grp_join_req_accepted_noti': '{grpName}の加入が承認されました。',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_title': 'グループ作成完了',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_msg1': 'STOVE Studioへの加入を歓迎いたします。',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_msg2': 'Studioでゲームの開発と運営を行うためにグループという空間を提供しています。',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_msg3':
    '作成したグループで招待コードを作成してメンバーを加入させ、Studioのサービスを利用してください。',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_grp_name': 'グループ名： ',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_create_date': '作成日： ',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_grp_pg_dir_btn': 'Studioグループに移動する',
  'studio.gnb.group_myinfo.email': 'Eメール',
  'studio.gnb.group_myinfo.nickname': 'ニックネーム',
  'studio.gnb.group_myinfo.nickname_edit1': 'ニックネーム',
  'studio.gnb.group_myinfo.nickname_edit2': '修正するニックネームを入力してください',
  'studio.gnb.group_myinfo.btn_nickname_edit_save': '修正',
  'studio.gnb.group_myinfo.nickname_edit_place_holder': '修正するニックネームを入力してください',
  'studio.gnb.group_myinfo.nickname_edit_val_msg1': '2文字以上20文字以下で入力してください。',
  'studio.gnb.group_myinfo.nickname_edit_val_msg2': '修正するニックネームを入力してください。',
  'studio.gnb.group_myinfo.nickname_edit_val_msg3': '重複しているニックネームは使用できません。<br/>違うニックネームを入力してください。',
  'studio.gnb.group_myinfo.registration_time': 'STUDIO加入日',
  'studio.gnb.group_myinfo.my_group': 'MYグループ ',
  'studio.gnb.group_myinfo.my_group_role_type': '役割タイプ ',
  'studio.gnb.group_myinfo.my_group_role_type_owner': 'グループ代表',
  'studio.gnb.group_myinfo.my_group_role_type_mem': 'グループメンバー',
  'studio.gnb.group_myinfo.waitlist': '待機リスト ',
  'studio.gnb.group_myinfo.my_group_group_name': 'グループ名 ',
  'studio.gnb.group_myinfo.my_group_join_date_time': '加入日',
  'studio.gnb.group_myinfo.my_group_none': '加入しているグループがありません。',
  'studio.gnb.group_myinfo.terms_agreement': '同意内訳',
  'studio.gnb.group_myinfo.terms_agreement.term1': 'Studio利用規約({date}) ',
  'studio.gnb.group_myinfo.terms_agreement.term_agree_time': '{time}同意',
  'studio.gnb.group_myinfo.terms_agreement.btn_view_term1': '規約確認 ',
  'studio.gnb.group_myinfo.terms_agreement.term2': '個人情報の収集および利用の同意({date})',
  'studio.gnb.group_myinfo.terms_agreement_btn_view_term2': '規約確認 ',
  'studio.gnb.group_myinfo.terms_agreement_mkt': '広告・宣伝情報の受信に同意',
  'studio.gnb.group_myinfo.terms_agreement_mkt1': '主要なお知らせおよびイベントへの参加案内などは受信の同意有無にかかわらず発送されます。',
  'studio.gnb.group_myinfo.terms_agreement_mkt_checkbox': '同意する ',
  'studio.gnb.group_myinfo.terms_agreement_mkt_agree_time': '{dateTime}同意 ',
  'studio.gnb.group_myinfo.terms_agreement_mkt_reject_time': '{dateTime}受信拒否',
  'studio.gnb.group_myinfo.my_group.detailed_group_breadcrumb1': 'MY情報 ',
  'studio.gnb.group_myinfo.my_group.detailed_group_breadcrumb2': 'グループ情報',
  'studio.gnb.group_myinfo.my_group.detailed_group_join_time': '{dateTime}加入',
  'studio.gnb.group_myinfo.my_group.detailed_group_permission': 'MYグループメニュー権限',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_edit': '編集',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_by_menu': '編集権限',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_menu_name': 'メニュー',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_grp_home': 'グループダッシュボード',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_prj_prod': 'プロジェクトおよび商品',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_collection': 'コレクション',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_store_comm': 'ストアコミュニティ',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_mem_mgmt': 'メンバー管理',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_biz_bank_info': '事業者・銀行情報設定',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr': '編集権限の内容',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr1': 'ダッシュボードの設定',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr2': 'プロジェクト作成、修正、削除<br/>商品作成、削除',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr3': 'コレクション作成、修正、削除',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr4': 'コミュニティ作成、修正、削除',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr5': 'メンバー招待、役割作成、修正、脱退',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr6': '事業者情報登録、修正、審査<br/>銀行情報登録、修正、審査',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_view': '照会',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_by_menu': 'メニュー ',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_home': 'グループダッシュボード',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_prj_prod': 'プロジェクトおよび商品',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_collection': 'コレクション',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_store_comm': 'ストアコミュニティ',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_mem_mngmt': 'メンバー管理',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_statistics': '指標',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_bill_settlement': '精算',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_biz_bank_info': '事業者・銀行情報',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_overall_maint': 'ゲームメンテナンス',
  'studio.gnb.group_myinfo.my_group.detailed_group_collapse_all_btn': 'すべて閉じる ',
  'studio.gnb.group_myinfo.my_group.detailed_group_expand_all_btn': 'すべて開く',
  'studio.gnb.group_myinfo.my_group.detailed_group_prj_product_name': '商品',
  'studio.gnb.group_myinfo.my_group.detailed_group_prj_role': '役割 ',
  'studio.gnb.group_myinfo.my_group.detailed_group_permission_given_date': '権限付与日',
  'studio.gnb.group_myinfo.my_group.detailed_group_prj_name': 'プロジェクト',
  'studio.gnb.group_myinfo.my_group.detailed_group_btn_leave_group': 'グループを脱退する ',
  'studio.gnb.group_myinfo.my_group.detailed_group_product_num': '商品数 ',
  'studio.gnb.group_myinfo.my_group.detailed_group_prj_num_none': 'リストがありません',
  'studio.gnb.group_myinfo.my_group.detailed_group_leave_group_msg': '本当にグループから脱退しますか？',
  'studio.gnb.group_myinfo.my_group.detailed_group_btn_leave_cf': '退会',
  'studio.gnb.group_myinfo.my_group.detailed_group_leave_done_msg': 'グループから脱退しました',
  'studio.gnb.group_myinfo.my_group.detailed_group_click_error_msg': 'エラーが発生しました。<br/> しばらくしてから再度お試しください。',
  'studio.gnb.group_myinfo.my_group.detailed_group_mkt_uncheck_msg': '広告・宣伝情報の受信への同意を解除しました。',
  'studio.gnb.group_myinfo.my_group.detailed_group_mkt_check_msg': '広告・宣伝情報の受信への同意を設定しました。',
  'studio.gnb.group_myinfo.join_req_waitlist': '待機リスト',
  'studio.gnb.group_myinfo.join_req_group_name': 'グループ名',
  'studio.gnb.group_myinfo.join_req_date_time': '加入リクエスト日',
  'studio.gnb.group_myinfo.join_req_status': '状態',
  'studio.gnb.group_myinfo.join_req_none': 'リストがありません',
  'studio.gnb.grp_myinfo.join_req_stt_rejected': '拒否',
  'studio.gnb.group_myinfo.join_req_stt_waiting': '待機 ',
  'studio.gnb.group_myinfo_terms1_popup_usage_term': 'STOVE Studio利用規約',
  'studio.gnb.group_myinfo_terms1_popup_usage_term_title': 'STOVE Studio利用規約',
  'studio.gnb.group_myinfo_terms1_popup_btn_close': '閉じる',
  'studio.gnb.group_myinfo_terms2_popup_usage_term': '個人情報の収集および利用の同意 ',
  'studio.gnb.group_myinfo_terms2_popup_btn_close': '閉じるボタン ',
  'studio.gnb.group_myinfo_terms2_popup_usage_term_title': '個人情報の収集および利用の同意 ',
  'studio.notice.none_guide': '登録されているお知らせがありません。',
  'studio.notice.see_more_btn': 'さらに表示',
  'studio.lnb.notice': 'Studioのお知らせ',
  'studio.group.home.btn_create_new_group': '新しいグループを作成',
  'studio.group.home.group_lnb_title': 'Studioグループ',
  'studio.group.home.title_group_name': 'グループ{grpName}',
  'studio.group.home.title_group_name_change_title1': 'グループ名を入力してください。',
  'studio.group.home.title_group_name_change_title2': 'Studioでグループを管理する用途で使用され、いつでも修正できます。',
  'studio.group.home.title_group_name_change_place_holder': 'グループ名を入力してください',
  'studio.group.home.title_group_name_change_val_msg1': 'グループ名を入力してください。',
  'studio.group.home.title_group_name_change_msg2': '同じ名前のグループが存在しています。違うグループ名を入力してください。',
  'studio.group.home.title_group_name_change_btn_modify': '修正',
  'studio.group.home.language_tool_tip':
    '現在設定している言語がAI翻訳の基準言語になります。<br/>グループ代表者のみ、グループホームの言語ボタンをクリックして変更可能です。',
  'studio.group.home.language_standard_setting': '基準言語設定',
  'studio.group.home.language_standard_guide1': 'グループ内のすべての商品が、選択した言語にAI翻訳されます。 ',
  'studio.group.home.language_standard_guide2':
    'この機能は必ず、必要な場合にのみ変更してください。言語設定の変更後は、AI翻訳がうまく適用されているかご確認ください。',
  'studio.basic_lang_setting.us': '英語',
  'studio.basic_lang_setting.ko': '韓国語',
  'studio.basic_lang_setting.ja': '日本語',
  'studio.basic_lang_setting.zh_cn': '中国語(簡体字)',
  'studio.basic_lang_setting.zh_tw': '中国語(繁体字)',
  'studio.group.home.language_standard_change': '変更する',
  'studio.group.home.join_req_accepted_popup': 'グループ加入が承認されました。<br/>グループページに移動します。',
  'studio.group.home.join_req_accepted_popup_close_btn': '閉じる',
  'studio.group.home.join_req_accepted_grp_dir_btn': 'グループ移動',
  'studio.group.home.join_req_accepted_noti': '{grpName}の加入が承認されました。',
  'studio.group.home.board_type1': 'プロジェクト・商品管理',
  'studio.group.home.board_type1_no_data1': '保有しているプロジェクトがありません',
  'studio.group.home.board_type1_no_data2': 'プロジェクトを登録しますか？',
  'studio.group.home.board_type1_no_data_btn': '登録する',
  'studio.group.home.board_type1_data1': 'プロジェクト',
  'studio.group.home.board_type1_data2': '商品',
  'studio.group.home.board_type2': 'グループメンバー',
  'studio.group.home.board_type2_no_data1': '共にプロジェクトを行うメンバーを招待してみましょう！',
  'studio.group.home.board_type2_mem_count': '{memCount}人',
  'studio.group.home.board_type3': '累計商品販売順位',
  'studio.group.home.board_type3_data1': '累計販売量／購入転換率',
  'studio.group.home.board_type4': '{currentMonth}月の予想販売金額',
  'studio.group.home.board_type4_no_data1': '精算するにはグループの  銀行情報が必要です。',
  'studio.group.home.board_type4_no_data2': '銀行情報を登録しますか？',
  'studio.group.home.board_type4_no_data_btn': '登録する',
  'studio.group.home.board_type5': 'リリース',
  'studio.group.home.board_type5_stt_to_be_opened_badge': '予定',
  'studio.group.home.board_type5_stt_to_be_opened_guide': '商品ページオープン予定',
  'studio.group.home.board_type5_stt_live_applied_badge': 'LIVE適用',
  'studio.group.home.board_type5_stt_live_applied_guide': '事前購入開始',
  'studio.group.home.board_type5_stt_to_be_applied_badge': '適用予定',
  'studio.group.home.board_type5_stt_to_be_applied_guide': '正式リリース',
  'studio.group.home.board_type6': 'ストアレビュー',
  'studio.group.home.board_type6_no_data1_after': '最近のレビューがありません',
  'studio.group.home.board_type6_no_data2_after': '最近のコメントがありません',
  'studio.group.home.board_type6_data1_after': '商品レビュー ',
  'studio.group.home.board_type6_data2_after': '最近のコメント ',
  'studio.group.home.board_type7': 'ストア<br/>コミュニティ',
  'studio.group.home.board_type7_no_data1_after': '最近の投稿がありません',
  'studio.group.home.board_type7_no_data2_after': '最近のコメントがありません',
  'studio.group.home.board_type7_data1_after': '最近の投稿 ',
  'studio.group.home.board_type7_data2_after': '最近のコメント ',
  'studio.group.home.board_type7_not_existed': 'コミュニティが存在しません。',
  'studio.group.home.board_type8': 'Lounge #タグ',
  'studio.group.home.board_type8_no_data1_after': '登録されたタグがありません',
  'studio.group.home.board_type8_data1_after': '最新の投稿',
  'studio.group.home.board_type9': 'ストアのお気に入り',
  'studio.group.home.board_type9_data1_after': 'お気に入り ',
  'studio.group.home.board_type10': '商品の指標',
  'studio.group.home.board_type10_select_box1_tool_tip': 'ゲームの同時接続ユーザー数',
  'studio.group.home.board_type10_select_box2_tool_tip': '商品ページへのアクセス数',
  'studio.group.home.board_type10_select_box3_tool_tip': 'ゲームプレイ日間ユーザー数',
  'studio.group.home.first_page_register_guide1': 'まずはプロジェクトを登録してください！',
  'studio.group.home.first_page_register_guide2': 'プロジェクトを登録すると商品登録、リリースなどStudioのすべての機能を使用できるようになります。',
  'studio.group.home.dash_board_setting': 'ダッシュボードの設定',
  'studio.group.home.select_product': '商品選択',
  'studio.group.home.edit_list': 'リスト編集',
  'studio.group.home.refresh_info': 'ストアのデータは毎週月曜日の00時に更新されるため、リアルタイムのデータと異なる場合があります｡ ',
  'studio.group.home.select_product.title': '商品選択',
  'studio.group.home.select_product.search_place_holder': '商品を検索してください。 ',
  'studio.group.home.select_product.search_no_result_msg': '検索結果がありません。',
  'studio.group.home.select_product.search_no_select': 'まだ選択された商品がありません。',
  'studio.group.home.edit_list.title': 'リスト編集',
  'studio.group.home.edit_list.guide': 'ダッシュボードに表示する項目を選択するかドラッグして順序を変更できます。',
  'studio.group.home.edit_list.breadcrumb1': 'グループのホーム',
  'studio.group.home.edit_list.breadcrumb2': 'リスト編集',
  'studio.group.notice.title': 'Studioのお知らせ',
  'studio.group.notice.sub_title': 'Studioのお知らせ',
  'studio.group.notice.copy_text_button': 'URLコピー',
  'studio.group.notice.file_download_btn': 'ダウンロードする',
  'studio.group.notice.notice_list_dir_btn': '全体内容を見る',
  'studio.group.notice.list_header1': '区分',
  'studio.group.notice.list_header2': 'タイトル',
  'studio.group.notice.list_header3': '作成日',
  'studio.group.notice.copied_toast_msg': '投稿のURLがコピーされました。',
  'studio.group.pre_grp_landing.new_term_agreement_chkbox': ' (必須)利用規約に同意します。',
  'studio.group.pre_grp_landing.all_terms_agreed_pop_msg1': 'すでにすべての規約に同意しました。',
  'studio.group.pre_grp_landing.all_terms_agreed_pop_msg2': 'グループのホームに移動します。',
  'studio.member_manage.member.member_title.nick_header': 'ニックネーム',
  'studio.member_manage.member.member_title.project_count_header': '所属プロジェクト',
  'studio.member_manage.member.member_title.regi_date_header': '加入日',
  'studio.member_manage.member_all_title': '全体',
  'studio.member_manage.member_invite_btn': 'メンバー招待',
  'studio.member_manage.member_invite_alert1_msg': '編集権限がありません。<br/>グループ管理者にお問い合わせください。',
  'studio.member_manage.member.guide1': '自分たちのグループにメンバーを招待して管理できます',
  'studio.member_manage.member.guide2': 'メンバーにメニュー／商品の権限と役割を与えることができます',
  'studio.member_manage.member.guide3':
    '役割は基本設定されている役割を付与したり、カスタマイズしてクリエイターグループに合わせて設定したりできます。',
  'studio.member_manage.member_invite.mem_invite': 'メンバー招待',
  'studio.member_manage.member_invite.mem_invite_link': '招待リンク',
  'studio.member_manage.member_invite.link_expiry': '{remainingTimeNum}{timeUnit}後に満了します。',
  'studio.member_manage.member_invite.link_used_times': '現在の回数： ',
  'studio.member_manage.member_invite.link_used_times_value': '{times}回',
  'studio.member_manage.member_invite.link_regen_btn': 'リンク再生成',
  'studio.member_manage.member_invite.link_regen_guide': 'もう一度招待リンクを生成します。<br/>今後は該当のリンクから加入できなくなります。',
  'studio.member_manage.member_invite.link_regen_cf_btn': 'リンク再生成',
  'studio.member_manage.member_invite.link_regen_done': '招待リンクが再生成されました。',
  'studio.member_manage.member_invite.mem_invite_link_advanced_settings': '高級設定',
  'studio.member_manage.member_invite.mem_invite_link_activation_y_n': '有効の有無',
  'studio.member_manage.member_invite.mem_invite_link_activation_guide': 'リンクを無効にすると、有効にするまでリンクを使用できなくなります。',
  'studio.member_manage.member_invite.mem_invite_link_activation_y': '有効にする',
  'studio.member_manage.member_invite.mem_invite_link_activation_n': '無効にする',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry': 'リンクの有効期限',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_guide': '有効期限を変更すると、保存した時点から有効期限が更新されます。 ',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_def_7d_': '7日',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_30m': '30分',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_1h': '1時間',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_6h': '6時間',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_12h': '12時間',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_1d': '1日',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_n': '有効期限なし',
  'studio.member_manage.member_invite.mem_invite_link_guide': '招待リンク',
  'studio.member_manage.member_invite.mem_invite_link_guide1':
    '生成された招待リンクをコピーして、招待したい方にお送りください。招待リンクを受け取った方は、Studioに未登録の場合はStudio登録を行い、既に登録済みの場合はグループへの参加リクエストが可能です。',
  'studio.member_manage.member_invite.mem_invite_link_advanced_setting_guide': '高級設定',
  'studio.member_manage.member_invite.mem_invite_link_advanced_setting_guide1':
    'リンクの設定を変更できます。変更後は保存が必要です。リンクを再生成すると、設定はデフォルトに戻ります。',
  'studio.member_manage.member_invite.mem_invite_link_expired': '期限切れの招待リンクです。',
  'studio.member_manage.member_invite.mem_invite_link_copied': 'コピー完了',
  'studio.member_manage.member.list_invite_date': '招待日時',
  'studio.member_manage.member.list_resend_invite_btn': '再送信',
  'studio.member_manage.member.list_cancel_invite_btn': '招待キャンセル',
  'studio.member_manage.member.invite_link_popup_case_4806': 'このグループはすでに加入済みです。',
  'studio.member_manage.member.invite_link_popup_case_4500_01_4804': '無効のリンクであるか、無効のメンバーです。',
  'studio.member_manage.member.invite_link_popup_case_4505':
    '{grpName}<br/>加入招待コードの期限が切れています。<br/>グループ代表者に再度シェアをしてもらい、加入を申請してください。',
  'studio.member_manage.member.invite_link_popup_case_0_success':
    '{grpName}<br/>グループ加入を申請しました。<br/>加入状態から承認の有無を確認してください。',
  'studio.member_manage.role_manage_btn': '役割管理',
  'studio.member_manage.role_value_operator': '運営',
  'studio.member_manage.role_value_marketer': 'ビジネス',
  'studio.member_manage.role_value_developer': '開発',
  'studio.member_manage.role_value_manager': 'プロジェクト管理者',
  'studio.member_manage.role_manage_create_role_btn': '新しい役割を作成',
  'studio.member_manage.role_manage_create_role_msg1': '役割名',
  'studio.member_manage.role_manage_create_role_place_holder': '役割名を入力してください ',
  'studio.member_manage.role_manage_create_role_alert1': '役割名を入力してください。',
  'studio.member_manage.role_manage_create_role_val1': '重複している役割名があります。確認後にもう一度入力してください。',
  'studio.member_manage.role_manage_create_role_msg2': '権限設定',
  'studio.member_manage.role_manage_create_role_msg3': '商品ごとのホーム画面の個別項目に権限を付与できます。',
  'studio.member_manage.role_manage_create_role_menu_header1': 'メニュー',
  'studio.member_manage.role_manage_create_role_perm_view_header2': '照会',
  'studio.member_manage.role_manage_create_role_perm_edit_header3': '編集',
  'studio.member_manage.role_manage_create_role_register_btn': '登録',
  'studio.member_manage.role_manage_create_role_msg6': '役割とメニューごとの権限設定',
  'studio.member_manage.role_manage_create_role_msg7':
    '権限設定メニューごとにアクセス権限を別途設定できます。<br/>区分しやすいように様々な役割名を付けてみましょう。<br/>役割名は重複して設定することはできません！',
  'studio.member_manage.role_manage_create_role_msg8': '指標／精算権限設定',
  'studio.member_manage.role_manage_create_role_msg9': '指標／精算を選択したときにグループメニューで照会できる権限を付与します。 ',
  'studio.member_manage.role_manage_create_role_register_alert_msg': '新しい役割が登録されました。',
  'studio.member_manage.role_manage_details_title': '役割を修正する',
  'studio.member_manage.role_manage_details_save_btn': '保存',
  'studio.member_manage.role_manage_details_delete_btn': '役割削除',
  'studio.member_manage.role_manage_details_save_alert_msg': '役割が保存されました。',
  'studio.member_manage.role_manage_details_delete_step1_msg':
    '本当に役割を削除しますか？<br/>役割が付与されたすべてのメンバーの役割が消去されます。',
  'studio.member_manage.role_manage_details_delete_step1_delete_btn': '削除',
  'studio.member_manage.role_manage_details_delete_step2_delete_alert1_msg': '役割が削除されました。',
  'studio.member_manage.role_manage_details_delete_step2_delete_alert2_msg': 'エラーが発生しました。<br/> しばらくしてから再度お試しください。',
  'studio.member_manage.role_manage_list_by_menu': 'メニュー',
  'studio.member_manage.role_manage_list_view_per': '照会',
  'studio.member_manage.role_manage_list_edit_per': '編集',
  'studio.member_manage.role_manage_list_by_menu_release_plan': 'リリース',
  'studio.member_manage.role_manage_list_by_menu_prod_pg_mgmt': '商品ページの管理',
  'studio.member_manage.role_manage_list_by_menu_prod_setting': '商品設定',
  'studio.member_manage.role_manage_list_by_menu_prod_pg': '商品ページ',
  'studio.member_manage.role_manage_list_by_menu_prod_term': '商品規約',
  'studio.member_manage.role_manage_list_by_menu_price': '販売価格',
  'studio.member_manage.role_manage_list_by_menu_discount': '割引',
  'studio.member_manage.role_manage_list_by_menu_pur_cond': '購入条件',
  'studio.member_manage.role_manage_list_by_menu_early_access': '早期アクセスの内容設定',
  'studio.member_manage.role_manage_list_by_menu_collection': 'コレクション',
  'studio.member_manage.role_manage_list_by_menu_prod_data_mgmt': '商品データ管理',
  'studio.member_manage.role_manage_list_by_menu_build_mgmt': 'ビルド管理',
  'studio.member_manage.role_manage_list_by_menu_exe_setting': '起動設定',
  'studio.member_manage.role_manage_list_by_menu_rating_build_review': 'レーティングおよびビルド審査',
  'studio.member_manage.role_manage_list_by_menu_stats': 'スタッツ',
  'studio.member_manage.role_manage_list_by_menu_ranking': 'ランキング',
  'studio.member_manage.role_manage_list_by_menu_challenge': 'チャレンジミッション',
  'studio.member_manage.role_manage_list_by_menu_cloud_saving': 'クラウドセーブ',
  'studio.member_manage.role_manage_list_by_menu_match_making': 'マッチメイク',
  'studio.member_manage.role_manage_list_by_menu_prod_mkt_mgmt': '商品マーケティング管理',
  'studio.member_manage.role_manage_list_by_menu_statistics': '指標',
  'studio.member_manage.role_manage_list_by_menu_bill_settlement': '精算',
  'studio.member_manage.role_manage_list_by_menu_ingame_store': 'ゲーム内ショップ',
  'studio.member_manage.role_manage_list_by_menu_ingame_setting': 'ゲーム内決済設定',
  'studio.member_manage.role_manage_list_by_menu_sub_ingame_store': 'ゲーム内ショップ',
  'studio.member_manage.role_manage_list_by_menu_ingame_store_product': 'ゲーム内商品',
  'studio.member_manage.role_manage_list_by_menu_ingame_store_discount': 'ゲーム内割引商品',
  'studio.member_manage.role_manage_list_by_menu_ingame_store_payment_history': 'ゲーム内決済履歴',
  'studio.member_manage.role_manage_details_msg1': 'Studioの基本の役割',
  'studio.member_manage.role_manage_details_msg2': 'Studioで提供する基本の役割は、変更や削除ができません。',
  'studio.member_manage.member_nick_header2': 'ニックネーム',
  'studio.member_manage.member_project_count_header3': '所属プロジェクト',
  'studio.member_manage.member_regi_date_header4': '加入日',
  'studio.member_manage.member_invite_date_header5': '招待日時',
  'studio.member_manage.search_place_holder': 'ニックネーム検索',
  'studio.member_manage.history': '履歴を確認する',
  'studio.member_manage.search_nmrf': '検索条件に合う結果がありません。',
  'studio.member_manage.list_no_data': 'リストがありません。',
  'studio.member_manage.mem_by_project_title': 'プロジェクト別メンバー',
  'studio.member_manage.project_project_name_header1': 'プロジェクト',
  'studio.member_manage.project_no_of_member_header2': 'メンバー数',
  'studio.member_manage.project_project_name_header2': '生成日',
  'studio.member_manage.project_list_member_title': 'メンバー',
  'studio.member_manage.project_list_nickname_header3': 'ニックネーム',
  'studio.member_manage.project_list_product_name_header1': '商品',
  'studio.member_manage.project_list_role_header4': '役割',
  'studio.member_manage.project_list_date_authorized_header5': '権限付与日',
  'studio.member_manage.project_list_collapse_all_btn': 'すべて閉じる',
  'studio.member_manage.project_list_expand_all_btn': 'すべて開く',
  'studio.member_manage.join_waitlist_chk_btn': '加入待機',
  'studio.member_manage.join_waitlist_nickname': 'ニックネーム',
  'studio.member_manage.join_waitlist_req_date': '加入リクエスト日',
  'studio.member_manage.join_waitlist_stt': '状態',
  'studio.member_manage.join_waitlist_stt_waiting': '待機',
  'studio.member_manage.join_waitlist_no_data':
    'まだグループに参加申請をしたメンバーがいません。<br/>メンバーを招待するには、招待リンクを作成して共有してください。',
  'studio.member_manage.membership_requests_decline_btn': '拒否',
  'studio.member_manage.membership_requests_approve_btn': '承認',
  'studio.member_manage.membership_requests_approve_alert_msg':
    '参加承認が完了しました。<br/>権限を付与するには、リストからメンバーをクリックして権限を設定してください。',
  'studio.member_manage.membership_requests_decline_alert_msg': '加入の拒否が完了しました。',
  'studio.member_manage.membership_requests_action_alert_msg': 'リストからメンバーを選択してください。',
  'studio.member_manage.member_details_msg2': 'ニックネーム',
  'studio.member_manage.member_details_msg3': '加入日',
  'studio.member_manage.member_details_group_menu_permission_title': 'グループメニュー権限選択',
  'studio.member_manage.member_details_product_permission_title': '商品権限選択',
  'studio.member_manage.member_details_right_guide1': 'プロジェクトおよび商品の権限',
  'studio.member_manage.member_details_right_guide2': '自分たちのグループが所有する商品に権限を与えることができます。',
  'studio.member_manage.member_details_right_guide3': '自動役割付与',
  'studio.member_manage.member_details_right_guide4':
    'メンバーが招待を承諾した後、商品を追加する際に権限を手動で付与せずに自動的に付与することが可能です。',
  'studio.member_manage.member_details_right_guide5':
    '権限は自動付与されるため、非表示にしたいプロジェクトや商品がある場合は、該当メンバーの詳細情報ページで権限の設定を変更してください。',
  'studio.member_manage.member_details_save_btn': '保存',
  'studio.member_manage.member_details_remove_btn': 'メンバーを脱退させる',
  'studio.member_manage.member_details_remove_step1_msg': '本当にグループからメンバーを脱退させますか？',
  'studio.member_manage.member_details_remove_step1_remove_btn': '脱退',
  'studio.member_manage.member_details_remove_step2_msg': 'メンバーがグループから脱退しました。 ',
  'studio.member_manage.member_details_group_menu_permission_msg1': 'メンバーに付与するグループメニュー権限を選択してください。',
  'studio.member_manage.member_details_group_menu_permission_msg2': '精算／指標メニューは商品権限を持っている場合のみ照会可能です。',
  'studio.member_manage.member_details_group_menu_permission_mail_or_notice_title': 'メール／通知',
  'studio.member_manage.member_details_group_menu_permission_mail_or_notice_msg': '権限を持っている商品のメールや通知を受け取ります。',
  'studio.member_manage.member_details_group_menu_permission_mail_or_notice_settlement_chkbox': '精算',
  'studio.member_manage.member_details_group_menu_permission_mail_or_notice_review_chkbox': '審査',
  'studio.member_manage.member_details_group_menu_permission_mail_or_notice_contract_chkbox': '契約',
  'studio.member_manage.member_details_product_permission_msg1': 'メンバーに付与する商品と役割を選択してください。',
  'studio.member_manage.member_details_product_permission_product_name_header1': 'プロジェクトおよび商品名',
  'studio.member_manage.member_details_product_permission_role_selection_dropbox_header2': '役割選択',
  'studio.member_manage.member_details_product_permission_apply_all_btn': '全体に適用',
  'studio.member_manage.member_details_product_permission_full_btn': 'フルスクリーン',
  'studio.member_manage.member_details_product_permission_msg2': 'グループ内に商品を追加する際、自動で役割を付与します。',
  'studio.member_manage.member_details_product_permission_product_place_holder':
    '権限を付与する商品がありません。<br/>グループ内で最低1つ以上の商品がなければなりません。',
  'studio.member_manage.history_nick_header1': 'ニックネーム',
  'studio.member_manage.history_summary_header2': '内容',
  'studio.member_manage.history_status_header3': '状態',
  'studio.member_manage.history_date_header4': '日時',
  'studio.member_manage.history_category_all': '全体',
  'studio.member_manage.history_category_joined': '登録',
  'studio.member_manage.history_category_rejected': '拒否',
  'studio.member_manage.history_category_edit': '修正',
  'studio.member_manage.history_category_left_gr': '退会',
  'studio.member_manage.history_status_edit_depth_details_added': '[追加]',
  'studio.member_manage.history_status_edit_depth_details_removed': '[削除]',
  'studio.member_manage.history_status_invited': '招待',
  'studio.member_manage.history_status_invited_details': '{email} を招待しました。',
  'studio.member_manage.history_status_joined': '登録',
  'studio.member_manage.history_status_joined_details': '新しく加入されました！',
  'studio.member_manage.history_status_declined': '拒否',
  'studio.member_manage.history_status_edit_product': '修正',
  'studio.member_manage.history_status_edit_product_details': '{nickName}の商品権限を修正しました。',
  'studio.member_manage.history_status_edit_menu': '修正',
  'studio.member_manage.history_status_edit_menu_details': '{nickName}のメニュー権限を修正しました。',
  'studio.member_manage.history_status_dismiss': '脱退',
  'studio.member_manage.history_status_dismiss_details': '{nickName}さんを脱退させました。',
  'studio.member_manage.history_status_left': '脱退',
  'studio.member_manage.history_status_left_details': '{nickName}さんがグループを脱退しました。',
  'studio.member_manage.history_status_expand_details': '詳細を見る',
  'studio.member_manage.history_search_place_holder': 'ニックネーム検索',
  'studio.prod_home.pur_cond.pur_cond': '購入条件',
  'studio.prod_home.pur_cond.btn_save': '保存',
  'studio.prod_home.pur_cond.pur_cond_prod': '購入条件商品',
  'studio.prod_home.pur_cond.pur_cond_prod_place_holder': '商品を検索してください。',
  'studio.prod_home.pur_cond.pur_cond_prod_no_result': '検索結果がありません。',
  'studio.prod_home.pur_cond.pur_cond_type': '条件タイプ',
  'studio.prod_home.pur_cond.pur_cond_type1': 'AND条件',
  'studio.prod_home.pur_cond.pur_cond_type2': 'OR条件',
  'studio.prod_home.pur_cond.pur_cond_option': '購入条件の使用有無',
  'studio.prod_home.pur_cond.pur_cond_option_y': '使用',
  'studio.prod_home.pur_cond.pur_cond_option_n': '未使用',
  'studio.prod_home.pur_cond.pur_cond_guide1': '購入条件商品に設定できる商品には何がありますか？',
  'studio.prod_home.pur_cond.pur_cond_guide1_detail':
    '所属グループの商品またはコレクション商品を、購入条件として設定できます。<br/>ただし、商品Aが商品Bの購入条件として登録されている場合、商品Bを商品Aの購入条件として設定することはできません。',
  'studio.prod_home.pur_cond.pur_cond_guide2': 'AND条件タイプとは何ですか？',
  'studio.prod_home.pur_cond.pur_cond_guide2_detail': '購入条件商品をすべて保有しているユーザーのみがこの商品を購入できます。 ',
  'studio.prod_home.pur_cond.pur_cond_guide3': 'OR条件タイプとは何ですか？',
  'studio.prod_home.pur_cond.pur_cond_guide3_detail': '購入条件商品のうち1つ以上を保有しているユーザーのみがこの商品を購入できます。 ',
  'studio.prod_home.pur_cond.pur_cond_guide5': '購入条件とは何ですか？',
  'studio.prod_home.pur_cond.pur_cond_guide5_detail':
    'この商品の「購入条件商品」にA商品を登録すると、A商品を保有しているユーザーのみがこの商品を購入できます。',
  'studio.prod_home.pur_cond.pur_cond_stove_set': 'STOVE設定購入条件商品',
  'studio.prod_home.pur_cond.pur_cond_guide4': 'STOVE設定購入条件商品とは何ですか？',
  'studio.prod_home.pur_cond.pur_cond_guide4_detail':
    'STOVEの運営者が設定した購入条件商品です。<br/>STOVE設定購入条件商品がある場合、購入条件を直接設定することはできません。他の商品を購入条件商品に設定したい場合は、<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。',
  'studio.prj_prod.this_prod.landing_msg1': '商品ページ',
  'studio.prj_prod.this_prod.landing_create_btn': '作成',
  'studio.prj_prod.this_prod.landing_msg2': '自分の商品がユーザーの目に留まるように商品ページを作って編集してみましょう！',
  'studio.prj_prod.this_prod.landing_msg3':
    '30MB以下のメイン画像、スクリーンショット、アイコン、および100MB以下の動画、商品紹介文をご準備の上、作成してください。',
  'studio.prj_prod.this_prod.landing_create_pop_msg1': '商品ページ名を入力してください。 ',
  'studio.prj_prod.this_prod.landing_create_pop_msg2': '商品ページを区別するための内部名称です。ユーザーには表示されません。',
  'studio.prj_prod.this_prod.landing_create_pop_page_name_place_holder': '商品ページ名を入力してください',
  'studio.prj_prod.this_prod.landing_create_pop_input_msg1': '商品ページ名を入力してください。 ',
  'studio.prj_prod.this_prod.landing_create_pop_create_btn': '作成',
  'studio.prj_prod.this_prod.edit_page_name': 'ソウルゲームストアページ',
  'studio.prj_prod.this_prod.edit_info_hover_msg':
    '現在設定している言語がAI翻訳の基準言語になります。<br/>グループ代表者のみ、グループホームの言語ボタンをクリックして変更可能です。',
  'studio.prj_prod.edit_preview_toggle_msg': 'プレビューを折りたたみ作業スペースを広げることができます',
  'studio.prj_prod.this_prod.edit_sidebar_title': '商品ページ編集',
  'studio.prj_prod.this_prod.edit_sidebar_msg1': '必須項目のみを見る',
  'studio.prj_prod.this_prod.edit_preview_btn': 'プレビュー',
  'studio.prj_prod.this_prod.edit_mls_btn': '多言語設定',
  'studio.prj_prod.this_prod.text_missing_mls_n_popup': '一言紹介文の内容を入力した後に多言語を設定できます。<br/>内容を入力して再度お試しください。',
  'studio.prj_prod.this_prod.edit_save_step0_msg':
    '必須項目のうち入力されていない内容があります。<br/>必須項目をすべて入力するとリリースプランに登録できるようになります。',
  'studio.prj_prod.this_prod.edit_display_prod_pg': '商品ページ表示',
  'studio.prj_prod.this_prod.edit_display_countries_msg1': '表示する国・地域',
  'studio.prj_prod.this_prod.edit_display_countries_view_btn': 'すべての国・地域を見る',
  'studio.prj_prod.this_prod.edit_display_countries_select_all': 'すべての国・地域に表示',
  'studio.prj_prod.this_prod.edit_display_countries_select_partial': '一部の国・地域のみ表示',
  'studio.prj_prod.this_prod.edit_display_countries_msg4': '国・地域の選択',
  'studio.prj_prod.this_prod.edit_display_countries_regions': 'エリアごとに見る',
  'studio.prj_prod.this_prod.edit_display_countries_search_country': '国・地域の検索',
  'studio.prj_prod.this_prod.edit_display_countries_regions_all': '全体',
  'studio.prj_prod.this_prod.edit_display_countries_checkbox_val1': '1つ以上の国を選択してください。',
  'studio.prj_prod.this_prod.edit_display_countries_search_country_placeholder': '国を検索してください',
  'studio.prj_prod.this_prod.edit_gamepreview_hover_msg1': 'マイコンピューター',
  'studio.prj_prod.this_prod.edit_gamepreview_hover_msg2': 'ストレージ',
  'studio.prj_prod.this_prod.edit_gamepreview_hover_msg3': '編集',
  'studio.prj_prod.this_prod.edit_gamepreview_import_this_media_alert2': '1個のファイルのみ選択してください。',
  'studio.prj_prod.this_prod.edit_gamepreview_import_this_media_alert3':
    '対応していないファイル形式です。<br/>ファイル拡張子をご確認の上、アップロードしてください。',
  'studio.prj_prod.this_prod.edit_gamepreview_import_this_media_alert4':
    'ファイルサイズが制限を超えています。<br/>上限サイズをご確認の上、アップロードしてください。',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_title': '開始日',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_immediate_radio_btn': '即時',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_select_time_radio_btn': '予約',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_req_msg': '商品を表示する開始日を選択してください。',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_invalid_msg': '予約日は現在時刻以降に設定してください。',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_pop1_msg': '今すぐ商品ページを適用しますか？',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_pop2_msg': '商品ページの予約を適用しますか？',
  'studio.prj_prod.this_prod.edit_gamepreview_title': '動画および画像',
  'studio.prj_prod.this_prod.edit_gamepreview_msg1': '画面タイプ選択',
  'studio.prj_prod.this_prod.edit_gamepreview_radio1': 'デフォルトタイプ',
  'studio.prj_prod.this_prod.edit_gamepreview_radio2': '動画背景タイプ',
  'studio.prj_prod.this_prod.edit_gamepreview_radio1_msg1': '商品ページの背景画像(選択)',
  'studio.prj_prod.this_prod.edit_gamepreview_radio2_msg1': '商品ページの背景動画',
  'studio.prj_prod.this_prod.edit_gamepreview_radio2_msg1_guide1': 'モバイル、PCウェブで商品ページの背景として表示されます。',
  'studio.prj_prod.this_prod.edit_gamepreview_radio2_required_n': '動画を登録してください。',
  'studio.prj_prod.this_prod.edit_gamepreview_radio2_msg2': '商品ページの背景画像(選択)',
  'studio.prj_prod.this_prod.edit_gamepreview_radio2_msg2_guide1': 'クライアントで商品ページの背景として表示されます。',
  'studio.prj_prod.this_prod.edit_gamepreview_msg6': '展示する動画および画像',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_btn': 'ファイル追加',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_link_btn': '動画リンク',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_video_file_btn': '動画ファイル',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_image_btn': '画像',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_video_link_title': '動画リンク ',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_video_link_place_holder': 'サムネイルを追加した後、動画のURLを入力してください。',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_video_file_title': '動画ファイル',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_image_title': '画像',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_btn_alert1': '動画または画像を登録してください。',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_btn_alert2': '動画のサムネイルを登録してください。',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_btn_alert3': '動画のURLを登録してください。',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_btn_alert4': 'URLは1から2,000文字の間で入力してください。',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_btn_alert5': '正しい URL 形式ではありません。',
  'studio.prj_prod.this_prod.edit_gamepreview_msg7': '1:1画像',
  'studio.prj_prod.this_prod.edit_gamepreview_msg7_1': '商品のタイトル画像に使用され、商品の順位ページなどにも表示されます。',
  'studio.prj_prod.this_prod.edit_gamepreview_1to1_info_hover_msg': '商品ページで表示された位置に表示されます。',
  'studio.prj_prod.this_prod.edit_gamepreview_msg7_attach_msg1': '画像を登録してください。',
  'studio.prj_prod.this_prod.edit_gamepreview_language_setting_btn': '言語ごとに登録',
  'studio.prj_prod.this_prod.edit_gamepreview_msg8': '16:9画像',
  'studio.prj_prod.this_prod.edit_gamepreview_msg8_1': '商品リスト、カート、ユーザープロフィールなどに表示されます。',
  'studio.prj_prod.this_prod.edit_gamepreview_msg8_attach_msg1': '画像を登録してください。',
  'studio.prj_prod.this_prod.edit_gamepreview_16to9_preview_btn': 'プレビュー',
  'studio.prj_prod.this_prod.edit_gamepreview_language_setting_guide':
    'ロゴが含まれている画像のため、言語によってロゴが異なる場合は言語ごとに登録できます。 ',
  'studio.ai_translation.base_lang_ko': '韓国語',
  'studio.ai_translation.base_lang_ch_cn': '中国語(簡体字)',
  'studio.ai_translation.base_lang_ch_tw': '中国語(繁体字)',
  'studio.prj_prod.this_prod.edit_title_bg_img': 'タイトルの背景画像(選択)',
  'studio.prj_prod.this_prod.edit_title_bg_img_guide': '1:1画像が目に留まるよう、背景に入れる画像を追加できます。',
  'studio.prj_prod.this_prod.edit_gamepreview_title_background_info_hover_msg': '商品ページで表示された位置に表示されます。',
  'studio.prj_prod.this_prod.edit_gamepreview_msg9': '一言紹介画像(選択)',
  'studio.prj_prod.this_prod.edit_gamepreview_msg9_1': 'PC環境の一言紹介文の上に表示される画像を追加できます。',
  'studio.prj_prod.this_prod.edit_gamepreview_headline_info_hover_msg': '商品ページで表示された位置に表示されます。',
  'studio.prj_prod.this_prod.edit_gamepreview_16to9_preview_title': '16:9画像の適用プレビュー',
  'studio.prj_prod.this_prod.edit_gamepreview_16to9_preview_msg1': '理解を深められるサンプル画像です。',
  'studio.prj_prod.this_prod.edit_gamepreview_16to9_preview_msg2': 'ストア商品リスト',
  'studio.prj_prod.this_prod.edit_gamepreview_16to9_preview_msg4': 'カート',
  'studio.prj_prod.this_prod.edit_texts': 'テキスト',
  'studio.prj_prod.this_prod.edit_texts_subtitle_title': '接頭タグ(選択)',
  'studio.prj_prod.this_prod.edit_texts_subtitle_guide': '任意で商品名の前に接頭タグを追加できます。商品名を補足できる内容にするのがおすすめです。',
  'studio.prj_prod.this_prod.edit_texts_subtitle_place_holder': '接頭タグを入力してください。',
  'studio.prj_prod.this_prod.edit_texts_headline_title': '一言紹介文',
  'studio.prj_prod.this_prod.edit_texts_headline_place_holder': '一言紹介を入力してください',
  'studio.prj_prod.this_prod.edit_texts_headline_alert1': '一言紹介を入力してください。',
  'studio.prj_prod.this_prod.edit_writing_guidance_btn': '作成ガイド',
  'studio.prj_prod.this_prod.edit_writing_guidance_info1': '一言紹介文は、検索エンジンで商品がうまく検索されるためにも使用されます。',
  'studio.prj_prod.this_prod.edit_writing_guidance_info2': 'このように書くのがおすすめです',
  'studio.prj_prod.this_prod.edit_writing_guidance_info3': '主なキーワードを含む',
  'studio.prj_prod.this_prod.edit_writing_guidance_info4': '商品の全体的な内容を要約する',
  'studio.prj_prod.this_prod.edit_writing_guidance_info5': '英語で160字以内、韓国語／日本語／中国語で80字以内',
  'studio.prj_prod.this_prod.edit_writing_guidance_info6': 'このような内容は避けましょう',
  'studio.prj_prod.this_prod.edit_writing_guidance_info7': 'キーワードを2回以上繰り返して使う',
  'studio.prj_prod.this_prod.edit_writing_guidance_info8': '商品と関係のないキーワードを含む',
  'studio.prj_prod.this_prod.edit_writing_guidance_info9': '商品名のみ入力する',
  'studio.prj_prod.this_prod.edit_summary_title': '商品説明(選択)',
  'studio.prj_prod.this_prod.edit_summary_title_full_btn': 'フルスクリーン表示',
  'studio.prj_prod.this_prod.edit_summary_place_holder1':
    'ゲームの商品説明にはこのような内容を入力することをおすすめします！<br/>理解を深められる画像があれば追加してみましょう。',
  'studio.prj_prod.this_prod.edit_summary_place_holder2': 'ユーザーのプレイのレビュー',
  'studio.prj_prod.this_prod.edit_summary_place_holder3': 'ゲームの魅力的なポイント',
  'studio.prj_prod.this_prod.edit_summary_place_holder4': 'キャラクター紹介',
  'studio.prj_prod.this_prod.edit_summary_place_holder5': 'ストーリー',
  'studio.prj_prod.this_prod.edit_summary_place_holder6': '操作方法',
  'studio.prj_prod.this_prod.edit_summary_place_holder7': '制作者のコメント',
  'studio.prj_prod.this_prod.edit_summary_info_hover_msg': 'フルスクリーンではダークモードで入力できます。',
  'studio.prj_prod.this_prod.edit_summary_attatch_msg1': 'マイコンピューター',
  'studio.prj_prod.this_prod.edit_summary_attatch_msg2': 'ストレージ',
  'studio.prj_prod.this_prod.edit_summary_fullscreen_exit_btn': 'フルスクリーン解除',
  'studio.prj_prod.this_prod.edit_summary_darkmode_btn': 'ダークモード',
  'studio.prj_prod.this_prod.edit_additional_info_title': '追加情報',
  'studio.prj_prod.this_prod.edit_additional_info_tags_title': 'タグ(選択)',
  'studio.prj_prod.this_prod.edit_additional_info_tags_guide':
    '登録したタグでユーザーが商品をフィルタリングして検索できます。<br/>タグは設定した順序で表示され、ドラッグすると順序を変更できます。',
  'studio.prj_prod.this_prod.edit_additional_info_tags_search_place_holder': 'タグを検索してください',
  'studio.prj_prod.this_prod.edit_additional_info_tags_search_no_msg': '検索結果がありません。 ',
  'studio.prj_prod.this_prod.edit_additional_info_tags_search_msg1': 'プラットフォームのポリシーにより、特定のタグが先に表示されることがあります。',
  'studio.prj_prod.this_prod.edit_additional_supporting_title': 'サポート機能(選択)',
  'studio.prj_prod.this_prod.edit_additional_supporting_languages_title': '商品内の対応言語',
  'studio.prj_prod.this_prod.edit_additional_supporting_languages_val_msg1': '1つ以上のサポート言語を選択してください。',
  'studio.prj_prod.this_prod.edit_additional_supporting_languages_msg1': 'インターフェース',
  'studio.prj_prod.this_prod.edit_additional_supporting_languages_msg2': '音声',
  'studio.prj_prod.this_prod.edit_additional_supporting_languages_msg3': '字幕',
  'studio.prj_prod.this_prod.edit_additional_requirements_title': '仕様',
  'studio.prj_prod.this_prod.edit_additional_requirements_add_btn': '仕様追加',
  'studio.prj_prod.this_prod.edit_additional_requirements_os_place_holder': '最低限の動作環境(必須)',
  'studio.prj_prod.this_prod.edit_additional_requirements_component': '項目',
  'studio.prj_prod.this_prod.edit_additional_requirements_component_min_place_holder': '最低限の動作環境(選択)',
  'studio.prj_prod.this_prod.edit_additional_requirements_component_recommended_place_holder': '推奨する動作環境(選択)',
  'studio.prj_prod.this_prod.edit_additional_requirements_toggle': '推奨する動作環境を入力',
  'studio.prj_prod.this_prod.edit_additional_requirements_os_val_msg': 'OSの項目を入力してください',
  'studio.prj_prod.this_prod.edit_additional_requirements_processor_val_msg': 'プロセッサの項目を入力してください',
  'studio.prj_prod.this_prod.edit_additional_requirements_memory_val_msg': 'メモリの項目を入力してください',
  'studio.prj_prod.this_prod.edit_additional_requirements_graphics_val_msg': 'グラフィックの項目を入力してください。',
  'studio.prj_prod.this_prod.edit_additional_requirements_directx_val_msg': 'DirectXの項目を入力してください',
  'studio.prj_prod.this_prod.edit_additional_requirements_storage_val_msg': 'ストレージの項目を入力してください',
  'studio.prj_prod.this_prod.edit_additional_requirements_sound_val_msg': 'サウンドの項目を入力してください',
  'studio.prj_prod.this_prod.edit_additional_links_title': '関連リンク(選択)',
  'studio.prj_prod.this_prod.edit_additional_links_add_btn': 'リンク追加',
  'studio.prj_prod.this_prod.edit_additional_links_name_place_holder': 'リンクのタイトル入力',
  'studio.prj_prod.this_prod.edit_additional_links_name_val_msg1': 'リンクのタイトルを入力してください。 ',
  'studio.prj_prod.this_prod.edit_additional_links_url_place_holder': 'URL入力',
  'studio.prj_prod.this_prod.edit_additional_links_url_val_msg1': '正しい URL 形式ではありません。 ',
  'studio.prj_prod.this_prod.edit_additional_awards_image_title': '受賞画像(選択)',
  'studio.prj_prod.this_prod.edit_additional_awards_image_add_btn': '受賞画像追加',
  'studio.prj_prod.this_prod.edit_additional_awards_image_val_msg1': '拡張子が異なるためアップロードできません。 ',
  'studio.prj_prod.this_prod.edit_additional_awards_image_val_msg2': 'ファイルの容量超過のためアップロードできません。',
  'studio.prj_prod.this_prod.edit_additional_awards_this_image_name': '画像',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_title': '画像編集',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_imagetype_subtitle': '16:9画像',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_msg1': 'ガイドを見る',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_info_tool_tip1':
    '画像が入るべき位置を確認してください。<br/><br/>メイン画像は赤線、ロゴは黄色い線の内側に入れる必要があります。<br/>ガイドの線は保存されません。',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_info_tool_tip2':
    '画像が入るべき位置を確認してください。<br/>メイン画像は赤線の内側に入れる必要があります。<br/>ガイドの線は保存されません。',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_msg2': 'ロゴ追加',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_local_btn': 'マイコンピューター',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_storage_btn': 'ストレージ',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_background_color_abbr': '背景色',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_background_color_full': '背景色',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_save_btn': '保存',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_save_storage_btn': 'ストレージ保存',
  'studio.prj_prod.this_proj.this_prod.status_header1': '状態',
  'studio.prj_prod.this_proj.this_prod.list_this_status_upcoming_msg': '適用予定',
  'studio.prj_prod.this_proj.this_prod.list_this_status_expired_msg': '終了',
  'studio.prj_prod.this_proj.this_prod.list_this_status_declined_msg': '審査リジェクト',
  'studio.prj_prod.this_proj.this_prod.list_this_status_active_msg': 'LIVE適用',
  'studio.prj_prod.this_proj.this_prod.list_this_status_suspend_msg': '展示中断',
  'studio.prj_prod.this_proj.this_prod.prod_page_name_header3': '商品ページ名',
  'studio.prj_prod.this_proj.this_prod.display_header2': '展示 ',
  'studio.prj_prod.this_proj.this_prod.registered_edited_date_header4': '登録日(編集日)',
  'studio.prj_prod.this_proj.this_prod.list_kebab_edit_page_name_btn': '商品ページ名修正',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_btn': 'コピー',
  'studio.prj_prod.this_proj.this_prod.list_kebab_delete_btn': '削除',
  'studio.prj_prod.this_proj.this_prod.list_kebab_display_n_btn': '展示中断',
  'studio.prj_prod.this_proj.this_prod.list_kebab_display_y_btn': '展示再開',
  'studio.prj_prod.this_proj.this_prod.release_period_header5': '期間',
  'studio.prj_prod.this_proj.this_prod.list_display_switch_pop1_msg': '展示再開',
  'studio.prj_prod.this_proj.this_prod.list_display_switch_pop1_msg1': '展示を開始するには「ON」を入力してください。 ',
  'studio.prj_prod.this_proj.this_prod.list_display_switch_pop1_display_y_btn': '展示再開',
  'studio.prj_prod.this_proj.this_prod.list_display_switch_pop2_msg': '展示中断',
  'studio.prj_prod.this_proj.this_prod.list_display_switch_pop2_msg1': '展示を中断するには「OFF」を入力してください。 ',
  'studio.prj_prod.this_proj.this_prod.list_display_switch_pop2_display_n_btn': '展示中断',
  'studio.prj_prod.this_proj.this_prod.list_this_status_in_review_msg': '審査中',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_title': '商品ページコピー',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_msg': 'この商品ページをコピーする位置をすべて選択してください。',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_prod_page_count_title': '全体',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_search_place_holder': '商品を検索してください。 ',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_duplicate_btn': 'コピー',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_product_header2': '商品',
  'studio.prj_prod.this_proj.this_prod.list_kebab_delete_x_msg': '適用状態が付与されているため、削除できません。',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_limit_exceed_msg': '一度に最大50個まで選択できます。',
  'studio.prj_prod.this_proj.this_prod.list_kebab_delete_pop_msg': '適用予定の商品ページを削除しますか？',
  'studio.prj_prod.this_proj.this_prod.list_kebab_delete_cf_btn': '削除',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_search_nmrf': '検索結果がありません。',
  'studio.prj_prod.this_prod.list_edit_edit_msg1': '商品ページ名を入力してください。 ',
  'studio.prj_prod.this_prod.list_edit_edit_msg2': '商品ページを区分するための名前で、ユーザーには表示されません',
  'studio.prj_prod.this_prod.list_edit_edit_page_name_input_place_holder': '商品ページ名を入力してください',
  'studio.prj_prod.this_prod.list_edit_edit_page_name_input_val_msg1': '商品ページ名を入力してください。 ',
  'studio.prj_prod.this_prod.edit_title': '商品ページ編集',
  'studio.prj_prod.this_prod.edit_page_not_status2_msg':
    '{releaseStatus}状態の商品ページです。編集ボタンを押すと、コピーされた商品ページを編集できます。 ',
  'studio.prj_prod.this_prod.edit_duplicate_btn': 'コピー',
  'studio.prj_prod.this_prod.edit.pop_declined_items_msg': 'リジェクト理由',
  'studio.prj_prod_mngmt.pg_title': 'プロジェクト・商品管理',
  'studio.prj_prod_mngmt.btn_prj_reg': 'プロジェクト登録',
  'studio.prj_prod_mngmt.prj_reg.breadcrumb1': 'プロジェクト・商品管理 ',
  'studio.prj_prod_mngmt.prj_reg.breadcrumb2': 'プロジェクトおよび商品の登録',
  'studio.prj_prod_mngmt.prj_reg.pg_title': 'プロジェクト登録',
  'studio.prj_prod_mngmt.prj_reg.prj_name': 'プロジェクト名',
  'studio.prj_prod_mngmt.prj_reg.prj_name_place_holder': 'プロジェクト名を入力してください',
  'studio.prj_prod_mngmt.prj_reg.prj_name_val_msg1': 'プロジェクト名を入力してください。 ',
  'studio.prj_prod_mngmt.prj_reg.prj_name_val_msg3': '同一の名前のプロジェクトがあります。<br/>別のプロジェクト名を入力してください。',
  'studio.prj_prod_mngmt.prj_reg.chkbox_add_prod': 'このプロジェクトの商品も一緒に登録する',
  'studio.prj_prod_mngmt.prj_reg.btn_reg': '登録',
  'studio.prj_prod_mngmt.prj_reg.prj_num_over100_val_msg1': 'プロジェクトは500個まで登録可能です。',
  'studio.prj_prod_mngmt.prj_reg.prj_num_over100_val_msg2': '既存のプロジェクトを削除してから登録してください。',
  'studio.prj_prod_mngmt.prj_reg.prj_guide1': 'プロジェクトとは何ですか？',
  'studio.prj_prod_mngmt.prj_reg.prj_guide2':
    'プロジェクトを作成後、その中で色々な商品を作ることができます。<br/>プロジェクト単位で契約と精算が行われます。',
  'studio.prj_prod_mngmt.prj_reg.prod_name': '商品名',
  'studio.prj_prod_mngmt.prj_reg.prod_name_place_holder': '商品名を入力してください',
  'studio.prj_prod_mngmt.prj_reg.prod_name_val_msg1': '商品名を入力してください。',
  'studio.prj_prod_mngmt.prj_reg.prod_name_val_msg3': '同一の商品名があります。別の商品名を入力してください。',
  'studio.prj_prod_mngmt.prj_reg.prod_type': '商品タイプ',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide': '商品タイプは登録後に変更できないため、慎重に選択してください。',
  'studio.prj_prod_mngmt.prj_reg.dropbox_prod_type': '商品タイプを選択してください',
  'studio.prj_prod_mngmt.prj_reg.prod_type_val_msg': '商品タイプを選択してください。',
  'studio.prj_prod_mngmt.prj_reg.prod_guide1': '商品とは何ですか？',
  'studio.prj_prod_mngmt.prj_reg.prod_guide2': '商品はStoreで販売するGame／Utilityを意味します。<br/>商品ごとにStoreの商品ページを作成できます。',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide1': '商品タイプとは何ですか？',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide2': '商品タイプによってアップロード可能なファイルが異なります。 ',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide3': 'ゲームに関連するビルドをアップロード可能',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide4': '画像、サウンド、映像などをアップロード可能',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide5': 'ゲーム制作エンジンあるいはツールをアップロード可能',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide6': 'DEMO、DLCは商品登録後に「商品設定」メニューで連携して設定できます。',
  'studio.prj_prod_mngmt.prj_reg.prod_num_over1000_val_msg1': '商品は1,000個まで登録できます。',
  'studio.prj_prod_mngmt.prj_reg.prod_num_over1000_val_msg2': '既存の商品を削除してから登録してください。',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_list': 'プロジェクト',
  'studio.prj_prod_mngmt.prj_prod_reg_done.btn_prj_list_collapse': 'すべて閉じる',
  'studio.prj_prod_mngmt.prj_prod_reg_done.btn_prj_list_expand': 'すべて開く',
  'studio.prj_prod_mngmt.prj_prod_reg_done.srch_place_holder': 'プロジェクト名・商品名を検索',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_list_sort': 'プロジェクト',
  'studio.prj_prod_mngmt.post_prj_reg.prod_num_sort': '商品数',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_file': 'プロジェクトファイル ',
  'studio.prj_prod_mngmt.prj_prod_reg_done.create_date': '生成日',
  'studio.prj_prod_mngmt.prj_prod_reg_done.btn_prj_reg': 'プロジェクト登録',
  'studio.prj_prod_mngmt.prj_prod_reg_done.btn_prod_reg': '商品登録 ',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_breadcrumb1': 'プロジェクト・商品管理',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_title': '商品登録',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_name': '商品名',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_name_place_holder': '商品名を入力してください',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_name_val_msg1': '商品名を入力してください。',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_name_val_msg2': '同一の商品名があります。別の商品名を入力してください。',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type': '商品タイプ',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide': '商品タイプは登録後に変更できないため、慎重に選択してください。',
  'studio.prj_prod_mngmt.post_prj_reg.dropbox_prod_reg_type': '商品タイプを選択してください',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_game': 'Game',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_contents': 'Content',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_utility': 'Utility',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_val_msg': '商品タイプを選択してください。',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_guide1': '商品とは何ですか？',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_guide2':
    '商品はStoreで販売するGame／Utilityを意味します。<br/>商品ごとにStoreの商品ページを作成できます。',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide1': '商品タイプとは何ですか？',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide2': '商品タイプによってアップロード可能なファイルが異なります。 ',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide3': 'ゲームに関連するビルドをアップロード可能',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide4': '画像、サウンド、映像などをアップロード可能',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide5': 'ゲーム制作エンジンあるいはツールをアップロード可能',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide6': 'DEMO、DLCは商品登録後に「商品設定」メニューで連携して設定できます。',
  'studio.prj_prod_mngmt.post_prj_reg.btn_prod_reg_cf': '登録',
  'studio.prj_prod_mngmt.post_prj_reg.prod_num_over1000_val_msg1': '商品は1,000個まで登録できます。',
  'studio.prj_prod_mngmt.post_prj_reg.prod_num_over1000_val_msg2': '既存の商品を削除してから登録してください。',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_list': '商品',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_sort': '商品',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_type_sort': '商品タイプ',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_release_status': '状態 ',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_price': '販売価格 ',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_discount_rate': '割引率',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_create_date': '生成日 ',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_discount_price': '割引価格',
  'studio.prj_prod_mngmt.prj_prod_list.discount_rate_by_currency': '(通貨ごとの設定)',
  'studio.prj_prod_mngmt.prj_prod_list.discount_price_by_currency': '(通貨ごとの設定)',
  'studio.prj_prod_mngmt.prj_prod_list.price_by_currency_guide': '通貨ごとの設定',
  'studio.prj_prod_mngmt.srch_no_result': '検索結果がありません。',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.title': '商品の大量登録',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.prod_num': '登録個数',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.guide1':
    '商品の大量登録は最大50個まで生成可能で、商品名を基準に任意のナンバリングが自動で追加されて登録されます。',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.guide2':
    '商品を大量に登録する際は同じ商品タイプで登録され、登録後は修正できないため、同じ商品タイプの分だけ登録を行ってください。',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.prod_num_input_place_holder': '商品の登録個数を入力してください',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.prod_num_input_val_msg': '商品の登録個数を入力してください。 ',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.prod_num_input_val_msg2': '商品の登録個数は2個以上50個まで入力できます。',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_title': '{prjName}大量登録',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_guide1':
    '商品を大量登録する際、商品名は任意でナンバリングされて生成されます。商品名は直接修正できます。',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_guide2':
    '商品タイプは登録後に変更できないため、慎重に選択してください。大量登録の場合、生成されるまで約1分かかることがあります。',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_prod_name': '商品名',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_prod_type': '商品タイプ',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_prod_name_place_holder': '商品名を入力してください',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_dup_name_val_msg': '同一の商品名があります。別の商品名を入力してください。',
  'email.prj_reg.completed.title': 'メールタイトル：[STOVE Studio] {prjName}プロジェクト登録完了',
  'email.prj_reg.completed.msg1': 'プロジェクト登録完了',
  'email.prj_reg.completed.msg2': 'プロジェクトの登録が完了しました。Studioで商品まで登録を行うと、商品のホームが作られます。',
  'email.prj_reg.completed.msg3': '商品のホームで商品ページを登録し、ビルドをアップロードしてリリースしてみましょう。',
  'email.completed.info_grp_name': 'グループ名',
  'email.completed.info_prj_name': 'プロジェクト名',
  'email.completed.grp_home_dir_btn': 'Studioグループのホームに移動する',
  'email.prj_del.completed.title': 'メールタイトル：[STOVE Studio] {prjName}プロジェクト削除完了',
  'email.prj_del.completed.msg1': 'プロジェクト削除完了',
  'email.prj_del.completed.msg2': 'プロジェクトが削除されました。削除されたプロジェクトの情報は復旧できません。',
  'email.prj_del.completed.msg3': 'プロジェクトやゲーム連携情報、ビルド情報などは照会できません。また、メンバーの権限はすべてリセットされます。',
  'studio.prj_prod_mngmt.btn_prj_edit': 'プロジェクト名修正',
  'studio.prj_prod_mngmt.btn_prj_del': '削除',
  'studio.prj_prod_mngmt.prj_edit_guide1': 'プロジェクト名を入力してください。 ',
  'studio.prj_prod_mngmt.prj_edit_guide2': 'Studioで複数の商品をまとめて管理する用途で使用され、いつでも修正できます。',
  'studio.prj_prod_mngmt.prj_edit_name_place_holder': 'プロジェクト名を入力してください',
  'studio.prj_prod_mngmt.prj_edit_name_val_msg1': 'プロジェクト名を入力してください。 ',
  'studio.prj_prod_mngmt.prj_edit_name_val_msg3': '同一の名前のプロジェクトがあります。<br/>別のプロジェクト名を入力してください。',
  'studio.prj_prod_mngmt.prj_edit_name_cf': '保存',
  'studio.prj_prod_mngmt.popup_prj_del_guide1': 'プロジェクト削除',
  'studio.prj_prod_mngmt.popup_prj_del_guide2':
    'プロジェクト内の全商品とストレージも一緒に削除されます。<br/>削除する場合は「DELETE」を入力してください。<br/>削除後は復旧できません。',
  'studio.prj_prod_mngmt.kebap_suspend_sale': '販売中断',
  'studio.prj_prod_mngmt.kebap_del_request': '削除リクエスト',
  'studio.prj_prod_mngmt.del_req_x_included_in_collection_guide1': 'コレクションに含まれる商品がありません。',
  'studio.prj_prod_mngmt.del_req_x_included_in_collection_guide2': 'コレクション構成リストから該当の商品を削除して、再度お試しください。',
  'studio.prj_prod_mngmt.del_req_x_on_sale_guide1': '商品がまだ販売中です。',
  'studio.prj_prod_mngmt.popup_suspend_sale_title': '販売中断',
  'studio.prj_prod_mngmt.popup_suspend_cf_btn': '中断',
  'studio.prj_prod_mngmt.popup_restart_sale_title': '販売再開',
  'studio.prj_prod_mngmt.popup_restart_sale_guide': '販売を再開するには「START」を入力してください。 ',
  'studio.prj_prod_mngmt.popup_restart_cf_btn': '再開',
  'studio.prod_list.kebap_del_request_popup_title': '削除リクエスト',
  'studio.prod_list.kebap_del_request_popup_msg':
    '削除をリクエストするには「DELETE」を入力してください。STOVE運営者の承認(2～3日所要)後に削除され、削除後は復旧できなくなります。',
  'studio.prj_prod_mngmt.popup_prod_del_cf_btn': '削除',
  'studio.prj_prod_mngmt.popup_prod_del_req_completed_msg': '削除のリクエストが完了しました。',
  'studio.prj_prod_mngmt.prod_del_req_stt': '削除リクエスト',
  'studio.prj_prod_mngmt.cancel_prod_del_req_btn': '削除リクエストのキャンセル',
  'studio.prj_prod_mngmt.popup_prod_del_req_cancelled_msg': '削除のリクエストがキャンセルされました。',
  'studio.prj_prod_mngmt.kebap_prod_pg_open_suspend_btn': 'オープン中断',
  'studio.prj_prod_mngmt.kebap_del_req_btn': '削除リクエスト',
  'studio.prj_prod_mngmt.del_req_x_prod_pg_open_guide1': '商品ページがオープンしています。',
  'studio.prj_prod_mngmt.del_req_x_prod_pg_open_guide2': 'オープンを中断して削除をリクエストしてください。',
  'studio.prj_prod_mngmt.popup_prod_pg_open_suspend_title': '商品ページオープン中断',
  'studio.prj_prod_mngmt.popup_prod_pg_open_suspend_guide': '商品ページのオープンを中断するには「SUSPEND」を入力してください。 ',
  'studio.prj_prod_mngmt.kebap_prod_pg_open_resume_btn': 'オープン再開',
  'studio.prj_prod_mngmt.del_req_completed_msg': '削除のリクエストが完了しました。',
  'studio.prj_prod_mngmt.kebap_del_req_cancel_btn': '削除リクエストのキャンセル',
  'studio.prj_prod_mngmt.kebap_del_req_cancelled_msg': '削除のリクエストがキャンセルされました。',
  'studio.prj_prod_mngmt.kebap_unreleased_prod_del_btn': '削除',
  'studio.prj_prod_mngmt.popup_unreleased_prod_del_title': '商品削除',
  'studio.prj_prod_mngmt.popup_unreleased_prod_del_guide1': '削除するには「DELETE」を入力してください。 ',
  'studio.prj_prod_mngmt.popup_unreleased_prod_del_guide2': '削除すると復旧できなくなります。',
  'studio.prj_prod_mngmt.popup_prod_pg_reopen_title': '商品ページ再オープン',
  'studio.prj_prod_mngmt.popup_prod_pg_reopen_guide': '商品ページをもう一度オープンするには「ON」を入力してください。 ',
  'studio.prj_prod_mngmt.noti_release_del_completed_msg':
    '{prodName}リリースの削除が完了しました。<br/>削除された商品の情報は元に戻せません。また、STOVEの運営ポリシーに従って、削除された商品の販売履歴と決済情報が保存されます。  ',
  'studio.prj_prod_mngmt.del_req_rejected_tooltip':
    "削除リクエストが却下されました。運営チームとの事前協議後に削除が可能です。<br/>協議をご希望の場合は、メール(stoveindie{'@'}smilegate.com)までお問い合わせください。",
  'studio.prj_prod_mngmt.display_restricted_case_user_report': '展示ペナルティ(ユーザー通報)',
  'studio.prj_prod_mngmt.display_restricted_case_operator_set': '展示ペナルティ(運営者)',
  'studio.prj_prod_mngmt.purchase_restricted_case': '購入ペナルティ',
  'studio.mail.case_prod_del_request_title': '商品削除のリクエスト',
  'studio.mail.case_prod_del_request_msg1': '商品削除のリクエストが完了しました。',
  'studio.mail.case_prod_del_request_msg2': 'STOVE運営者の承認まで1～3日が所要されます。また、削除された情報は元に戻せません。',
  'studio.mail.case_prod_del_request_msg3': 'STOVEの運営ポリシーに基づき、削除された商品の販売履歴と決済情報は保存されます。',
  'studio.mail.this_release_info_1_grp_name': 'グループ名：',
  'studio.mail.this_release_info_2_prj_name': 'プロジェクト名：',
  'studio.mail.this_release_info_3_prod_pg': '商品ページ：',
  'studio.mail.prod_home_dir_btn': 'Studio商品のホームに移動する',
  'studio.prj_prod.release_info_del_completed': '商品削除完了',
  'studio.mail.this_release_info_del_completed_detail_msg1': 'リリース情報の削除が完了しました。削除されたリリース情報は復旧できません。 ',
  'studio.mail.this_release_info_del_completed_detail_msg2': 'STOVEの運営ポリシーに従って、削除された商品の販売履歴と決済情報が保存されます。',
  'studio.mail.grp_home_dir_btn': 'Studioグループのホームに移動する',
  'studio.prj_prod.release_info_del_rejected': '商品削除リクエストのリジェクト',
  'studio.mail.this_release_info_del_rejected_detail_msg1': 'STOVE運営者の審査が完了しました。',
  'studio.mail.this_release_info_del_rejected_detail_msg2': 'リリースの削除リクエストがリジェクトされました。',
  'studio.mail.this_release_info_del_rejected_detail_msg3':
    "リリース後、お客様の購入履歴がある商品は商品販売中断の告知、精算および契約の撤回過程などを事前に協議した後に削除できます。協議をするには下記のEメールアドレスにお問い合わせください。<br/>stoveindie{'@'}smilegate.com",
  'studio.prj_prod_mngmt.btn_storage': 'ストレージ',
  'studio.prj_prod_mngmt.storage_intro_guide':
    'プロジェクト単位で管理するストレージです。<br/>商品の画像、動画などのリソースをあらかじめアップロードして商品ページを整えたり、画像を登録したりする際に使用してください。',
  'studio.prj_prod_mngmt.storage.title': '{prjName}ストレージ',
  'studio.prj_prod_mngmt.storage_no_folder_file.guide1':
    'ドラッグ&ドロップするか、ファイルアップロードボタンをクリックしてください。<br/>一度に最大10個までアップロードできます。',
  'studio.prj_prod_mngmt.storage_no_folder_file.guide2': 'アップロード可能なファイル：JPG, PNG, GIF, WEBP, ICO, MP4',
  'studio.prj_prod_mngmt.storage_no_folder_file.create_folder_btn': '新しいフォルダ',
  'studio.prj_prod_mngmt.storage_no_folder_file.create_folder_title': 'フォルダ作成',
  'studio.prj_prod_mngmt.storage_no_folder_file.create_folder_place_holder': 'フォルダ名を入力してください',
  'studio.prj_prod_mngmt.storage_no_folder_file.create_folder_cf_btn': '作成',
  'studio.prj_prod_mngmt.storage_no_folder_file.create_folder_val_msg1': 'フォルダ名を入力してください。',
  'studio.prj_prod_mngmt.storage_no_folder_file.create_folder_val_msg2': 'すでに同一のフォルダ名があります。別のフォルダ名を入力してください。',
  'studio.prj_prod_mngmt.storage_only_folder.title': 'フォルダ',
  'studio.prj_prod_mngmt.storage_only_folder.btn_edit_folder_name': 'フォルダ名修正',
  'studio.prj_prod_mngmt.storage_only_folder.btn_del_folder': '削除',
  'studio.prj_prod_mngmt.storage_only_folder.edit_folder_name_title': 'フォルダ名修正',
  'studio.prj_prod_mngmt.storage_only_folder.btn_edit_folder_name_cf': '修正',
  'studio.prj_prod_mngmt.storage_only_folder.del_folder_popup_msg':
    '選択したフォルダを削除しますか？<br/>フォルダを削除するとフォルダ内のファイルもすべて削除され、削除後は復元できません。',
  'studio.prj_prod_mngmt.storage_only_folder.btn_del_folder_cf': '削除',
  'studio.prj_prod_mngmt.storage_upload_method1.btn_upload': 'ファイルのアップロード',
  'studio.prj_prod_mngmt.storage_upload_method1.btn_open': '開く',
  'studio.prj_prod_mngmt.storage_upload_method1.file_num_over10_msg': '一度に10個まで選択してアップロードできます。',
  'studio.prj_prod_mngmt.storage_upload_method1.wrong_format_msg1':
    'サポートされていないファイル形式です。<br/>インベントリでサポートされているファイルを確認してからアップロードしてください。',
  'studio.prj_prod_mngmt.storage_upload_method1.wrong_format_msg2': 'サポートされているファイル',
  'studio.prj_prod_mngmt.storage_upload_method1.wrong_format_msg3': 'JPG, PNG, GIF, WEBP, ICO, MP4',
  'studio.prj_prod_mngmt.storage_upload_method1.storage_exceed_msg':
    'ストレージの容量よりもファイルのサイズが大きい状態です。<br/>既存のファイルを削除するか、別のファイルをアップロードしてください。',
  'studio.prj_prod_mngmt.storage_upload_method1.uploading_msg': 'ファイルをインベントリにアップロード中です。<br/>しばらくお待ちください。',
  'studio.prj_prod_mngmt.storage_upload_method1.upload_cancel_msg': 'アップロードがキャンセルされました。',
  'studio.prj_prod_mngmt.storage_upload_method1.upload_done_msg': '{fileNum}個のファイルがアップロードされました。',
  'studio.prj_prod_mngmt.storage_upload_method1.upload_failed_msg': 'ファイルのアップロードに失敗しました。<br/>再度お試しください。',
  'studio.prj_prod_mngmt.storage_upload_method1.upload_damaged_msg': 'ファイルが壊れています。<br/>ファイルを確認してからアップロードしてください。',
  'studio.prj_prod_mngmt.storage_upload_method1.upload_limit_msg':
    '100MB以下のファイルのみアップロードできます。<br/>容量を確認してからアップロードしてください。 ',
  'studio.prj_prod_mngmt.storage_upload.file_drop_guide': 'ファイルをここにドロップしてください。 ',
  'studio.prj_prod_mngmt.storage_upload_done.file_title': 'ファイル',
  'studio.prj_prod_mngmt.storage_upload_done.file_info1': 'サイズ',
  'studio.prj_prod_mngmt.storage_upload_done.file_info2': '大きさ：',
  'studio.prj_prod_mngmt.storage_upload_done.btn_move_to_folder': 'フォルダ移動',
  'studio.prj_prod_mngmt.storage_upload_done.btn_download': 'オリジナルダウンロード',
  'studio.prj_prod_mngmt.storage_upload_done.btn_del': '削除',
  'studio.prj_prod_mngmt.storage_upload_done.popup_del_msg':
    '選択した{fileNum}個のファイルをすべて削除します。よろしいですか？<br/>削除後は復元できません。',
  'studio.prj_prod_mngmt.storage_upload_done.del_completed_msg': 'ファイルが削除されました。',
  'studio.prj_prod_mngmt.storage_upload_done.popup_move_to_folder_title': 'フォルダ移動',
  'studio.prj_prod_mngmt.storage_upload_done.storage_folder': 'ストレージ',
  'studio.prj_prod_mngmt.storage_upload_done.btn_move': '移動',
  'studio.prj_prod_mngmt.storage_upload_done.move_completed_msg': 'ファイルを移動しました。',
  'studio.prj_prod_mngmt.storage_multiple_select.del_all_msg': '選択した{fileNum}個のファイルをすべて削除しますか？<br/>削除後は復元できません。',
  'studio.prj_prod_mngmt.storage_multiple_select.del_btn': '削除',
  'studio.prj_prod_mngmt.storage_multiple_select.del_all_done_msg': '{fileNum}個のファイルが削除されました。',
  'studio.prj_prod_mngmt.storage_srch_result.srchbar_place_holder': '{folderName}検索',
  'studio.prj_prod_mngmt.storage_srch_result.no_result_msg1': '{searchValue}の検索結果がありません。',
  'studio.prj_prod_mngmt.storage_srch_result.no_result_msg2': '別のキーワードで検索してみましょう。',
  'studio.prj_prod_mngmt.storage_srch_sorting_value1': '新しい順',
  'studio.prj_prod_mngmt.storage_srch_sorting_value2': '古い順',
  'studio.prj_prod_mngmt.storage_srch_sorting_value3': '昇順',
  'studio.prj_prod_mngmt.storage_srch_sorting_value4': '降順',
  'studio.prj_prod_mngmt.storage_folder_selected.no_file_msg': 'このフォルダは空です。',
  'studio.prj_prod_mngmt.storage_srch_in_folder.no_result_msg1': '{searchValue}の検索結果がありません。',
  'studio.prj_prod_mngmt.storage_srch_in_folder.no_result_msg2': '別のキーワードで検索してみましょう。',
  'studio.prj_prod_mngmt.storage_select_attachment.no_folder_file.subtitle': '添付ファイル選択',
  'studio.prj_prod_mngmt.storage_select_attachment.no_folder_file.guide':
    'ストレージに追加されたファイルがありません。<br><em class="font-medium text-on-surface-elevation-2">プロジェクト管理&gt;ストレージ</em>ファイルを追加できます。',
  'studio.prj_prod_mngmt.storage_select_attachment.no_folder_file.btn_go_to_prj_mngmt': 'プロジェクト管理ページに移動する',
  'studio.prj_prod_mngmt.storage_select_attachment.no_folder_file.btn_upload_file': '選択したファイルを登録',
  'studio.prj_prod_mngmt.storage_select_attachment.no_folder_file.title': '{prjName}ストレージ',
  'studio.prj_prod_mngmt.prod_home.prod_terms.pg_title': '商品規約',
  'studio.prj_prod_mngmt.prod_home.prod_terms.guide_1':
    '商品のリリース時に必要な規約を作成できます。<br/>EULAの規約はSTOVE PCクライアントでゲームをインストールする際に表示されます。<br/>サービス利用規約はゲーム内ショップを利用したり、オンラインサービスをサポートしたりしている場合に必要になる場合があります。',
  'studio.prj_prod_mngmt.prod_home.prod_terms.guide_2': '起動オプションで「モバイル」のみを選択したユーザーは規約を設定する必要がありません。',
  'studio.prj_prod_mngmt.prod_home.prod_terms.sample1': '基本(クライアント)表示<br/>ソフトウェアのユーザー同意規約(EULA)',
  'studio.prj_prod_mngmt.prod_home.prod_terms.sample2': 'ゲーム内表示<br/>サービス利用規約',
  'studio.prj_prod_mngmt.prod_home.prod_terms.create_btn': '登録',
  'studio.prj_prod_mngmt.prod_home.create_term.pg_title': '規約登録',
  'studio.prj_prod_mngmt.prod_home.create_term.select_type': '規約の種類選択 ',
  'studio.prj_prod_mngmt.prod_home.create_term.select_type_guide': '生成する規約の種類を選択できます。選択した種類によって入力項目が変わります。',
  'studio.prj_prod_mngmt.prod_home.create_term.select_type_dropbox': '選択してください',
  'studio.prj_prod_mngmt.prod_home.create_term.select_type_required_msg': '規約の種類を選択してください。',
  'studio.prj_prod_mngmt.prod_home.create_term.title': '規約登録',
  'studio.prj_prod_mngmt.prod_home.create_term.overall_guide': '規約の種類にはどのようなものがありますか？',
  'studio.prj_prod_mngmt.prod_home.create_term.overall_guide_content':
    '規約の種類はユーザーに商品をリリースする前、使用する機能に応じて様々な種類のものを作成できます。',
  'studio.prj_prod_mngmt.prod_home.create_term.type1_guide': 'エンドユーザー使用許諾契約書(EULA)',
  'studio.prj_prod_mngmt.prod_home.create_term.type1_guide_1':
    'インストールが必要なゲームあるいはソフトウェアの場合、ユーザーに規約の内容を提示して同意を得たうえでインストールできるようになります。',
  'studio.prj_prod_mngmt.prod_home.create_term.type2_guide': 'サービス利用規約',
  'studio.prj_prod_mngmt.prod_home.create_term.type2_guide_1':
    'パッケージゲームあるいはゲーム内決済をサポートしていない場合、必須作成の対象ではありません。自社のサービスの利用規約について同意を得たいときに作成されます。',
  'studio.prj_prod_mngmt.prod_home.create_term.type3_guide': '決済前の注意事項',
  'studio.prj_prod_mngmt.prod_home.create_term.type3_guide_1':
    'STOVEのゲームキャッシュチャージサービスを利用するときに使用されます。ゲームキャッシュのチャージを行う際に決済ウィンドウで案内する内容を作成できます。',
  'studio.prj_prod_mngmt.prod_home.create_term.type4_guide': '第三者への情報提供に同意',
  'studio.prj_prod_mngmt.prod_home.create_term.type4_guide_1':
    'ユーザーの情報についてゲーム内で提供を受け、STOVE以外の第三者に提供する必要がある際に使用されます。',
  'studio.prj_prod_mngmt.prod_home.create_term.type5_guide': 'ゲーム利用における保護者同意',
  'studio.prj_prod_mngmt.prod_home.create_term.type5_guide_1':
    'パッケージゲームあるいはゲーム内決済をサポートしていない場合、必須作成の対象ではありません。',
  'studio.prj_prod_mngmt.prod_home.create_term.type5_guide_2':
    '満18歳未満の青少年がゲームを利用する際に保護者の同意を得る必要があるときに必要な内容を表示できます。',
  'studio.prj_prod_mngmt.prod_home.create_term.type6_guide': '保護者の個人情報収集の同意',
  'studio.prj_prod_mngmt.prod_home.create_term.type6_guide_1':
    'パッケージゲームあるいはゲーム内決済をサポートしていない場合、必須作成の対象ではありません。',
  'studio.prj_prod_mngmt.prod_home.create_term.type6_guide_2':
    '未成年がゲーム内で決済する際に保護者の同意を得る必要があるときに必要な内容を表示できます。',
  'studio.prj_prod_mngmt.prod_home.create_term.type7_guide': '個人情報の収集および利用の同意',
  'studio.prj_prod_mngmt.prod_home.create_term.type7_guide_1':
    'ユーザーの情報についてゲーム内で提供を受け、ユーザーに対してイベントプロモーションの内容を案内する際に使用されます。',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_duplicate_popup':
    'すでに登録が完了した規約です。<br/>規約の内容を修正するには、リストから該当の規約を照会してください。',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_eula': 'エンドユーザー使用許諾契約書(EULA)',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_usage': 'サービス利用規約',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_pre_payment_caution': '決済前の注意事項',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_3rd_party': '第三者への情報提供に同意',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_guardian': 'ゲーム利用に関する保護者の同意',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_guardian_info': '保護者の個人情報収集の同意',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_personal_info': '個人情報の収集および利用の同意',
  'studio.prj_prod_mngmt.prod_home.create_term.term_name': '規約管理名',
  'studio.prj_prod_mngmt.prod_home.create_term.term_name_guide': '入力した規約管理名は自分が見るための用途であり、ユーザーには表示されません。',
  'studio.prj_prod_mngmt.prod_home.create_term.term_name_place_holder': '規約管理名を入力してください',
  'studio.prj_prod_mngmt.prod_home.create_term.term_content_title': '規約内容 ',
  'studio.prj_prod_mngmt.prod_home.create_term.term_content_guide':
    'リリースされた規約の内容を修正する場合、新しいバージョンの規約として作成されます。リリース前は保存のみ行ってください！',
  'studio.prj_prod_mngmt.prod_home.create_term.eula_content_sample':
    '本文書は法的効力があり、エンドユーザーと{businessName}(以下「会社」)の間に提供されるソフトウェアの起動ファイルまたはインストールファイル(以下「製品」)、インストールガイド、ユーザーガイドなどのすべての文書(以下「文書」)の権利および義務を定義するものです。<br/>「製品」をダウンロード、インストール、コピー、アクセスすることは本契約条項に同意したことを意味し、すべての契約内容を熟知し、すべての条件を理解していることを意味します。<br/>本契約条件に同意できない場合は「製品」をダウンロード、インストール、コピー、アクセスおよび使用を行わないでください。すでにインストールされている「製品」を削除し、ダウンロードした「製品」および「文書」をすぐに破棄しなければなりません。「製品」を購入した場合は、払い戻しのポリシーに従ってライセンス証明書を返却し、支払った金額の払い戻しを受けてください。',
  'studio.prj_prod_mngmt.prod_home.create_term.term_version_select': '読み込む',
  'studio.prj_prod_mngmt.prod_home.create_term.btn_multi_lang_setting': '多言語設定',
  'studio.prj_prod_mngmt.prod_home.create_term.btn_input_fullscr': 'フルスクリーン',
  'studio.prj_prod_mngmt.prod_home.create_term.btn_create': '登録',
  'studio.prj_prod_mngmt.prod_home.create_term.btn_exit_fullscr': 'フルスクリーン解除',
  'studio.prj_prod_mngmt.prod_home.prod_terms.release_applied_term_ver': 'リリース適用バージョン',
  'studio.prj_prod_mngmt.prod_home.prod_terms.release_applied_term_name': '規約管理名',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_type': '規約の種類',
  'studio.prj_prod_mngmt.prod_home.prod_terms.release_applied_term_apply_date': '規約施行日',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_ver': 'バージョン',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_name': '規約管理名',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_create_date': '生成日',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_apply_date': '規約施行日',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_del_btn': '削除',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_del_guide': '商品規約削除',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_del_guide1': '削除するには「DELETE」を入力してください。<br/>削除した後は復元できません。 ',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_del_cf_btn': '削除',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.pg_title': '規約の詳細',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_name': '規約管理名',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_name_guide': '入力した規約管理名は自分が見るための用途であり、ユーザーには表示されません。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_name_place_holder': '規約管理名を入力してください',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_content_title': '規約内容 ',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_content_edit_guide':
    'リリースされた規約の内容を修正する場合、新しいバージョンの規約として作成されます。リリース前は保存のみ行ってください！',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_eula_content_place_holder':
    '本文書は法的効力があり、エンドユーザーと{businessName}(以下「会社」)の間に提供されるソフトウェアの起動ファイルまたはインストールファイル(以下「製品」)、インストールガイド、ユーザーガイドなどのすべての文書(以下「文書」)の権利および義務を定義するものです。<br/>「製品」をダウンロード、インストール、コピー、アクセスすることは本契約条項に同意したことを意味し、すべての契約内容を熟知し、すべての条件を理解していることを意味します。<br/>本契約条件に同意できない場合は、「本製品」のダウンロード、インストール、複製、アクセスおよび使用を行わないでください。すでにインストールされている「本製品」を削除し、ダウンロードした「本製品」および「文書」を直ちに破棄してください。「製品」を購入した場合は、払い戻しのポリシーに従ってライセンス証明書を返却し、支払った金額の払い戻し手続きを行ってください。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_version_select': '読み込む',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date': '規約施行日',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date_guide':
    '規約の施行日時を定めることができます。まだ施行日時を定めていない場合、予約機能で任意の日付を指定してください。 ',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date_immediate': '即時',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date_select_time': '予約',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_case_1': 'すでに適用中の規約があります。<br/>新しい規約を今すぐ適用しますか？',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_case_2': '作成した規約を今すぐ適用します。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date_sel_guide':
    '施行日時は未来の日付のみ設定可能です。<br/>施行日時を再度確認してください。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_sched_guide': 'すでに適用中の規約があります。<br/>新しい規約の適用を予約しますか？',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date_change_x': '適用中の規約の日時の予約を変更できます。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_saved_popup': '保存が完了しました。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.save_as_new_ver_popup_msg':
    'リリース履歴のある規約新しいバージョンを登録することで改訂が可能になります。<br/>作成した内容を新しいバージョンとして登録しますか？',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.save_as_new_ver_cf_btn': '登録',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.saved_as_new_ver_cf_msg': '新しいバージョンの登録が完了しました。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.view_mode_term_name': '規約管理名',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.view_mode_term_content': '規約内容 ',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.view_mode_term_apply_date': '規約施行日',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_app_suspend_btn': '中断',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_app_suspend_guide_title': '規約の中断',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_app_suspend_guide':
    '中断するには「SUSPEND」を入力してください。<br/>中断した後は復元できません。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_app_suspend_cf_btn': '中断',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_none_guide':
    'ゲームがゲーム内ショップをサポートしている場合、サービス利用規約の登録を必須で行ってください。',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_content_place_holder':
    'サンプル内容は右側のガイドの「公正取引委員会標準規約」を参考に入力してください',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_guide': 'サービス利用規約',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_guide_1':
    'サービス利用規約はSTOVEおよびStudioの利用規約とは無関係であり、ユーザーとデベロッパーの間に発生する紛争についていかなる責任も負いません。',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_guide_2':
    '内容の作成が難しい場合、下記のリンクからゲームごとの特記事項を反映してサービス利用規約を作成してください。',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_guide_standard_ref': '公正取引協議会標準規約＞ ',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_guide_3':
    '*デベロッパーはサービス利用規約の変更内容を消費者に対して一般的には7日前、中断や不利になる場合は30日前に告知することが必要であるとされています。',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_guide_preview': 'サンプル画像)',
  'studio.prj_prod_mngmt.prod_home.create_term.pre_payment_caution_content_sample':
    '提供者：{businessName}<br/>決済したcashはID(アカウント)に支給され、決済後すぐに使用できます。<br/>チャージしたキャッシュの有効期限は最終利用日から5年です。<br/>使用していないキャッシュはチャージした日から7日以内は払い戻しが可能で、決済に使用した手段で払い戻されます。ただし、決済のキャンセルが不可能な決済手段や決済のキャンセル可能期限を超過した場合は、お客様の口座に払い戻されます。<br/>誓約撤回および払い戻しに関連する詳細は有料サービスの規約を参照してください。<br/>キャッシュの支給を受けて利用するためにはインターネットへの接続が必要です。Internet Explorer11、Chromeの最新バージョンの利用をお勧めします。キャッシュでコンテンツやアイテムなどを購入する場合、各ゲームまたはサービスの起動に必要な技術仕様が別途求められることがあります。決済の前に各ゲームおよびサービスのホームページで「システム仕様」をご確認ください。<br/>消費者相談に関する電話番号はホームページの下部をご確認ください。',
  'studio.prj_prod_mngmt.prod_home.create_term.pre_payment_caution_guide': '決済前の注意事項',
  'studio.prj_prod_mngmt.prod_home.create_term.pre_payment_caution_guide_1':
    'ゲームのキャッシュを「STOVE」で管理する場合のみ使用される規約です。キャッシュをチャージする前に表示される内容を作成して管理することができます。',
  'studio.prj_prod_mngmt.prod_home.create_term.term_content_place_holder': '規約の内容を入力してください',
  'studio.prj_prod_mngmt.prod_home.create_term.3rd_party_info_use_guide': '第三者への情報提供に同意',
  'studio.prj_prod_mngmt.prod_home.create_term.3rd_party_info_use_guide_1':
    'ユーザーの情報をSTOVEやデベロッパー以外の第三者に提供する必要がある場合に同意を得るために使用されます。',
  'studio.prj_prod_mngmt.prod_home.create_term.guardian_agree_guide': 'ゲーム利用における保護者同意',
  'studio.prj_prod_mngmt.prod_home.create_term.guardian_agree_guide_1':
    '満18歳未満の青少年がゲームを利用する際に保護者の同意を得る必要がある場合に同意の内容を表示できます。保護者の本人認証によって同意の手続きを行うことができます！',
  'studio.prj_prod_mngmt.prod_home.create_term.guardian_info_guide': '保護者の個人情報収集の同意',
  'studio.prj_prod_mngmt.prod_home.create_term.guardian_info_guide_1': '未成年がゲーム内で決済する際に保護者の同意を得る場合に案内できる規約です！',
  'studio.prj_prod_mngmt.prod_home.create_term.personal_info_guide': '個人情報の収集および利用の同意',
  'studio.prj_prod_mngmt.prod_home.create_term.personal_info_guide_1': 'ユーザーの個人情報の提供を受けてそれを活用するときに使用される同意規約です！',
  'studio.prj_prod.this_prod.home_search_place_holder': '商品を検索してください',
  'studio.prj_prod.this_project.this_product.home_search_nmrf_msg': '検索結果がありません。',
  'studio.prj_prod.prod_home.tabs_home': '商品のホーム',
  'studio.prj_prod.this_prod.home_setting_guide': '商品に関する基本情報やDemo、DLCなどの関連商品をこちらに設定してください。',
  'studio.prj_prod.this_prod.home_product_page_guide': '画像、動画、説明を準備して商品ページを整えてみましょう。',
  'studio.prj_prod.this_prod.home_price_guide': '商品販売価格を設定してください。',
  'studio.prj_prod.this_prod.home_discount_guide': '期間ごとの割引を追加できます。',
  'studio.prj_prod.this_prod.home_sale_guide': '特定の商品を保有しているユーザーのみがこの商品を購入できるように設定できます。',
  'studio.prj_prod.this_prod.home_early_access_guide': '完成前の商品を前もって販売するには、案内文を入力してください。',
  'studio.gnb.common_2depth_stove_pc_sdk': 'STOVE PC SDK',
  'studio.prj_prod.this_prod.home_stove_pc_sdk_guide': 'オーナーシップ、指標管理などのSTOVE付加サービスを利用できます。',
  'studio.prj_prod.this_prod.home_build_guide': 'Storeで販売するGame、Utilityなどをアップロードできます。',
  'studio.prj_prod.this_prod.home_execution_guide': '商品の起動プラットフォームおよび駆動方法を設定できます。',
  'studio.gnb.common_2depth_client_test': 'クライアント実行テスト',
  'studio.prod_home.component_client_test': 'クライアント実行テスト',
  'studio.prj_prod.this_prod.home_client_test_guide': 'STOVEのPCクライアントをダウンロードして直接テストしてみましょう。',
  'studio.prj_prod.this_prod.home_tier_review_guide': 'STOVEが無料で提供する「社内審査によるレ―ティング」の審査を受けることができます。 ',
  'studio.prj_prod.this_prod.home_condition_guide': '標準規約や直接作成したカスタム規約を使用できます。',
  'studio.prj_prod.this_prod.home_stats_guide': 'SDKに連携している商品は数値データを保存して管理できます。',
  'studio.prj_prod.this_prod.home_ranking_guide': 'スタッツのデータを活用してユーザーの順位を確認できます。',
  'studio.prj_prod.this_prod.home_challenges_guide': '目標を設定してユーザーごとの達成有無を確認できます。',
  'studio.prj_prod.this_prod.home_cloud_guide': 'どの機器からでも最新のセーブファイルとして同期できます。',
  'studio.prj_prod.this_prod.home_match_guide': 'ネットワーク遅延について低い水準を維持できるようサポートします。',
  'studio.prj_prod.this_prod.home_banner_guide': 'バナー画像を登録すると、商品リストにより目立つ形で表示されます。',
  'studio.prj_prod.this_prod.home_in_app_setting_guide': 'ゲーム内ショップの使用有無を選択できます。 ',
  'studio.prj_prod.this_prod.home_in_app_shop_guide': 'ゲーム内アイテムショップを作成できます。 ',
  'studio.prj_prod.this_prod.home_in_app_product_guide': 'ゲーム内で販売するアイテムを登録できます。 ',
  'studio.prj_prod.this_prod.home_in_app_discount_guide': 'アイテムを割引価格で販売できます。',
  'studio.prj_prod.this_prod.home_in_app_payment_history_guide': 'ゲーム内アイテムの販売履歴を確認して管理できます。 ',
  'studio.prj_prod.this_prod.home_in_app_discount_pre_release_access_n':
    '割引メニューは、商品リリースしてからご利用いただけます。<br/>リリースした後、別途の設定から割引を適用できます。',
  'studio.prj_prod.this_prod.home_product_setting_title': '商品設定',
  'studio.prj_prod.this_prod.home_product_setting_basic_title': '基本情報',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg1': '入力した基本情報の翻訳は、多言語設定機能によって確認できます。',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg2': '商品名',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg2_place_holder': '商品名を入力してください',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg2_required_n': '商品名を入力してください。',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg4_invalid':
    "- : [ ] . TM ® # ( ) ' ! ? • {'|'} & _ \"   ~ , < > * / 、。以外の特殊文字は使用できません。",
  'studio.prj_prod.this_prod.home_product_setting_basic_msg3': 'クリエイター名',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg3_place_holder': 'クリエイター名を入力してください',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg3_required_n': 'クリエイター名を入力してください。',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg4': 'パブリッシャー名',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg4_place_holder': 'パブリッシャー名を入力してください',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg4_required_n': 'パブリッシャー名を入力してください。',
  'studio.prj_prod.this_prod.home_product_setting_category': 'ジャンル',
  'studio.prj_prod.this_prod.home_product_setting_category_val_msg': '1つ以上のジャンルを選択してください。 ',
  'studio.prj_prod.this_prod.home_product_setting_representative_category': '代表ジャンル',
  'studio.prj_prod.this_prod.home_product_setting_prod_type': '商品タイプ',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_guide':
    'リリース前は自由にタイプを変更できますが、連携した商品がある場合や正式リリース後は変更できません。',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_basic': '製品版Game',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_demo': 'Demo Game',
  'studio.prj_prod.this_prod.home_product_setting_prod_search_place_holder': '商品を検索してください。',
  'studio.prj_prod.this_prod.home_product_setting_prod_add_btn': '追加する',
  'studio.prj_prod.this_prod.home_product_setting_prod_supported_type': '対応機能',
  'studio.prj_prod.this_prod.home_product_setting_prod_supported_type_online': 'オンライン - インターネットに接続してサーバーにアクセスする場合',
  'studio.prj_prod.this_prod.home_product_setting_prod_supported_type_vr': 'VR - VR機能が必須または対応可能な場合 ',
  'studio.prj_prod.this_prod.home_product_setting_guide1': '基本情報およびジャンル',
  'studio.prj_prod.this_prod.home_product_setting_guide1_1':
    '入力した情報は商品ページでユーザーに表示され、レーティングの判定を受ける場合にも使用される重要な情報です。基本情報の場合、基準言語で入力した後に多言語設定からAI翻訳を行ってください。<br/>GRAC STOVE審査レーティングの商品は商品名、クリエイター名、ジャンルを変更するには内容修正報告を行って、再度レーティングの判定を受ける必要があります。',
  'studio.prj_prod.this_prod.home_product_setting_guide2': '商品タイプ',
  'studio.prj_prod.this_prod.home_product_setting_guide2_1':
    '基本で「製品版」に選択されていますが、正式に製品版をリリースする前に「Demo版」を先に選択して表示させることもできます。<br/>Demo版をリリースしてからタイプを変更して、製品版をリリースすることもでき、Demo版のための新しい商品を登録し、連携して別途管理することも可能ですので、自由に選択してみましょう。',
  'studio.prj_prod.this_prod.home_product_setting_guide6': '商品連携',
  'studio.prj_prod.this_prod.home_product_setting_guide6_1':
    '製品版の他にも関連するDemo、DLC、Utilityなどのビルドが別途にある場合、登録した商品ページに連携して製品版の商品ページに表示させることができます。<br/>この場合、連携した各商品のページとビルドは該当の商品の管理メニューから情報を入力した後、審査・リリースを行う必要があります。(DLCはリリース後に解除できなくなります。)<br/>※すでに他の商品ページに連携されている商品は追加できません。先に連携を解除すると追加できるようになります。',
  'studio.prj_prod.this_prod.home_product_setting_guide9': '商品ページ－DEMO適用例',
  'studio.prj_prod.this_prod.home_product_setting_guide8': '商品ページに連携した DLC/Utilityの表示例',
  'studio.prj_prod.this_prod.home_product_setting_prod_search_nmrf': '選択できる商品がありません。',
  'studio.prj_prod.this_prod.home_product_setting_depth_search_add_btn': '新しい商品を追加',
  'studio.prj_prod.this_prod.home_product_setting_search_all_prod_chkbox': 'すべての商品',
  'studio.prj_prod.this_prod.home_product_setting_multiple_select_case': '{productName} ({productID})の他{extraSelectedNum}個の商品',
  'studio.prj_prod.this_prod.home_product_setting_demo_add_pop_msg': '新規登録するDEMO商品の名前を入力してください。',
  'studio.prj_prod.this_prod.home_product_setting_new_add_pop_place_holder': '商品名を入力してください',
  'studio.prj_prod.this_prod.home_product_setting_val_required_n': '商品名を入力してください。 ',
  'studio.prj_prod.this_prod.home_product_setting_val_duplication_msg': '同一の商品名があります。別の商品名を入力してください。',
  'studio.prj_prod.this_prod.home_product_setting_add_register_btn': '登録',
  'studio.prj_prod.this_prod.home_product_setting_dlc_add_pop_msg': '新規登録するDLC商品の名前を入力してください。',
  'studio.prj_prod.this_prod.home_product_setting_content_add_pop_msg': '新規登録するコンテンツ商品の名前を入力してください。',
  'studio.prj_prod.this_prod.home_product_setting_utility_add_pop_msg': '新規登録するユーティリティ商品の名前を入力してください。',
  'studio.prj_prod.this_prod.home_product_setting_prod_id_header1': '商品No.',
  'studio.prj_prod.this_prod.home_product_setting_prod_name_header2': '商品名',
  'studio.prj_prod.this_prod.home_product_setting_prod_status_header3': 'リリースの状態',
  'studio.prj_prod.this_prod.home_product_setting_prod_haspage_header4': '独立ページ',
  'studio.prj_prod.this_prod.home_product_setting_prod_haspage_hover_msg':
    'Demoとして追加した商品のストア商品ページを表示する場合は、有効にしてください。',
  'studio.prj_prod.this_prod.home_product_setting_list_unlink_btn': '解除',
  'studio.prj_prod.this_prod.home_product_setting_demo_list_unlink_pop_msg1': 'DEMOの連携を解除しますか？',
  'studio.prj_prod.this_prod.home_product_setting_list_unlink_pop_cnf_btn': '解除',
  'studio.prj_prod.this_prod.home_product_setting_dlc_list_unlink_pop_msg1': 'DLCの連携を解除しますか？',
  'studio.prj_prod.this_prod.home_product_setting_content_list_unlink_pop_msg1': 'コンテンツの連携を解除しますか？',
  'studio.prj_prod.this_prod.home_product_setting_utility_list_unlink_pop_msg1': 'ユーティリティの連携を解除しますか？',
  'studio.prj_prod.this_prod.home_product_setting_type_list_change_pop_msg1': '商品タイプを変更しますか？',
  'studio.prj_prod.this_prod.home_product_setting_type_list_change_pop_msg2':
    'リリースプランを通じて Live を適用する際、ユーザーの既存の所有権を再設定する必要があります。',
  'studio.prj_prod.this_prod.home_product_setting_list_unlink_pop_change_btn': '変更',
  'studio.prj_prod.this_prod.home_product_setting_dlc_link_x_pop_msg1': 'DLC連携不可案内',
  'studio.prj_prod.this_prod.home_product_setting_dlc_link_x_pop_msg2':
    'ゲーム内決済が設定されています。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。',
  'studio.prj_prod.this_prod.home_product_setting_dlc_link_x_dir_ingame_setting_btn': '移動する',
  'studio.prj_prod.this_prod.home_product_setting.demo_prod_pg_yn_tooltip': 'オプションを無効にすると上位の商品ページのみ運営可能になります。',
  'studio.prj_prod.this_prod.home_product_setting.demo_prod_pg_yn_tooltip_details':
    'DEMO商品ページ非表示<br/>DEMO商品のレビューおよびユーザー評価非表示<br/>DEMO商品の掲示板は上位商品の掲示板に代替<br/>上位商品ページでDEMO商品の規約とレーティングを表示',
  'studio.prj_prod.this_prod.home_product_setting_linked_game': '上位ゲーム',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_prod_id_header1': '商品 No.',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_prod_name_header2': '商品名',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_prod_status_header3': 'リリース状態',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_release_stt_requesting': 'リリース申請',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_release_stt_rejected': 'リリース却下',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_release_stt_coming_soon': 'リリース予定',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_release_stt_available': 'リリース中',
  'studio.prj_prod.this_prod.home_product_setting_higher_game': '上位ゲーム',
  'studio.prj_prod.this_prod.home_product_setting_higher_game_no': '商品No.',
  'studio.prj_prod.this_prod.home_product_setting_higher_game_name': '商品名',
  'studio.prj_prod.this_prod.home_product_setting_higher_game_stt_under_review': '検収中',
  'studio.prj_prod.this_prod.home_product_setting_higher_game_stt_release_awaiting': 'リリース待機',
  'studio.prj_prod.this_prod.home_product_setting_higher_game_stt_released': 'リリース中',
  'studio.prj_prod.this_prod.home_product_setting_higher_game_stt_release_suspended': 'リリース中断',
  'studio.prj_prod.this_prod.home_product_setting_guide5': '連携解除',
  'studio.prj_prod.this_prod.home_product_setting_guide5_1': '連係解除は、連携されている上位商品の設定メニューから解除を行うことができます。',
  'studio.prj_prod.this_prod.home_product_setting_guide11': '商品タイプ',
  'studio.prj_prod.this_prod.home_product_setting_guide11_1':
    'DEMOに商品が連携されている場合、商品タイプは変更できません。別途正式リリースが必要な場合、連係解除後に商品タイプを変更してください。',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_msg0': '独立ページは非表示に設定されています。',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_publish_edit_btn': '編集する',
  'studio.prj_prod.this_prod.home_product_setting_guide6_2':
    '商品の内容が含まれている実行可能なDEMOビルドを新しい商品にアップロードして連携すると、商品ページでDEMO商品を一緒に表示できるようになります。<br/>ただし、連携されている各商品のページとビルドは該当の商品の管理メニューから情報を入力した後で審査とリリースを行う必要があります。<br/>※別の商品に連携されている商品は追加できません。連携を解除すると追加できるようになります。',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_msg1':
    'リリース前は自由にタイプを変更できますが、連携した商品がある場合や正式リリース後は変更できません。',
  'studio.prj_prod.this_prod.home_product_setting_content_type': '詳細タイプ',
  'studio.prj_prod.this_prod.home_product_setting_content_sound_hover_msg': 'サウンドトラック、フルボイスなど音声に関連したコンテンツ',
  'studio.prj_prod.this_prod.home_product_setting_content_image_hover_msg': 'イラスト、アートブックなど画像に関連したコンテンツ',
  'studio.prj_prod.this_prod.home_product_setting_content_video_hover_msg': 'PV、シネマティックムービーなど映像に関連したコンテンツ',
  'studio.prj_prod.this_prod.home_product_setting_content_type_val_msg': '詳細タイプを選択してください。',
  'studio.prj_prod.this_prod.home_product_setting_guide7': '基本情報',
  'studio.prj_prod.this_prod.home_product_setting_guide7_1':
    '入力した情報は商品ページでユーザーに表示される重要な情報です。基準言語で入力した後に多言語設定からAI翻訳を行ってください。',
  'studio.prj_prod.this_prod.home_product_setting_guide2_2':
    '正式リリースのためコンテンツタイプが基本で選択されていますが、正式リリース前にDEMOを先に選択してリリースすることもできます。<br/>DEMOのリリース後にコンテンツにタイプを変更して正式リリースを行うことも、DEMOのために新しい商品を登録し、連携して別途管理することも可能ですので、自由にお選びください。',
  'studio.prj_prod.this_prod.home_product_setting_guide4': '詳細タイプ',
  'studio.prj_prod.this_prod.home_product_setting_guide4_1':
    '選択したタイプに応じてストアの商品ページでタイプごとに分けて表示されます。選択したタイプがアップロードしたファイルと一致するか確認してください。',
  'studio.prj_prod.this_prod.home_product_setting_guide6_3':
    '正式リリースバージョンの内容が含まれている体験用コンテンツを新しい商品にアップロードして連携すると、正式リリース商品ページでDEMO商品を一緒に表示できるようになります。<br/>ただし、連携されている各商品のページとビルドは該当の商品の管理メニューから情報を入力した後で審査とリリースを行う必要があります。<br/>※別の商品に連携されている商品は追加できません。連携を解除すると追加できるようになります。',
  'studio.prj_prod.this_prod.home_product_setting_linked_content': '上位コンテンツ',
  'studio.prj_prod.this_prod.home_product_setting_guide2_3':
    'タイプは基本「Utility」に選択されていますが、正式リリース前に「Demo」を選択してリリースすることもできます。<br/>Demo版のUtilityをリリースしてからタイプを製品版のUtilityに変更して正式リリースを行うこともできます。Demo版のための新しく商品を登録し、連携して別途管理することも可能ですので、自由に選択してみましょう。',
  'studio.prj_prod.this_prod.home_product_setting_guide6_4':
    '製品版の他にも関連するDemoまたはDLCのビルドが別途にある場合、登録した商品ページに連携して製品版の商品ページに表示させることができます。<br/>この場合、連携した各商品のページとビルドは該当の商品の管理メニューから情報を入力した後、審査・リリースを行う必要があります。(DLCはリリース後に解除できなくなります。)<br/>※すでに他の商品ページに連携されている商品は追加できません。先に連携を解除すると追加できるようになります。',
  'studio.prj_prod.this_prod.home_product_setting_guide10': '商品ページ－DLC適用例',
  'studio.prj_prod.this_prod.home_product_setting_linked_utility': '上位ユーティリティ',
  'studio.prj_prod.this_prod.home_product_setting_guide6_5':
    'Demoビルドが別途存在する場合、商品を作成し、正式にリリースされるユーティリティ商品にリンクさせて商品ページで一緒に表示することができます。<br/>ただし、リンクされた各商品のページとビルドは、該当商品の管理メニューで情報設定後、検収とリリースが必要です。<br/>※ 他の商品にリンクされている場合、追加することはできません。リンクを解除した後、追加することができます。再設定後、リリースプランに再登録してください。',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_stt': '審査中',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_guide': 'LIVEリリース審査中には修正できません。審査完了までお待ちください。',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_prod_name': '商品名',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_creator_name': 'クリエイター名',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_distrib_co_name': 'パブリッシャー名',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_genre': 'ジャンル',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_prod_type': '商品タイプ',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_supported_type': 'サポート機能',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_supported_type1_onl': 'オンライン',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_supported_type2_onl_vr': 'オンライン',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_supported_type3_none': '該当なし',
  'studio.common.live_apply_popup_title': 'LIVE適用',
  'studio.common.popup_case_ii_release_guide':
    '適用するには「RELEASE」を入力してください。<br/>商品名、クリエイター名、代表ジャンルは内容修正報告の審査が完了すると自動的に適用されます。',
  'studio.common.popup_case_iv_release_guide': 'LIVEに適用されました。',
  'studio.common.popup_case_v_release_guide': '修正した内容がありません。<br/>再度ご確認ください。',
  'studio.common.popup_case_vi_release_guide': '修正された内容があります。<br/>適用しないで移動しますか？',
  'studio.common.popup_case_vi_release_guide_close_btn': '閉じる',
  'studio.prj_prod.this_prod.home_product_setting_rating_under_review_edit_x_guide': 'レーティングの審査中は基本情報を修正できません。',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_prod_detailed_type': '詳細タイプ',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_title':
    "商品タイプ変更案内(DEMO <i class='stove-ui-icon h-20 w-20 text-3xl before:ic-v2-control-arrow-right-line'></i> {basicType})",
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_guide1':
    '{basicType}に変更するためには、既存のDEMO商品のリリースを中断してビルド、商品ページおよび価格などの正式リリースを行うための必須項目を設定しなおしてから再度リリ―スすることで適用できるようになります。',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_copyright_setting': '商品の所有権',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_copyright_setting_withdraw': '回収',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_copyright_setting_withdraw_guide':
    '(ユーザーのDEMO商品の所有権を回収すると、所有権が初期化されて正式リリースが行われます。)',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_copyright_setting_remain': '維持 ',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_copyright_setting_remain_guide':
    '(Demo版の所有権が製品版に同じく適用されます)',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_guide2_1': '再リリースを行うには「CONFIRM」を入力してください。',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_guide2_2':
    '再リリースを行った後、以前の設定に戻すことはできません。慎重にご検討ください。',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_cf_btn': '再リリースを行う',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_complete_popup':
    'リリースが中断されました。<br/>正式リリースのための必須項目を設定した後でリリースを行ってください。',
  'studio.prj_prod.post_release.demo_to_game.popup_msg1': '既存に登録したDemo版の販売が中断されました。',
  'studio.prj_prod.post_release.demo_to_game.popup_msg2': '製品版リリースに必ず入力必要な機能が解放されました。',
  'studio.prj_prod.post_release.demo_to_game.popup_msg3': '(価格、割引、早期アクセス)<br/>「リリースする」を押して製品版をリリースしましょう。',
  'studio.prj_prod.this_prod.home_early_access_title': 'アーリーアクセス文言設定',
  'studio.prj_prod.this_prod.home_early_access_save_btn': '保存',
  'studio.prj_prod.this_prod.home_early_access_msg': 'アーリーアクセス案内',
  'studio.prj_prod.this_prod.home_early_access_preview_btn': 'プレビュー',
  'studio.prj_prod.this_prod.home_early_access_full_btn': 'フルスクリーン表示',
  'studio.prj_prod.this_prod.home_early_access_prompt1': 'Q.なぜアーリーアクセスを行うのですか？',
  'studio.prj_prod.this_prod.home_early_access_place_holder': 'A.内容を入力してください。',
  'studio.prj_prod.this_prod.home_early_access_prompt2': 'Q.このゲームのアーリーアクセス期間はどのぐらいありますか？',
  'studio.prj_prod.this_prod.home_early_access_prompt3': 'Q.正式バージョンはアーリーアクセスバージョンとどう違いますか？',
  'studio.prj_prod.this_prod.home_early_access_prompt4': 'Q.アーリーアクセス期間とアーリーアクセス後のゲームの価格は変わりますか？',
  'studio.prj_prod.this_prod.home_early_access_prompt5': 'Q.開発過程ではどのようにコミュニティを参加させる計画がおありですか？',
  'studio.prj_prod.this_prod.home_early_access_prompt_required_n': '早期アクセスに関する内容を入力してください。',
  'studio.prj_prod.this_prod.home_early_access_guide1': 'アーリーアクセスとは何ですか？',
  'studio.prj_prod.this_prod.home_early_access_guide1_1':
    'まだ開発中という事実をユーザーに知らせたうえで販売する商品です。アーリーアクセス商品は完全に完成していなくてもプレイできる状態である必要があり、開発を継続してリリースする計画がなければなりません。',
  'studio.prj_prod.this_prod.home_early_access_guide2': 'アーリーアクセスの案内文は必ず作成しなければならないのでしょうか？',
  'studio.prj_prod.this_prod.home_early_access_guide2_1':
    'アーリーアクセスでリリースするには、アーリーアクセスの案内文を必ず作成してください。作成したアーリーアクセスの案内文は、アーリーアクセスの期間中にストアページに表示されます。',
  'studio.prj_prod.this_prod.home_early_access_tooltip_hover_msg': 'フルスクリーンではダークモードで入力できます。',
  'studio.prj_prod.this_prod.home_early_access_preview_title': '早期アクセス欄のプレビュー',
  'studio.prj_prod.this_prod.home_early_access_preview_guide1': 'この商品は早期アクセス版です。',
  'studio.prj_prod.this_prod.home_early_access_preview_guide2':
    '今後のアップデートにより、商品内容が一部修正されたり、価格が変更される場合があります。',
  'studio.prj_prod.this_prod.home_early_access_preview_see_creator_comment': '開発社からのコメント',
  'studio.prj_prod.this_prod.home_early_access_text_display': '表示オプション',
  'studio.prj_prod.this_prod.home_early_access_text_display_y': '表示',
  'studio.prj_prod.this_prod.home_early_access_text_display_n': '非表示',
  'studio.prj_prod.this_prod.home_early_access_full_exit_btn': 'フルスクリーン解除',
  'studio.prj_prod.this_prod.home_early_access_darkmode': 'ダークモード',
  'studio.prj_prod.this_prod.marketing_banner_rectangular_image_title': '正方形の画像',
  'studio.prj_prod.this_prod.marketing_banner_portrait_image_title': '縦長画像',
  'studio.prj_prod.this_prod.marketing_banner_landscape_image_title': '横長画像',
  'studio.prj_prod.this_prod.marketing_banner_preview_btn': 'プレビュー',
  'studio.prj_prod.this_prod.marketing_banner_image_title': 'バナー画像',
  'studio.prj_prod.this_prod.marketing_banner_guide1': 'バナー画像とは何ですか？必ず登録しなければならないのでしょうか？',
  'studio.prj_prod.this_prod.marketing_banner_guide1_1':
    'バナー画像は必須の入力項目ではありません。<br/>バナー画像を登録しておくと、STOVEストアの運営者が商品リストページに表示されるように設定できます。<br/>登録された商品は商品リストでより目立つ形で表示させられます。',
  'studio.prj_prod.this_prod.marketing_banner_preview_title': '画像プレビュー',
  'studio.prj_prod.this_prod.marketing_banner_preview_msg': '理解を深められるサンプル画像です。',
  'studio.prj_prod.this_prod.marketing_banner_preview_sample_title1': 'オールドワールド(Old World)',
  'studio.prj_prod.this_prod.marketing_banner_preview_sample_title2': 'フェイブルダム(Fabledom)',
  'studio.prj_prod_mngmt.rating_build_review.popup_no_view_per': '照会権限がありません。<br/>グループ管理者にお問い合わせください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.guide1': 'ゲームをリリースするにはアップロードしたビルドの審査を受ける必要があります。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.guide1_1':
    '審査を受ける前に、下記の項目があるかチェックしてください。<br/>審査が完了するまで最大で7日かかることがあるため、前もって準備が必要です。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.bims_bank_info': '個人／事業者情報',
  'studio.prj_prod_mngmt.rating_build_review.self_review.bims_bank_info_guide':
    '個人／事業者情報を入力する際には住民登録謄本、パスポート、身分証明書、事業者登録証の準備が必要です',
  'studio.prj_prod_mngmt.rating_build_review.self_review.build_upl': 'ビルドアップロード',
  'studio.prj_prod_mngmt.rating_build_review.self_review.build_upl_guide': 'まず審査を受けるビルドをアップロードしてください',
  'studio.prj_prod_mngmt.rating_build_review.self_review.game_content': 'ゲーム内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.game_content_guide': 'ゲーム動画／CG画像／台詞のファイルを前もって準備してください',
  'studio.prj_prod_mngmt.rating_build_review.self_review.bims_bank_info_pg_dir_btn': '情報を入力する',
  'studio.prj_prod_mngmt.rating_build_review.self_review.build_mgmt_pg_dir_btn': 'アップロードする',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb1': 'プロジェクト・商品管理',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb2': '{productName}',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb3': 'レーティングおよびビルド審査',
  'studio.prj_prod_mngmt.rating_build_review.self_review.pg_title': 'レーティングおよびビルド審査',
  'studio.prj_prod_mngmt.rating_build_review.self_review.popup_no_info':
    '登録されているゲーム・事業者情報がありません。<br/>まずは個人・事業者情報を入力してください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_reg_x':
    '個人・事業者情報を審査中です。<br/>審査完了後に登録できるようになります。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_req_btn': '審査登録',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history_btn': '履歴を確認する',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.game_info_title': 'ゲーム基本情報',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.game_name': 'ゲーム名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.dev_company': 'デベロッパー名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.genre': '代表ジャンル',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.info_edit_btn': '情報修正',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.biz_info_title': '事業者／担当者情報',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.country': '所在地の国',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.biz_reg_num': '事業者登録番号',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.biz_type': '事業者のタイプ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.biz_category': '制作／配給業のタイプ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.biz_name': '事業者名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.representative_name': '代表者名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.pic_name': '担当者氏名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.email': 'Eメール',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.contact': '連絡先',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.contact_guide':
    '{grpName}で審査過程を受け取る担当者の連絡先情報です。<br/>入力された連絡先情報に審査過程をお伝えします。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide1': 'ここではどんなことを行うのでしょうか？',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide1_1':
    '正式リリースを行うにはレーティングが必要です。<br/>審査を受けるレーティングを選択し、リリースするビルドを連携してください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide2': 'GRAC STOVE審査レーティング分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide2_1':
    'STOVEを通してGRACのレーティング審査を受けることができます。審査が初めての場合はご利用ください！<br/>費用は無料です。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide3': '大韓民国のレーティング番号を照会する',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide3_1':
    '審査が完了した大韓民国等級番号を直接入力してレーティングを登録できます。<br/>起動設定がWEBのみの場合、直接入力でも登録可能です。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide4': '国際レーティング分類番号',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide4_1':
    'GRAC以外の国際的なレーティング番号がある場合は、直接入力して年齢制限を登録できます。<br/>登録された年齢制限は、以下の画像のように表示されます。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_1': '審査情報の登録',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.title': '審査情報の登録',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.select_rating': 'レーティングの選択',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.select_rating_grac_self_review': 'GRAC(大韓民国)STOVE審査レーティング分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.guide':
    '青少年利用不可のゲームは社内審査を行うことができません。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.guide_ex': '例',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.build': 'ビルド',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.build_place_holder': 'ビルドを選択してください',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.build_no_result': '検索結果がありません。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.origin_country': '原作国',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.origin_country_guide':
    'ゲームが実際に生まれた原作国を選択してください ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.description': '一言説明',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.description_guide': 'ゲームを紹介する一言説明を作成してください',
  'studio.prj_prod_mngmt.rating_build_review.rating_reg.intl_org.chkbox': '国際レーティング分類番号があります。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.select_org_dropbox_place_holder': '選択してください',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.ESRB': 'ESRB(北米／南米)',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.PEGI': 'PEGI(ヨーロッパ／中東)',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.PEGI2': 'PEGI 2(ポルトガル)',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.USK': 'USK(ドイツ)',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.ACB': 'ACB(オーストラリア)',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.CLASS_IND': 'Classlnd(ブラジル)',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.CERO': 'CERO(日本)',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.IARC': 'IARC(その他の国)',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.select_rating_dropbox_place_holder': '選択してください',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.enter_rating_reg_num_place_holder':
    'レーティング分類番号を入力してください',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.none_rating_reg_num_val_msg1':
    '1つ以上の国際機関のレーティングを登録してください。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.self_review.rating_reg.intl_org.allowed_char_msg':
    '数字、「-」、英字のみ入力してください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.add_rating_reg_num_btn': '追加する ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.rating_num_exceed_case1_popup':
    '一種類の国際レーティングにつき最大2個までのレーティングを追加できます。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.rating_num_exceed_case2_popup':
    '一種類の国際レーティングにつき最大1個のレーティングを追加できます。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.region_org': '地域',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.rating': '等級',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.rating_reg_num': '番号',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.rating_num_exceed_case3_popup':
    '一種類の国際レーティングにつき<br/>最大2個までのレーティングを追加できます。<br/>リストを初期化しますか？',
  'studio.prj_prod_mngmt.rating_build_review.rating_reg.next_btn': '次へ ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.teenagers_prohibited_review_x_guide_popup':
    "審査を受けるゲームが<span class='text-tint-red-a400 font-bold'>青少年利用不可</span>に該当する場合、<br/><span class='text-on-surface-elevation-1 font-medium'>社内審査でレーティングの判定を受けることはできません。</span><br/>GRAC(ゲーム管理委員会)の<br/>審査を受けてはじめてレーティングの判定を受けることができます。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_missing_popup': 'ゲームの基本情報および事業者情報は必ず入力しなければなりません。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.fill_qtn_tab': 'アンケート作成',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_reg_title': '審査情報の登録',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_tab': '審査資料の添付',
  'studio.prj_prod_mngmt.rating_build_review.self_review.pre_qtn': '0.事前アンケート',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_violence': '1.暴力性',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_sexuality': '2.扇情性',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_gambling': '3.射幸性',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_horror': '4.恐怖',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_language': '5.言語',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_drug': '6.薬物',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_crime': '7.犯罪',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_progress': '進行率：{percentage}%',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_next_btn': '次へ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_back_btn': '戻る',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_btn': '審査資料の<br/>添付',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_country_of_origin': '原作国を選択',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_country_of_origin_guide': 'ゲームが実際に誕生した原作国を選択してください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_country_of_origin_place_holder': '選択',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_country_of_origin_val_msg': '原作国を選択してください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_descr': 'ゲームの説明',
  'studio.common.full_scr_btn': 'フルスクリーン',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_descr_guide': '審査に必要なゲームの説明を書き込んでください ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_descr_req_val_msg': 'ゲームの説明を作成してください。',
  'studio.common.exit_full_scr_btn': 'フルスクリーン解除',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_create_method': 'ゲームの操作方法',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_create_method_guide':
    'ゲームをどのように操作するか、方法を説明してください。<br/>スクリーンショットを添付しても構いません。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_create_method_req_val_msg': 'ゲームの操作方法を作成してください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc': '審査資料の添付',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_guide': '別途ファイルの添付や、ダウンロードできるリンクの入力が可能です。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_link_format_val_msg': '正しいリンク先を入力してください。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_add_dl_link_btn': 'リンク追加',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_add_btn': '添付',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_size_limit_val_msg1': '添付ファイルの容量は2GBを超えることはできません。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_size_limit_val_msg2':
    'ファイルが添付可能な容量を超える場合はファイルをダウンロードできる別途のリンクを書き込んで、審査リクエストを行ってください。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_num_limit_val_msg1': 'ファイルは最大10個まで添付できます。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_num_limit_val_msg2':
    '添付するファイルが10個を超える場合はファイルをダウンロードできる別途のリンクを書き込んで、審査リクエストを行ってください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide': '審査資料の添付必須項目',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1': '1.ゲームプレイ映像',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_1':
    '序盤／中盤／終盤それぞれファイルを分けてアップロードしてください。(マルチエンディングの場合、すべてのエンディング映像を添付)',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_2':
    '煽情的な映像や暴力的な映像は別のファイルに表示する形でアップロードしてください',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_3':
    '添付ファイルはmp4やaviなどの動画ファイルの形式でアップロードしてください',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_4':
    '動画の容量が大きい場合、動画をダウンロードできる別途のリンクを｢Gameの説明｣に書き込んでください',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_ex1': 'ゲーム序盤(6分)',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_ex2': 'ゲーム中盤(6分)',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_ex3': 'ゲーム終盤(6分)',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide2': 'CG画像',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide2_1': 'ゲームに登場する全キャラクターのCG画像を添付してください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide2_2':
    '煽情的な画像や暴力的な画像は別のファイルに表示する形でアップロードしてください',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide2_3':
    '添付ファイルはpng、jpg、gifなどの画像ファイルの形式でアップロードしてください',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide3': '3.テキストファイル',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide3_1':
    'ゲームに登場する全テキストが入ったファイルを添付してください。(キャラクターの台詞、ナレーション、UIなど)',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide3_2': '乱暴な台詞や煽情的な台詞がなければ添付しなくても構いません',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide3_3':
    '添付ファイルはword、pdf、hwpなどの文書ファイルの形式でアップロードしてください',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide1_1': '{rating}歳以上対象<br/>{category}',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide1_2': 'の結果が予想されます',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide1_3': '審査中は商品情報および事業者情報を変更できません。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide1_4':
    '審査完了後に商品名、クリエイター名、ジャンルが変更になる場合は<br/>再度審査を受ける必要があります。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_req_cf_btn': '審査リクエスト',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide2_1':
    '<span class="text-tint-red-a400">青少年利用不可</span>と予想されます',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide2_2':
    '青少年利用不可のゲームは<br/>直接韓国ゲーム物管理委員会の審査を受ける必要があります。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide2_3':
    "審査に関するお問い合わせは<br/>stove.rating{'@'}smilegate.comにご連絡ください｡",
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide3_1': '審査リクエストが完了しました。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide3_2': '2～4営業日を要する予定です。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide3_3': '審査結果はEメールまたは通知でご案内します。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_guide1': '審査中です。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_guide2': '最大で2～4営業日かかります。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_stt_1': '審査前',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_stt_2': '審査中',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_stt_3': '完了',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_detail_pg_dir_btn': '審査中の情報確認 ',
  'studio.prj_prod_mngmt.rating_build_review.info_detailed_pg_dir_btn': '詳細情報',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_name': 'ゲーム名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_company': 'デベロッパー名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_genre': '代表ジャンル',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_rating_type': 'レーティングの種類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_rating_assigned_date': 'レーティング分類日',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_rating_classif': 'レーティング分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_rating_classif_detail': '分類内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_rating_reg_num': 'レーティング分類番号',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_build_id': 'ビルドID',
  'studio.prj_prod_mngmt.rating_build_review.reg_btn': '登録',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_done_guide': '審査が完了しました。<br/>ゲームをリリースできる状態です。',
  'studio.prj_prod_mngmt.rating_build_review.release_plan_dir_btn': 'リリースへ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_done_re_reg_guide':
    '社内審査によるレーティング分類によって判定されたレーティングがあります。<br/>新規登録を行う場合は分類番号を直接入力する必要があり、過去に判定されたレーティングは削除されます。<br/><br/>新規登録を続行しますか？ ',
  'studio.prj_prod_mngmt.rating_build_review.see_history_btn': '履歴を確認する',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rejected_guide': '審査が<span class="text-[#EC3B47]">リジェクト</span>されました。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rejected_stt': 'リジェクト',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rejected_reason_chk_btn': 'リジェクト理由確認',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rejected_reason_pg_title': 'リジェクト理由確認',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_2': 'リジェクト理由確認',
  'email.review_result_noti.completed.title': '{prodName}審査完了 ',
  'email.review_result_noti.completed.msg_1': '{prodname}の審査が完了しました。 ',
  'email.review_result_noti.completed.msg_2': '社内審査によるレーティングの審査結果は{rating}です。 ',
  'email.review_result_noti.go_to_review_pg_btn': '移動する ',
  'email.review_result_noti.rejected.title': '{prodName}審査リジェクト',
  'email.review_result_noti.rejected.msg_1':
    '{prodname}の審査がリジェクトされました。<br/>リジェクト理由を確認するには［移動する］をクリックしてください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn01_guide1': '正当な権限とは何ですか？',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn01_guide2':
    '正当な権限とは「法的根拠」を意味します。<br/>正当な著作権を行使して作った創作物であれば、審査を受けることができます。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1': 'レーティング再分類対象基準',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1_1':
    'ゲームの主な内容(シナリオ、キャラクター、アイテムなど)、映像、音響要素などにレーティングの判定に影響を及ぼすほどの修正や追加がある場合。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1_2':
    'ゲームマネーのチャージ、振込、使用などの利用方法が修正された場合。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1_3':
    'その他、射幸性やユーザーののめり込みを誘発しうるゲームの進め方が修正された場合。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1_4':
    'アーケードゲームとしてゲームの内容・利用方法・プログラムの修正がある場合。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1_5':
    '長期間にわたり内容修正報告を行っていなかったり、追加された内容が大量であったりする場合。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1_6':
    'その他、レ―ティングの変更を要するほどの修正があった場合。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2': '射幸性ゲーム物',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_1': 'ゲームの結果として現金報酬が得られるもの  ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_2':
    '情報通信網を通して提供されるベット要素のあるゲームで、次の各号のいずれか一つに該当するもの',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_3': '1) ゲームマネーを直接現金でチャージするもの',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_4':
    '2) ゲーム内でユーザー間のゲームマネー振込が可能になっているもの',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_5':
    '3) ゲーム内で勝敗の結果で得た点数やゲームマネーを現金化するもの',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_6':
    '4) ゲームの勝敗の結果として現金またはその他の物品を提供されたり受け取ったりできるもの',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_7':
    '5) ゲームの勝敗の結果として得た点数またはゲームマネーを直接・間接的に流通過程を経て有形・無形の報酬として提供するもの',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn01_copyright_n_popup':
    'ゲームの著作権を有していることで審査が可能になります。<br/>著作権を確認後に再度選択してください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn023_gambling_y_popup':
    '射幸性ゲーム物は社内審査によるレーティング分類による<br/>審査ができません。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn031_crime_y_popup':
    '該当内容が含まれているゲームは<br/>社内審査によるレーティング分類による審査ができません。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide1': '人型キャラクター',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide1_1':
    '実際の人間や人間の姿をしたキャラクター、モンスター(例：ハピ、ケンタウロス)などが含まれる',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide2': '暴力表現の例',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide2_1': '下記の画像は参考資料です。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide2_1_1': '単純、漫画的なエフェクトの水準で表現されている',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide2_1_2': '流血表現があるが漫画的表現である',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide3': '武器や攻撃表現の例',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide3_1': '下記の画像は参考資料です。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide3_1_1': '攻撃行為が含まれる',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide3_1_2': '攻撃表現がリアルである',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide4': '流血、身体毀損、死体の描写',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide4_1': '下記の画像は参考資料です。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide4_1_1': '行為は出ているが直接的ではない。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide4_1_2': 'リアルな毀損があるが、ごく一部だけに存在する場合',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide5': '資源の略奪要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide5_1':
    '単純な水準：<br/>相手の領土に侵攻して相手が集めた資源を消耗させることができる(単純)',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide5_2':
    '軽微な水準：<br/>領土に侵攻して相手の資源も奪うことができるその代わり、24時間は同じ相手をまったく同じように侵攻することはできず、週に3回以上略奪を行うことができない',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn2_guide': '煽情的な描写',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn2_guide1': '下記の画像は参考資料です。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn2_guide1_1': '一定部分の露出がある軽微な露出',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn2_guide1_2': '上半身(胸)、下半身の露出が軽微な露出',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn2_guide1_3': '露骨な露出があって性を連想させる',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn2_guide1_4': '性器を除く重要な部分の露出',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide1': '射幸性の要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide1_1':
    '軽微な水準：<br/>賭博、ベット要素がない。カード、ルーレットはあるがゲーム内だけのルール<br/>ポーカー、ブラックジャック、ワンカードの要素なし',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide1_2':
    '制限的水準：<br/>ごく一部のミニゲームにのみポーカー、ワンカードがあり、ベット要素があってはいけない',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide1_3':
    '事実的水準：<br/>ポーカー、ブラックジャック、ワンカード、花札の要素が存在する<br/>ゲームで得た通貨が現金と近い価値を持つ<br/>ユーザー間の取引が行われるオークションシステムが存在する',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide2': '確率型アイテム(ガチャなど)',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide2_1':
    'プレイ可能なキャラクターあるいはアイテムを利用する際、ゲーム内の通貨をチャージして購入した後にランダムでキャラクターやアイテムを手に入れることでプレイできる',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide2_2':
    '自分たちのゲームでチャージや獲得した通貨を取引場所でユーザー同士が取引したり現実で交換したりできる',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn4_guide': '恐怖描写',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn4_guide1': '下記の画像は参考資料です。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn4_guide1_1': '雰囲気が背景にのみ表現されている',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn4_guide1_2': '陰鬱で暗い雰囲気が演出されている',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn4_guide1_3': 'リアルな恐怖感を演出している',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn4_guide1_4': '恐怖要素が過度に演出されている',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn5_guide': '言語的要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn5_guide_1': '軽微な水準：<br/>消えろ、黙れ、クソなど',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn5_guide_2': '制限的水準：<br/>ぼかしたFワードなど',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn5_guide_3':
    '過度な水準：<br/>不適切な言葉が過度に使われていたり、誹謗中傷的な言葉がフィルタリングせずに使われていたりする場合',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn6_guide': '薬物の要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn6_guide_1':
    '軽微な水準：<br/>喫煙、飲酒が単純な背景としてのみ存在(ドット、漫画的表現)',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn6_guide_2':
    '制限的水準：<br/>ユーザーが酒、煙草を使用可能(プレイヤー)<br/>きわめて少ないモーションまたは使用効果のみ存在',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn6_guide_3': '直接的水準：<br/>酒、煙草、麻薬を使用可能(プレイヤー)',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn7_guide': '犯罪の要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn7_guide_1':
    '軽微な水準：<br/>強盗、殺人要素が単純なテキストに存在<br/>性犯罪の要素なし',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn7_guide_2':
    '制限的水準：<br/>強盗、殺人要素について画像またはテキストによる犯行描写が存在',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn7_guide_3': '直接的水準：<br/>強盗、殺人、性犯罪の要素のリアルな表現',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_detail_pg_title': '審査情報 詳細情報',
  'studio.prj_prod_mngmt.rating_build_review.self_review.detailed_pg.appeal_btn': '異議申し立て',
  'studio.prj_prod_mngmt.rating_build_review.self_review.detailed_pg.appeal_info_edited_popup_msg1':
    '異議申し立てをするレーティングに適用するゲーム名、デベロッパー名、代表ジャンルが変更されました。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.detailed_pg.appeal_info_edited_popup_msg2': 'まずは内容修正報告を行ってください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.detailed_pg.next_btn': '次へ ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_title': '異議申し立て',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_detail_input': '内容作成',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_qtn': 'アンケート作成',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_attch_doc': '審査資料の添付',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_rating': '調整をリクエストするレーティング',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_rating_place_holder': '選択',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_rating_val_msg': '調整をリクエストするレーティングを選択してください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_use_existed_info_chkbox': '過去にアンケートを作成した内容をそのまま使用します。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_select_content': 'ゲームに含まれる内容を選択してください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_violence': '暴力性',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_sexuality': '扇情性',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_gambling': '射幸性',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_horror': '恐怖',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_lang': '言語',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_drug': '薬物',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_crime': '犯罪',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_reason_input': '異議申し立ての理由作成',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_reason_val_msg': '異議申し立ての理由を作成してください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_next_btn': '次へ ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_guide': '異議申し立て',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_guide1':
    '審査が完了したレーティングに異議がある場合は異議申し立てを行うことができます。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_guide2':
    '調整をリクエストするレーティングとゲームに含まれる内容を選択し、異議申し立ての理由を作成してください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_guide3':
    '過去に使用したアンケートの内容をそのまま使用したい場合、該当のチェックボックスにチェックを入れてください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_guide4':
    '異議申し立ては最初に付与されたレーティングを基準に一商品に対して1回だけ行うことができます。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_raise_title': '異議申し立て',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_btn': '審査リクエスト',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_noti_popup_msg1':
    '異議申し立ての審査中は<br/>商品情報および事業者情報を変更できません。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_noti_popup_msg2': '異議申し立ては審査結果と<br/>関係なく1回のみ申請できます。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_cf_btn': '異議申し立て ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_done_popup_msg1':
    '審査リクエストが完了しました。<br/>2～4営業日を要する予定です。<br/>審査結果はEメールまたは通知でご案内します。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_under_review_guide': '異議申し立ての審査中です。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_under_review_guide_1': '最大で2～4営業日かかります。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_chk_req_detail_btn': '審査中の情報確認',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_review_done_msg': '異議申し立ての審査が完了しました。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_review_result': '{assignedRating} → {requestedRating}',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info': '最近の審査完了情報',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_guide':
    'まだリリースされていない予備のレーティングの審査情報です。リリース後は「レーティングの審査情報」にアップデートされます。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_rejected_msg':
    "異議申し立ての審査が<span class='text-error'>リジェクト</span>されました。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_rejected_reason_chk_btn': 'リジェクト理由確認',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_rejected_result': 'リジェクト',
  'email.appeal_review_result_noti.completed.title': '{prodName}審査完了',
  'email.appeal_review_result_noti.completed.msg_done': '{prodName}の審査が完了しました。',
  'email.appeal_review_result_noti.completed.msg_assigned_rating': '既存のレーティング：「{assignedRating}」',
  'email.appeal_review_result_noti.completed.msg_requested_rating': '申請したレーティング：「{requestedRating}」',
  'email.appeal_review_result_noti.completed.msg_assigned_category': '既存の分類内容：「{assignedCategory}」',
  'email.appeal_review_result_noti.completed.msg_requested_category': '申請した分類内容：「{requestedCategory}」',
  'email.appeal_review_result_noti.rejected.title': '{prodName}審査リジェクト',
  'email.appeal_review_result_noti.rejected.msg_rejected': '{prodName}の審査がリジェクトされました。',
  'email.appeal_review_result_noti.rejected.msg_assigned_rating': '既存のレーティング：「{assignedRating}」',
  'email.appeal_review_result_noti.rejected.msg_requested_rating': '申請したレーティング：「{requestedRating}」',
  'email.appeal_review_result_noti.rejected.msg_assigned_category': '既存の分類内容：「{assignedCategory}」',
  'email.appeal_review_result_noti.rejected.msg_requested_category': '申請した分類内容：「{requestedCategory}」',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change_btn': '内容修正報告',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.title': '内容修正報告',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.basic_info': 'ゲーム基本情報',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.basic_info_name': 'ゲーム名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.basic_info_company': 'デベロッパー名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.basic_info_genre': '代表ジャンル',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_info': 'レーティング審査情報',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_rating': 'レーティング分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_category': '含まれる内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide1': '内容修正報告とは？',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide1_1':
    'ゲーム物を報告し、ゲーム物の変更がある場合、どのような内容が変更されたのか報告をしなければなりません。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide2': '修正報告の範囲',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide2_1':
    'ビルドに単純なバグの修正がある場合は、内容修正報告を行わずにそのままビルドをリリースできます。<br/>ゲームと関連するコンテンツやゲームの基本情報が変更になった場合は、どのような事項が変更されたか審査資料を添付して審査を受ける必要があります。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide2_2':
    'ゲーム名、デベロッパー名(クリエイター名)だけを変更する場合は内容修正報告を行っても自動で報告されます',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide3': 'アンケート作成',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide3_1':
    '変更した事項がゲームの分類内容(例：暴力性、煽情性)に影響する場合でなければ、過去のアンケートの内容をそのまま使用してチェックを入れてアンケート内容をそのまま活用できます。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide3_2':
    'ただし、変更事項がアンケートの内容と一致するか、Studioの担当者が追加で審査を行う場合があります。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.build_id': 'ビルドID',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.build_id_place_holder': 'ビルドを選択してください',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.build_id_val_msg': 'ビルドを選択してください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info': '変更内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_guide':
    '単純なバグ修正の場合は、内容修正報告を行わずにそのままビルドをリリースできます。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_game_name': 'ゲーム名の変更',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_company': '開発社名（クリエイター名）の変更',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_genre': 'メインジャンルの変更',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_background': '背景、映像の変更',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_sys_ui': '基本システム、UI変更',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_billing_sys': '課金体系の変更',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_mission_scenario': 'クエスト、シナリオの変更',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_char_item': 'キャラクター、アイテムの変更',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_intl_rating': '国際機関のレーティング変更',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.req_val_msg': '変更事項を最低一つ以上選択してください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_detail': '変更内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.use_existed_info_chkbox': '過去にアンケートを作成した内容をそのまま使用します。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_intl_rating_chkbox': '国際機関のレーティング変更',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.next_btn': '次へ ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_name': 'ゲーム名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_rating_type': 'レーティングの種類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_rating_assigned_date': 'レーティング分類日',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_rating_classif': 'レーティング分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_rating_classif_detail': '含まれる内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_rating_reg_num': 'レーティング分類番号',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_build_id': 'ビルドID',
  'email.review_result_noti.change_update_completed.msg_1': '{prodname}の内容修正報告の審査が完了しました。',
  'email.review_result_noti.change_update_completed.msg_2': '審査が完了したビルドをリリースできます',
  'email.review_result_noti.change_update_rejected.msg_1': '{prodName}の内容修正報告の審査がリジェクトされました。',
  'email.review_result_noti.change_update_rejected.reason_chk_guide': 'リジェクトの理由を確認するには［移動する］をクリックしてください。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.title': '大韓民国のレーティング番号を照会する',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.sub_title': '大韓民国のレーティング番号を照会する',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.place_holder': 'レーティング分類番号を入力してください',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.required_msg': 'レーティング番号を入力してください。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.allowed_char_msg': '数字、「-」、英字のみ入力してください。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.add_btn': '追加する',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.rating_info_game_title': 'ゲーム物名',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.rating_info_rating': 'レーティング',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.rating_info_category': '含まれる内容',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.rating_info_reg_num': 'レーティング分類番号',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.rating_info_assigned_date': 'レーティング分類日',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.inquiry_failed_reg_num_not_existed':
    '存在しない情報です。<br/>レーティング分類番号を確認してください。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.failed_reg_num_limit': '一つのゲームにつき最大2個までのレーティングを追加できます。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.guide': '大韓民国のレーティング番号を照会する',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.guide_1':
    '事前に付与された大韓民国のレーティング番号を直接入力してレーティングを登録できます。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_btn': '登録',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_completed': 'レーティング情報の登録が<br/>完了しました。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.required_val_popup': '一つ以上のレーティング情報を追加してください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb5': '大韓民国のレーティング番号を照会する',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_completed_guide': '登録が完了しました。<br/>ゲームをリリースできる状態です。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_completed.rating_existed_guide': '登録されているレーティングが存在します。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_completed.rating_existed_new_reg_guide':
    '新規登録を行う場合、社内レーティング審査によって行われ、過去に判定されたレーティングは削除されます。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_completed.rating_existed_edit_guide':
    '修正事項がある場合、<br/>詳細情報から修正してください。<br/>新規登録を行いますか？',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_8': 'レーティングの詳細情報',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_detailed_pg_title': 'レーティングの詳細情報',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_basic': 'ゲーム基本情報',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_basic_name': 'ゲーム名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_basic_company': 'デベロッパー名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_basic_genre': '代表ジャンル',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz': '事業者／担当者情報',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz_country': '所在地の国',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz_type': '事業者のタイプ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz_name': '事業者名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz_reg_num': '事業者登録番号',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz_category': '制作／配給業のタイプ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz_representative_name': '代表者名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_pic_name': '担当者氏名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_pic_email': 'Eメール',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_pic_contact': '連絡先',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_pic_guide':
    '事業者から審査過程を受け取る担当者の連絡先情報です。<br/>審査過程をGRAC STOVE審査レーティングの担当者にお伝えします。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_select': 'レーティングの選択',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_select_self_review': 'GRAC(大韓民国) STOVE審査レーティング分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_select_direct_input': '大韓民国のレーティング番号を照会する',
  'studio.prj_prod_mngmt.rating_build_review.edit_cf_msg3': '過去のレーティング情報は「履歴の表示」から確認できます。',
  'studio.prj_prod_mngmt.rating_build_review.edit_done_msg': 'レーティング情報が新規登録されました。',
  'studio.prj_prod_mngmt.rating_build_review.rating_info_title': 'レーティング情報',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_monitoring_rating_adj_guide':
    "該当のゲームは、事後のモニタリングによって<span class='text-tint-red-a400 font-bold'>レーティング調整措置の対象</span>に分類されました。詳細内容を確認してください。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.adj_see_detail_btn': '詳細の確認',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_3': 'レーティング調整措置',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_title': 'レーティング調整措置のご案内',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_rating': '調整レーティング',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_category': '含まれる内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_applied_date': '施行予定日',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_reason': '調整理由',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_accept_btn': 'レーティング承諾',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_accepted_msg1': '調整措置によるレーティングを承諾します',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_accepted_msg2':
    'レーティング施行予定日までレーティングおよびビルドの審査は行えません。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_accepted_cf_msg': 'レーティング調整措置によるレーティングの受諾が完了しました。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.reject_adj_change_msg1': '措置内容を受諾せず、ゲームの内容を修正します',
  'studio.prj_prod_mngmt.rating_build_review.self_review.reject_adj_change_msg2':
    '審査が完了するまでゲームがストアで展示中止の扱いとなり、販売できなくなります。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change_guide_popup':
    'レーティングおよびビルド審査のメニューから<br/>内容修正報告を完了してください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_change_x':
    '個人・事業者情報を審査中です。<br/>審査完了後に内容修正報告ができるようになります。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_guide': 'レーティング調整措置のご案内',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_guide1':
    'レーティング承諾をすると、レーティング施行予定日までビルドおよびレーティング審査の登録を行うことができません。施行予定日には変更されたレーティングで適用されます。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_guide2_1':
    'コンテンツの修正を行うと、審査が完了するまでゲームがストアで展示中止の扱いとなり、販売できなくなります。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_guide2_2':
    '内容修正の報告の審査が完了後、<br/>Gameを再度リリースプランに登録して販売できるようになります。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_accepted_guide':
    "レーティング調整措置による<span class='text-brand-primary font-bold'>措置内容を受諾</span>しました。{reclassifyDate}まで新しいビルドおよびレーティング審査をリクエストできません。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change_required_guide':
    '内容修正報告を行ってください。審査が完了するまでゲームが展示中止の扱いとなり、販売できなくなります。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_guide':
    "該当のゲームは、事後のモニタリングによって<span class='text-tint-red-a400 font-bold'>職権による再分類の対象</span>に分類されました。詳細内容を確認してください。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_4': '職権による再分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_pg_title': '職権による再分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_title': '職権による再分類のご案内',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_accepted_cf_msg': '職権による再分類によるレーティングの受諾が完了しました。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_announce': '職権による再分類のご案内',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_guide1_1':
    'レーティングの受諾を行うと、レーティング施行予定日までゲームがストアで展示中止の扱いとなり、販売できなくなります。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_guide1_2': '施行予定日には変更されたレーティングで適用されます。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_guide1_3':
    '内容修正報告の報告の審査が完了後、レーティングが{rating}に分類された後でGameを再度リリースプランに登録して販売できるようになります。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_guide2':
    'コンテンツの修正を行う場合、審査が完了するまでGameがStoreで展示中止の扱いとなり、販売できなくなります。<br/>内容修正報告の審査完了後に<br/>Gameを再度リリースプランに登録して販売できるようになります。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_accepted_guide':
    "職権による再分類による<span class='text-brand-primary font-bold'>措置内容を受諾</span>しました。{date}までゲームの展示が中止され、販売できません。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.adj_adj_see_detail_btn': '詳細の確認',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_report_change_required_guide':
    '内容修正報告を行ってください。審査が完了するまでゲームが展示中止の扱いとなり、販売できなくなります。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_teenager_x_info_reg_guide':
    '職権による再分類によってレーティングが青少年利用不可に分類されたゲームです。GRAC(韓国ゲーム物管理委員会)の審査後に発給されたレーティング分類情報を登録してください。',
  'studio.prj_prod_mngmt.rating_build_review.edit_cf_msg2': 'すでにゲームがリリースされている場合は、今後変更した内容が適用されます。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_guide':
    "該当のGameは、事後のモニタリングによって<span class='text-tint-red-a400 font-bold'>レーティング取消措置の対象</span>に分類されました。Storeでの販売が中断され、ユーザーはGameをプレイできなくなります。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_5': 'レーティング取消',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_pg_title': 'レーティング取消',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_title': 'レーティング取消のご案内',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_appeal_detail': '釈明内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_appeal_req_btn': '釈明申請 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_appeal_req_done_popup':
    '釈明申請が完了しました。<br/>釈明の確認まで3～4営業日かかります。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_guide_title': 'レーティング取消のご案内',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_guide1_1': 'レーティングが取り消されました。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_guide1_2':
    '釈明申請を行わないと、施行予定日にはレーティングが取り消されます。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_guide1_3': '施行予定日以降はゲームの展示、販売、プレイが中断されます。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_guide':
    "該当のGameは、事後のモニタリングによって<span class='text-tint-red-a400 font-bold'>レーティング審査拒否の対象</span>に分類されました。Storeでの販売が中断され、ユーザーはGameをプレイできなくなります。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_6': 'レーティング拒否',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_pg_title': 'レーティング拒否',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_title': 'レーティング拒否のご案内',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_appeal_detail': '釈明内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_announce': 'レーティング拒否のご案内',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_guide1_1': 'レーティングが拒否されました。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_guide1_2': '釈明申請を行わないと、施行予定日にはレーティングが拒否されます。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_guide1_3': '施行予定日以降はゲームの展示、販売、プレイが中断されます。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_7': '履歴を確認する',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history_pg_title': '履歴を確認する',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.report_change_approved': '内容修正報告（承認）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.dropbox_latest_order': '新しい順',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case1_approved_title': '登録(承認)',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_a': 'ゲーム名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_b': 'レーティングの種類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_c': 'レーティング分類日',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_d': 'レーティング分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_e': '含まれる内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_f': 'レーティング分類番号',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_h': '国際レーティング分類番号',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case2_rejected_title': '登録(リジェクト)のケース',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_g': 'ビルドID',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_i': '理由',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case3_registered_title': '登録のケース',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case4_edit_title': '修正のケース',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case5_change_approved_title': '内容修正報告(承認)',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_j': '変更事項',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case6_change_rejected_title': '内容修正報告－リジェクト',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case7_rating_adj_title': 'レーティング調整',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_k': '施行日 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case8_auth_adj_title': '職権による再分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case9_rating_cancelled_title': 'レーティング取消',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case10_rating_rejected_title': 'レーティング拒否 ',
  'studio.prj_prod_mngmt.rating_build_review.latest_review_req_info_title': '最近の審査完了情報',
  'studio.prj_prod_mngmt.rating_build_review.latest_review_req_info_guide':
    'まだリリースされていない予備のレーティングの審査情報です。リリース後は「レーティングの審査情報」にアップデートされます。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_prod_name': 'ゲーム名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_company': 'デベロッパー名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_genre': '代表ジャンル',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_type': 'レーティングの種類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_assigned_date': 'レーティング分類日',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_classif': 'レーティング分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_classif_detail': '含まれる内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_reg_num': 'レーティング分類番号',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_build_id': 'ビルドID',
  'studio.prj_prod_mngmt.rating_build_review.rating_review_info_title': 'レーティング審査情報',
  'studio.prj_prod.this_prod.prod_mgmt_price_breadcrumb1': 'プロジェクト・商品管理 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_breadcrumb2': '{prodName}',
  'studio.prj_prod.this_prod.prod_mgmt_price_breadcrumb3': '商品ページ',
  'studio.prj_prod.this_prod.prod_mgmt_price_title': '価格',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_btn': '登録',
  'studio.prj_prod.this_prod.prod_mgmt_price_landing_guide1': '商品の販売価格を登録してください。<br/>国別に表示させる価格も直接登録できます。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_x_under_review_pop_msg1':
    '審査状態の価格情報があります。<br/>取消または削除後に修正できるようになります。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_title': '価格登録',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_sales_type_title': '販売タイプ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_sales_type_paid_msg': '有料',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_sales_type_free_msg': '無料',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_base_price_title': '基準販売価格',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_base_price_required_val_msg': '基準販売価格を設定してください。 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_base_price_msg':
    'USDの価格を選択するか入力してください。基準販売価格の適用後に通貨ごとの価格を直接修正できます。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_standard_price_manual_input_btn': '直接入力',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_guide1': 'ストア表示価格と決済価格の通貨がなぜ違うのでしょうか？',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_guide1_1':
    '実際の決済はグローバル－USD(＄)、大韓民国－KRW(₩)で行われます。ストア表示価格は参考用であり、その日のレートによって価格の表示が変わります。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_guide2': '入力可能な価格条件はありますか？',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_guide2_1': '価格はUSDの場合は0.99以上、KRWの場合は10以上を10単位で入力できます。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_standard_price_manual_input_title': '直接入力',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_standard_price_manual_input_apply_btn': '適用する',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_title': '通貨別価格',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_header1': 'ストア表示価格',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_checkout_price_header2': '決済価格',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_usd_msg': 'アメリカ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_krw_msg': '大韓民国',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_cny_msg': '中華人民共和国',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_eur_msg': 'EU',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_gbp_msg': 'イギリス',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_hkd_msg': '香港',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_idr_msg': 'インドネシア',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_jpy_msg': '日本',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_myr_msg': 'マレーシア',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_php_msg': 'フィリピン',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_sgd_msg': 'シンガポール',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_thb_msg': 'タイ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_vnd_msg': 'ベトナム',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_required_val_msg1': '基準販売価格を入力後に適用してください。 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_required_val_msg2': '未入力の項目があります。 決済価格欄を確認してください。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_standard_price_manual_input_invalid_val_msg2': '決済価格には数字と「.」のみ入力できます。',
  'studio.prj_prod.this_prod.prod_mgmt_price_edit_btn': '修正',
  'studio.prj_prod.this_prod.prod_mgmt_price_msg1': '商品のリリース後、下記の価格が適用されます。',
  'studio.breadcrumb.price_edit': '価格修正',
  'studio.prj_prod.this_prod.prod_mgmt_price_edit_title': '価格修正',
  'studio.prj_prod.this_prod.prod_mgmt_price_ msg0': '審査中',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_msg': 'LIVE適用',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_from_msg': '{dateTime}適用',
  'studio.prj_prod.this_prod.prod_mgmt_price_edit_adjust_live_price_pop_msg':
    '価格を修正する際には審査の手続きが必要です。<br/>審査には最大で5営業日かかることがあります。<br/>修正した価格は審査通過後にすぐ適用されます。 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_edit_adjust_live_price_pop_review_req_btn': '審査リクエスト',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_awaiting_review_msg1': '審査リクエスト',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_awaiting_review_msg2': '審査通過後にすぐ適用',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_awaiting_review_cancel_pop_msg':
    '審査をキャンセルしますか？<br/>キャンセルする場合、審査中のデータは削除されます。',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_awaiting_review_cancel_pop_withdraw_review_btn': '審査キャンセル',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_in_review_msg1': '審査中',
  'studio.prj_prod.this_prod.prod_mgmt_price_declined_review_msg': '審査リジェクト',
  'studio.prj_prod.this_prod.prod_mgmt_price_declined_review_timestamp_msg': '{dateTime}リジェクト',
  'studio.prj_prod.this_prod.prod_mgmt_price_delete_btn': '削除',
  'studio.prj_prod.this_prod.prod_mgmt_price_declined_reason_guide': 'リジェクト理由',
  'studio.prj_prod.this_prod.prod_mgmt_price_delete_pop_msg': '審査リジェクト状態の価格を削除しますか？',
  'studio.prj_prod.this_prod.prod_mgmt_price_delete_pop_delete_btn': '削除',
  'studio.prj_prod.this_prod.prod_mgmt_discount_title': '割引',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_btn': '登録',
  'studio.prj_prod.this_prod.prod_mgmt_discount_landing_guide1':
    '商品に複数の割引を追加できます。<br/>［販売価格］で入力した価格を基準に割引率が反映されます。<br/>限定数量の割引販売も可能です。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_title': '割引登録',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discount_name_title': '割引名',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discount_name_place_holder': '割引名を入力してください',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discount_name_required_val_msg1': '割引名を入力してください。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_start_date_title': '開始日',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_start_date_immed_apply': '即時',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_start_date_schedule_apply': '予約',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_end_date_title': '終了日',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_dup_period_val_msg1':
    '期間が重複している割引があります。期間を変更してから再度お試しください。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_reset_time_val_msg2': '予約日は現在時刻以降に設定してください。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_end_date_invalid_val_msg3': '終了日は開始日以降に設定してください。 ',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discount_rate_title': '割引率',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discount_rate_req_val_msg1': '割引率を入力してください。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discount_rate_valid_num_val_msg2': '割引率は0から100の範囲でなければなりません。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_guide1': '割引名とは何ですか？',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_guide1_1': '割引を区別できる名称を入力できます。ユーザーには表示されません。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_guide2': '割引率はどのように反映されるのですか？',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_guide2_1': '割引期間中の販売価格を基準に割引率が反映されます。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_guide3': '限定数量の割引価格を使用するとどうなりますか？',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_guide3_1':
    '限定数量の割引販売を設定した場合、全数が売り切れると割引価格での販売が終了します。<br/>全部売り切れなくても終了日時になると割引販売は終了します。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discounted_price_title': '割引適用価格',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discounted_price_msg':
    '下の価格は現在適用されている販売価格の基準で、販売価格を変更する場合はこれが変わります。<br/>ストア表示価格はその日のレートによって表示が変わる場合があります。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discounted_price_displayed_price_header1': 'ストア表示価格',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discounted_price_checkout_price_header2': '決済価格',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discounted_price_free_guide':
    '価格が無料に設定されています。レートに関係なく割引適用価格が無料として表示されています。 ',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discounted_price_free_msg': '無料',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_limited_sales_title': '限定数量の割引販売',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_limited_sales_enable_msg': '使用',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_limited_sales_disable_msg': '未使用',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_limited_sales_quantity_title': '限定販売数量',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_limited_sales_quantity_unit_msg': '個',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_limited_sales_quantity_valid_num_val_msg':
    '販売数量は1から9,999,999の間でなければなりません。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_status_header1': '状態',
  'studio.prj_prod.this_prod.prod_mgmt_discount_name_header2': '割引名',
  'studio.prj_prod.this_prod.prod_mgmt_discount_discount_rate_header3': '割引率',
  'studio.prj_prod.this_prod.prod_mgmt_discount_remaining_quantity_header4': '残数',
  'studio.prj_prod.this_prod.prod_mgmt_discount_period_header5': '期間',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_delete_btn': '削除',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_suspend_btn': '中断',
  'studio.prj_prod.this_prod.prod_mgmt_discount_status_upcoming_msg': '適用予定',
  'studio.prj_prod.this_prod.prod_mgmt_discount_status_active_msg': 'LIVE適用',
  'studio.prj_prod.this_prod.prod_mgmt_discount_status_expired_msg': '終了',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_suspend_pop_msg1': '割引中断',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_suspend_pop_msg2':
    '中断するには「SUSPEND」を入力してください。<br/>中断した後は復元できません。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_suspend_pop_withdraw_btn': '中断',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_delete_pop_msg': '適用予定の割引を削除しますか？',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_delete_pop_delete_btn': '削除',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_filter_all_msg': '全体',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_filter_active_or_upcoming_msg': 'LIVE適用／適用予定',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_filter_expired_msg': '終了',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_filter_no_data': '選択した条件に合う結果がありません。',
  'studio.breadcrumb.discount_details': '割引の詳細',
  'studio.prj_prod.this_prod.prod_mgmt_discount_this_discount_details_title': '割引の詳細',
  'studio.prj_prod.this_prod.prod_mgmt_discount_this_discount_details_limited_sales_remaining_quantity_msg': '(残数：{remainingNum}個)',
  'studio.prj_prod.this_prod.home_release_status': 'Studio商品のリリース状況',
  'studio.prj_prod.this_prod.home_release_status_msg1': '商品をリリースして、リリース後にアップデートする場合は進行状況を確認してください。',
  'studio.prj_prod.this_prod.home_release_status_msg2':
    'リリース後にアップデートを行う際は、各機能から即時あるいは予約してアップデートしてください。 ',
  'studio.prj_prod.this_prod.home_release_btn': 'リリースする',
  'studio.prj_prod.this_prod.home_guide1': '商品ページを<br/>準備してください。',
  'studio.prj_prod.this_prod.home_guide1_1': '商品設定と商品ページを両方入力したら、商品ページを先にリリースしてみましょう。',
  'studio.prj_prod.this_prod.home_guide2': 'ビルドと一緒に<br/>リリースしてください。',
  'studio.prj_prod.this_prod.home_guide2_1': '事前購入、アーリーアクセスなどリリース計画に応じて商品ページと一緒にビルドを正式リリースしてください。',
  'studio.prj_prod.this_prod.home_guide3': 'リリース後はアップデートを<br/>気軽に行ってください。',
  'studio.prj_prod.this_prod.home_guide3_1':
    '適用する項目のみを選択して気軽にアップデートしてみましょう。<br/>機能別の修正後、即時適用あるいは予約を行うことができます。',
  'studio.prj_prod.this_prod.home_release_status_timezone': 'Studio商品のリリース状況(UTC+9)',
  'studio.prj_prod.this_prod.home_prod_page_title': '商品ページ',
  'studio.prj_prod.this_prod.home_build_title': 'ビルド',
  'studio.prj_prod.this_prod.home_build_msg1': '正式リリースの場合、ビルドの状態が表示される予定です。',
  'studio.prj_prod.this_prod.home_sales_title': '価格(割引率)および割引価格',
  'studio.prj_prod.this_prod.home_sales_msg': '正式リリースの場合、販売価格が表示される予定です。',
  'studio.prj_prod.this_prod.home_review_progress_title': '審査およびLIVE適用',
  'studio.prj_prod.this_prod.home_review_progress_tooltip_msg':
    '審査リクエスト時は審査リクエスト、審査中、審査完了、審査リジェクトの状態が表示され、<br/>リリース後に機能ごとのアップデートが発生する場合は適用日時が表示されます。',
  'studio.prj_prod.this_prod.home_review_progress_stt1': '審査リクエスト',
  'studio.prj_prod.this_prod.home_review_progress_stt2': '審査中',
  'studio.prj_prod.this_prod.home_review_progress_stt3': '審査完了',
  'studio.prj_prod.this_prod.home_review_progress_stt4': '審査リジェクト',
  'studio.prj_prod.this_prod.home_release_stt_title': 'リリース状態',
  'studio.prj_prod.this_prod.home_release_stt_tooltip_msg':
    '商品ページのみを公開する場合は「商品ページオープン」、<br/>正式リリースする場合は「事前購入」「リリース予定」「正式リリース」として表示されます。<br/>ペナルティ状態の場合はアイコンが表示されますので、ステータスを確認してください。',
  'studio.prj_prod.this_prod.home_pre_release_guide': 'リリースプランに応じて状態が表示される予定です。',
  'studio.prj_prod.this_prod.home_release_stt_chk_btn': '商品リリース状況',
  'studio.prj_prod.this_prod.home_apply_stt1': '適用予定',
  'studio.prj_prod.this_prod.home_apply_stt2': 'LIVE適用',
  'studio.prj_prod.this_prod.stt_restriction_display_operator': '展示ペナルティ(運営者)',
  'studio.prj_prod.this_prod.stt_prod_pg_go_live_y': '商品ページのLIVE適用',
  'studio.prj_prod.this_prod.stt_prod_pg_go_live_n': '商品設定のLIVE適用',
  'studio.prj_prod.this_prod.stt_community_go_live_y': 'コミュニティのLIVE未適用',
  'studio.prj_prod.this_prod.stt_community_go_live_n': 'コミュニティのLIVE適用',
  'studio.prj_prod.this_prod.stt_discount_go_live_y': '割引のLIVE適用',
  'studio.prj_prod.this_prod.stt_discount_go_live_n': '起動設定のLIVE適用',
  'studio.prj_prod.this_prod.stt_ingame_store_go_live_y': 'ゲーム内ショップのLIVE適用',
  'studio.prj_prod.this_prod.stt_ingame_store_go_live_n': 'ゲーム内ショップのLIVE未適用',
  'studio.prj_prod.this_prod.stt_term_go_live_y': '商品規約のLIVE適用',
  'studio.prj_prod.this_prod.stt_term_go_live_n': '商品規約のLIVE未適用',
  'studio.prj_prod.this_prod.stt_achievement_go_live_y': 'チャレンジミッションのLIVE適用',
  'studio.prj_prod.this_prod.stt_achievement_go_live_n': 'チャレンジミッションのLIVE未適用',
  'studio.prj_prod.this_prod.stt_ranking_go_live_y': 'ランキングのLIVE適用',
  'studio.prj_prod.this_prod.stt_ranking_go_live_n': 'ランキングのLIVE未適用',
  'studio.prj_prod.this_prod.stt_cloud_saving_go_live_y': 'クラウドセーブのLIVE適用',
  'studio.prj_prod.this_prod.stt_cloud_saving_go_live_n': 'クラウドセーブのLIVE未適用',
  'studio.prj_prod.this_prod.stt_match_making_go_live_y': 'マッチメイクのLIVE適用',
  'studio.prj_prod.this_prod.stt_match_making_go_live_n': 'マッチメイクのLIVE未適用',
  'studio.prj_prod.this_prod.release_stt_browser_title': 'Studio商品のリリース状況',
  'studio.prj_prod.this_prod.release_stt_title': 'Studio商品のリリース状況',
  'studio.prj_prod.this_prod.release_stt_msg':
    '商品のリリースやアップデートの予約をするとカレンダーに状況が登録されます。登録した項目に応じて詳細情報と合わせて状態も一緒に確認できます。',
  'studio.prj_prod.this_prod.release_stt_browser_release_btn': 'リリースする',
  'studio.prj_prod.this_prod.release_stt_calendar_today_btn': '今日',
  'studio.prj_prod.this_prod.release_stt_filter_cbox_all': '全体',
  'studio.prj_prod.this_prod.release_stt_filter_cbox_prod_page': '商品ページ',
  'studio.prj_prod.this_prod.release_stt_filter_cbox_build': 'ビルドおよびレーティング',
  'studio.prj_prod.this_prod.release_stt_filter_cbox_price_and_discounts': '価格および割引',
  'studio.prj_prod.status_review_requested': '審査リクエスト',
  'studio.prj_prod.status_review_declined': '審査リジェクト／ペナルティ',
  'studio.prj_prod.status_live': 'LIVE適用',
  'studio.prj_prod.status_suspend_or_deleted': '中止／削除',
  'studio.prj_prod.this_prod.release_stt_calendar_event_date': '{eventDate}日',
  'studio.prj_prod.this_prod.release_stt_calendar_event_msg': 'まだ登録した商品がありません。',
  'studio.prj_prod.this_prod.release_stt_event_list_ex_msg': 'まだ登録した商品がありません。',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_request_review_btn': '審査リクエスト',
  'studio.prj_prod.this_prod.release_details_pbar_msg1': 'リリースの準備中です',
  'studio.prj_prod.this_prod.release_details_pbar_prep_completed': 'リリースの準備が完了しました。審査をリクエストしてください。',
  'studio.prj_prod.this_prod.review_status_pbar_under_review': '運営者が審査中です。最大で5日かかることがあります。',
  'studio.prj_prod.this_prod.release_details_pbar_rejected': 'リジェクトされました。項目を確認してから審査をリクエストしてください。',
  'studio.prj_prod.this_prod.review_status_pbar_msg5': '審査が完了しました。リリース待機中です。',
  'studio.prj_prod.this_prod.release_stt_pbar_msg6': '商品がリリースされ、LIVE適用中です。',
  'studio.prj_prod.this_prod.release_stt_pbar_release_terminated': 'リリースが中断されました。リリースの再開や削除を行うことができます。',
  'studio.prj_prod.this_prod.release_details_page_only_title': '商品ページのみオープンします。',
  'studio.prj_prod.this_prod.release_details_page_only_msg':
    'リリース予定として表示して商品を先に広報し、コミュニティでユーザーとコミュニケーションを取ることができます。',
  'studio.prj_prod.this_prod.release_details_with_build_msg':
    'リリースに必要な内容をすべて準備しましたか？事前リリース、アーリーアクセスなどの計画を立てて商品を販売できます。',
  'studio.prj_prod.this_prod.release_details_product_page_info_title': '商品ページの準備',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_setting_title': '商品設定',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_setting_msg1':
    '商品の基本情報(商品名、クリエイター名、パブリッシャー名)、ジャンル、商品タイプがすべて入力されているか確認してください。',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_setting_redirect_btn': '移動する',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_setting_complete_msg': '商品設定がすべて入力されていません。',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_setting_missing_msg': '商品設定ができていません。',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_page_title': '商品ページ',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_page_msg': '必須項目をすべて入力した商品ページのみがリストに表示されます。',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_page_redirect_btn': '移動する',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_page_dbox_default_msg': '商品ページを選択してください',
  'studio.prj_prod.this_prod.release_details_product_page_preview_dir_btn': 'プレビュー',
  'studio.prj_prod.this_prod.release_details_product_page_option_title': '商品ページのオプション',
  'studio.prj_prod.this_prod.release_details_product_page_option_store_community_title': 'ストアコミュニティ',
  'studio.prj_prod.this_prod.release_details_product_page_option_store_community_msg1':
    'コミュニティがまだ登録されていなくても、商品ページのオープン後に自動でコミュニティが登録されます。',
  'studio.prj_prod.this_prod.release_details_product_page_option_store_community_mgmt_dir_btn': '移動する',
  'studio.prj_prod.this_prod.release_details_product_page_option_store_community_msg2':
    '商品ページの公開後、コミュニティが自動で作成される予定です。<br/>コミュニティを他の商品と統合したい場合は、グループホーム > ストアコミュニティメニューで統合設定を行ってください。',
  'studio.prj_prod.this_prod.release_details_release_plan_title': 'リリースプラン',
  'studio.prj_prod.this_prod.release_details_release_plan_product_page_open_title': 'ショップページオープン',
  'studio.prj_prod.this_prod.release_details_release_plan_product_page_open_date_title': '商品ページオープン日',
  'studio.timezone_preview_view_btn': '主要都市のUTCを見る',
  'studio.timezone_preview_pop_title': '主要都市のUTC',
  'studio.timezone_preview_pop_seoul': 'ソウル',
  'studio.timezone_preview_pop_tokyo': '東京',
  'studio.timezone_preview_pop_beijing': '北京 ',
  'studio.timezone_preview_pop_taipei': '台北',
  'studio.timezone_preview_pop_london': 'ロンドン',
  'studio.timezone_preview_pop_nyc': 'ニューヨーク',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_title': 'リリース情報',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_msg': '設定した順序に沿ってストアに適用され、リリースされる予定です。',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_current_status_msg': '現在(リリース前)',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_this_status_msg': 'ショップページオープン',
  'studio.prj_prod.this_prod.release_details_release_form_confirmation': '設定した情報でリリースします。',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_info_mismatch_msg1':
    '各機能で設定したデータとリリース情報とが合致しません。 ',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_info_mismatch_msg2': '項目を確認してから更新ボタンを押してください。',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_msg1': '審査中は、リリースに記入した情報を修正したり削除したりできません。',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_msg2': 'STOVEの運営者による審査は、1～5日程度かかることがあります。',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item_title': '審査項目',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item1': '商品設定',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item2': '商品ページ ',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item3': 'リリースプラン',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_manual_release_select_msg':
    '審査完了後、設定したリリース日程を調整してすぐにリリースできます。',
  'studio.prj_prod.this_prod.release_details_browser_request_review_request_review_alert_msg': '審査のリクエストが完了しました。',
  'studio.prj_prod.this_prod.release_details_browser_withdraw_review_request_btn': '審査リクエストのキャンセル',
  'studio.prj_prod.this_prod.release_details_browser_withdraw_review_request_pop_msg1': '本当に審査のリクエストをキャンセルしますか？',
  'studio.prj_prod.this_prod.release_details_browser_withdraw_review_request_pop_msg2': 'キャンセル後、再審査は1～5日程度かかることがあります。',
  'studio.common.popup_case_close_btn': '閉じる',
  'studio.prj_prod.this_prod.release_details_browser_withdraw_review_request_msg1': '審査のリクエストがキャンセルされました。',
  'studio.prj_prod.this_prod.release_details_browser_withdraw_review_request_msg2': '必須項目を確認してから再度審査をリクエストしてください。',
  'studio.prj_prod.this_prod.release_stt_browser_product_release_info_btn': '商品リリース情報',
  'studio.noti.review_req_for_release.completed_msg':
    '{prodName}({prodNo})の商品リリースに向けた審査がリクエストされました。<br/>間もなくSTOVE運営者の審査が行われる予定です。審査期間は、営業日基準で最大一週間かかります。審査中は商品情報を修正できなくなります。',
  'studio.mail.case_review_request.title': '審査リクエスト',
  'studio.mail.case_review_request.mail_content': 'リリースのための審査のリクエストが完了しました。',
  'studio.prj_prod.prod_release_info_pg_dir_btn': '商品リリース情報',
  'studio.mail.case_in_review.title': '審査中',
  'studio.mail.case_in_review.content_msg1': 'STOVEの運営者が審査を進行中です。',
  'studio.mail.case_in_review.content_msg2': '審査中は商品情報を修正できません。',
  'studio.mail.review_status_in_review_detail_msg3':
    '※Studioの審査が完了すると、リリース日に合わせて商品ページがオープンし、商品を販売できるようになります。',
  'studio.mail.review_status_in_review_detail_msg4':
    '審査期間は最大で一週間かかります。審査中は商品情報の修正や審査のリクエストを行うことができません。',
  'studio.noti.review_req_rejected_msg':
    '{prodName}({prodNo})の審査リクエストがリジェクトされました。<br/>リジェクトの理由を確認して、再度審査をリクエストしてください。 ',
  'studio.prj_prod.this_prod.review_status_pbar_msg4_1': 'リジェクトされました。',
  'studio.prj_prod.this_prod.review_status_pbar_msg4_2': '項目を確認し修正した後、更新ボタンを押して審査リクエストを送信してください！',
  'studio.prj_prod.release_info_checklist_stt_incompleted': '未完了',
  'studio.prj_prod.this_prod.release_details_rejection_criteria_msg': 'リジェクト理由',
  'studio.mail.case_review_rejected.title': '審査リジェクト',
  'studio.mail.case_review_rejected.content_msg1': 'STOVE運営者の審査が完了しました。',
  'studio.mail.case_review_rejected.content_msg2':
    '商品のリリースがリジェクトされたため、商品のリリース状況を確認して再度審査のリクエストを行ってください。',
  'studio.prj_prod.this_prod.popup_product_page_change_saved_msg': 'リリース情報が反映されました。',
  'studio.mail.case_review_completed.title': '審査完了',
  'studio.mail.case_review_completed.content_msg1': 'STOVE運営者の審査が完了しました。',
  'studio.mail.case_review_completed.content_msg2': 'リリースのスケジュールに従ってストアに商品ページがオープンする予定です。',
  'studio.mail.case_review_completed.content_msg3': '手動リリースに設定した商品は、商品リリース状況から直接リリースを行ってください。',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_btn': '手動LIVE適用',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_pop_title': 'LIVE適用',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_pop_msg': '商品ページを適用するには「RELEASE」を入力してください。 ',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_apply_pop_msg1': 'おめでとうございます！ ',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_apply_pop_msg2': '商品ページがオープンしました。',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_apply_pop_msg3': 'ストアで商品ページを確認してください。',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_apply_pop_redirect_store_btn': 'ストアに移動',
  'studio.prj_prod.this_prod.home_release_stt_browser_manual_release_btn': '手動LIVE適用',
  'studio.noti.prod_pg_opened_msg': 'おめでとうございます！<br/>{prodName}(prodNo})の商品ページが公開されました。',
  'studio.prj_prod.this_prod.release_stt_calendarview_store_dir_btn': 'ストアに移動',
  'studio.prj_prod.this_prod.release_stt_calendarview_community_dir_btn': 'コミュニティ',
  'studio.mail.case_release_notice.title': 'リリース案内',
  'studio.mail.case_release_notice.content_msg1': 'おめでとうございます。',
  'studio.mail.case_release_notice.content_msg2': 'STOVEストアに商品ページがオープンしました。',
  'studio.mail.redirect_product_page_btn': 'ストアの商品ページに移動',
  'studio.prod_home.release_info_open_suspend_btn': '商品ページオープン中断',
  'studio.prod_home.popup_prod_pg_open_suspend_msg1': '商品ページのオープン中断時は商品の削除が可能で、ストアから自動で展示が非表示になります。 ',
  'studio.prod_home.popup_prod_pg_open_suspend_msg2': '商品ページのオープンを中断しますか？',
  'studio.prod_home.popup_prod_pg_open_suspend_cf_btn': 'オープン中断',
  'studio.prod_home.prod_pg_reopen_btn': '商品ページオープンペナルティ',
  'studio.prod_home.popup_prod_pg_reopen_msg1': '再度オープン状態に変更しますか？',
  'studio.prod_home.popup_prod_pg_reopen_msg2': 'ストアに再度商品ページがオープンします。',
  'studio.prj_prod.this_prod.stt_release_sale_suspended_guide.case_prod_pg_only':
    '商品ページのオープンが中断されました。再度オープンするか、プロジェクトおよび商品管理から削除することができます。',
  'studio.prj_prod.this_prod.stt_release_sale_suspended_guide.case_prod_pg_build':
    '販売が中断されました。販売を再開するか、プロジェクトおよび商品管理から削除することができます。',
  'studio.prod_home.release_info_sale_suspend_btn': '販売中断',
  'studio.prod_home.popup_release_info_sale_suspend_msg1': '本当に販売を中断しますか？',
  'studio.prod_home.popup_release_info_sale_suspend_msg2': 'ストアで販売が中断された状態に表示されます。',
  'studio.prod_home.release_info_restart_sale_btn': '販売再開',
  'studio.prj_prod.this_prod.del_req_rejected_reason_1':
    "リリース後の商品ページのオープン中断に関する内容は、運営者との事前協議後に削除できます。<br/>協議をするにはEメール(stoveindie{'@'}smilegate.com)でお問い合わせください。",
  'studio.prj_prod.this_prod.del_req_rejected_reason_2':
    "リリース後、お客様の購入履歴がある商品は商品の販売中断についての告知、精算および契約撤回過程などを運営者と事前に協議した後で削除できます。<br/>協議をするにはEメール(stoveindie{'@'}smilegate.com)でお問い合わせください。",
  'studio.prj_prod.release_info_official_release_date_input_n': '未入力',
  'studio.prj_prod.this_prod.release_details_product_page_guide':
    '必須項目をすべて入力した商品ページの中で選択できます。リリース日は審査期間を考慮して1週間後から設定できます。',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_title': '早期アクセスの文言',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_msg': 'アーリーアクセスの文言を設定していません',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_preview_btn': 'アーリーアクセスの文言表示有無',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_redirect_btn': '移動する',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_content_place_holder': '早期アクセスの文言を設定していません。',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_period_title': '期間設定',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_period_msg':
    '「アーリーアクセス」の文言は、正式リリース後も自由に設定し、表示することができます。',
  'studio.release_details.period_settings.start_date_before_open_val_msg2': '開始日は商品ページのオープン日以降に設定してください。',
  'studio.prj_prod.this_prod.release_details_build_title': 'ビルド準備',
  'studio.prj_prod.this_prod.release_details_build_execution_title': '起動設定',
  'studio.prj_prod.this_prod.release_details_build_execution_msg':
    'ビルドアップロード後、STOVEのPCクライアントからビルドを生成できる設定を行ってください。',
  'studio.prj_prod.this_prod.release_details_build_execution_place_holder2': '起動設定がすべて入力されていません',
  'studio.prj_prod.this_prod.release_details_build_execution_place_holder1': '起動設定がされていません。',
  'studio.prj_prod.this_prod.release_details_build_execution_redirect_btn': '移動する',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review_title': 'ビルド管理およびレーティング',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review_msg1':
    'リリースするビルドを選択してください。ビルドリストはレーティング審査が完了した最新のビルド順に表示されます。',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review_msg2':
    'リストにビルドが表示されない場合は、ビルド管理からアップロードした後にレーティングの審査を受けているか確認してください。',
  'studio.prj_prod.build_mgmt_pg_dir_btn': 'ビルド管理',
  'studio.prj_prod.rating_build_review_pg_dir_btn': 'レーティングおよびビルド審査',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review_build_dbox_place_holder': 'リリースするビルドを選択してください',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review_build_dbox_required_val': 'リリースするビルドを選択してください。',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review.self_review_expected_rating_guide':
    'レーティング審査により、予備レーティング({expectedRating})を獲得しました。このレーティングはリリース当日に反映されます。 ',
  'studio.prj_prod.this_prod.release_details_studio_support_title': 'ゲームサポートサービス設定',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_title': 'ゲーム内ショップ ',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_msg':
    'ゲーム内でアイテムを生成してユーザーに販売できる機能です。 ゲーム内ショップがアクティブな場合、商品規約＞サービス利用と決済前の注意事項を必ず設定してください。',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_redirect_btn': '移動する',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_shop_name_msg': 'ショップ名',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_quantity_msg': '商品数',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_server_hosting_msg': 'ゲームサーバーの有無',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_place_holder': 'ゲーム内ショップが登録されていません。',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review.rating_none_guide': 'まだレーティングを判定されていません。',
  'studio.prj_prod.this_prod.release_details_studio_support_term_title': '商品規約',
  'studio.prj_prod.this_prod.release_details_studio_support_term_msg':
    '商品をリリースする際は規約を適用してリリースしなければなりません。商品規約の設定で前もって規約を生成して適用してください。',
  'studio.prj_prod.this_prod.release_details_studio_support_no_term_msg': 'ショップの規約が登録されていません。',
  'studio.prj_prod.this_prod.release_details_studio_support_term_category': '規約の種類',
  'studio.prj_prod.this_prod.release_details_studio_support_term_name': '規約管理名',
  'studio.prj_prod.this_prod.release_details_studio_support_term_version': 'バージョン',
  'studio.prj_prod.this_prod.release_details_studio_support_term_redirect_btn': '移動する',
  'studio.prj_prod.this_prod.release_details_studio_support_achievements_title': 'チャレンジミッション',
  'studio.prj_prod.this_prod.release_details_studio_support_achievements_msg':
    'ゲームデータと連携してチャレンジミッションを作成し、商品ページに表示および適用できます。SDK連携後にチャレンジミッションが登録・設定されることで適用されます。',
  'studio.prj_prod.this_prod.release_details_studio_support_achievements_redirect_btn': '移動する',
  'studio.prj_prod.this_prod.release_details_studio_support_achievements_registered_challenges_msg': 'チャレンジミッションの登録数',
  'studio.prj_prod.this_prod.release_details_studio_support_achievements_place_holder': 'チャレンジミッションが登録されていません。',
  'studio.prj_prod.this_prod.release_details_studio_support_ranking_title': 'ランキング',
  'studio.prj_prod.this_prod.release_details_studio_support_ranking_msg':
    'スタッツを基準にユーザーが達成するランキングを商品ページに表示および適用できます。SDK連携後にランキングが登録・設定されることで適用されます。',
  'studio.prj_prod.this_prod.release_details_studio_support_ranking_redirect_btn': '移動する',
  'studio.prj_prod.this_prod.release_details_studio_support_ranking_registered_ranking_to_total_number_msg': 'ランキング登録数',
  'studio.prj_prod.this_prod.release_details_studio_support_ranking_place_holder': 'ランキングが登録されていません。',
  'studio.prj_prod.this_prod.release_details_studio_support_cloud_title': 'クラウドセーブ',
  'studio.prj_prod.this_prod.release_details_studio_support_cloud_msg':
    'ユーザーのゲームデータファイルをクラウドサーバーに適用できる機能です。SDK連携後にクラウドセーブの適用有無を設定してください。',
  'studio.prj_prod.this_prod.release_details_studio_support_cloud_redirect_btn': '移動する',
  'studio.prj_prod.this_prod.release_details_studio_support_cloud_savefile_location_msg': 'セーブファイル保存フォルダ',
  'studio.prj_prod.this_prod.release_details_studio_support_cloud_savefile_info_msg': 'セーブファイル情報',
  'studio.prj_prod.this_prod.release_details_studio_support_cloud_savefile_place_holder': 'クラウドセーブが設定されていません。',
  'studio.prj_prod.this_prod.release_details_studio_support_match_title': 'マッチメイク',
  'studio.prj_prod.this_prod.release_details_studio_support_match_msg':
    'ゲームプレイ時にユーザーが低いネットワークPINGを維持するためにサポートする機能です。SDKが連携されると有効にできるようになります。 ',
  'studio.prj_prod.this_prod.release_details_studio_support_match_redirect_btn': '移動する',
  'studio.prj_prod.this_prod.release_details_studio_support_match_status_intergrated_msg': 'マッチメイクが連携されました。',
  'studio.prj_prod.this_prod.release_details_studio_support_match_status_not_prepared_msg': 'マッチメイクが設定されていません。',
  'studio.prj_prod.this_prod.release_details_sales_setting_title': '販売設定',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_title': '価格設定',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_msg':
    '登録されている販売価格を確認してください。入力されている販売価格が異なる場合、価格ページで修正してください。',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_redirect_btn': '移動する',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_sales_type_msg': '販売タイプ',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_sales_type_this_type_free': '無料',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_case_free_place_holder': '価格が設定されていません',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_sales_type_this_type_paid': '有料',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_price_msg': '販売価格',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_title': 'リリース割引設定',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_msg':
    'リリースの際に割引が必要な場合に設定してください。',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_radio_enable_msg': '使用',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_radio_disable_msg': '未使用',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_period_title': '割引期間',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_period_msg': '正式リリース日から',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_period_in_days_msg': 'デイリー',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_discount_rate_title': '割引率',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_discounted_price_title': '割引適用価格',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_discounted_price_msg1':
    '下の価格は現在適用されている価格の基準で、販売価格を変更する場合に変わります。 ',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_discounted_price_msg2':
    'ストア表示価格はその日のレートによって表示が変わることがあります。',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_discounted_price_regional_price_btn':
    '国別販売価格の確認',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_displayed_price_header1': 'ストア表示価格',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_checkout_price_header2': '決済価格',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_discounted_price_regional_price_pop_title': '国別価格',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_title': '限定販売の設定',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_msg':
    '正式リリース後に残数がなくなったり期間が終了したりすると、販売が中断されます。',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_radio_sales_by_volume_msg': '販売数量の終了時に中断',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_radio_sales_by_period_msg': '期間終了時に中断',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_radio_deactivated_msg': '未使用',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_quantity_limit_title': '販売数量の設定',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_quantity_limit_counting_unit_ko': '個',
  'studio.release_info_setting.limited_sales_quantity_required_msg': '販売数量を入力してください。',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_period_setting': '終了日の設定',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_period_input_n_val_msg': '終了日を設定してください。 ',
  'studio.prj_prod.this_prod.release_details_pur_cond_title': '購入オプション',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_title': '購入条件の設定',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_msg1':
    '現在リリースしている商品を購入する前に他の商品を購入しなければならないという条件を適用できます。 ',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_msg2': '購入条件で設定した商品リストが追加されます。',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_cond_type_title': '条件タイプ',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_cond_type_this_type_and': 'AND条件',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_cond_type_this_type_or': 'OR条件',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_place_holder': '購入条件が設定されていません。',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_redirect_btn': '移動する',
  'studio.prj_prod.this_prod.release_details_plan_title': 'リリースプラン',
  'studio.prj_prod.this_prod.release_details_plan_product_page_open_title': '商品ページオープン',
  'studio.prj_prod.this_prod.release_details_plan_product_page_open_msg': '商品ページオープン日は、審査期間を考慮して1週間後から設定できます。',
  'studio.prj_prod.this_prod.release_details_plan_product_page_open_date_title': '商品ページオープン日',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_title': '事前購入の設定',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_msg':
    '正式リリース日より前に販売したい場合は、事前購入を設定してください。事前購入したユーザーのダウンロードおよびインストール、起動オプションも設定できます。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_radio_enable_msg': '使用',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_radio_disable_msg': '未使用',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_title': '正式リリース日の設定',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_msg':
    'まだ正式リリース日が決まっていない場合は、ユーザーに表示されるオプションを設定してください。リリース前にいつでも自由に変更できます。',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_release_option': '表示オプション',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_release_option_dbox_opt1_upcoming': 'リリース予定',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_release_option_dbox_opt4_quarter': '{relYear} 第{quarter}四半期',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_release_date_title': '正式リリース日',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_schedule_setting_title': '期間設定',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_schedule_setting_end_date_input_n_val_msg1': '終了日を選択してください。 ',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_schedule_setting_end_date_after_official_release_val_msg2':
    '終了日は正式にリリースする日より前に設定してください。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_download_and_installation_title': 'ダウンロードとインストール',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_download_and_installation_allow': '許可',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_download_and_installation_not_allow': '許可しない',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_title': '起動',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_allow_all': 'すべて許可',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_allow_by_stove_mem_no': 'STOVE会員番号登録',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_stove_mem_no_reg_tooltip':
    'STOVEにログイン後、MY情報＞会員番号を確認してテンプレートに登録すると許可したユーザーだけが起動できます。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_allow_by_ip_address': 'IPアドレス登録',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_ip_address_reg_tooltip':
    'ゲームを起動するため、テンプレートに登録されているIPアドレスのユーザーのみを許可して起動します。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_not_allow': '許可しない',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_reg_template_placeholder':
    'テンプレートのダウンロード後にアップロードしてください。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_reg_file_upload_btn': 'アップロード',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_upload_failed_alert1': 'アップロードに失敗しました。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_upload_failed_alert2_case_mem_no':
    '{memNo}に誤りがあります。修正後、再アップロードしてください。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_upload_failed_alert2_case_ip_address':
    '{ipAddress}に誤りがあります。修正後、再アップロードしてください。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_upload_failed_case_invalid_input_value':
    'アップロード失敗：Excelファイル内に非対応の文字が含まれています。ファイルをご確認ください。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_upload_failed_case_over_1000':
    'アップロード失敗：サポートメンバーが1,000名を超えています。メンバーの数を調整してからもう一度お試しください。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_upload_failed_case_invalid_format':
    'アップロード失敗：正しくないファイル形式です。対応しているファイル形式を使用してください。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_reg_template_download_btn': 'テンプレートダウンロード',
  'studio.file_excel_whitelist_sheet1_guide_header2': 'ガイド(Guide)',
  'studio.file_excel_whitelist_sheet1_introduction':
    'STOVEに登録している会員番号を入力してください。<br/>最大で1,000名まで入力可能です。<br/>Please enter STOVE membership number.<br/>You can enter up to 1,000 Users.',
  'studio.file_excel_whitelist_sheet2_introduction':
    'プレイを許可するIPアドレスを入力してください。<br/>最大で1,000名まで入力可能です。<br/>Please enter your IP address.You can enter up to 1,000 Users.',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_view_guide': '登録した情報を確認してください。',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_present': '現在(リリース前)',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_prod_pg_open': '商品ページオープン',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_early_access_display_on': '早期アクセス文言の表示',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_end_date_invalid_val_msg1': '終了日は正式リリース日以降に設定できません。',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_pre_order': '事前購入',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_official_release': '正式リリース',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_discount': 'リリース割引',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_discount_start_date_invalid_val_msg':
    'リリース割引開始日は正式リリース日に合わせて設定しなければなりません。',
  'studio.prj_prod.this_prod.release_details_opt_switch.prod_pg_release_only_popup_msg1':
    '商品ページに関する情報を除き、これまで入力した情報がリセットされます。 ',
  'studio.prj_prod.this_prod.release_details_opt_switch.prod_pg_release_only_popup_msg2': '商品ページのみをオープンに変更しますか？',
  'studio.common.popup_case_change_btn': '変更する',
  'studio.prj_prod.release_info_checklist_stt_completed': '完了',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item4': '起動設定',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item5': 'ビルド管理およびレーティング',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item6': '価格設定',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item7': 'リリース割引',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item8': '販売数量の設定',
  'studio.home.release_timeline.prod_pg_item.community_open': 'コミュニティオープン',
  'studio.home.release_timeline.prod_pg_item.community_early_access': 'アーリーアクセス',
  'studio.home.release_timeline.prod_pg_item.community_ingame_store': 'ゲーム内ショップ',
  'studio.home.release_timeline.prod_pg_item.community_term': '商品規約',
  'studio.home.release_timeline.prod_pg_item.community_achievements': 'チャレンジミッション',
  'studio.home.release_timeline.prod_pg_item.community_ranking': 'ランキング',
  'studio.home.release_timeline.prod_pg_item.community_cloud_saving': 'クラウドセーブ',
  'studio.home.release_timeline.prod_pg_item.community_match_making': 'マッチメイク',
  'studio.home.release_timeline.prod_pg_item.price_release_discount': 'リリース割引',
  'studio.home.release_timeline.prod_pg_item.price_discount_period': '{discountDayNum}日',
  'studio.home.release_timeline.prod_pg_item.price_sale_limit': '販売数量',
  'studio.home.release_timeline.prod_ptyitem.price_sale_limit_quantity': '{limitedNum}個',
  'studio.home.release_timeline.prod_pg_item.price_sale_limit_guide': '販売数量の終了時に中断',
  'studio.home.release_timeline.prod_pg_item.price_sale_period_terminate_guide': '期間終了時に中断',
  'studio.home.release_timeline.prod_pg_item.price_purchase_cond_set': '購入条件の設定',
  'studio.home.release_timeline.prod_pg_item.release_plan_prod_page_open': '商品ページオープン',
  'studio.home.release_timeline.prod_pg_item.release_plan_pre_order': '事前購入',
  'studio.home.release_timeline.prod_pg_item.release_plan_download_install_allow_yn': 'ダウンロードおよびインストールを許可',
  'studio.home.release_timeline.prod_pg_item.release_plan_exe_allow_yn': '起動をすべて許可',
  'studio.home.release_timeline.prod_pg_item.release_plan_official_release_date': '正式リリース日',
  'studio.prj_prod.this_prod.release_details_save_btn': '保存',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_period_start_end_date_equal_val_msg1':
    '終了日時は開始日時より後に設定してください。開始日時と終了日時を再度設定してください。',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_period_start_date_before_open_val_msg2':
    '開始日は商品ページのオープン日以降に設定してください',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_period_end_date_input_n_val_msg3': '終了日を設定してください。 ',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_period_end_date_after_official_release_val_msg4':
    '終了日は正式リリース日以前に設定してください。',
  'studio.group.home.board_type5_to_be_applied_item1_prod_pg': '商品ページ',
  'studio.group.home.board_type5_to_be_applied_item2_build_rating': 'ビルド及び年齢制限',
  'studio.group.home.board_type5_to_be_applied_item3_price': '価格',
  'studio.group.home.board_type5_to_be_applied_item4_discount': '割引',
  'studio.mail.this_release_info_4_build': 'ビルド：',
  'studio.mail.this_release_info_5_sale_prep': '販売準備：',
  'studio.mail.this_release_info_6_release_plan': 'リリースプラン：',
  'studio.mail.this_release_info_6_1_official_release': '正式リリース：',
  'studio.mail.this_release_info_6_2_pre_order': '事前販売：',
  'studio.mail.case_pre_order_started.title': '事前販売開始',
  'studio.mail.case_pre_order_started.mail_content': 'おめでとうございます！<br/>STOVE StoreにGameが事前購入で登録されました。',
  'studio.mail.case_official_released.title': '正式リリース',
  'studio.mail.case_official_released.mail_content': 'おめでとうございます！<br/>STOVE StoreにGameが正式リリースで登録されました。',
  'studio.noti.case_restricted':
    '{prodName}が{resrictionType}の状態になりました。<br/>商品の展示および販売が中断されました。リリース状況のメニューからペナルティの理由を確認し、ペナルティ解除のためのアップデートを行ってください。',
  'studio.prj_prod.restriction_type_user_report': 'ユーザーを通報',
  'studio.prj_prod.restriction_criteria_policy_violation': '法律違反',
  'studio.prj_prod.restriction_criteria_adult_content': '成人向けコンテンツ',
  'studio.prj_prod.restriction_criteria_defamation': '名誉毀損',
  'studio.prj_prod.restriction_criteria_copyright_violation': '著作権侵害',
  'studio.prj_prod.restriction_criteria_child_bully': '児童虐待',
  'studio.prj_prod.restriction_criteria_malicious_code': 'マルウェア',
  'studio.prj_prod.this_prod.release_details_pbar_msg10_user_report': 'によってリリースが中断されました。修正後に審査をリクエストしてください。',
  'studio.prj_prod.this_prod.release_details_pbar_msg11_operator':
    '運営者の<span class="font-medium text-tint-red-a400">{restrictionType}</span>でリリースが中断されました。修正後に審査をリクエストしてください。',
  'studio.prj_prod.this_prod.release_details_restriction_criteria_partners_title': '展示ペナルティ',
  'studio.prj_prod.this_prod.release_details_pbar_msg11_operator_review_restriction_msg1':
    '運営者の審議ペナルティでリリースが中断されました。修正後に審査をリクエストしてください。',
  'studio.prj_prod.this_prod.release_details_pbar_msg11_operator_review_restriction_msg2':
    'レーティングおよびビルド審査に移動して詳しい内容を確認し、審査リクエストを行ってください。',
  'studio.prj_prod.this_prod.release_details_pbar_redirect_btn': '移動する',
  'studio.mail.this_release_status.checklist_btn': 'チェックリスト',
  'studio.mail.this_release_status.checklist_popup_title': 'チェックリスト',
  'studio.prj_prod.release_info_checklist_review_stt': '審査状態',
  'studio.prj_prod.release_info_checklist_review_stt_prep': '準備中',
  'studio.prj_prod.release_info_checklist_official_release_date': '正式リリース日',
  'studio.prj_prod.release_info_checklist_official_release_stt_pre_release': 'リリース前',
  'studio.prj_prod.release_info_checklist_official_release_stt_to_be_release': 'リリース予定',
  'studio.mail.this_release_status_checklist_release_date': '正式リリース日',
  'studio.mail.this_release_status_checklist_release_upcoming': 'リリース予定',
  'studio.mail.this_release_status.checklist_popup_item1_prod_pg_prep': '商品ページの準備',
  'studio.mail.this_release_status.checklist_popup_item1_prod_pg_prep.prod_setting': '商品を設定する',
  'studio.mail.this_release_status_checklist_product_page_info_product_page': '商品ページを作成する',
  'studio.mail.this_release_status_checklist_product_page_option_title': '商品ページのオプション',
  'studio.mail.this_release_status_checklist_product_page_option_community': 'コミュニティを適用する',
  'studio.mail.this_release_status_checklist_prod_pg_opt_early_access_guide': '早期アクセス文言の表示',
  'studio.mail.this_release_status_checklist_release_plan_title': 'リリースプラン',
  'studio.mail.this_release_status_checklist_release_plan_open_date_input': '商品ページの公開日を入力',
  'studio.mail.this_release_status_checklist_monetization_setting_title': '販売収益金の精算準備',
  'studio.mail.this_release_status_checklist_monetization_setting_business_info': '事業者情報を登録する',
  'studio.mail.this_release_status_checklist_monetization_setting_bank_account_info': '銀行情報を登録する(オプション)',
  'studio.prj_prod.status_rejected': '審査リジェクト',
  'studio.mail.this_release_status_checklist_build_title': 'ビルド準備',
  'studio.mail.this_release_status_checklist_build_execution': '起動設定を行う',
  'studio.mail.this_release_status_checklist_build_file_upload': 'ビルドファイルをアップロードする',
  'studio.mail.this_release_status_checklist_build_ratings_and_review': 'レーティングおよびビルド審査を受ける',
  'studio.mail.this_release_status_checklist_studio_support_title': 'ゲームサポートサービス',
  'studio.mail.this_release_status_checklist_studio_support_in_app_shop': 'ゲーム内ショップを適用する',
  'studio.mail.this_release_status_checklist_studio_support_condition': '商品規約を適用する',
  'studio.mail.this_release_status_checklist_studio_support_challenges': 'チャレンジミッションを適用する',
  'studio.mail.this_release_status_checklist_studio_support_ranking': 'ランキングを適用する',
  'studio.mail.this_release_status_checklist_studio_support_cloud': 'クラウドセーブを適用する',
  'studio.mail.this_release_status_checklist_studio_support_match': 'マッチメイクを適用する',
  'studio.mail.this_release_status_checklist_sales_setting_title': '販売設定',
  'studio.mail.this_release_status_checklist_sales_setting_price_and_discount': '価格および割引を適用する',
  'studio.mail.this_release_status_checklist_sales_setting_sale': '購入条件を設定する',
  'studio.mail.this_release_status_checklist_release_plan_early_access': '事前購入を設定する(オプション)',
  'studio.mail.this_release_status_checklist_release_plan_schedule': '正式リリース日を設定する',
  'studio.prj_prod.post_release.price_update.popup_msg':
    '価格を修正する際には審査の手続きが必要です。<br/>審査には最大で5営業日かかることがあります。<br/>修正した価格は審査通過後にすぐ適用されます。 ',
  'studio.prj_prod.post_release.price_update.popup_request_cf_btn': '審査リクエスト',
  'studio.prj_prod.post_release.price_update.stt_requested': '審査リクエスト',
  'studio.prj_prod.post_release.price_update.request_cancel_btn': 'キャンセル',
  'studio.prj_prod.post_release.price_update.requested_guide': '審査通過後にすぐ適用',
  'studio.prj_prod.post_release.price_update.popup_request_cancel_msg':
    '審査をキャンセルしますか？<br/>キャンセルする場合、審査中のデータは削除されます。',
  'studio.prj_prod.post_release.price_update.popup_cancel_cf_btn': '審査キャンセル',
  'studio.prj_prod.this_prod.release_status_in_promotion': '割引のLIVE適用',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_discount_rate': '割引',
  'studio.build_mgmt.case_build_upload_error.upload_failure_error_name': 'アップロード失敗',
  'studio.build_mgmt.case_build_upload_error.upload_failure_error_msg':
    'アップロード中に不明のエラーが発生しました。<br/>アップロード終了後に再度お試しください。',
  'studio.build_mgmt.case_build_upload_error.build_copy_failure_error_name': 'ビルドコピー失敗',
  'studio.build_mgmt.case_build_upload_error.build_copy_failure_error_msg':
    'ビルドファイルのコピーエラーが発生しました。<br/>アップロード終了後に再度お試しください。 ',
  'studio.build_mgmt.case_build_upload_error.build_comparison_failure_error_name': 'ビルド比較失敗',
  'studio.build_mgmt.case_build_upload_error.build_comparison_failure_error_msg':
    '過去のビルドとの比較過程でエラーが発生しました。<br/>アップロード終了後に再度お試しください。 ',
  'studio.build_mgmt.case_build_upload_error.installjaon_file_creation_failure_error_name': 'InstallJaonファイル作成失敗',
  'studio.build_mgmt.case_build_upload_error.installjaon_file_creation_failure_error_msg':
    'インストールファイルの作成エラーが発生しました。<br/>アップロード終了後に再度お試しください。',
  'studio.build_mgmt.case_build_upload_error.compression_folder_creation_failure_error_name': '圧縮フォルダ生成失敗',
  'studio.build_mgmt.case_build_upload_error.compression_folder_creation_failure_error_msg':
    'ディレクトリの生成中にエラーが発生しました。<br/>アップロード終了後に再度お試しください。',
  'studio.build_mgmt.case_build_upload_error.compression_folder_copy_failure_error_name': '圧縮フォルダコピー失敗',
  'studio.build_mgmt.case_build_upload_error.compression_folder_copy_failure_error_msg':
    'ビルドファイルのコピー中にエラーが発生しました。<br/>アップロード終了後に再度お試しください。 ',
  'studio.build_mgmt.case_build_upload_error.compression_failure_error_name': '圧縮失敗',
  'studio.build_mgmt.case_build_upload_error.compression_failure_error_msg':
    'ビルドファイルの圧縮中にエラーが発生しました。<br/>アップロード終了後に再度お試しください。 ',
  'studio.build_mgmt.case_build_upload_error.game_list_fetch_failure_error_name': '利用可能なゲームリストの取得失敗',
  'studio.build_mgmt.case_build_upload_error.game_list_fetch_failure_error_msg':
    '商品リストの読み込み中にエラーが発生しました。<br/>アップロード終了後に再度お試しください。 ',
  'studio.build_mgmt.case_build_upload_error.game_info_fetch_failure_error_name': 'ゲーム情報の取得失敗',
  'studio.build_mgmt.case_build_upload_error.game_info_fetch_failure_error_msg':
    'ゲーム情報の読み込み中にエラーが発生しました。<br/>アップロード終了後に再度お試しください。 ',
  'studio.build_mgmt.case_build_upload_error.history_deletion_failure_error_name': '履歴削除失敗',
  'studio.build_mgmt.case_build_upload_error.history_deletion_failure_error_msg':
    '過去のアップロードファイル履歴の削除中にエラーが発生しました。<br/>アップロード終了後に再度お試しください。 ',
  'studio.build_mgmt.case_build_upload_error.folder_creation_failure_error_name': 'フォルダ生成失敗',
  'studio.build_mgmt.case_build_upload_error.folder_creation_failure_error_msg':
    'フォルダ生成中にエラーが発生しました。<br/>アップロード終了後に再度お試しください。 ',
  'studio.build_mgmt.case_build_upload_error.checklist_creation_failure_error_name': 'チェックリスト生成失敗',
  'studio.build_mgmt.case_build_upload_error.checklist_creation_failure_error_msg':
    'チェックリストの生成中にエラーが発生しました。<br/>アップロード終了後に再度お試しください。 ',
  'studio.build_mgmt.case_build_upload_error.buildsetting_creation_failure_error_name': 'ビルド設定の生成失敗',
  'studio.build_mgmt.case_build_upload_error.buildsetting_creation_failure_error_msg':
    'ビルド設定の生成中にエラーが発生しました。<br/>アップロード終了後に再度お試しください。 ',
  'studio.build_mgmt.case_build_upload_error.drmmaker_info_creation_failure_error_name': 'DRMMakerの情報生成失敗',
  'studio.build_mgmt.case_build_upload_error.drmmaker_info_creation_failure_error_msg':
    'DRMMakerの情報生成中にエラーが発生しました。<br/>アップロード終了後に再度お試しください。 ',
  'studio.build_mgmt.case_build_upload_error.upload_termination_build_cancel_error_name': 'アップロード中止 ビルドキャンセル',
  'studio.build_mgmt.case_build_upload_error.upload_termination_build_cancel_error_msg': 'アップロードに必要なビルド情報がありません。',
  'studio.build_mgmt.case_build_generate_error.build_file_download_failure_error_name': 'ビルドファイルのダウンロード失敗',
  'studio.build_mgmt.case_build_generate_error.build_file_download_failure_error_msg':
    'ビルドファイルのダウンロード中にエラーが発生しました。<br/><a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_build_generate_error.build_file_zip_unzip_failure_error_name': 'ビルドファイルのZip圧縮解除失敗',
  'studio.build_mgmt.case_build_generate_error.build_file_zip_unzip_failure_error_msg':
    'ビルドファイルの圧縮解除中にエラーが発生しました。<br/><a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。',
  'studio.build_mgmt.case_build_generate_error.uploaded_files_wrong_format_error_name': 'UploadedFilesの誤った形式 ',
  'studio.build_mgmt.case_build_generate_error.uploaded_files_wrong_format_error_msg':
    '誤った形式のビルドファイルが見つかりました。<br/><a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。',
  'studio.build_mgmt.case_build_generate_error.base_build_file_comparison_failure_error_name': 'ベースビルドファイル比較過程のエラー',
  'studio.build_mgmt.case_build_generate_error.base_build_file_comparison_failure_error_msg':
    '過去のビルドファイルとの比較過程でエラーが発生しました。<br/><a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_build_generate_error.new_build_file_verification_failure_error_name': '新規ビルドファイル確認中のエラー',
  'studio.build_mgmt.case_build_generate_error.new_build_file_verification_failure_error_msg':
    'ビルドファイル情報の確認中にエラーが発生しました。<br/><a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_build_generate_error.base_build_file_download_failure_error_name': 'ベースビルドファイルのダウンロード失敗',
  'studio.build_mgmt.case_build_generate_error.base_build_file_download_failure_error_msg':
    '過去のビルドファイルのダウンロード中にエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_build_generate_error.md5_hash_failure_error_name': 'MD5ハッシュ失敗',
  'studio.build_mgmt.case_build_generate_error.md5_hash_failure_error_msg':
    'MD5ハッシュのエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_build_generate_error.new_file_update_classification_failure_error_name': '新規ファイルのアップデートファイル分類中のエラー',
  'studio.build_mgmt.case_build_generate_error.new_file_update_classification_failure_error_msg':
    'ビルドファイルの分類中にエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_build_generate_error.s3_failure_error_name': 'S3失敗',
  'studio.build_mgmt.case_build_generate_error.s3_failure_error_msg':
    'S3失敗エラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_build_generate_error.status_update_failure_error_name': '状態アップデート失敗',
  'studio.build_mgmt.case_build_generate_error.status_update_failure_error_msg':
    'ビルド状態のアップデート中にエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_build_generate_error.file_deletion_failure_error_name': '削除失敗',
  'studio.build_mgmt.case_build_generate_error.file_deletion_failure_error_msg':
    'ビルドファイルの削除中にエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_build_generate_error.metadata_file_read_failure_error_name': 'メタファイル読み込み失敗',
  'studio.build_mgmt.case_build_generate_error.metadata_file_read_failure_error_msg':
    'ビルドファイル情報の確認中にエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_build_generate_error.drmmaker_application_failure_error_name': 'DRM Makerの適用失敗',
  'studio.build_mgmt.case_build_generate_error.drmmaker_application_failure_error_msg':
    'DRM Makerの適用中にエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。',
  'studio.build_mgmt.case_build_generate_error.drmmaker_application_failure_error_msg_2971':
    'DRM Makerの適用中にエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_build_generate_error.drmmaker_application_failure_error_msg_2972':
    'DRM Makerの適用中にエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_build_generate_error.unknown_error_error_name': '不明のエラー',
  'studio.build_mgmt.case_build_generate_error.unknown_error_error_msg':
    '不明なエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。',
  'studio.build_mgmt.case_security_inspection_error.program_execution_parameter_error_error_name': 'プログラムの起動パラメーターが正しくありません',
  'studio.build_mgmt.case_security_inspection_error.program_execution_parameter_error_error_msg':
    '誤ったパラメータが見つかりました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.logger_setup_failure_error_name': 'Logger設定失敗',
  'studio.build_mgmt.case_security_inspection_error.logger_setup_failure_error_msg':
    'Loggerの設定中にエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.config_parsing_failure_error_name': 'Configフィッシング失敗',
  'studio.build_mgmt.case_security_inspection_error.config_parsing_failure_error_msg':
    'Configフィッシング中にエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.work_directory_setup_failure_error_name': '作業ディレクトリ設定失敗',
  'studio.build_mgmt.case_security_inspection_error.work_directory_setup_failure_error_msg':
    '作業ディレクトリ設定中にエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.task_ini_parsing_failure_error_name': 'Task INIフィッシング失敗',
  'studio.build_mgmt.case_security_inspection_error.task_ini_parsing_failure_error_msg':
    'Task INIフィッシング中にエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1099_error_name': '不明なエラー',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1099_error_msg':
    'セキュリティ審査中に不明のエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.download_failure_error_name': 'ダウンロード失敗',
  'studio.build_mgmt.case_security_inspection_error.download_failure_error_msg':
    'ビルドファイルのダウンロード中にエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1199_error_name': '不明なエラー',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1199_error_msg':
    'セキュリティ審査中に不明のエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.invalid_path_for_extracted_file_error_name': '解凍先のパスがファイルパスとして無効',
  'studio.build_mgmt.case_security_inspection_error.invalid_path_for_extracted_file_error_msg':
    '解凍の対象パス確認中にエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1299_error_name': '不明なエラー',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1299_error_msg':
    '不明なエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.possible_malware_code_found_error_name': 'ウイルススキャンの結果、悪意のあるコードがあると判明',
  'studio.build_mgmt.case_security_inspection_error.possible_malware_code_found_error_msg':
    '悪意のあるコードが存在する可能性があります。<br/>該当のビルドで進めたい場合は特殊なセキュリティ審査をリクエストしてください。<br/>{fileName} ',
  'studio.build_mgmt.case_security_inspection_error.no_file_found_for_scan_error_name': 'ウイルススキャンの対象が存在しない',
  'studio.build_mgmt.case_security_inspection_error.no_file_found_for_scan_error_msg':
    '検査対象のファイルが見つからないエラーが発生しました。<br/>該当のビルドで進めたい場合は特殊なセキュリティ審査をリクエストしてください。 ',
  'studio.build_mgmt.case_security_inspection_error.too_many_rescan_attempts_error_name': 'ウイルススキャンの再トライ回数超過',
  'studio.build_mgmt.case_security_inspection_error.too_many_rescan_attempts_error_msg':
    'ウイルススキャンの再トライ回数が超過しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.time_limit_exceeded_for_scan_error_name': 'ウイルススキャンが指定の制限時間を超過',
  'studio.build_mgmt.case_security_inspection_error.time_limit_exceeded_for_scan_error_msg':
    'ウイルススキャンが制限時間を超過しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.server_error_during_scan_error_name': 'ウイルススキャンサーバーエラー',
  'studio.build_mgmt.case_security_inspection_error.server_error_during_scan_error_msg':
    'ウイルススキャンのサーバーエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.malware_found_and_file_deleted_error_name':
    '対象ファイルからマルウェアが検出され、リスクを除去しました',
  'studio.build_mgmt.case_security_inspection_error.malware_found_and_file_deleted_error_msg':
    'マルウェアが存在する可能性があります。<br/>該当のビルドで進めたい場合は手動のセキュリティ審査をリクエストしてください。<br/>{fileName}... ',
  'studio.build_mgmt.case_security_inspection_error.malware_found_and_file_removed_error_name':
    '対象ファイルからマルウェアが検出されたため、削除しました',
  'studio.build_mgmt.case_security_inspection_error.malware_found_and_file_removed_error_msg':
    'マルウェアが存在する可能性があります。<br/>該当のビルドで進めたい場合は手動のセキュリティ審査をリクエストしてください。<br/>{fileName}... ',
  'studio.build_mgmt.case_security_inspection_error.unverifiable_file_for_security_scan_error_name': '対象ファイルは検査に対応していない形式です',
  'studio.build_mgmt.case_security_inspection_error.unverifiable_file_for_security_scan_error_msg':
    '<br/>このファイル形式は自動セキュリティ検査に対応していません。<br/>このビルドでの進行をご希望の場合は、手動セキュリティ検査をリクエストしてください。<br/>{fileName}...',
  'studio.build_mgmt.case_security_inspection_error.file_encrypted_and_scan_unavailable_error_name':
    '対象ファイルがパスワードで暗号化されているため、検査不可',
  'studio.build_mgmt.case_security_inspection_error.file_encrypted_and_scan_unavailable_error_msg':
    '<br/>このファイル形式は自動セキュリティ検査に対応していません。<br/>このビルドでの進行をご希望の場合は、手動セキュリティ検査をリクエストしてください。<br/>{fileName}...',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1399_error_name': '不明なエラー',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1399_error_msg':
    '不明なエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.status_update_attempts_exceeded_error_name': '状態アップデートAPIの再トライ回数の超過',
  'studio.build_mgmt.case_security_inspection_error.status_update_attempts_exceeded_error_msg':
    'ファイル状態のアップデート中にエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.status_update_api_invalid_format_error_name': '状態アップデートAPIの応答フォーマットが有効でない',
  'studio.build_mgmt.case_security_inspection_error.status_update_api_invalid_format_error_msg':
    'ファイル状態のアップデート中にエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.status_update_api_invalid_response_error_name': '状態アップデートAPIの応答コードが成功しない',
  'studio.build_mgmt.case_security_inspection_error.status_update_api_invalid_response_error_msg':
    'ファイル状態のアップデート中にエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.status_update_api_failure_due_to_other_reason_error_name':
    'その他の理由による状態アップデートAPIの応答処理失敗',
  'studio.build_mgmt.case_security_inspection_error.status_update_api_failure_due_to_other_reason_error_msg':
    'ファイル状態のアップデート中にエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1499_error_name': '不明なエラー',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1499_error_msg':
    '不明なエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.work_directory_deletion_failure_error_name': '作業ディレクトリ削除失敗',
  'studio.build_mgmt.case_security_inspection_error.work_directory_deletion_failure_error_msg':
    '作業ディレクトリ削除中にエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.unconfigured_option_error_name': '動作を定義していないオプション値の使用',
  'studio.build_mgmt.case_security_inspection_error.unconfigured_option_error_msg':
    'エラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1599_error_name': '不明なエラー',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1599_error_msg':
    '不明のエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1999_error_name': '不明なエラー',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1999_error_msg':
    '不明なエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.case_drm_maker.setup_failed_error_name': 'セットアップ中のエラー発生',
  'studio.build_mgmt.case_drm_maker.setup_failed_error_msg': 'セットアップ中にエラーが発生しました。 ',
  'studio.build_mgmt.case_drm_maker.download_failed_error_name': 'ダウンロード失敗',
  'studio.build_mgmt.case_drm_maker.download_failed_error_msg': 'ファイルのダウンロード中にエラーが発生しました。 ',
  'studio.build_mgmt.case_drm_maker.zip_decompression_failed_error_name': 'ファイル圧縮解除失敗',
  'studio.build_mgmt.case_drm_maker.zip_decompression_failed_error_msg': 'ファイルの圧縮解除中にエラーが発生しました。 ',
  'studio.build_mgmt.case_drm_maker.drm_application_failed_error_name': 'DRM Maker実行中のエラー発生',
  'studio.build_mgmt.case_drm_maker.drm_application_failed_error_msg': 'DRMの適用中にエラーが発生しました。 ',
  'studio.build_mgmt.case_drm_maker.api_call_error_name': 'アップデートAPIの呼び出しプロセスでのエラー発生',
  'studio.build_mgmt.case_drm_maker.api_call_error_msg': 'サーバーアクセスエラーが発生しました。 ',
  'studio.build_mgmt.case_drm_maker.file_compression_failed_error_name': 'アップロードするファイル圧縮失敗',
  'studio.build_mgmt.case_drm_maker.file_compression_failed_error_msg': 'ファイルの圧縮中にエラーが発生しました。 ',
  'studio.build_mgmt.case_drm_maker.s3_upload_failed_error_name': 'S3へのファイルアップロード中にエラー発生',
  'studio.build_mgmt.case_drm_maker.s3_upload_failed_error_msg': 'サーバーへのファイルアップロード中にエラーが発生しました。 ',
  'studio.build_mgmt.case_drm_maker.upload_api_error_name': 'アップロードアップデートAPIの呼び出しプロセスでのエラー発生',
  'studio.build_mgmt.case_drm_maker.upload_api_error_msg': 'サーバーアクセスエラーが発生しました。 ',
  'studio.build_mgmt.case_drm_maker.unknown_error_error_name': '不明なエラー',
  'studio.build_mgmt.case_drm_maker.unknown_error_error_msg': '不明なエラーが発生しました。 ',
  'studio.prj_prod.this_prod.product_data.build.home_title': 'ビルド管理',
  'studio.prj_prod.this_prod.product_data.build.home_product_key_msg': '商品キー',
  'studio.prj_prod.this_prod.product_data.build.home_product_key_tooltip_prod_id_row1': '商品No.',
  'studio.toast.link_copied': 'コピー完了',
  'studio.prj_prod.this_prod.product_data.build.home_sdk_guide_btn': 'SDK連携ガイド',
  'studio.prj_prod.this_prod.product_data.build.home_upload_btn': 'アップロード',
  'studio.prj_prod.this_prod.product_data.build.home_guide1': '販売する商品のビルドをアップロードして、リリースの準備をしましょう！',
  'studio.prj_prod.this_prod.product_data.build.home_guide2':
    'ウェブ、モバイルゲームなどのインストール型PCゲームではない場合、商品データ管理＞起動設定メニューからリンクを入力してください。 ',
  'studio.prj_prod.this_prod.product_data.build.home_guide3':
    'STOVEで提供しているPC SDKを使用するとStudioで提供するスタッツ、ランキング、チャレンジミッション、マッチメイクなどの付加的なサービスを活用できます。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_pop1_msg1': 'アップロードプログラムをインストールしてください',
  'studio.prj_prod.this_prod.product_data.build.home_upload_pop1_msg2':
    'アップロードプログラムをダウンロードして、<br/>インストールが必要なファイルをアップロードしてください。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_latest_badge': '最新 ',
  'studio.prj_prod.this_prod.product_data.build.home_upload_install_client_btn': 'アップロードプログラムのダウンロード',
  'studio.prj_prod.this_prod.product_data.build.home_upload_pop2_msg1': 'アップロードプログラムをアップデートしてください',
  'studio.prj_prod.this_prod.product_data.build.home_upload_pop2_msg2':
    '新しいバージョンがアップデートされました。<br/>インストールファイルをダウンロードしてインストールしてから続行してください。 ',
  'studio.prj_prod.this_prod.product_data.build.home_upload_alert_msg': 'STOVE Studio Uploaderが<br/>すでに起動中です。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step2_title': 'STOVE Studio Uploaderのインストール',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step2_msg1': '使用許諾の契約',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step2_msg2':
    'STOVE Studio Uploaderをインストールされる前に使用許諾の契約内容をご確認ください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step2_msg3':
    '使用許諾の契約同意事項の残りの部分を見るには[Page Down]キーを押してください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step2_msg4':
    'エンドユーザー使用許諾契約書<br/><br/>“STOVE” Studio Uploaderプログラムをご自身のコンピューターにインストールする前に、次のエンドユーザー使用許諾契約書(以下「本使用許諾契約書」または「本使用許諾契約」)をよくお読みになったうえで使用許諾契約に同意しなければなりません。<br/>本Uploaderソフトウェアプログラム(以下「本ソフトウェア」)は、お客様が本使用許諾契約の内容を確認したうえで「同意する」ボタンを選択することによってインストールが行われ、「キャンセル」ボタンを選択するとインストールが中断されます。<br/>本使用許諾契約書の条件に同意されない場合は、本ソフトウェアのインストールや起動を中止してください。<br/><br/>［エンドユーザー使用許諾契約書］<br/>ソフトウェア名：“STOVE” Studio Uploaderプログラム<br/>本ソフトウェアをユーザーのコンピューターハードウェアにインストールすることは、下記に明示された契約条件に同意することを意味します。<br/>これは(株)スマイルゲートストーブがユーザーの所有または個人的な統制下にある一台以上のコンピューターに本ソフトウェアをインストールすることにより、ユーザーにソフトウェアと関連する個人的な用途で制限的なライセンスを付与するために要求する事項です。<br/>本使用許諾契約は“STOVE” Studio Uploaderのソフトウェアに対する契約であり、オンラインのゲームサービスと関連する利用規約とは異なります。オンラインのゲームサービスと関連する利用規約は公式ホームページ(http://www.onstove.com)で登録申請を行う際に提供されます。<br/><br/>1.ソフトウェア使用許諾<br/>①(株)スマイルゲートストーブ(および本ソフトウェアに対する権利の所有が明示されたすべての協力業者)は、ユーザーに対して本ソフトウェアを通してSTOVE Studio(PCパッケージゲームの運用プラットフォーム)にゲームを登録、修正、管理する目的で使用することを許諾します。しかし、本ソフトウェア自体に関するいかなる権利もユーザーに移転されません。<br/>②(株)スマイルゲートストーブは、本使用許諾契約書に明示された条件を常時更新、修正または変更する権利を有します。<br/>③ユーザーが本使用許諾契約書に明示されていない方法でソフトウェアを使用したり再配布したりすることは禁止されており、(株)スマイルゲートストーブに事前の書面による同意を得ることなく本ソフトウェアを変形、コピー、販売、貸与、流通または他の営利追求の目的で利用することはできません。<br/>④ユーザーは本ソフトウェアを利用して他のプログラムの再生産、翻訳、分析、デコンパイル、ディスアセンブル、リバースエンジニアリングを行うことはできません。また、本ソフトウェアを利用して二次的著作物を作ることはできません。<br/><br/>2.変更と更新などに関する使用許諾<br/>① (株)スマイルゲートストーブは、ユーザーが継続的にSTOVE Studioにゲームを登録、修正、管理できるように本ソフトウェアを更新あるいは変更したり、エラーを修正したりする権利を有します。<br/>②本ソフトウェアを使用して継続的にゲームを登録、修正、管理することは、ユーザーが本ソフトウェアと関連するあらゆる変更を受け入れることを意味し、ユーザーはそれらの更新および変更事項、エラーの修正内容を適用できるように使用許諾契約に同意したことを意味します。<br/>③その他の事項は、第1項(ソフトウェア使用許諾)で定めた内容に従います。<br/>3.責任の制限および免責<br/>①本ソフトウェアは、(株)スマイルゲートストーブが提供する“STOVE” Studio(PCパッケージゲームの運営プラットフォーム)にゲームを登録、修正、管理する目的に限って無料で提供されます。<br/>②本ソフトウェアは現在の状態で提供され、(株)スマイルゲートストーブは本ソフトウェアの内容と使用による機能、有効性、正確性、安定性、そして本ソフトウェアの利用によって期待する効果を得られなかった、あるいは喪失したことに対する保証および責任を負いません。<br/>③(株)スマイルゲートストーブは、本ソフトウェアの使用や作動があらゆる条件において起動することを保証せず、本ソフトウェアの使用による被害や損失に対する責任を負いません。ただし、(株)スマイルゲートストーブの故意または重大な過失によって発生した場合は除きます。<br/>④第3項が端緒の場合、(株)スマイルゲートストーブはユーザーが本ソフトウェアを適法性をもって起動する中で発生した実質的かつ直接的な被害に対してのみ補償します。また、(株)スマイルゲートストーブは第三者による不正使用などによる結果については責任を負いません。<br/><br/>4.使用許諾の解除<br/>①ユーザーはいつでも本ソフトウェアを除去、廃棄することによって本使用許諾契約を解除できます。<br/>②ユーザーが本使用許諾契約書に明示された条項に抵触する行為をした場合、(株)スマイルゲートストーブは該当するユーザーの使用許諾をいかなる補償もなく一方的に終了することができます。その場合、ユーザーは本ソフトウェアの副産物を含むすべての部分を即時廃棄し、本ソフトウェアを除去することに同意します。<br/>③本使用許諾契約が何らかの理由によって終了する場合、本使用許諾契約書に従って(株)スマイルゲートストーブがユーザーに授与した本ソフトウェアに関連するあらゆる使用権限は即時終了されます。<br/>④本条第1項または第2項による契約解除であったとしても、本契約の第1条第3項および第4項、第5条は解除後にも効力を維持します。<br/><br/>5.その他の事項<br/>本使用許諾契約書のすべての事項は大韓民国法に基づくもので、ユーザーと(株)スマイルゲートストーブの間に本使用許諾契約に関連する紛争による訴訟が提起された場合、両当事者は民事訴訟法上の管轄裁判所に訴えを提起することができます。<br/><br/>附則(2020.12.10)<br/>(施行日)本使用許諾契約は2020年12月10日から施行されます。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step2_msg5':
    '内容に同意される場合は「同意する」を押してください。STOVE StudioUploadterをインストールするには、必ず内容に同意しなければなりません。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_previous_btn': '＜戻る',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_agree_btn': '同意する',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_cancel_pop_title': 'インストール',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_cancel_pop_msg1': 'STOVE Studio Uploaderのインストールをキャンセルしますか？',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_cancel_pop_yes_btn': 'はい',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_cancel_pop_no_btn': 'いいえ',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step3_msg1': 'インストール先を選択',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step3_msg2':
    'STOVE Studio Uploaderをインストールするフォルダを選択してください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step3_msg3':
    'STOVE Studio Uploaderを次のフォルダにインストールする予定です。<br/>別のフォルダにインストールしたい場合は「探す」ボタンを押して別のフォルダを選択してください。<br/>インストールを開始するには「インストール」ボタンを押してください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step3_destination_folder_title': 'インストールフォルダー',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_browse_btn': '探す',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step3_msg4': '必要なディスク容量：{reqDiskCapa}',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step3_msg5': 'ディスクの空き容量：{availDiskCapa}',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_install_btn': 'インストール',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_browse_pop_title': 'フォルダを探す',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_browse_pop_msg': 'STOVE Studio Uploaderを次のフォルダにインストールします。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_browse_pop_new_folder_btn': '新規フォルダ作成',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step4_msg1': 'インストール中',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step4_msg2':
    'STOVE Studio Uploaderをインストールするあいだ、しばらくお待ちください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step4_msg3': '解凍中…',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step5_msg1': 'STOVE Studio Uploaderのインストール完了',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step5_msg2':
    '［完了］をクリックするとインストールが完了します。<br/>STOVE Studioにログイン後にアップロードを行ってください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_finish_btn': '完了',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_msg1':
    'アップロードするファイルがあるフォルダの場所を指定してアップロードを開始してください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_select_file_title': 'アップロードファイル',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_select_file_place_holder': 'ビルドがあるフォルダのパスを選択してください',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_select_req_val': 'ビルドがあるフォルダのパスを選択してください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_select_file_browse_btn': '探す',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_temp_folder_title': '臨時ファイル保存フォルダ',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_temp_folder_place_holder': '未入力時は基本的に臨時ファイルのフォルダに保存されます',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_temp_folder_change_btn': '変更',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_build_detail': 'ビルドの説明',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_build_detail_place_holder':
    'アップロードしたファイルを区別できる内容を入力してください',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_file_upload_guide_title': '案内事項',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_file_upload_guide1': 'アップロードが中断された場合でも、途中から再開できます。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_file_upload_guide2':
    'アップロードに失敗した場合は、再度アップロードをやり直してください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_file_upload_guide3':
    'アップロードが終了するとセキュリティ審査およびビルドの生成が行われ、アップロードの状態がアップデートされます。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_start_upload_btn': 'アップロードをはじめる',
  'studio.prj_prod.this_prod.product_data.build.uploader_terminate_pop_msg': 'STOVE Studio Uploader<br/>を終了しますか？',
  'studio.prj_prod.this_prod.product_data.build.uploader_terminate_pop_cf_btn': '終了',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_start_upload_alert1_msg':
    'アップロードできないファイルやフォルダがあります。<br/>該当ファイルを削除してから、再度お試しください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_start_upload_alert2_msg':
    'dllファイルがありません。<br/>ファイルをダウンロードして、含めてお試しください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_start_upload_alert3_msg':
    'ユーザーの認証情報が期限切れになっています。<br/>アップローダーを再度実行してください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_select_file_browse_cf_alert_msg1':
    'グループ保存先の空き容量が不足しています。<br/>過去のビルドを削除して再度実行してください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_this_action_cf_alert_msg':
    'ハードディスクの容量が不足しているため、アップロードできません。<br/>臨時ファイルの保存フォルダを再設定してください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_incompleted_bld_exist_popup_title': 'アップロード中止',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_incompleted_bld_exist_popup_msg':
    'アップロードが中止されたビルドがあります。<br/>再度アップロードしますか？',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_incompleted_bld_exist_popup_cont_upload_btn': '再開',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_incompleted_bld_exist_popup_start_new_upload_btn': '新しくはじめる',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_msg': 'ファイル確認中。。。 ',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_remaining_time_msg': '残り時間',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_cancel_upload_btn': 'アップロードキャンセル',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_retry_btn': 'リトライ',
  'studio.prj_prod.this_prod.product_data.build.uploader_quitting_attempt_pop_msg': 'STOVE Studio Uploaderを終了しますか？',
  'studio.prj_prod.this_prod.product_data.build.uploader_cannot_cont_upload_popup':
    'アップロードが中止されたファイルが見つかりません。<br/>削除後に再度アップロードしてください。 ',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_file_transfer_paused_msg':
    'ネットワークエラーが発生し、アップロードが一次的に中断しました。<br/>続きからアップロードを行ってください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_file_transfer_failed_msg':
    'インストール情報ファイルのコピーエラーが発生してアップロードに失敗しました。<br/>エラーコードを確認後に再度お試しください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_error_case1_temp_paused': '一時中止。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_continue_upload_btn': '続きから行う',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_stt3_2_upload_failed':
    'アップロード失敗。{overallProg}% ({completedFileNum}/{totalFileNum}) ',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_stt1_checking': 'ファイル確認中。{overallProg}% ',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_stt2_1_compressing': 'ファイル圧縮中。{overallProg}% ',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_stt2_2_compress_failed': 'ファイル圧縮失敗。{overallProg}% ',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_stt3_1_uploading': 'アップロード中。。。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_finish_btn': '完了',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide1_sdk_sync_guide_btn': 'SDK連携方法を見る',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide2_title': 'PCクライアント実行テスト',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide2_client_download': 'クライアントのダウンロード',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide3_title': 'スタッツ',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide3_2':
    'スタッツはゲームに関連する数値を意味します。<br/>スタッツを基準にランキングやチャレンジミッションを作成することもできます。',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide4_title': 'クラウドセーブ',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide4_1':
    'ゲームのインストール後、STOVE PCクライアントを通してゲームのデータをクラウドに保存して最新のファイルに同期化できるサービスです。',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide5_title': 'マッチメイク',
  'studio.prj_prod.this_prod.product_data.build_build_count_title': '全体',
  'studio.prj_prod.this_prod.product_data.build_redirect_execution_btn': '設定に移動する',
  'studio.prj_prod.this_prod.product_data.build_guide1':
    'アップロードしたビルドが正しく起動するかテストしてみましょう。<br/>STOVE PCクライアントから商品ごとに試すことができます。',
  'studio.prj_prod.this_prod.product_data.build_guide2': 'クライアント実行テスト',
  'studio.prj_prod.this_prod.product_data.build_client_download_btn': 'クライアントのダウンロード',
  'studio.prj_prod.this_prod.product_data.build_group_storage_msg': '{totalCapa} GB中{usedCapa} GBを使用',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_total_capacity_msg': 'グループ保存容量({totalCapa} GB)',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_occupied_capacity_msg': '{usedCapa} GB',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_remaining_capacity_msg': '{totalCapa} GB',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_request_more_storage_btn': '追加申請',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_request_sent': '申請完了',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_request_more_storage_pop_msg1': 'グループ保存容量の追加申請',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_request_more_storage_pop_msg2':
    '事前に協議していない申請はリジェクトされることがあります。詳しい内容は<br/>STOVE Studio運営者にお問い合わせください。',
  'studio.prj_prod.this_prod.product_data.build_group_storage_pop_inquiry_btn': '問い合わせ',
  'studio.prj_prod.this_prod.product_data.build_group_storage_pop_request_btn': 'リクエストする',
  'studio.prj_prod.this_prod.product_data.build.home_build_id_header1': 'ビルドNo.',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_header2': 'アップロードの状態',
  'studio.prj_prod.this_prod.product_data.build.home_integrity_header4': '完全性',
  'studio.prj_prod.this_prod.product_data.build.home_file_size_header5': '容量',
  'studio.prj_prod.this_prod.product_data.build.home_edited_date_header6': '登録日(修正日)',
  'studio.prj_prod.this_prod.product_data.build.home_prod_status_header7': 'リリース状態',
  'studio.prj_prod.this_prod.product_data.build.home_list_delete_n_alert_msg': '審査が進行中であるかリリース中の商品のファイルは削除できません。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop1_msg1': 'アップロード中止',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop1_msg2':
    'アップロード中に中止された履歴があります。<br/>アップロードを再開するか、履歴を削除してください。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop1_delete_build_btn': 'ビルドを削除',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop1_resume_btn': '再開',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop2_msg1': 'アップロード進行不可',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop2_msg2': 'アップロードを続きから行えないアカウントです。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop2_delete_build_btn': 'ビルドを削除',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_failed_pop_msg': 'アップロード失敗',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_testing_pop_build_status_creating_msg': 'ビルド生成',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_testing_pop_security_test_msg': 'セキュリティ審査',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_testing_pop_build_status_failed_msg': 'ビルド生成失敗',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_testing_pop_security_test_failed_msg': 'セキュリティ審査失敗',
  'studio.prj_prod.this_prod.product_data.build.security_test_failed_manual_test_request_btn': '手動セキュリティ審査リクエスト',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_failed_manual_test_requested_msg': '手動セキュリティ審査リクエスト中',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_failed_manual_test_declinded_msg': '手動セキュリティ審査リジェクト',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_title': '手動セキュリティ審査リクエストおよび同意書',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_name_place_holder': '氏名または会社名',
  'studio.build.request_manual_test_pop.request_form_name_req_msg': '氏名または会社名を入力してください。',
  'studio.common.def_key.special_character_n': '特殊文字は入力できません。',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_agreement_text':
    '上の案内および同意事項を確認し、これに同意します。',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_year': '年',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_req_msg': '日付を入力してください。',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_month': '月',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_day': '日',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_signature_applicant_place_holder': '氏名 or 代表取締役名',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_signature_applicant_req_msg':
    '氏名または代表取締役名を入力してください。',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_submit_btn': '提出',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_reason_for_requst_place_holder':
    'リクエストの理由を入力してください。',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_submit_pop_title': '手動審査リクエスト完了',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_submit_pop_msg2':
    '作成した同意書が提出されました。<br/>STOVE Studioの運営者が確認した後に結果がアップデートされます。',
  'studio.prj_prod.this_prod.product_data.build_del_pop_title': 'ビルドを削除',
  'studio.prj_prod.this_prod.product_data.build_del_pop_msg': '削除するには「DELETE」を入力してください。<br/>削除した後は復元できません。',
  'studio.prj_prod.this_prod.product_data.build_del_pop_del_cf_btn': '削除',
  'studio.build_mgmt.build_upload_stt1_paused': 'アップロード中止',
  'studio.build_mgmt.build_upload_stt2_upload_failed': 'アップロード失敗',
  'studio.build_mgmt.build_upload_stt3_inspecting': '審査中',
  'studio.build_mgmt.build_upload_stt4_build_gen_failed': 'ビルド生成失敗',
  'studio.build_mgmt.build_upload_stt5_security_inspection_failed': 'セキュリティ審査失敗',
  'studio.build_mgmt.build_upload_stt6_failed': '失敗',
  'studio.build_mgmt.build_upload_stt7_completed': '完了',
  'studio.build_mgmt.build_detail.description_place_holder': 'ビルドの説明を入力してください',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_build_size_row3': '容量',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_date_upload_row4': '登録日',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_modified_date_row5': '修正日',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_release_status_row6': 'リリース状態',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_upload_status_row7': 'アップロードの状態',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_upload_status1_paused_guide':
    'アップロード中に中止された履歴があります。<br/>アップロードを再開するか、履歴を削除してください。',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_upload_status_resume_btn': '続きから行う',
  'studio.prj_prod.this_prod.product_data.build.security_test_failed_manual_test_requested_stt': '手動セキュリティ審査リクエスト中',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_upload_status_request_manual_test_rejected_stt': '手動セキュリティ審査リジェクト',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_upload_status_testing_build_msg': '審査中',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_option_msg': '適用有無',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_option_apply_yes_msg': '適用',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_option_apply_no_msg': '未適用',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_title': '完全性の審査',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_msg1':
    'STOVE PCクライアントを通してゲームを起動する際に必要なファイルがコンピューターに正しくインストールされているかを確認する機能です。',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_msg2':
    'DLCファイルと上位商品のファイルが重複する場合、DLCファイルが優先して処理されます。',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_files_msg': '適用ファイル',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_files_place_holder': '適用するファイルを選択してください',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_files_file_selected_text': '{fileName}の他{extraSelectedFileNum}個',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_files_select_file_btn': 'ファイル選択',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_timeout_setting_title': '審査タイムアウト',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_files_msg': '適用ファイル',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_files_applied': '適用完了',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_files_failed': '適用失敗',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_files_applying': '適用をリクエストする',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_files_withdrawed': '解除をリクエストする',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_select_file_pop_title': 'DRM Makerファイル選択',
  'studio.prj_prod.this_prod.product_data.build.details_select_file_pop_total_file': '全体',
  'studio.prj_prod.this_prod.product_data.build.details_select_file_pop_filename_header2': 'ファイル名',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_select_file_pop_status_header3': '適用状態',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_select_file_pop_title': '整合性確認のファイル選択',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_type_exist_hash_msg':
    'EXIST_HASH：ファイルの存在とハッシュ値が一致しない場合に検証',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_type_exist_msg': 'EXIST：ファイルの存在を確認し、存在しない場合に検証',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_select_file_pop_test_type_header3': '審査タイプ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_stt_3_rejected': '審査リジェクト',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_stt_4': '審査完了',
  'studio.prj_prod.this_prod.home_prod_stt_terminated': '終了',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update_btn': 'ビルドのアップデート',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.title': 'ビルドのアップデート',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.badge_live_apply_y': '適用中',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item_check':
    '今回のビルドで発生する変更内容を選択してください。',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item1_bug_fix': 'バグ修正',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item2_background_img_vid': '背景、映像の変更',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item3_ui': '基本システム、UI変更',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item4_billing_sys': '課金体系の変更',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item5_scenario': 'クエスト、シナリオの変更',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item6_char_item': 'キャラクター、アイテムの変更',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.info_change_report_guide':
    '内容修正報告によって審査が完了すると、起動設定メニューからLIVE適用が可能になります。',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.info_change_report_rating_menu_dir_btn':
    'レーティングおよびビルド審査',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.info_change_report_stt_under_review': '審査中です。',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.change_report_complete.build_apply_date': 'ビルド適用日',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.change_report_complete.immed_apple': '即時',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.change_report_complete.schedule_apply': '予約',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.change_report_complete.schedule_req_msg1':
    '開始日を選択してください。',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.change_report_complete.schedule_invalid_msg2':
    '現在の日時以降を選択してください。',
  'studio.prj_prod.this_prod.execution_register_btn': '登録',
  'studio.prj_prod.this_prod.execution_guide1': 'PCクライアントで商品を起動するために最低限必要になる情報を入力してください。',
  'studio.prj_prod.this_prod.execution_guide1_1': 'クライアントに適用する30MB以下の商品画像とicoファイルを用意し、登録してください。',
  'studio.prj_prod.this_prod.execution_setting_option_title': '起動オプション',
  'studio.prj_prod.this_prod.execution_setting_option_msg': '選択したプラットフォームによって起動が必要な必須項目を入力してください。',
  'studio.prj_prod.this_prod.execution_setting_option_platform_msg': 'プラットフォーム',
  'studio.prj_prod.this_prod.execution_setting_option_platform_dropbox_place_holder': 'プラットフォームを選択してください',
  'studio.prj_prod.this_prod.execution_setting_option_platform_dropbox_req_msg': 'プラットフォームを選択してください。',
  'studio.prj_prod.this_prod.execution_setting_option_add_btn': 'オプション追加',
  'studio.prj_prod.this_prod.execution_setting_option_name': 'オプション名',
  'studio.prj_prod.this_prod.execution_setting_option_name_place_holder': 'オプション名を入力してください',
  'studio.prj_prod.this_prod.execution_setting_option_name_req_msg': 'オプション名を入力してください。',
  'studio.prj_prod.this_prod.execution_setting_option_name_duplicate_msg': '重複したオプション名です。他のオプション名をご入力ください。',
  'studio.prj_prod.this_prod.execution_setting_option_executing_file_msg': '起動ファイル',
  'studio.prj_prod.this_prod.execution_setting_option_executing_file_place_holder': '起動ファイルを入力してください',
  'studio.prj_prod.this_prod.execution_setting_option_executing_file_req_msg': '起動ファイルを入力してください。',
  'studio.prj_prod.this_prod.execution_setting_option_parameter_msg': '引数値',
  'studio.prj_prod.this_prod.execution_setting_option_parameter_place_holder': '引数値を入力してください',
  'studio.prj_prod.this_prod.execution_setting_option_working_directory_msg': '作業パス',
  'studio.prj_prod.this_prod.execution_setting_option_working_directory_place_holder': '作業パスを入力してください',
  'studio.prj_prod.this_prod.execution_setting_option_process_name_msg': 'プロセスファイル',
  'studio.prj_prod.this_prod.execution_setting_option_process_name_place_holder': 'プロセスファイルを入力してください',
  'studio.prj_prod.this_prod.execution_setting_option_collapse_all_msg': '簡易表示',
  'studio.prj_prod.this_prod.execution_setting_option_expand_all_msg': 'さらに表示する',
  'studio.prj_prod.execution_setting_option_requirements_cpp_place_holder': '選択しない',
  'studio.prj_prod.execution_setting_option_platform_msg': 'プラットフォーム',
  'studio.prj_prod.execution_setting_option_platform_dropbox_place_holder': 'プラットフォームを選択してください',
  'studio.prj_prod.execution_setting_option_platform_dropbox_req_msg': 'プラットフォームを選択してください。',
  'studio.prj_prod.execution_setting_option_delete_btn': '削除',
  'studio.prj_prod.execution_setting_option_delete_cf_btn': '削除',
  'studio.prj_prod.execution_setting_option_name': 'オプション名',
  'studio.prj_prod.execution_setting_option_name_place_holder': 'オプション名を入力してください',
  'studio.prj_prod.execution_setting_option_name_req_msg': 'オプション名を入力してください。',
  'studio.prj_prod.execution_setting_exe_url': '起動URL',
  'studio.prj_prod.execution_setting_exe_url_place_holder': 'http:// または https:// を含めて入力してください。',
  'studio.prj_prod.execution_setting_exe_url_req_msg': '起動可能なURLまたはホームページのURLを入力してください。',
  'studio.prj_prod.execution_setting_option_mob_store_url_title': 'モバイルストアURL',
  'studio.prj_prod.execution_setting_option_mob_store_url_place_holder': 'http:// または https:// を含めて入力してください。',
  'studio.prj_prod.execution_setting_option_mob_store_url_req_msg': '最低1つのURLを入力してください。',
  'studio.prj_prod.this_prod.execution_setting_title': 'インストール設定',
  'studio.prj_prod.this_prod.execution_setting_folder_title': 'インストールフォルダ',
  'studio.prj_prod.this_prod.execution_setting_folder_msg':
    'ユーザーが商品をダウンロードする場合、ローカルドライブにインストールされるフォルダの名前を入力してください。',
  'studio.prj_prod.this_prod.execution_setting_folder_name_placeholder': 'インストールフォルダ名を入力してください',
  'studio.prj_prod.this_prod.execution_setting_folder_name_req_msg': 'インストールフォルダ名を入力してください。',
  'studio.prj_prod.this_prod.execution_setting_folder_name_invalid_msg': 'インストールフォルダ名が正しくありません。フォルダ名をご確認ください。',
  'studio.prj_prod.execution_setting_pc_client_title': 'PCクライアント設定',
  'studio.prj_prod.execution_setting_pc_client_launcher_image_title': 'インストール後に作成されるデスクトップのショートカット',
  'studio.prj_prod.execution_setting_pc_client_launcher_image_format_guide': 'icoファイル｜30MB以下',
  'studio.prj_prod.execution_setting_pc_client_launcher_image_req_msg': '画像を登録してください。',
  'studio.prj_prod.execution_setting_pc_client_logo_image_title': 'PCクライアント商品のサムネイル画像',
  'studio.prj_prod.execution_setting_pc_client_logo_image_format_guide': 'jpg、ipeg、png｜30MB以下',
  'studio.prj_prod.execution_setting_pc_client_logo_image_req_msg': '画像を登録してください。',
  'studio.prj_prod.execution_setting_pc_client_client_wallpaper_image_title': 'PCクライアントの代表おすすめ画像',
  'studio.prj_prod.execution_setting_pc_client_img_preview_btn': 'プレビュー',
  'studio.prj_prod.execution_setting_pc_client_preview_title': 'PCクライアントの画像適用プレビュー',
  'studio.prj_prod.execution_setting_pc_client_preview_msg1': '説明用のサンプル画像です。',
  'studio.prj_prod.execution_setting_pc_client_preview_msg2': 'ホーム商品おすすめ',
  'studio.prj_prod.execution_setting_pc_client_preview_play_btn': 'プレイ',
  'studio.prj_prod.execution_setting_pc_client_preview_random_search_title': 'ランダムサーチ',
  'studio.prj_prod.execution_setting_pc_client_preview_random_search_msg': 'アイコンをクリックすると別のゲームがおすすめされます。',
  'studio.prj_prod.execution_save_btn': '保存',
  'studio.prj_prod.this_prod.execution_setting_option_platform_alert_msg': '保存が完了しました。<br/>ビルドをアップロードしてください。',
  'studio.prj_prod.build_upload_pg_dir_btn': 'ビルドアップロード',
  'studio.prj_prod.execution_basic_guide1': '起動設定',
  'studio.prj_prod.execution_basic_guide1_1': '必須項目をすべて入力し、STOVEのPCクライアントで正しく起動するかテストを行ってください。',
  'studio.prj_prod.execution_install_set_enabled_guide2': 'インストールフォルダ',
  'studio.prj_prod.execution_pc_client_set_enabled_guide2': 'PCクライアント設定',
  'studio.prj_prod.execution_pc_client_set_enabled_guide2_1':
    'STOVEクライアントを通じてユーザーに表示される商品の画像を登録してください。登録された画像はアイコン、サムネイル、バナーに使用されます。',
  'studio.prj_prod.execution_pc_client_set_enabled_guide3': '起動アイコン',
  'studio.prj_prod.execution_pc_client_set_enabled_guide3_1':
    'ユーザーがゲームをインストールする場合、Windowsホーム画面のアイコンに使用される画像です。',
  'studio.prj_prod.execution_pc_client_set_enabled_guide4': 'PCクライアント商品のサムネイル画像',
  'studio.prj_prod.execution_pc_client_set_enabled_guide4_1':
    'STOVEクライアントの左側にあるSTOVEゲームメニューまたはお気に入りメニューに登録されたゲームのサムネイルがユーザーに表示されます。',
  'studio.prj_prod.execution_pc_client_set_enabled_guide5': 'おすすめ画像',
  'studio.prj_prod.execution_pc_client_set_enabled_guide5_1':
    'STOVEの運営者が確認したゲームに限り、PCクライアントのメインに表示されることがあります。',
  'studio.prj_prod.execution_exe_opt_enabled_guide2': '起動オプション',
  'studio.prj_prod.execution_exe_opt_enabled_guide3_1':
    'この設定はいつでも変更できます。リリース以降にも変更できますが、間違った情報を公開した場合、正常に起動されなくなりますのでご注意ください。',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_1_1': '起動ファイル',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_2_1': '引数値',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_2_2': '- 起動ファイルを実行する際に一緒に呼び出す必要のある値を入力してください。',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_3_1': '作業パス',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_3_2': '- exe起動ファイルと起動に必要なファイルの位置が異なる場合は作業パスを入力してください。',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_4_1': 'プロセスファイル',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_4_2':
    '- インストールファイルと起動ファイルが分離したビルドの場合、プロセスファイル名に実際の起動ファイルを入力してください。',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_5_1': '必須プログラム',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_5_2':
    '- ゲームの実行に必要なプログラムを選択していない場合はゲームが正常に起動しない場合があるため、必ず選択してください。',
  'studio.prj_prod.execution_exe_opt_enabled_guide5_1': '起動URL',
  'studio.prj_prod.execution_exe_opt_enabled_guide5_2': '- リンクから直接ゲームの起動が可能なURLまたはホームページのアクセスURLを入力してください。',
  'studio.prj_prod.execution_exe_opt_enabled_guide6_1': 'モバイルストアURL',
  'studio.prj_prod.execution_exe_opt_enabled_guide6_2':
    '- ストアの商品ページからモバイルストアにアクセスできるようサポートします。モバイルストアのアドレスを入力してください。',
  'studio.prj_prod.execution_setting_folder_title': 'インストールフォルダ',
  'studio.prj_prod.execution_setting_folder_msg1':
    'ユーザーが商品をダウンロードする場合、ローカルドライブにインストールされるフォルダの名前を入力してください。',
  'studio.prj_prod.execution_setting_folder_msg2':
    'DLCは製品版のインストールフォルダ内にインストールされます。  同じフォルダにインストールする場合は「.」(ピリオド)を入力してください。',
  'studio.prj_prod.execution_setting_folder_name_placeholder': 'インストールフォルダ名を入力してください',
  'studio.prj_prod.execution_setting_folder_name_req_msg': 'インストールフォルダ名を入力してください。',
  'studio.prj_prod.execution_setting_folder_name_invalid_msg': 'インストールフォルダ名が正しくありません。フォルダ名をご確認ください。',
  'studio.prj_prod.execution_setting_dlc_auto_install_title': 'DLC自動インストール',
  'studio.prj_prod.execution_setting_dlc_auto_install_msg1': 'ユーザーがDLCの購入を完了すると、自動でインストールします。',
  'studio.prj_prod.execution_setting_dlc_auto_install_y': '使用',
  'studio.prj_prod.execution_setting_dlc_auto_install_n': '未使用',
  'studio.prj_prod.execution_setting.post_release_update_guide': 'LIVEリリース審査中には修正できません。審査完了までお待ちください。',
  'studio.prj_prod.execution_setting.post_release_update_info_run_option': '起動オプション',
  'studio.prj_prod.execution_setting.post_release_update_info_platform': 'プラットフォーム',
  'studio.prj_prod.execution_setting.post_release_update_info_opt_name': 'オプション名',
  'studio.prj_prod.execution_setting.post_release_update_info_exe_file': '起動ファイル',
  'studio.prj_prod.execution_setting.post_release_update_info_exe_url': '起動URL',
  'studio.prj_prod.execution_setting.post_release_update_info_folder': 'インストールフォルダ',
  'studio.prj_prod.execution_setting.post_release_update_info_argument_value': '引数値',
  'studio.prj_prod.execution_setting.post_release_update_info_path': '作業パス',
  'studio.prj_prod.execution_setting.post_release_update_info_process_file': 'プロセスファイル',
  'studio.group.collection.title': 'コレクション',
  'studio.group.collection.make_btn': '作成',
  'studio.group.collection.guide1': '2つ以上の商品を合わせてコレクションを作ってみましょう。<br/>複数の商品を合わせて一度に販売できます。',
  'studio.group.collection.register_title': 'コレクション登録',
  'studio.group.collection.register_header_name': 'コレクション商品設定',
  'studio.group.collection.register_product_config': '商品構成',
  'studio.group.collection.register_product_config_place_holder': '商品を検索してください。',
  'studio.group.collection.register_product_config_nation_btn': '商品別の表示国',
  'studio.group.collection.register_product_config_list_msg1': '商品を2つ以上選択してください。',
  'studio.group.collection.register_product_config_list_msg2': '移管された商品があります。{prodNo}の商品を削除してください。',
  'studio.group.collection.register_product_config_list_msg3': '移管された商品があります。{prodNo}の商品を削除してください。',
  'studio.group.collection.register_product_config_list_msg4': '選択した商品がありません。 ',
  'studio.group.collection.register_product_config_place_holder_msg1': '検索結果がありません。',
  'studio.group.collection.register_product_config_list_no': '商品No.',
  'studio.group.collection.register_product_config_list_type': 'タイプ',
  'studio.group.collection.register_product_config_list_name': '商品名',
  'studio.group.collection.register_product_config_list_status': '状態',
  'studio.group.collection.register_product_config_check_box': '代表商品の情報を呼び出す',
  'studio.group.collection.register_product_config_check_box_guide':
    '代表商品の情報をもとにコレクション情報と商品ページが自動生成され、自由に編集できます。',
  'studio.group.collection.register_product_config_select_apply_btn': '適用する',
  'studio.group.collection.register_product_config_nation_btn_select_region': 'エリア選択',
  'studio.group.collection.register_basic_info': '基本情報',
  'studio.group.collection.register_lang_setting_btn': '多言語設定',
  'studio.group.collection.register_basic_info_name': '商品名',
  'studio.group.collection.register_basic_info_name_place_holder': '商品名を入力してください',
  'studio.group.collection.register_basic_info_name_msg1': '商品名を入力してください。',
  'studio.group.collection.register_basic_info_name_msg2': '同一の商品名があります。別の商品名を入力してください。',
  'studio.group.collection.register_basic_info_creator_name': 'クリエイター名',
  'studio.group.collection.register_basic_info_creator_name_place_holder': 'クリエイター名を入力してください',
  'studio.group.collection.register_basic_info_creator_name_msg1': 'クリエイター名を入力してください。',
  'studio.group.collection.register_basic_info_distributor_name': 'パブリッシャー名',
  'studio.group.collection.register_basic_info_distributor_name_place_holder': 'パブリッシャー名を入力してください',
  'studio.group.collection.register_basic_info_distributor_name_msg1': 'パブリッシャー名を入力してください。',
  'studio.group.collection.register_product_page': '商品ページ',
  'studio.group.collection.register_product_page_guide': 'ストアに表示されるコレクションの商品ページを編集できます。',
  'studio.group.collection.register_product_page_edit_btn': '商品ページ編集',
  'studio.group.collection.register_sales_settings': '販売設定',
  'studio.group.collection.register_sales_settings_previous_price': 'コレクション割引適用前の価格',
  'studio.group.collection.register_launch_discount': 'リリース割引',
  'studio.group.collection.register_launch_discount_y': '使用',
  'studio.group.collection.register_launch_discount_n': '未使用',
  'studio.group.collection.register_discount_period': '割引期間',
  'studio.group.collection.register_discount_period_text1': '正式リリース日から ',
  'studio.group.collection.register_discount_period_text2': 'デイリー',
  'studio.group.collection.register_discount_rate': '割引率',
  'studio.group.collection.register_discount_rate_msg1': 'コレクションの割引率を入力してください。',
  'studio.discount.register_rate_valid_msg': '1から100までの値を入力してください。',
  'studio.group.collection.register_price_preview': '価格プレビュー',
  'studio.group.collection.register_price_preview_guide':
    '以下の価格は現在の販売価格に基づいており、価格変更により変動する可能性があります。<br/>ストアでの表示価格は、日々の為替レートにより異なる場合があります。',
  'studio.group.collection.register_price_preview_select1': 'ストア表示価格',
  'studio.group.collection.register_price_preview_select2': '決済価格',
  'studio.group.collection.register_price_preview_sub_title1': 'このコレクションに含まれる商品',
  'studio.group.collection.register_price_preview_sub_title2': '計{prodNum}件 ',
  'studio.group.collection.register_price_preview_pay_info1': '商品価格',
  'studio.group.collection.register_price_preview_pay_info2': 'コレクション割引',
  'studio.group.collection.register_price_preview_pay_info3': 'コレクション割引金額',
  'studio.group.collection.register_price_preview_pay_info4': '最終販売価格',
  'studio.group.collection.register_limited_sale': '限定販売の設定',
  'studio.group.collection.register_limited_sale_guide': '正式リリース後、在庫切れまたは販売期間終了により販売を終了いたします。',
  'studio.group.collection.register_limited_sale_option1': '在庫切れ時に販売終了',
  'studio.group.collection.register_limited_sale_option2': '期間終了時に中断',
  'studio.group.collection.register_limited_sale_option3': '未使用',
  'studio.group.collection.register_sales_quantity': '販売数',
  'studio.group.collection.register_sales_quantity_text': '個',
  'studio.group.collection.register_sales_quantity_msg1': '販売数量を入力してください。',
  'studio.group.collection.register_end_date': '終了日の設定',
  'studio.group.collection.register_end_date_msg1': '終了日は正式リリース日以降に設定してください。',
  'studio.group.collection.register_plan': 'リリース',
  'studio.group.collection.register_plan_open_date': '商品ページオープン日',
  'studio.group.collection.register_plan_utc_view_btn': '主要都市のUTCを見る',
  'studio.group.collection.register_plan_pre_order': '事前購入の設定',
  'studio.group.collection.register_plan_pre_order_guide': '正式リリース日より前に商品を販売したい場合は、事前購入を設定してください。',
  'studio.group.collection.register_plan_pre_order_y': '使用',
  'studio.group.collection.register_plan_pre_order_n': '未使用',
  'studio.group.collection.register_plan_pre_order_period': '事前購入の期間設定',
  'studio.group.collection.register_plan_pre_order_period_start': '開始日',
  'studio.group.collection.register_plan_pre_order_period_end': '終了日',
  'studio.group.collection.register_plan_pre_order_period_msg1': '開始日を商品ページのオープン以降に設定してください。',
  'studio.group.collection.register_plan_pre_order_period_msg2': '終了日は開始日以降に設定してください。',
  'studio.group.collection.register_plan_pre_order_period_msg3': '終了日を正式リリース日以前に設定してください。',
  'studio.group.collection.register_plan_official_release_date_option': 'リリース予定日の表示オプション',
  'studio.group.collection.register_plan_official_release_date_option_def_value': 'リリース予定',
  'studio.group.collection.register_plan_official_release_date': '正式リリース日',
  'studio.group.collection.register_plan_official_release_date_msg1': '正式リリース日を選択してください',
  'studio.group.collection.register_banner_img': 'バナー画像',
  'studio.group.collection.register_banner_img_preview_btn': 'プレビュー',
  'studio.group.collection.register_banner_img_rectangular': '正方形の画像',
  'studio.group.collection.register_banner_img_portrait': '縦長の画像',
  'studio.group.collection.register_banner_img_landscape': '横長の画像',
  'studio.group.collection.register_banner_img_preview_title': '画像プレビュー',
  'studio.group.collection.register_banner_img_preview_guide': '説明用のサンプル画像です。',
  'studio.group.collection.register_pass_validation': 'コレクションをLIVEに適用しますか？',
  'studio.group.collection.list_total': '全体',
  'studio.group.collection.list_header_status': '状態',
  'studio.group.collection.list_header_display': '展示',
  'studio.group.collection.list_header_collection_name': 'コレクション商品名',
  'studio.group.collection.list_header_product_count': '商品数',
  'studio.group.collection.list_header_discount_rate': '割引率',
  'studio.group.collection.list_header_release_date': 'リリース(予定)日',
  'studio.group.collection.list_header_discount_btn': '割引設定',
  'studio.group.collection.list_search_place_holder': 'コレクション商品名検索',
  'studio.group.collection.list_more_btn_sales_suspention': '販売中断',
  'studio.group.collection.list_more_btn_display_suspention': '展示中断',
  'studio.group.collection.list_more_btn_go_to_store': 'ストアに移動する',
  'studio.group.collection.list_more_btn_opening_suspention': 'オープン中断',
  'studio.group.collection.list_more_btn_reopening': '展示再開',
  'studio.group.collection.list_more_btn_delete_request': '削除リクエスト',
  'studio.group.collection.list_more_btn_cancel_delete_request': '削除リクエストのキャンセル',
  'studio.group.collection.list_more_btn_delete_request_pop_guide':
    '削除をリクエストするには「DELETE」を入力してください。STOVE運営者の承認(2～3日所要)後に削除され、削除後は復元できなくなります。',
  'studio.group.collection.list_more_btn_delete_request_place_holder': 'DELETE',
  'studio.group.collection.list_more_btn_delete_request_del_btn': '削除',
  'studio.group.collection.list_more_btn_delete_request_del_btn_msg1': '削除のリクエストが完了しました。',
  'studio.prj_prod.this_prod.stt_release_sale_resumed_guide': '販売を再開するには「START」を入力してください。 ',
  'studio.prj_prod.this_prod.stt_release_sale_resumed_place_holder': 'START',
  'studio.prj_prod.this_prod.stt_release_resumed_btn': '再開',
  'studio.prj_prod.this_prod.stt_product_page_withdrawn_guide': '商品ページのオープンを中断するには「SUSPEND」を入力してください。 ',
  'studio.prj_prod.this_prod.stt_product_page_withdrawn_place_holder': 'SUSPEND',
  'studio.prj_prod.this_prod.stt_product_page_withdrawn_btn': '中断',
  'studio.group.collection.list_more_btn_delete_request_del_btn_msg2': '削除できないコレクションです。',
  'studio.prj_prod.this_prod.stt_release_display_resumed': '展示再開',
  'studio.prj_prod.this_prod.stt_release_display_resumed_guide': '展示を再開するには「ON」を入力してください。 ',
  'studio.prj_prod.this_prod.stt_release_display_resumed_place_holder': 'ON',
  'studio.prj_prod.this_prod.stt_release_display_suspended': '展示中断',
  'studio.prj_prod.this_prod.stt_release_display_suspended_guide': '展示を中断するには「OFF」を入力してください。 ',
  'studio.prj_prod.this_prod.stt_release_display_suspended_place_holder': 'OFF',
  'studio.group.collection.list_more_btn_delete_request_del_btn_msg3': '削除のリクエストがキャンセルされました。',
  'studio.group.collection.list_search_result': '{searchKeyWord}の検索結果 ',
  'studio.group.collection.list_search_result_no': '検索条件に合う結果がありません。',
  'studio.group.collection.list.details_title': 'コレクション詳細',
  'studio.group.collection.list.details_del_statuts_info': '削除リクエスト中の商品情報です。商品情報を変更できません。',
  'studio.group.collection.list.details_restriction_info1':
    '<span class="font-medium text-tint-red-a400">{reportedReason}</span>の理由でリリースが中断されました。<br/>再度リリースするには内容修正後に<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。',
  'studio.group.collection.list.details_restriction_info2':
    '運営者の<span class="font-medium text-tint-red-a400">{restrictionType}</span>でリリースが中断されました。<br/>再度リリースするには内容修正後に<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.group.collection.list.details_restriction_info3': '不適切なコンテンツがあります。',
  'studio.group.collection.list.details_collection_restriction_info':
    '<span class="font-medium text-tint-red-a400">{restrictionType}</span>でリリースが中断されました。再度リリースするには、移管された商品を削除してから保存してください。',
  'studio.group.collection.discount_title': '割引',
  'studio.group.collection.discount_registration_btn': '登録',
  'studio.group.collection.discount_main_guide':
    'コレクション商品に複数の割引を設定できます。<br/>割引率はコレクション内の各商品の価格を基準に適用されます。<br/>数量限定割引の設定も可能です。',
  'studio.breadcrumb.discount_registration': '割引登録',
  'studio.group.collection.discount_registration_title': '割引登録',
  'studio.group.collection.discount_registration_discount_name': '割引名',
  'studio.group.collection.discount_registration_discount_name_place_holder': '割引名を入力してください',
  'studio.group.collection.discount_registration_discount_name_msg1': '割引名を入力してください。',
  'studio.group.collection.discount_registration_start_date': '開始日',
  'studio.group.collection.discount_registration_start_date_option1': '即時',
  'studio.group.collection.discount_registration_start_date_option2': '予約',
  'studio.group.collection.discount_registration_end_date': '終了日',
  'studio.group.collection.discount_registration_end_date_msg1': '期間が重複している割引があります。期間を変更してから再度お試しください。',
  'studio.group.collection.discount_registration_end_date_msg2': '予約日は現在時刻以降に設定してください。',
  'studio.group.collection.discount_registration_rate': '割引率',
  'studio.group.collection.discount_registration_rate_msg1': '割引率を入力してください。',
  'studio.group.collection.discount_registration_limited_sale': '限定数量の割引販売',
  'studio.group.collection.discount_registration_limited_sale_y': '使用 ',
  'studio.group.collection.discount_registration_limited_sale_n': '未使用',
  'studio.group.collection.discount_registration_limited_quantity': '限定販売数量',
  'studio.group.collection.discount_registration_limited_quantity_text': '個',
  'studio.group.collection.discount_registration_limited_quantity_msg1': '販売数量は1から9,999,999の間でなければなりません。',
  'studio.group.collection.discount_registration_header_info': '価格が無料に設定されています。割引は有料の場合のみ適用されます。',
  'studio.group.collection.discount_registration_header_info_free': '無料',
  'studio.group.collection.discount_registration_list_sorting1': '全体',
  'studio.group.collection.discount_registration_list_sorting2': 'LIVE適用／適用予定',
  'studio.group.collection.discount_registration_list_sorting3': '終了',
  'studio.transfer.mgmt_history.detail_pg_tittle': 'プロジェクト移管の詳細情報',
  'studio.transfer.mgmt_history.detail_pg_guide1':
    'プロジェクト移管を受けるには、基本情報を入力する必要があります。<br/>入力された基本情報に基づいて、STOVEの審査が行われます。審査が完了すると、移管を受けられます。<br/>審査期間は最大1週間までかかります。',
  'studio.transfer.mgmt_history.detail_pg_guide2':
    'STOVEは、既存グループの関連法に基づいてプロジェクトに関する知的財産権をはじめとする一切の権利と義務を新しく移管する所有者に譲渡し、',
  'studio.transfer.mgmt_history.detail_pg_guide3':
    'そのグループがこれらの権利と義務を法律上有効な形で譲り受けた場合に限り、プロジェクト移管が有効に行われたことを保証します。',
  'studio.transfer.mgmt_history.detail_pg_info1_grp_name': 'グループ名',
  'studio.transfer.mgmt_history.detail_pg_info1_grp_name_place_holder': 'グループ名を入力してください',
  'studio.transfer.mgmt_history.detail_pg_info1_grp_name_req_msg': 'グループ名を入力してください。',
  'studio.transfer.mgmt_history.detail_pg_info1_grp_name_dup_msg': '重複しているグループ名は使用できません。<br/>他のグループ名を入力してください。',
  'studio.transfer.mgmt_history.request_review_btn': '審査をリクエストする',
  'studio.transfer.mgmt_history.request_review_cf_popup_msg': '入力した情報で審査を審査をリクエストしますか？',
  'studio.business_bank_setting.group_discontinue_guide_popup_msg1':
    'グループ削除時、 関連情報がすべて削除され、<br/>一度削除した情報は復元できなくなります。',
  'studio.business_bank_setting.group_discontinue_guide_popup_msg2': '本当に削除しますか？',
  'studio.business_bank_setting.group_discontinue_completed_popup_msg': 'グループ削除が完了しました。',
  'studio.business_bank_setting.group_discontinue_not_allowed_popup_msg1': 'グル―プを削除できませんでした。',
  'studio.business_bank_setting.group_discontinue_not_allowed_popup_msg2':
    'プロジェクトがグループに存在するか移管中の場合、グループを削除することができません。',
  'studio.business_bank_setting.title': '事業者・銀行情報設定',
  'studio.business_bank_setting.individual.select_gender_required_msg': '代表者の性別を選択してください。',
  'studio.business_bank_setting.individual.select_birth_wrong_format_msg': 'この日時には設定できません。もう一度ご確認ください。',
  'studio.business_bank_setting.individual.game_production_no_guide_req_msg': 'ゲーム制作(配給)業の登録証を添付してください。',
  'studio.business_bank_setting.individual.telecom_sales_no_guide_req_msg': '通信販売業登録証を添付してください',
  'studio.business_bank_setting.account.question4_invalid_msg': '入力された口座番号が無効です。再度入力してください。',
  'studio.business_bank_setting.account.question5_invalid_msg': '入力された預金者名が無効です。再度入力してください。',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_basic_game': '製品版',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_demo_game': 'Demo版',
  'studio.prj_prod.this_prod.home_product_setting_prod_link': '商品連携 ',
  'studio.prj_prod.this_prod.home_product_setting_prod_link_guide':
    '本商品と連携させる商品を追加してください。連携させた商品を当該のタイプに自動変更されます。',
  'studio.prj_prod.this_prod.home_product_setting_info_mismatch_new_reg_popup':
    '入力した基本情報が社内レーティングの審査内容と異なります。<br/>新しくレーティング審査をリクエストしてください。',
  'studio.prj_prod.this_prod.home_product_setting__new_reg_btn': 'リクエストする',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_basic_content': 'ゲームコンテンツ',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_demo_content': 'デモコンテンツ',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_basic_util': '正式Utility',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_demo_util': 'Demo Utility',
  'studio.prj_prod.this_prod.edit_display_countries_regions_north_america': '北アメリカ',
  'studio.prj_prod.this_prod.edit_display_countries_regions_central_america': '中央アメリカ',
  'studio.prj_prod.this_prod.edit_display_countries_regions_south_america': '南アメリカ',
  'studio.prj_prod.this_prod.edit_display_countries_regions_western_europe': '西ヨーロッパ',
  'studio.prj_prod.this_prod.edit_display_countries_regions_eastern_europe': '東ヨーロッパ',
  'studio.prj_prod.this_prod.edit_display_countries_regions_northern_europe': '北ヨーロッパ',
  'studio.prj_prod.this_prod.edit_display_countries_regions_east_asia': '東アジア',
  'studio.prj_prod.this_prod.edit_display_countries_regions_southeast_asia': '東南アジア',
  'studio.prj_prod.this_prod.edit_display_countries_regions_western_asia': '西アジア',
  'studio.prj_prod.this_prod.edit_display_countries_regions_southern_asia': '南アジア',
  'studio.prj_prod.this_prod.edit_display_countries_regions_central_asia': '中央アジア',
  'studio.prj_prod.this_prod.edit_display_countries_regions_oceania': 'オセアニア',
  'studio.prj_prod.this_prod.edit_display_countries_regions_north_africa': '北アフリカ',
  'studio.prj_prod.this_prod.edit_display_countries_regions_western_africa': '西アフリカ',
  'studio.prj_prod.this_prod.edit_display_countries_regions_central_africa': '中央アフリカ',
  'studio.prj_prod.this_prod.edit_display_countries_regions_east_africa': '東アフリカ',
  'studio.prj_prod.this_prod.edit_display_countries_regions_southern_africa': '南アフリカ',
  'studio.prj_prod.this_prod.edit_display_countries_regions_other': 'その他',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_standard_price_manual_input_req_val_msg1': '基準販売価格を設定してください。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_standard_price_manual_input_invalid_val_msg3': '最低 USD0.99 以上の金額を入力してください。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_price_invalid_val_msg5': '金額は小数点2桁を含む最大8桁まで入力できます。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_payment_price_req_val_msg1': '決済金額を入力してください。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_payment_price_invalid_val_msg2': '最低KRW10以上の10単位で入力してください。 ',
  'studio.member_manage.member.invite_link_popup_case_4809':
    '{grpName}<br/>すでにリクエスト中のグループです。<br/>グループ管理者の承認までお待ちください。',
  'studio.member_manage.role_manage_list_by_menu_coupon': 'クーポン',
  'studio.member_manage.role_manage_list_by_menu_event': 'イベント',
  'studio.member_manage.role_manage_list_by_menu_banner_img': 'バナー画像',
  'studio.member_manage.member_details_pg_title': 'メンバー詳細情報',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_content1':
    '本手動セキュリティ審査リクエストおよび同意書(以下「本同意書」という)は、株式会社スマイルゲートホールディングスがオンラインプラットフォームを通じて提供するSTOVE Studioサービス(以下「STOVE」といいます)において、商品(プログラム等)を販売するパートナー(以下「パートナー」といいます)による商品の手動セキュリティ審査リクエストおよびこれに関連するパートナーの責任に関する同意事項を定めることを目的とします。',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_content2':
    'パートナーはSTOVEで販売を行うためにアップロードしようとする商品にウイルス、ワーム、トロイの木馬、バックドア、スパイウェア、ランサムウェア、アドウェア、悪性ボットなど悪意のあるプログラムおよびその他の有害なプログラム(以下「マルウェア」)が含まれていないにもかかわらず、何らかの理由によってSTOVEで実施する自動セキュリティ審査を通過できなかった場合、次の内容に同意して手動のセキュリティ審査リクエストを行い、審査を通過した場合に商品を販売できるようになります。本同意書による同意の内容は、パートナーが本同意書の提出後にアップロードする商品すべてに適用されます。<br/>①パートナーは、アップロードするすべての商品にマルウェアが含まれていないことを保証するとともに、商品のアップロード及びアップロードした商品に関連して生じるいかなる結果についても、その一切の責任を負うものとします。<br/>②STOVEは、STOVEの故意または重過失によるものでない限り、パートナーがアップロードした商品に関連して発生した損害や問題については、パートナーがその責任を負うものとします。また、これに関連してSTOVEとの間で法的な問題が生じた場合、パートナーの責任と費用において解決するものとし、STOVEに生じた損害について補償するものとします。',
  'studio.prj_prod.this_prod.product_data.build.details_select_file_security_standard_header2': 'セキュリティの水準',
  'studio.prj_prod.this_prod.product_data.build.details_select_file_security_standard_high': '高',
  'studio.prj_prod.this_prod.product_data.build.details_select_file_security_standard_basic': '一般',
  'studio.build_mgmt.build_gen_steps_0_build_prep': 'ビルド生成を待機中',
  'studio.build_mgmt.build_steps_count': '({currentStep}/{totalStep}段階)',
  'studio.build_mgmt.build_gen_steps_1_build_download': 'ビルド原本をダウンロード中',
  'studio.build_mgmt.build_gen_steps_2_build_extract': 'ビルド原本を解凍中',
  'studio.build_mgmt.build_gen_steps_3_prev_build_check': '以前にアップロードしたビルドを確認中',
  'studio.build_mgmt.build_gen_steps_4_drm_apply': 'DRM適用中',
  'studio.build_mgmt.build_gen_steps_5_build_file_compare': 'ビルドファイルを比較中',
  'studio.build_mgmt.build_gen_steps_6_generate': 'ビルドファイルを生成中',
  'studio.build_mgmt.build_gen_steps_7_waiting_for_completion': '完了待機中',
  'studio.build_mgmt.security_inspection_steps_0_waiting': 'セキュリティ審査の待機中',
  'studio.build_mgmt.security_inspection_steps_1_download': 'ビルド原本のダウンロード中',
  'studio.build_mgmt.security_inspection_steps_2_extract': 'ビルド原本を解凍中',
  'studio.build_mgmt.security_inspection_steps_3_scan': 'ビルドファイルをスキャン中',
  'studio.build_mgmt.security_inspection_steps_4_waiting_for_completion': '完了待機中',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_inspection_failed_title': 'セキュリティ審査失敗',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_inspection_success_title': 'セキュリティ審査完了',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_success_msg': '完了しました。 ',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_success_title': 'ビルド生成完了',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_applicant_name': 'お名前',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_applicant_signature': '(印)',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_files_num': '{numByItems}個',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_file_tooltip':
    'プロジェクト共用で使用される画像や動画を<br/>ストレージにあらかじめアップロードできます。商品ページを管理する際に使用できます。',
  'studio.prod_pg.img_edit_popup.img_type1_prod_pg_bg_img': '商品ページの背景画像',
  'studio.prod_pg.img_edit_popup.img_type2_display_vid_thumbnail': '展示する動画および画像(動画のサムネイル)',
  'studio.prod_pg.img_edit_popup.img_type3_display_img': '展示する動画および画像(画像)',
  'studio.prod_pg.img_edit_popup.img_type4': '1:1画像',
  'studio.prod_pg.img_edit_popup.img_type5': '16:9画像',
  'studio.prod_pg.img_edit_popup.img_type6_title_bg_img': 'タイトルの背景画像',
  'studio.prod_pg.img_edit_popup.img_type7_one_line_intro_img': '一言紹介(Game説明)画像',
  'studio.prod_pg.img_edit_popup.img_type8_award_img': '受賞時に表示される画像',
  'studio.prod_pg.img_edit_popup.img_type9': 'コンテンツバナー_正方形の画像_2×2',
  'studio.prod_pg.img_edit_popup.img_type10': 'コンテンツバナー_縦長の画像_1×2',
  'studio.prod_pg.img_edit_popup.img_type11': 'コンテンツバナー_横長の画像_1×2',
  'studio.prod_pg.img_edit_popup.img_type12_pc_logo_img': 'PCクライアント商品のサムネイル画像',
  'studio.prod_pg.img_edit_popup.img_type13_pc_recommended_img': 'PCクライアントの「ランダムおすすめ」に表示される画像',
  'studio.common.popup_case_lang_setting_input_required': '{reqValue}を入力した後から言語を設定できます。<br/>内容を入力して再度お試しください。',
  'studio.common.file_upl_guide1_1': '{acceptFileExtAttributeLabel}',
  'studio.common.file_upl_guide1_2': '{size}MB以下',
  'studio.prj_prod.execution_pc_client_logo_img_content1_fav_search': 'お気に入り',
  'studio.prj_prod.execution_pc_client_logo_img_content2': 'LOSTARK',
  'studio.prj_prod.execution_pc_client_logo_img_content3': 'LORDNINE',
  'studio.prj_prod.execution_pc_client_logo_img_content4_guide1': '自由度の高い武器選択＆育成、自分だけの戦闘スタイルでお楽しみください。',
  'studio.prj_prod.execution_pc_client_logo_img_content5': 'MMORPG · 18歳以上対象',
  'studio.prj_prod.execution_pc_client_logo_img_content6_play': 'プレイ',
  'studio.prj_prod.execution_pc_client_logo_img_content7_random_search': 'ランダムサーチ',
  'studio.prj_prod.execution_pc_client_logo_img_content8_guide2': 'アイコンをクリックすると<br>他のアカウントがおすすめされます。',
  'studio.common.def_key.space_not_allowed': '最大1文字以上を入力してください。 ',
  'studio.common.popup_case_no_access_per': 'アクセス権限がないグループです。<br/>グループの管理者にお問い合わせください。 ',
  'studio.lnb.common_2depth_tutorial_vid': 'Studioからのお知らせ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.build_required_msg': 'ビルドを選択してください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.origin_country_place_holder': '選択',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.origin_country_required_msg': '原作国を選択してください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.description_required_msg':
    'ゲームの説明を簡単に作成してください ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_request_required_msg':
    '必須の情報をすべて入力してから審査リクエストを行ってください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide1_rating_by_age': '{rating}歳利用可',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide1_rating_all': '全年齢対象',
  'studio.prj_prod_mngmt.rating_build_review.self_review_req.qtn_required_msg': 'アンケートの項目を選択してください。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_select_content_required_msg': 'ゲームに含まれる内容を最低1個選択してください。',
  'studio.rating_build_review.reason_input_place_holder': '異議内容を入力してください',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_appeal_required_msg': '異議内容を入力してください。 ',
  'studio.prj_prod_mngmt.rating_build_review.intl_org_save_msg':
    'このまま<span class="font-bold">国際レーティング分類番号を<br/>保存します。保存時、</span><br/><br/>現在適用されているレーティング情報に<br/>即反映されます。',
  'studio.prj_prod_mngmt.rating_build_review.report_change_required_msg': '変更事項を最低一つ以上選択してください。 ',
  'studio.prj_prod_mngmt.rating_build_review.report_change_item_name_kr': 'タイトル(韓国語)：',
  'studio.prj_prod_mngmt.rating_build_review.report_change_item_name_en': 'タイトル(英語)：',
  'studio.gnb.group_myinfo.pg_title': '自分の情報',
  'studio.registration.agreement-required': 'Studioの会員登録にはサービス利用規約への同意が必要です。',
  'studio.registration.email': 'Eメール',
  'studio.registration.terms-privacy-agree': 'Studioのサービス利用規約と個人情報の収集に同意してください。',
  'studio.registration.all-agree': '以下の内容をすべて同意します。',
  'studio.stove.terms-service-required': '[STOVE]サービス利用規約(必須)',
  'studio.stove.privacy-required': '[STOVE]個人情報の収集および利用の同意(必須)',
  'studio.stove.ads-consent-optional': '[STOVE]広告・宣伝情報の受信に同意(選択)',
  'studio.registration.terms-service-required': '[Studio]サービス利用規約(必須)',
  'studio.registration.privacy-required': '[Studio]個人情報の収集および利用の同意(必須)',
  'studio.registration.ads-consent-optional': '[Studio]広告・宣伝情報の受信に同意(選択)',
  'studio.registration.view-terms': '規約を見る',
  'studio.registration.sign_up_btn': '会員登録',
  'studio.registration.cancel-confirm': 'このままStudioの会員登録をキャンセルしますか？<br/>キャンセルすると、入力した内容が消滅します。',
  'studio.national_code.af': 'アフガニスタン',
  'studio.national_code.al': 'アルバニア',
  'studio.national_code.ax': 'オーランド諸島',
  'studio.national_code.an': 'オランダ領アンティル',
  'studio.national_code.bv': 'ブーベ島',
  'studio.national_code.hm': 'ハード島とマクドナルド諸島',
  'studio.national_code.tf': 'フランス南部地域',
  'studio.national_code.um': '合衆国領有小離島',
  'studio.national_code.dz': 'アルジェリア',
  'studio.national_code.as': 'アメリカ領サモア',
  'studio.national_code.ad': 'アンドラ',
  'studio.national_code.ao': 'アンゴラ',
  'studio.national_code.ai': 'アンギラ',
  'studio.national_code.aq': '南極大陸',
  'studio.national_code.ag': 'アンティグア・バーブーダ',
  'studio.national_code.ar': 'アルゼンチン',
  'studio.national_code.am': 'アルメニア',
  'studio.national_code.aw': 'アルバ',
  'studio.national_code.au': 'オーストラリア',
  'studio.national_code.at': 'オーストリア',
  'studio.national_code.az': 'アゼルバイジャン',
  'studio.national_code.bs': 'バハマ',
  'studio.national_code.bh': 'バーレーン',
  'studio.national_code.bd': 'バングラデシュ',
  'studio.national_code.bb': 'バルバドス',
  'studio.national_code.by': 'ベラルーシ',
  'studio.national_code.be': 'ベルギー',
  'studio.national_code.bz': 'ベリーズ',
  'studio.national_code.bj': 'ベナン',
  'studio.national_code.bm': 'バミューダ',
  'studio.national_code.bt': 'ブータン',
  'studio.national_code.bo': 'ボリビア',
  'studio.national_code.bq': 'ボネール島',
  'studio.national_code.ba': 'ボスニア・ヘルツェゴビナ',
  'studio.national_code.bw': 'ボツワナ',
  'studio.national_code.br': 'ブラジル',
  'studio.national_code.io': 'イギリス領インド洋地域',
  'studio.national_code.vg': 'イギリス領ヴァージン諸島',
  'studio.national_code.bn': 'ブルネイ・ダルサラーム',
  'studio.national_code.bg': 'ブルガリア',
  'studio.national_code.bf': 'ブルキナファソ',
  'studio.national_code.bi': 'ブルンジ',
  'studio.national_code.kh': 'カンボジア',
  'studio.national_code.cm': 'カメルーン',
  'studio.national_code.ca': 'カナダ',
  'studio.national_code.cv': 'カーボベルデ',
  'studio.national_code.ky': 'ケイマン諸島',
  'studio.national_code.cf': '中央アフリカ共和国',
  'studio.national_code.td': 'チャド',
  'studio.national_code.cl': 'チリ',
  'studio.national_code.cn': '中華人民共和国',
  'studio.national_code.cx': 'クリスマス島',
  'studio.national_code.cc': 'ココス諸島',
  'studio.national_code.co': 'コロンビア',
  'studio.national_code.km': 'コモロ',
  'studio.national_code.cg': 'コンゴ－ブラザヴィル',
  'studio.national_code.ck': 'クック諸島',
  'studio.national_code.cr': 'コスタリカ',
  'studio.national_code.ci': 'コートジボワール',
  'studio.national_code.hr': 'クロアチア',
  'studio.national_code.cu': 'キューバ',
  'studio.national_code.cw': 'キュラソー',
  'studio.national_code.cy': 'キプロス',
  'studio.national_code.cz': 'チェコ共和国',
  'studio.national_code.dk': 'デンマーク',
  'studio.national_code.dj': 'ジブチ',
  'studio.national_code.dm': 'ドミニカ',
  'studio.national_code.do': 'ドミニカ共和国',
  'studio.national_code.ec': 'エクアドル',
  'studio.national_code.eg': 'エジプト',
  'studio.national_code.sv': 'エルサルバドル',
  'studio.national_code.gq': '赤道ギニア',
  'studio.national_code.er': 'エリトリア',
  'studio.national_code.ee': 'エストニア',
  'studio.national_code.et': 'エチオピア',
  'studio.national_code.fk': 'フォークランド諸島',
  'studio.national_code.fo': 'フェロー諸島',
  'studio.national_code.fj': 'フィジー',
  'studio.national_code.fi': 'フィンランド',
  'studio.national_code.fr': 'フランス',
  'studio.national_code.gf': 'フランス領ギアナ',
  'studio.national_code.pf': 'フランス領ポリネシア',
  'studio.national_code.ga': 'ガボン',
  'studio.national_code.gm': 'ガンビア',
  'studio.national_code.ge': 'ジョージア',
  'studio.national_code.de': 'ドイツ',
  'studio.national_code.gh': 'ガーナ',
  'studio.national_code.gi': 'ジブラルタル',
  'studio.national_code.gr': 'ギリシャ',
  'studio.national_code.gl': 'グリーンランド',
  'studio.national_code.gd': 'グレナダ',
  'studio.national_code.gp': 'グアドループ',
  'studio.national_code.gu': 'グアム',
  'studio.national_code.gt': 'グアテマラ',
  'studio.national_code.gg': 'ガーンジー島',
  'studio.national_code.gn': 'ギニア',
  'studio.national_code.gw': 'ギニアビサウ',
  'studio.national_code.gy': 'ガイアナ',
  'studio.national_code.ht': 'ハイチ',
  'studio.national_code.hn': 'ホンジュラス',
  'studio.national_code.hk': '香港',
  'studio.national_code.hu': 'ハンガリー',
  'studio.national_code.is': 'アイスランド',
  'studio.national_code.in': 'インド',
  'studio.national_code.id': 'インドネシア',
  'studio.national_code.ir': 'イラン・イスラム共和国',
  'studio.national_code.iq': 'イラク',
  'studio.national_code.ie': 'アイルランド',
  'studio.national_code.im': 'マン島',
  'studio.national_code.il': 'イスラエル',
  'studio.national_code.it': 'イタリア',
  'studio.national_code.jm': 'ジャマイカ',
  'studio.national_code.jp': '日本',
  'studio.national_code.je': 'ジャージー島',
  'studio.national_code.jo': 'ヨルダン',
  'studio.national_code.kz': 'カザフスタン',
  'studio.national_code.ke': 'ケニア',
  'studio.national_code.sz': 'エスワティニ',
  'studio.national_code.ki': 'キリバス',
  'studio.national_code.kw': 'クウェート',
  'studio.national_code.kg': 'キルギスタン',
  'studio.national_code.la': 'ラオス人民民主共和国',
  'studio.national_code.lv': 'ラトビア',
  'studio.national_code.lb': 'レバノン',
  'studio.national_code.ls': 'レソト',
  'studio.national_code.lr': 'リベリア',
  'studio.national_code.ly': 'リビア',
  'studio.national_code.li': 'リヒテンシュタイン',
  'studio.national_code.lt': 'リトアニア',
  'studio.national_code.lu': 'ルクセンブルク',
  'studio.national_code.mo': 'マカオ',
  'studio.national_code.mk': '北マケドニア',
  'studio.national_code.mg': 'マダガスカル',
  'studio.national_code.mw': 'マラウイ',
  'studio.national_code.my': 'マレーシア',
  'studio.national_code.mv': 'モルディブ',
  'studio.national_code.ml': 'マリ',
  'studio.national_code.mt': 'マルタ',
  'studio.national_code.mh': 'マーシャル諸島',
  'studio.national_code.mq': 'マルティニーク',
  'studio.national_code.mr': 'モーリタニア',
  'studio.national_code.mu': 'モーリシャス',
  'studio.national_code.yt': 'マヨット',
  'studio.national_code.mx': 'メキシコ',
  'studio.national_code.fm': 'ミクロネシア連邦',
  'studio.national_code.md': 'モルドバ共和国',
  'studio.national_code.mc': 'モナコ',
  'studio.national_code.mn': 'モンゴル',
  'studio.national_code.me': 'モンテネグロ',
  'studio.national_code.ms': 'モントセラト',
  'studio.national_code.ma': 'モロッコ',
  'studio.national_code.mz': 'モザンビーク',
  'studio.national_code.mm': 'ミャンマー',
  'studio.national_code.na': 'ナミビア',
  'studio.national_code.nr': 'ナウル',
  'studio.national_code.np': 'ネパール',
  'studio.national_code.nl': 'オランダ',
  'studio.national_code.nc': 'ニューカレドニア',
  'studio.national_code.nz': 'ニュージーランド',
  'studio.national_code.ni': 'ニカラグア',
  'studio.national_code.ne': 'ニジェール',
  'studio.national_code.ng': 'ナイジェリア',
  'studio.national_code.nu': 'ニウエ',
  'studio.national_code.nf': 'ノーフォーク島',
  'studio.national_code.kp': '朝鮮民主主義人民共和国',
  'studio.national_code.mp': '北マリアナ諸島',
  'studio.national_code.no': 'ノルウェー',
  'studio.national_code.om': 'オマーン',
  'studio.national_code.pk': 'パキスタン',
  'studio.national_code.pw': 'パラオ',
  'studio.national_code.ps': 'パレスチナ',
  'studio.national_code.pa': 'パナマ',
  'studio.national_code.pg': 'パプアニューギニア',
  'studio.national_code.py': 'パラグアイ',
  'studio.national_code.pe': 'ペルー',
  'studio.national_code.ph': 'フィリピン',
  'studio.national_code.pn': 'ピトケアン諸島',
  'studio.national_code.pl': 'ポーランド',
  'studio.national_code.pt': 'ポルトガル',
  'studio.national_code.pr': 'プエルトリコ',
  'studio.national_code.qa': 'カタール',
  'studio.national_code.re': 'レユニオン',
  'studio.national_code.ro': 'ルーマニア',
  'studio.national_code.ru': 'ロシア連邦',
  'studio.national_code.rw': 'ルワンダ',
  'studio.national_code.bl': 'サン・バルテルミー島',
  'studio.national_code.sh': 'セントヘレナ',
  'studio.national_code.kn': 'セントクリストファー・ネービス',
  'studio.national_code.lc': 'セントルシア',
  'studio.national_code.mf': 'サン・マルタン',
  'studio.national_code.pm': 'サンピエール島・ミクロン島',
  'studio.national_code.vc': 'セントビンセント及びグレナディーン諸島',
  'studio.national_code.ws': 'サモア',
  'studio.national_code.sm': 'サンマリノ',
  'studio.national_code.st': 'サントメ・プリンシペ',
  'studio.national_code.sa': 'サウジアラビア',
  'studio.national_code.sn': 'セネガル',
  'studio.national_code.rs': 'セルビア',
  'studio.national_code.sc': 'セーシェル',
  'studio.national_code.sl': 'シエラレオネ',
  'studio.national_code.sg': 'シンガポール',
  'studio.national_code.sx': 'シント・マールテン',
  'studio.national_code.sk': 'スロバキア',
  'studio.national_code.si': 'スロベニア',
  'studio.national_code.sb': 'ソロモン諸島',
  'studio.national_code.so': 'ソマリア',
  'studio.national_code.za': '南アフリカ',
  'studio.national_code.gs': 'サウスジョージア・サウスサンドウィッチ諸島',
  'studio.national_code.kr': '韓国',
  'studio.national_code.ss': '南スーダン',
  'studio.national_code.es': 'スペイン',
  'studio.national_code.lk': 'スリランカ',
  'studio.national_code.sd': 'スーダン',
  'studio.national_code.sr': 'スリナム',
  'studio.national_code.sj': 'スヴァールバル諸島およびヤンマイエン島',
  'studio.national_code.se': 'スウェーデン',
  'studio.national_code.ch': 'スイス',
  'studio.national_code.sy': 'シリア・アラブ共和国',
  'studio.national_code.tw': '台湾',
  'studio.national_code.tj': 'タジキスタン',
  'studio.national_code.tz': 'タンザニア連合共和国',
  'studio.national_code.th': 'タイ',
  'studio.national_code.cd': 'コンゴ－キンシャサ',
  'studio.national_code.tl': '東ティモール',
  'studio.national_code.tg': 'トーゴ',
  'studio.national_code.tk': 'トケラウ',
  'studio.national_code.to': 'トンガ',
  'studio.national_code.tt': 'トリニダード・トバゴ',
  'studio.national_code.tn': 'チュニジア',
  'studio.national_code.tr': 'トルコ',
  'studio.national_code.tm': 'トルクメニスタン',
  'studio.national_code.tc': 'タークス・カイコス諸島',
  'studio.national_code.tv': 'ツバル',
  'studio.national_code.vi': 'アメリカ領ヴァージン諸島',
  'studio.national_code.ug': 'ウガンダ',
  'studio.national_code.ua': 'ウクライナ',
  'studio.national_code.ae': 'アラブ首長国連邦',
  'studio.national_code.gb': 'イギリス',
  'studio.national_code.us': 'アメリカ合衆国',
  'studio.national_code.uy': 'ウルグアイ',
  'studio.national_code.uz': 'ウズベキスタン',
  'studio.national_code.vu': 'バヌアツ',
  'studio.national_code.va': 'バチカン市国(法王庁)',
  'studio.national_code.ve': 'ベネズエラ・ボリバル共和国',
  'studio.national_code.vn': 'ベトナム',
  'studio.national_code.wf': 'ウォリス・フツナ',
  'studio.national_code.eh': '西サハラ',
  'studio.national_code.ye': 'イエメン',
  'studio.national_code.zm': 'ザンビア',
  'studio.national_code.zw': 'ジンバブエ',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_maint': 'ゲームメンテナンス',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr7': '商品ごとのメンテナンス登録、修正、削除',
  'studio.gnb.group_myinfo.my_group.detailed_group_my_prj': 'マイプロジェクト',
  'studio.gnb.group_myinfo.my_group.detailed_group_prj_product_list': '{prjName} の商品 [{prodNum}]',
  'studio.gnb.group_myinfo_btn_join_req_accept': '承認',
  'studio.gnb.group_myinfo_btn_join_req_reject': '拒否',
  'studio.gnb.group_myinfo.invitation.detailed_group_group_name': '{grpName} グループ',
  'studio.gnb.group_myinfo.invitation.detailed_group_join_time': '招待日時',
  'studio.gnb.group_myinfo.invitation.detailed_group_invite_status': 'ステータス',
  'studio.gnb.group_myinfo.invitation.detailed_invited_permissions': '招待されたグループメニューの権限',
  'studio.gnb.group_myinfo.invitation.detailed_invited_prj': '招待されたプロジェクト',
  'studio.gnb.group_myinfo.invitation.detailed_prj_product_list': '{prjName} の商品 [{prodNum}]',
  'studio.gnb.group_myinfo.invitation.detailed_prj_product_name': '商品名',
  'studio.gnb.group_myinfo.invitation.detailed_prj_role': '役割',
  'studio.gnb.group_myinfo.invitation.detailed_permission_given_date': '権限付与日',
  'studio.gnb.group_myinfo.invitation.detailed_prj_name': 'プロジェクト名',
  'studio.gnb.group_myinfo.invitation.detailed_product_num': '商品数',
  'studio.gnb.group_myinfo.invitation.detailed_btn_accept': '承認',
  'studio.gnb.group_myinfo.invitation.detailed_btn_reject': '拒否',
  'studio.gnb.group_myinfo.join_req_btn_reject_msg': 'グループ招待を拒否しますか？',
  'studio.gnb.group_myinfo.join_req_btn_reject_cf': '拒否',
  'studio.gnb.group_myinfo.join_req_btn_accept_msg': 'グループ招待を承認しますか？',
  'studio.gnb.group_myinfo.join_req_btn_accept_cf': '承認',
  'studio.gnb.group_myinfo.join_req_reject_done_msg': 'グループ招待の拒否が完了しました。',
  'studio.gnb.group_myinfo.join_req_accept_done_msg': 'グループ招待の承認が完了しました。',
  'studio.gnb.group_myinfo.join_req_btn_close': '閉じる',
  'studio.gnb.group_myinfo.join_req_btn_visit_group': 'グループを訪問',
  'studio.gnb.group_myinfo.join_req_unknown_err_msg':
    'ページを更新するか、再試行してください。<br/>この招待リクエストはすでにキャンセルされています。',
  'studio.gnb.group_myinfo.join_req_join_req_withdrawn_msg': 'この招待リクエストはすでにキャンセルされています。',
  'studio.group.home.notice': 'Studio お知らせ',
  'studio.group.home.notice_no': '登録されたお知らせはありません。',
  'studio.group.home.notice_read_more': 'もっと見る',
  'studio.group.home.board_type2_data1': '新しいメンバーが参加しました。',
  'studio.group.home.board_type4_data1': '前月比 ',
  'studio.group.home.board_type5_plan_stt_released': 'リリース',
  'studio.group.home.board_type5_plan_stt_expected': '予定',
  'studio.group.notice.details_popup_title': 'Studio お知らせ',
  'studio.group.notice.details_popup_download': 'ダウンロード',
  'studio.member_manage.member.member_title.email_header': 'メール',
  'studio.member_manage.member.guide4': 'メニュー権限',
  'studio.member_manage.member.guide5': '商品権限',
  'studio.member_manage.member.guide6': 'メンバー招待',
  'studio.member_manage.member.guide7': 'メニュー権限、商品権限の付与',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use': '最大使用回数',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_guide':
    '使用回数を変更すると、既存のメンバーが変更後の回数を超えた場合、リンクを使用できなくなります。',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_def_100': '100回',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_1': '1回',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_5': '5回',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_10': '10回',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_25': '25回',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_50': '50回',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_n': '制限なし',
  'studio.member_manage.member_invite.msg2': '招待するメンバーリスト (1/50)',
  'studio.member_manage.member_invite.inviting_member_perm_btn': '権限',
  'studio.member_manage.member_invite.invite_btn': '招待',
  'studio.member_manage.member_invite.invite_pop_msg': 'メンバー招待が完了しました。',
  'studio.member_manage.member_invite.email_add_step0_msg':
    '入力したメールアドレスで N 件の STOVE アカウントが見つかりました。<br/>招待するアカウントを選択してください。',
  'studio.member_manage.member_invite.email_add_step0_header2': 'タイプ',
  'studio.member_manage.member_invite.email_add_step0_header3': 'ニックネーム',
  'studio.member_manage.member_invite.email_add_step0_cnf_btn': '確認',
  'studio.member_manage.member_invite.email_add_step0_alert1_msg': 'すでにグループに加入しているアカウントは招待できません。',
  'studio.member_manage.member_invite.email_add_step0_alert2_msg': 'すでにグループ招待をリクエストしたアカウントです。',
  'studio.member_manage.role_manage_role_name_header1': '役割名',
  'studio.member_manage.member_email_header1': 'メール',
  'studio.member_manage.project_list_email_header2': 'メール',
  'studio.member_manage.member_details_msg1': 'メール',
  'studio.member_manage.member_details_remove_cf_btn': 'エクスポート',
  'studio.member_manage.member_details_save_alert_msg': '保存されました。',
  'studio.member_manage.history_selbox_status_all': '状態: 全体',
  'studio.prj_prod.this_prod.edit_display_show_msg0': '表示オプション',
  'studio.prj_prod.this_prod.edit_display_show_exposed_btn': '表示',
  'studio.prj_prod.this_prod.edit_display_show_unexposed_btn': '非表示',
  'studio.prj_prod.this_prod.edit_gamepreview_image_guide1': '{acceptFileExtAttributeLabel}ファイル｜{size}MB以下',
  'studio.prj_prod.this_prod.edit_gamepreview_video_guide1': '{acceptFileExtAttributeLabel}ファイル｜{size}MB以下',
  'studio.prj_prod.this_prod.edit_gamepreview_msg9_2': 'PC環境の一言紹介文の上に表示される画像を追加できます。',
  'studio.prj_prod.this_prod.edit_additional_requirements_component_val_msg': '項目名を入力してください。 ',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_prj_name': 'プロジェクト名',
  'studio.mail.this_release_info_del_completed_detail_msg3': 'STOVE運営ポリシーに従い、削除された商品の販売履歴と支払い情報が保存されます。',
  'studio.prj_prod.this_prod.home_product_setting_category_msg': '代表ジャンルを選択してください。',
  'studio.member_manage.member_invite.email_add_btn': '追加する',
  'studio.prj_prod.this_prod.home_product_setting_msg1': 'Demo',
  'studio.prj_prod.this_prod.home_product_setting_msg2': 'DLC',
  'studio.prj_prod.this_prod.home_product_setting_msg4': 'Utility',
  'studio.prj_prod_mngmt.popup_release_prod_exist_msg1': '現在発売中の商品が含まれています。',
  'studio.prj_prod_mngmt.popup_release_prod_exist_msg2': '商品ホーム > 発売停止後、再度試してください。',
  'studio.prj_prod_mngmt.btn_prod_del': '削除',
  'studio.prj_prod_mngmt.popup_prod_del_guide1': '商品削除',
  'studio.prj_prod_mngmt.popup_prod_del_guide2': '削除するには「DELETE」を入力してください。 ',
  'studio.prj_prod_mngmt.popup_prod_del_guide3': '削除すると復旧できなくなります。',
  'studio.prj_prod_mngmt.popup_prod_del_place_holder': 'DELETE',
  'studio.business_bank_setting.guide1_3': '<span>住民登録証明書</span>',
  'studio.business_bank_setting.guide1_5': '<span>事業者登録証明書</span>',
  'studio.business_bank_setting.individual.select_birth_msg2': '数字のみ入力してください。',
  'studio.business_bank_setting.individual.select_birth_msg3': '不正な形式で登録されました。生年月日を確認してください。',
  'studio.business_bank_setting.individual.info_global_o_btn_adress': '住所を探す',
  'studio.business_bank_setting.individual.info_global_o_adress_box_place_holder3': '郡',
  'studio.business_bank_setting.individual.info_global_o_adress_box_place_holder4': '区',
  'studio.business_bank_setting.individual.info_global_o_adress_box_required_n': '住所を選択してください。',
  'studio.business_bank_setting.individual.btn_no_check': '検索',
  'studio.business_bank_setting.individual.btn_attach_alert1': '拡張子が異なるためアップロードできません。',
  'studio.business_bank_setting.individual.btn_attach_alert2': 'ファイルの容量超過のためアップロードできません。',
  'studio.business_bank_setting.individual.game_production_no': 'ゲーム制作（配信）業の登録番号',
  'studio.business_bank_setting.individual.telecom_sales_no': '通信販売業の登録番号',
  'studio.business_bank_setting.individual.nation_change_alert1':
    '国情報を変更する場合、変更された国情報は最後の国情報を基準に審査完了後、翌月1日に変更処理されます。',
  'studio.business_bank_setting.individual.game_business_no_kr': '韓国の事業者登録番号',
  'studio.gnb.common_2depth_metrics': '指標',
  'studio.gnb.group_myinfo.my_group.detailed_group_role_type': '種類',
  'studio.group.home.board_type10_select_box1': 'ACU',
  'studio.group.home.board_type10_select_box2': 'NRU',
  'studio.group.home.board_type10_select_box3': 'DAU',
  'studio.member_manage.member_invite.email_add_msg1': 'すでにグループに参加しているアカウントは招待できません。',
  'studio.member_manage.member_invite.email_add_msg2': 'すでにグループへの招待をリクエストしたアカウントです。',
  'studio.member_manage.member_invite.email_add_msg3': 'そのアカウントはSTOVEに登録されていません。',
  'studio.member_manage.member_invite.email_add_msg4': '有効なメールアドレスを入力してください。',
  'studio.member_manage.member_invite.email_add_msg5': '最大数を超えてメンバーを追加することはできません。',
  'studio.member_manage.member_invite.msg4': '招待するメールアドレス',
  'studio.member_manage.member_invite.msg5':
    'STOVEに登録されているユーザーにStudioへの招待ができます。STOVEに登録されているユーザーのみ招待メールが送信されます！',
  'studio.member_manage.member_invite.email_add_step1_msg1': 'グループメニュー権限の選択',
  'studio.member_manage.member_invite.email_add_step1_msg2': 'メンバーに付与するグループメニュー権限を選んでください。',
  'studio.member_manage.member_invite.email_add_step1_all_check': 'すべて選択',
  'studio.member_manage.member_invite.email_add_step1_menuname_header1': 'メニュー名',
  'studio.member_manage.member_invite.email_add_step1_view_header2': '閲覧',
  'studio.member_manage.member_invite.email_add_step1_edit_header3': '編集',
  'studio.member_manage.member_invite.email_add_step1_msg3': 'メール/通知',
  'studio.member_manage.member_invite.email_add_step1_msg4': 'この権限を持つ商品について、メールまたは通知を受け取ります。',
  'studio.member_manage.member_invite.email_add_step1_msg5': '決済',
  'studio.member_manage.member_invite.email_add_step1_msg6': '審査',
  'studio.member_manage.member_invite.email_add_step1_msg7': '契約',
  'studio.member_manage.member_invite.email_add_step1_pro_btn': '次へ',
  'studio.member_manage.member_invite.email_add_step2_msg1': '商品権限の選択',
  'studio.member_manage.member_invite.email_add_step2_fullscreen_btn': '全画面',
  'studio.member_manage.member_invite.email_add_step2_msg2': 'メンバーに付与する商品と役割を選んでください。',
  'studio.member_manage.member_invite.email_add_step2_msg3': '少なくとも1つの権限を選択する必要があります。',
  'studio.member_manage.member_invite.email_add_step2_selbox_place_holder': '選択',
  'studio.member_manage.member_invite.email_add_step2_prjnproduct_header1': 'プロジェクト名と商品名',
  'studio.member_manage.member_invite.email_add_step2_msg5': 'グループに商品を追加すると、選択した役割が自動的に設定されます。',
  'studio.member_manage.member_invite.email_add_step2_pre_btn': '前へ',
  'studio.member_manage.member_invite.email_add_step2_msg6': '権限を付与する商品がありません。<br/>グループ内に少なくとも1つの商品が必要です。',
  'studio.member_manage.member_invite.email_add_step2_help_menuname_header1': 'メニュー名',
  'studio.member_manage.member_invite.email_add_step2_help_perm_detail_header2': '編集権限の内容',
  'studio.member_manage.member_invite.email_add_step2_help_msg1': 'ダッシュボード設定',
  'studio.member_manage.member_invite.email_add_step2_help_msg2': 'プロジェクトの作成、編集、削除',
  'studio.member_manage.member_invite.email_add_step2_help_msg3': '商品の作成、編集、削除',
  'studio.member_manage.member_invite.email_add_step2_help_msg4': 'コレクションの作成、編集、削除',
  'studio.member_manage.member_invite.email_add_step2_help_msg5': 'コミュニティの作成、編集、削除',
  'studio.member_manage.member_invite.email_add_step2_help_msg6': 'メンバー招待、権限の変更、エクスポート',
  'studio.member_manage.member_invite.email_add_step2_help_msg7': '事業者情報の登録、編集、審査',
  'studio.member_manage.member_invite.email_add_step2_help_msg8': '銀行情報の登録、編集、審査',
  'studio.member_manage.member_invite.email_add_step2_help_msg9': '商品ごとの点検登録、編集、削除',
  'studio.member_manage.member.list_resend_invite_pop_msg': '指定したメールアドレスに再度招待リクエストを送信します。',
  'studio.member_manage.member.list_resend_invite_pop_resend_btn': '再送信',
  'studio.member_manage.member.list_cancel_invite_pop_msg':
    '招待リクエストをキャンセルします。<br/>登録が進行中の場合、キャンセルできないことがあります。',
  'studio.member_manage.member.list_cancel_invite_pop_close_btn': '閉じる',
  'studio.member_manage.member.list_cancel_invite_pop_cancel_invite.btn': '招待のキャンセル',
  'studio.member_manage.member.list_action_alert1_msg': '更新または再試行してください。',
  'studio.member_manage.member.list_action_alert1_cnf_btn': '確認',
  'studio.member_manage.member.list_action_alert2_msg': 'すでにグループ招待を受け入れたメンバーです。',
  'studio.member_manage.member.list_action_alert3_msg': '招待を拒否したメンバーです。',
  'studio.member_manage.role_manage_modified_date_header2': '変更日',
  'studio.build_rating_review.self_review.build_search_place_holder': '検索',
  'studio.build_rating_review.self_review.build_search_none_registered_build': '登録されたビルドがありません。',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_example_title': '青少年利用不可 例',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_example_category': '種類',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_example_description': '内容',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type1_sexual': '扇情性',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type1_sexual_descr':
    '臀部、胸部、限定的な下半身の露出、性的な連想をさせる音声などがある場合',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type2_violence': '暴力性',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type3_violence_descr':
    '人体の毀損、臓器、切断された人体、写実的な武器の表現、過剰なレベルの血痕がある場合',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type3_horror': '恐怖',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type3_horror_descr':
    '過度な外見のNPC(肉、骨、血痕)、不気味な犯罪の現場(食肉処理場など)、見た者を驚愕させる要素がある場合',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type4_language': '言語',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type4_language_descr':
    '過度な水準の言葉遣い(卑俗語や低俗なスラング)などの要素がある場合',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type5_drug': '薬物',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type5_drug_descr': 'アルコール、タバコ、麻薬など、過剰な水準の薬物要素がある場合',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type6_crime': '犯罪',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type6_crime_descr': '誘拐、性的暴行、殺人など、過度な水準の画像やテキスト描写がある場合',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type7_gambling': '射幸性',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type7_gambling_descr':
    'ポーカー、ブラックジャック、花札、麻雀など、過度な水準の賭博性、配当(チップ、現金)のイメージ要素がある場合',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_descr_sample':
    '例)<br/>ジャンル：<br/><br/>ストーリー：<br/><br/><br/>ゲームの説明：<br/><br/>登場人物：',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_completed.rating_existed_new_reg_btn': '新規登録',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.dropbox_oldest_order': '古い順',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.review_info_title': '審査情報',
  'studio.prj_prod_mngmt.rating_build_review.see_history.case_no_data_msg': '閲覧可能な審査情報がありません。 ',
  'studio.prj_prod_mngmt.rating_build_review.pre_release_change.case_info_mismatch_guide':
    '商品設定に登録されている情報({fields})と一致しません。最近の審査完了情報を削除して、再度審査をリクエストしてください。',
  'studio.prj_prod_mngmt.rating_build_review.case_info_mismatch.rel_info_del_btn': '審査情報の削除',
  'studio.prj_prod_mngmt.rating_build_review.case_info_mismatch.rel_info_del_cf_popup':
    '審査情報を削除しますか？<br/>削除する場合、年齢制限の審査をやり直す必要があります。',
  'studio.prj_prod_mngmt.rating_build_review.case_info_mismatch.rel_info_del_cf_btn': '削除',
  'studio.notice.category_stu_notice': 'Studioからのお知らせ',
  'studio.group.home.board_type2_mem_invite_mgmt_guide': 'グループにメンバーを招待して管理することができます。',
  'studio.group.home.board_type3_no_data2': 'まだ販売された商品はありません。',
  'studio.common.popup_case_i_logout': 'ログアウトしますか？<br/>ログアウトすると、保存されていない内容は消失します。',
  'studio.common.popup_case_logout_btn': 'ログアウト',
  'studio.common.footer.stu_usage_term': 'Studio利用規約',
  'studio.common.footer.stove_usage_term': '利用規約',
  'studio.common.footer.stu_personal_info_protection': 'プライバシーポリシー',
  'studio.common.popup_case_ai_trans_failed': 'AI自動翻訳に失敗しました。<br/>再度適用するか、直接入力してください。',
  'studio.common.popup_case_ai_trans_required_field':
    '必須項目のうち入力されていない内容があります。<br/>必須項目をすべて入力するとリリースプランに登録できるようになります。',
  'studio.ai_translation.badge': 'AI翻訳',
  'studio.common.calendar_week_day.sun': '日',
  'studio.common.calendar_week_day.mon': '月',
  'studio.common.calendar_week_day.tue': '火',
  'studio.common.calendar_week_day.wed': '水',
  'studio.common.calendar_week_day.thurs': '木',
  'studio.common.calendar_week_day.fri': '金',
  'studio.common.calendar_week_day.sat': '土',
  'studio.prj_prod.this_prod.execution_setting_option_add_limit_popup': '起動オプションは、最大100個まで追加することができます。',
  'studio.member_manage.member_details_role_setting_required_popup': '役割を選択してください。',
  'studio.group.collection.register_discount_rate_placeholder': '0',
  'studio.group.collection.register_discount_period_req_msg': '割引期間を入力してください。 ',
  'studio.group.collection.register_discount_period_placeholder': '1~99',
  'studio.group.collection.list.details_save_completed_popup': 'コレクション情報が<br/>保存されました。',
  'studio.build_mgmt.step_waiting': '待機中',
  'studio.build_mgmt.step_file_download': 'ファイルをダウンロード中',
  'studio.build_mgmt.step_file_scan': 'ファイルをスキャン中',
  'studio.build_mgmt.step_waiting_for_completion': '完了待機中',
  'studio.build_mgmt.step_build_check': 'ビルド確認中',
  'studio.build_mgmt.step_make_build': 'ビルド生成中',
  'studio.build_mgmt.step_drm_apply': 'DRM適用中',
  'studio.build_mgmt.case_build_upload_error.db_gen_error_msg': 'DB生成中にエラーが発生しました。<br/>アップローダーを終了後、再度お試しください。',
  'studio.build_mgmt.case_build_upload_error.path_check_error_msg':
    'インストール先のパスの確認中にエラーが発生しました。<br/>アップロードを終了して再度お試しください。',
  'studio.build_mgmt.case_build_upload_error.previous_build_check_error_msg':
    '以前のビルド確認中にエラーが発生しました。<br/>アップロードを終了して再度お試しください。',
  'studio.build_mgmt.case_build_upload_error.file_compare_error_msg':
    'ファイル比較中にエラーが発生しました。<br/>アップロードを終了して再度お試しださい。',
  'studio.build_mgmt.case_build_upload_error.storage_check_error_msg':
    'ストレージの確認中にエラーが発生しました。<br/>アップロードを終了して再度お試しください。',
  'studio.build_mgmt.case_build_upload_error.file_list_gen_error_msg':
    'ファイルリストの作成中にエラーが発生しました。<br/>アップロードを終了して再度お試しください。',
  'studio.build_mgmt.case_build_upload_error.build_regist_error_msg':
    'ビルド登録中にエラーが発生しました。<br/>アップロードを終了して再度お試しください。',
  'studio.build_mgmt.case_build_upload_error.upload_prep_error_msg':
    'アップロード準備中にエラーが発生しました。<br/>アップロードを終了して再度お試しください。',
  'studio.build_mgmt.case_build_upload_error.upload_error_msg':
    'アップロード中にエラーが発生しました。<br/>アップロードを終了して再度お試しください。',
  'studio.build_mgmt.case_build_upload_error.upload_complete_error_msg':
    'アップロード完了中にエラーが発生しました。<br/>アップロードを終了して再度お試しください。',
  'studio.build_mgmt.build_pipeline_common_error.unknown_error_msg':
    '不明のエラーが発生しました。<br/> <a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。 ',
  'studio.build_mgmt.build_pipeline_common_error.process_prep_error_msg':
    'プロセス準備中にエラーが発生しました。<br/><a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。',
  'studio.build_mgmt.vaccine_task_error.file_download_error_msg':
    'ファイルのダウンロード中にエラーが発生しました。<br/><a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。',
  'studio.build_mgmt.vaccine_task_error.file_scan_error_msg':
    'ファイルスキャン中にエラーが発生しました。<br/><a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。',
  'studio.build_mgmt.vaccine_task_error.malicious_code_error_msg':
    'マルウェアの疑いのあるファイルが見つかりました。<br/>続行する場合は、手動でセキュリティ審査をリクエストしてください。',
  'studio.build_mgmt.vaccine_task_error.vaccine_task_impossible_error_msg':
    'セキュリティ検査を実行できないファイルが見つかりました<br/>続行する場合は、手動でセキュリティ審査をリクエストしてください。',
  'studio.build_mgmt.make_build_task_error.build_check_error_msg':
    'ビルドを確認中にエラーが発生しました。<br/><a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。',
  'studio.build_mgmt.make_build_task_error.make_build_error_msg':
    'ビルドを作成中にエラーが発生しました。<br/><a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。',
  'studio.build_mgmt.make_build_task_error.drm_apply_error_msg':
    'DRMを適用中にエラーが発生しました。<br/><a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。',
  'studio.build_mgmt.drm_maker_task_error.process_prep_error_msg': 'プロセスを準備中にエラーが発生しました。',
  'studio.build_mgmt.drm_maker_task_error.prod_info_check_error_msg': '商品情報の確認中にエラーが発生しました。',
  'studio.build_mgmt.drm_maker_task_error.build_info_check_error_msg': 'ビルド情報を確認中にエラーが発生しました。',
  'studio.build_mgmt.drm_maker_task_error.file_check_error_msg': 'ファイルを確認中にエラーが発生しました。',
  'studio.build_mgmt.drm_maker_task_error.storage_check_error_msg': 'ストレージを確認中にエラーが発生しました。',
  'studio.build_mgmt.drm_maker_task_error.drm_apply_error_msg': 'DRMを適用中にエラーが発生しました。',
  'studio.build_mgmt.drm_maker_task_error.build_reconfig_error_msg': 'ビルドを再構成中にエラーが発生しました。',
  'studio.prj_prod.this_prod.product_data.build.home_product_key_tooltip_game_id': 'ゲームID',
  'studio.prj_prod.this_prod.product_data.build.home_upload_alert_msg2': 'STOVEアップローダーは<br/>Windows環境のみ対応しています。',
  'studio.build_mgmt.build_upload.existing_upload_guide_popup_title': 'アップロードのご案内',
  'studio.build_mgmt.build_upload.existing_upload_guide_msg1':
    'アップロードが停止されたビルドがあります。<br/>新たに開始する場合、そのビルドは失敗処理されます。',
  'studio.build_mgmt.build_upload.existing_upload_guide_msg2': '※引き継ぎは、同じアカウントでのみ可能です。',
  'studio.build_mgmt.upload_in_progress_exist_popup_msg1': 'アップロード中のビルドがあります。<br/>新たにアップロードを開始しますか？',
  'studio.build_mgmt.upload_in_progress_exist_popup_msg2': '※アップロード中のビルドは失敗処理されます。',
  'studio.build_mgmt.upload_terminate_btn': '終了',
  'studio.build_mgmt.upload_start_new_btn': '新しくはじめる',
  'studio.build_mgmt.build_aborted_for_new_start_popup_msg':
    '別のPCからアップロードが開始されたため、<br/>進行中のアップロードがキャンセルされました。',
  'studio.build_mgmt.uploader.exe_impossible_guide_popup':
    'プログラムを実行中に問題が発生しました。問題が解決しない場合は、STOVE Studio運営にお問い合わせください。 ',
  'studio.build_mgmt.uploader.exe_impossible_inquiry_btn': '問い合わせ',
  'studio.build_mgmt.uploader.terminate_guide_popup': 'STOVE Studio Uploader<br/>を終了しますか？',
  'studio.build_mgmt.uploader.terminate_cf_btn': '終了',
  'studio.build_mgmt.uploader.error_retry_guide_popup': 'エラーが発生しました。<br/>しばらく経ってから、もう一度お試しください。',
  'studio.build_mgmt.uploader.info_not_found_guide_popup': '商品情報が見つかりません。<br/>商品確認後、再度お試しください。',
  'studio.build_mgmt.uploader.verified_info_expired_guide_popup': 'ユーザー認証情報の更新に失敗しました。<br/>アップローダーを再起動してください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_msg1': 'ファイルリスト作成中…',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_msg2': 'アップロード準備中…',
  'studio.build_mgmt.uploader.guide_popup_path_not_found': 'ファイルが見つかりません。<br/>フォルダのパスを再度選択してください。 ',
  'studio.build_mgmt.uploader.guide_popup_invalid_folder_file_name':
    'アップロードするフォルダとファイル名を確認してください。<br/>(\\ / : * ? ＂ < > \\|は使用できません。)',
  'studio.build_mgmt.uploader.guide_popup_invalid_file_exist':
    'アップロードできないファイルが存在します。<br/>該当のファイルを除いてから再度お試しください。',
  'studio.build_mgmt.uploader.guide_popup_build_no_change': '更新されたファイルがありません。<br/>ファイルを確認して再度お試しください。',
  'studio.build_mgmt.uploader.guide_popup_inefficient_storage_msg1':
    'グループ保存先の空き容量が不足しています。<br/>リリースしないビルドを削除して再度実行してください。',
  'studio.build_mgmt.uploader.guide_popup_inefficient_storage_msg2': '<span class="lackingCapa"></span>の追加容量が必要',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_stt4_upload_completed': 'アップロード完了。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_terminate_upload_btn': 'アップロード終了',
  'studio.build_mgmt.build_upload_stt0_in_progress': 'アップロード中',
  'studio.prj_prod.this_prod.product_data.build.security_test_failed_learn_more_btn': '詳しく見る',
  'studio.build_mgmt.build_detail.pg_title': 'ビルドの詳細',
  'studio.prj_prod.this_prod.product_data.build.details_select_file_security_standard_tooltip':
    'DRM Makerを適用する場合、商品のセキュリティのために高い水準で適用されます。失敗した場合は、一般的なものに変更して再度お試しください。',
  'studio.business_bank_setting.individual.info_passport_copy': 'パスポートのコピー',
  'studio.business_bank_setting.individual.info_passport_attach_guide': 'パスポートのコピーを添付してください',
  'studio.business_bank_setting.individual.info_passport_copy_req_msg': 'パスポートのコピーを添付してください。',
  'studio.business_bank_setting.individual.query_req_msg': '事業者登録番号を入力してください。',
  'studio.file_upload.val_popup_size_exceed': 'ファイル容量を確認してください。',
  'studio.file_upload.val_popup_select_one': '1個のファイルのみ選択してください。',
  'studio.file_upload.val_popup_file_format_not_supported':
    '対応していないファイル形式です。<br/>ファイルの形式をご確認のうえで、アップロードしてください。',
  'studio.business_bank_setting.individual.upload_resident_req_msg': '住民登録謄本を添付してください。',
  'studio.business_bank_setting.individual.game_production_no_kr_req_msg': '大韓民国ゲーム制作(配給)業の登録証を添付してください。',
  'studio.business_bank_setting.individual.telecom_sales_no_kr_req_msg': '大韓民国通信販売業登録証を添付してください。',
  'studio.business_bank_setting.individual.game_business_no_kr_req_msg': '大韓民国事業者登録証を添付してください。 ',
  'studio.business_bank_setting.account.question6_req_msg': '通帳のコピーを添付してください 。',
  'studio.business_bank_setting.account.guide1': '口座情報はどのように使用されますか？',
  'studio.business_bank_setting.account.guide1_1': '入力いただいた口座へ販売代金をお振り込みいたします！',
  'studio.business_bank_setting.account.guide2': '口座情報を変更したいです',
  'studio.business_bank_setting.account.guide2_1':
    'すでに精算/支払いが完了している場合は、審査完了後、次回の支払日以降から変更された口座に入金されます。<br/>精算履歴の確認は「精算」メニューから確認することができます。',
  'studio.business_bank_setting.list_stt_approve': '承認',
  'studio.business_bank_setting.list_stt_reject': 'リジェクト',
  'studio.business_bank_setting.list_stt_in_review': '審査中',
  'studio.business_bank_setting.list_biz_type_indiv': '個人',
  'studio.business_bank_setting.list_biz_type_indiv_biz_owner': '個人事業者',
  'studio.business_bank_setting.list_biz_type_business': '法人事業者',
  'studio.prj_prod_mngmt.storage_upload_done.popup_del_cf_btn': '削除',
  'studio.prj_prod_mngmt.prod_home.create_term.term_name_req_msg': '規約管理名を入力してください。',
  'studio.prj_prod_mngmt.prod_home.create_term.eula_content_place_holder': '規約の内容を入力してください',
  'studio.prj_prod_mngmt.prod_home.create_term.eula_content_req_msg': '規約の内容を入力してください。',
  'studio.prod_home.pur_cond.select_prod_req_msg': '商品を選択してください。',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_video_thumbnail_link': 'サムネイル{thumbnailSize}',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_video_file_thumbnail_guide':
    '* サムネイルを選択しない場合、動画ファイルの最初のフレームで自動的に選択されます！',
  'studio.prj_prod.this_prod.edit_summary_place_holder0': '商品説明を入力してください。',
  'studio.supported_lang.en': '英語',
  'studio.supported_lang.ko': '韓国語',
  'studio.supported_lang.zh_tw': '中国語(繁体字)',
  'studio.supported_lang.zh_cn': '中国語(簡体字)',
  'studio.supported_lang.ja': '日本語',
  'studio.supported_lang.ge': 'ドイツ語',
  'studio.supported_lang.fr': 'フランス語',
  'studio.supported_lang.es': 'スペイン語',
  'studio.supported_lang.pt': 'ポルトガル語',
  'studio.supported_lang.vi': 'ベトナム語',
  'studio.supported_lang.id': 'インドネシア語',
  'studio.supported_lang.th': 'タイ語',
  'studio.supported_lang.it': 'イタリア語',
  'studio.supported_lang.ru': 'ロシア語',
  'studio.supported_lang.pt_br': 'ポルトガル語(ブラジル)',
  'studio.prj_prod.this_prod.edit_additional_links_name_length_val_msg1': 'リンクのタイトルは1から35文字の間で入力してください。',
  'studio.prj_prod.this_prod.edit_additional_links_name_length_val_msg2': 'リンクのタイトルは1から15文字の間で入力してください。',
  'studio.prj_prod.this_prod.edit_additional_links_url_req_msg1': 'リンクURLを入力してください。',
  'studio.prj_prod.this_prod.edit_additional_links_url_length_val_msg1': 'URLは1から2,000文字の間で入力してください。',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_logo': 'ロゴ',
  'studio.prj_prod.this_proj.this_prod.list_kebab_delete_pop_msg_case2': '商品ページを削除しますか？',
  'studio.group.collection.guide1_1': 'コレクションとは何ですか？',
  'studio.group.collection.guide1_2':
    'コレクションとは、グループ内の商品を2個から100個までまとめて販売できる機能です。<br/>販売できない商品が含まれている場合は、それらを除外してコレクションが作成されます。',
  'studio.group.collection.guide2': 'コレクションとして構成できる商品に条件はありますか？',
  'studio.group.collection.guide2_1': '以下の条件をすべて満たす商品のみコレクションに含めることができます。',
  'studio.group.collection.guide2_1_a': 'グループ内のプロジェクト管理者権限を持つ商品',
  'studio.group.collection.guide2_1_b': 'タイプがゲーム、コンテンツ、ユーティリティ、DLCである商品',
  'studio.group.collection.guide2_1_c': '事前購入可能または正式発売状態の商品',
  'studio.group.collection.guide3': 'コレクション商品の一部を購入したユーザーも、コレクションを購入できますか？',
  'studio.group.collection.guide3_1':
    'コレクションの一部をすでに購入している場合は、未購入のゲームだけをまとめて、コレクションの割引率を反映した価格で購入することができます。',
  'studio.group.collection.guide4': 'コレクションの価格は、どのように設定されますか？',
  'studio.group.collection.guide4_1':
    'コレクション内の商品合計額から割引率を設定できます。個別商品の割引がある場合、その割引とコレクション割引を両方適用した価格で販売されます。 ',
  'studio.group.collection.guide5': 'バナー画像は必ず登録する必要がありますか？',
  'studio.group.collection.guide5_1':
    'バナー画像を必ず登録する必要はありませんが、<br/>バナー画像を登録すると、STOVEストアの運営者がストアの商品一覧ページに表示されるように設定することができます。<br/>バナー画像が登録された商品は、商品一覧でより目立つ可能性があります。',
  'studio.group.collection.del_prod_from_list_btn': '削除',
  'studio.group.collection.register_product_page_req_info_val': '商品ページに入力されていない必須情報があります。',
  'studio.group.collection.register_sales_quantity_place_holder': '1,000,000まで入力可能です。',
  'studio.registration.email_title': 'Eメール',
  'studio.registration.email_place_holder': 'メールアドレスを入力してください',
  'studio.registration.email_req_msg': 'メールアドレスを入力してください。',
  'studio.registration.email_invalid_msg': 'メールアドレスの形式が正しくありません。',
  'studio.registration.send_verification_code_btn': '認証番号を転送',
  'studio.registration.resend_verification_code_btn': '再送信',
  'studio.registration.send_verification_code_completed_popup': '入力したメールアドレスに認証番号が送信されました。',
  'studio.registration.verification_code_not_received_guide':
    '認証番号が届かない場合は、認証したいメールの迷惑メールフォルダを確認するか、再送信ボタンを押してください。',
  'studio.registration.verification_stt_complete': '認証完了',
  'studio.registration.verification_stt_failed': '認証失敗',
  'studio.registration.verification_stt_code_expired': '認証終了',
  'studio.registration.verification_code_place_holder': '認証番号を入力してください',
  'studio.registration.verification_code_req_msg': '認証番号を入力してください。',
  'studio.build_run_test.lnb_stu_build_test': 'Studioビルドテスト',
  'studio.build_run_test.stu_redir_btn': 'Studioに移動する',
  'studio.build_run_test.select_prod_guide': 'プロジェクトと商品を選択してください。',
  'studio.build_run_test.select_pj_prod_dropbox_place_holder': 'プロジェクト/商品選択',
  'studio.build_run_test.select_pj_prod.case_no_pj_msg': 'There is no registered project.',
  'studio.build_run_test.select_pj_prod.case_no_prod_msg': '登録された商品がありません。',
  'studio.build_run_test.filter_search_by_prod_no': '商品No.',
  'studio.build_run_test.filter_search_by_build_no': 'ビルドNo.',
  'studio.build_run_test.no_search_results_msg': '一致する検索結果がありません。',
  'studio.build_run_test.no_access_per_msg1': 'この商品へのアクセス権がありません。',
  'studio.build_run_test.no_access_per_msg2': 'Studioメンバー管理で役割を付与してください。',
  'studio.build_run_test.no_build_uploaded_msg1': 'テスト可能なビルドがありません。',
  'studio.build_run_test.build_list': 'ビルドリスト',
  'studio.build_run_test.build_list.header1_build_no': 'ビルドNo.',
  'studio.build_run_test.build_list.header2_build_descr': 'ビルドの説明',
  'studio.build_run_test.build_list.header3_build_stt': 'ビルド状態',
  'studio.build_run_test.build_list.build_stt_test': 'テスト',
  'studio.build_run_test.build_list.build_stt_released': 'リリース',
  'studio.build_run_test.build_list.header4_release_stt': 'リリース状態',
  'studio.build_run_test.build_list.test_btn': 'テスト',
  'studio.back_to_list_btn': 'リストを見る',
  'studio.build_run_test.build_info': 'ビルド情報',
  'studio.build_run_test.build_info1_grp': 'グループ',
  'studio.build_run_test.build_info2_prj_name': 'プロジェクト名',
  'studio.build_run_test.build_info3_prod_name': '商品名',
  'studio.build_run_test.build_info4_prod_type': '商品タイプ',
  'studio.build_run_test.build_info5_build_no': 'ビルドNo.',
  'studio.build_run_test.build_info6_decsr': '説明',
  'studio.build_run_test.build_info7_reg_date': '登録日',
  'studio.build_run_test.build_info8_build_stt': 'ビルド状態',
  'studio.build_run_test.build_info9_release_stt': 'リリース状態',
  'studio.prj_prod.this_prod.release_details.opt_1to2_switch_popup':
    'ビルドと一緒に正式リリースを進行しますか？<br/>商品ページを除く必須情報を入力後、審査依頼を実行してください。',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_period_place_holder': '1~99',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_rate_place_holder': '0',
  'studio.age-restriction-message':
    '14歳未満の方はStudioサービスをご利用いただけません。<br/>本件に関する詳細につきましては、<a href="{link}" class="font-medium underline">カスタマーサービス</a>までお問い合わせください。',
  'studio.brand_page.sign_up_btn': 'STOVE Studioを始める',
  'studio.brand_page.sign_up_btn_alert': 'PC環境で登録してください。',
  'studio.brand_page.easy_and_fast_title': 'より手軽で簡単に、<br/>ストアでゲームを<br/>リリースしてみましょう！',
  'studio.brand_page.easy_and_fast_guide':
    'あなたの作ったゲームをSTOVE Studioでリリースしてみましょう。<br/>専用チュートリアルで安心・簡単にリリースできます。',
  'studio.brand_page.feature_preview': 'STOVE Studio機能一覧',
  'studio.brand_page.global_service_guide0':
    '外国語もStudioで解決！<br/><span class="text-[#13D4FF] md:text-brand-primary">グローバルへのゲームリリースは</span>AI翻訳にお任せください',
  'studio.brand_page.global_sevice_guide':
    'AIを活用した多言語翻訳機能により、クリエイターの皆様のグローバル展開をサポートいたします。手軽に翻訳機能をご利用いただけます。',
  'studio.brand_page.global_sevice_interaction':
    'あらゆる嗜好のゲームが勢揃い！STOVEストア！<br/>AIによる便利なグローバルサービスを、ぜひご体験ください。',
  'studio.brand_page.store_btn': 'STOVEストアに移動する',
  'studio.brand_page.all_in_one_go_title': '審査からマーケティングまでSTOVE Studioが一括サポート！',
  'studio.brand_page.all_in_one_go_guide': '複雑なゲームの審査プロセス<span class="text-brand-primary">STOVE Studio</span>がサポートします。',
  'studio.brand_page.stove_rating_title': 'STOVE Studioでゲームのレーティング審査をサポートします',
  'studio.brand_page.stove_rating_guide': 'ゲーム1本につき、約100万ウォン相当の審査費用と、1か月間の審査申請および追加資料対応をサポートいたします。',
  'studio.brand_page.stove_marketing_title': 'STOVE Studioを利用して、自作のゲームを紹介しましょう',
  'studio.brand_page.stove_marketing_guide': 'キーワード広告やプレスリリース、メディア広告を通じて宣伝をサポートいたします。',
  'studio.brand_page.stove_event_title': '自作のゲームをプレイするユーザーたちと、直接交流することができます',
  'studio.brand_page.stove_event_guide': 'オフラインゲームイベントへの出展サポートで、新たなビジネスチャンスを広げましょう。',
  'studio.brand_page.game_indicator_title': 'ゲーム別のKPIを一目で確認',
  'studio.brand_page.game_indicator_guide': '売上、販売量、訪問者数などのゲームのKPI分析サービスが提供されます。',
  'studio.brand_page.game_review_title':
    '自作のゲームの<span class="text-on-surface-elevation-1 md:text-brand-primary">感想やレビュー</span>を確認してみましょう！',
  'studio.brand_page.game_review_guide':
    'STOVEラウンジはゲームを楽しむすべてのユーザーとコミュニケーションを行える空間です。ハッシュタグ(#)を利用して<span class="md:font-bold">様々なユーザーの投稿を確認し、ゲームのアップデートに参考してみましょう！</span>',
  'studio.direct_stove_lounge_btn': 'STOVE Loungeに移動する',
  'studio.brand_page.full_service_title1': 'STOVE Studioが責任を持って対応いたします',
  'studio.brand_page.full_service_title2': 'ゲームの創作活動のみに集中してください。',
  'studio.brand_page.full_service_guide':
    'PCクライアントSDK、ログイン認証、商品購入、ゲームサービスへの サポートなど、様々なプラットフォーム開発ツールが提供されます。',
  'studio.direct_dev_guide_page_btn': '開発者用の使用ガイドを確認する',
  'studio.lnb.common_2depth_tutorial_video': 'チュートリアル動画',
  'login.redirect-login-page': 'ログインページに移動する',
  'login.studio-redirect-brand-site': '前のページに移動する',
  'studio.gnb.common_language_setting': '言語設定',
  'studio.common.lang_setting.invalid_char_val_msg': "- : [ ] . TM ® # ( ) ' ! ? • {'|'} & _ \"   ~ , < > * / 、。以外の特殊文字は使用できません。，",
  'studio.redirect_prod_home_btn': '商品ホームに移動',
  'studio.common.language_settings.pro_pg_ai_trans_badge': 'AI翻訳バッジ表示',
  'studio.common.language_settings.pro_pg_ai_trans_tooltip':
    'AI翻訳を活用して作成された言語を翻訳・変更してください。<br/>商品ページに「AI翻訳」バッジが表示されます。',
  'studio.registration.redirect-login-page': 'ログインページに移動する',
  'studio.pro_prj_mgmt.prod_name_translating_guide': '商品を作成しています。',
  'studio.prj_prod_mngmt.prj_prod_reg_done.release_prep_tooltip_tiltle': '商品ホームに移動！',
  'studio.prj_prod_mngmt.prj_prod_reg_done.release_prep_tooltip_msg':
    'リストをクリックすると商品ホームに移動します。<br/>商品ホームでリリース準備を行えます。',
  'studio.event_period_settings.case1_pp_open_after_pre_purchase_start': '事前購入開始日より後の日付には設定できません。',
  'studio.event_period_settings.case2_pp_open_after_pre_purchase_end': '事前購入終了日より後の日付には設定できません。',
  'studio.event_period_settings.case3_pp_open_after_official_release': '正式リリース日より後の日付には設定できません。',
  'studio.event_period_settings.case4_pp_open_after_limited_sale_end': '限定販売終了日より後の日付には設定できません。',
  'studio.event_period_settings.case5_pre_purchase_start_before_pp_open': '商品ページオープン日より前の日付には設定できません。',
  'studio.event_period_settings.case6_pre_purchase_start_after_pre_purchase_end': '事前購入終了日より後の日付には設定できません。',
  'studio.event_period_settings.case7_pre_purchase_start_after_official_release': '正式リリース日より後の日付には設定できません。',
  'studio.event_period_settings.case8_pre_purchase_start_after_limited_sale_end': '限定販売終了日より後の日付には設定できません。',
  'studio.event_period_settings.case9_pre_purchase_end_before_pp_open': '商品ページオープン日より前の日付には設定できません。',
  'studio.event_period_settings.case10_pre_purchase_end_before_pre_purchase_start': '事前購入開始日より前の日付には設定できません。',
  'studio.event_period_settings.case11_pre_purchase_end_after_official_release': '正式リリース日より後の日付には設定できません。',
  'studio.event_period_settings.case12_pre_purchase_end_after_limited_sale_end': '限定販売終了日より後の日付には設定できません。',
  'studio.event_period_settings.case13_official_release_before_pp_open': '商品ページオープン日より前の日付には設定できません。',
  'studio.event_period_settings.case14_official_release_before_pre_purchase_start': '事前購入開始日より前の日付には設定できません。',
  'studio.event_period_settings.case15_official_release_before_pre_purchase_end': '事前購入終了日より前の日付には設定できません。',
  'studio.event_period_settings.case16_official_release_after_limited_sale_end': '限定販売終了日より前の日付には設定できません。',
  'studio.event_period_settings.case17_limited_sale_end_before_pp_open': '商品ページオープン日より前の日付には設定できません。',
  'studio.event_period_settings.case18_limited_sale_end_before_pre_purchase_start': '事前購入開始日より前の日付には設定できません。',
  'studio.event_period_settings.case19_limited_sale_end_before_pre_purchase_end': '事前購入終了日より前の日付には設定できません。',
  'studio.event_period_settings.case20_limited_sale_end_before_official_release': '正式リリース日より前の日付には設定できません。',
  'studio.calendar_event_period.val_msg_start_time_before_current_time': 'オープン日時を現在時刻より後に設定してください。',
  'studio.group.collection.register_product_none_to_select': '登録された商品がありません。',
  'studio.group.collection.collection_info': 'コレクション情報',
  'studio.group.collection.collection_basic_info': '基本情報',
  'studio.group.collection.collection_basic_info1_prod_name': '商品名',
  'studio.group.collection.collection_basic_info1_prod_name_place_holder': '商品名を入力してください',
  'studio.group.collection.collection_basic_info1_prod_name_required': '商品名を入力してください。',
  'studio.group.collection.collection_basic_info1_prod_name_duplicate': '同一の商品名があります。別の商品名を入力してください。',
  'studio.group.collection.collection_basic_info1_prod_name_invalid':
    "- : [ ] . TM ® # ( ) ' ! ? • {'|'} & _ \"   ~ , < > * / 、。，以外の特殊文字は使用できません。",
  'studio.group.collection.collection_basic_info2_publisher_name': 'クリエイター名',
  'studio.group.collection.collection_basic_info2_publisher_name_place_holder': 'クリエイター名を入力してください',
  'studio.group.collection.collection_basic_info2_publisher_name_required': 'クリエイター名を入力してください。',
  'studio.group.collection.collection_basic_info3_distributor_name': 'パブリッシャー名',
  'studio.group.collection.collection_basic_info3_distributor_name_place_holder': 'パブリッシャー名を入力してください',
  'studio.group.collection.collection_basic_info3_distributor_name_required': 'パブリッシャー名を入力してください。',
  'studio.group.collection.register_btn': 'コレクション登録',
  'studio.group.collection.register_product_config_select_none_available_msg':
    '呼び出す商品ページがありません<br/>商品ページの状態を確認してください。',
  'studio.group.collection.register_product_page_list_dir_btn': '商品ページ',
  'studio.supported_features.single_player': 'シングルプレイヤー',
  'studio.supported_features.multi_player': 'マルチプレイヤー',
  'studio.supported_features.pvp': 'PvP',
  'studio.supported_features.cooperative': '協力プレイ',
  'studio.supported_features.vr_support': 'VRサポート',
  'studio.supported_features.controller_some_support': 'コントローラー一部サポート',
  'studio.supported_features.controller_perfect_support': 'コントローラー完全サポート',
  'studio.supported_features.cloud_saving': 'クラウド保存',
  'studio.supported_features.user_stat': 'ユーザースタッツ',
  'studio.supported_features.challenge': 'チャレンジミッション',
  'studio.supported_features.match_making': 'マッチメイク',
  'studio.supported_features.leader_board': 'リーダーボード',
  'studio.supported_features.ingame_payment': 'インゲーム決済',
  'studio.tooltip.product_count': '商品数',
  'studio.group.collection_list.filter_all': '全体',
  'studio.group.collection_list.filter_prod_pg_only': '商品ページ',
  'studio.group.collection_list.filter_official_release': '正式リリース',
  'studio.group.collection_list.filter_suspended_or_deleted': '中断/削除',
  'studio.group.collection.storage_select_popup_guide': 'コレクションでストレージを使用するにはプロジェクトを選択する必要があります。',
  'studio.group.collection.storage_select_prj_dropbox': 'プロジェクトを選択してください',
  'studio.group.collection.storage_select_prj_cf_btn': '選択',
  'studio.group.collection.storage_select_prj_required_msg': 'プロジェクトを選択してください。',
  'studio.group.collection.storage_select_prj_none_popup': '使用できるストレージがありません。',
  'studio.group.collection.storage_search_no_result': '検索結果がありません。',
  'studio.group.collection.discount_case_registration_impossible':
    'リリース前には割引オプションを追加できません。<br/>リリースしてからお試しください。',
  'studio.member_manage.role_manage_reg_modified_date': '登録/修正日',
  'studio.member_manage.role_manage_create_role_msg4': 'リリース権限を付与するメンバーにはすべての権限が付与されます。',
  'studio.common.search_place_holder': '検索',
  'studio.business_bank_setting.individual.review_officer_info_guide1':
    'ゲームリリースの審査情報を確認するグループの内部担当者情報を入力してください。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.biz_info_not_set_msg':
    '事業者情報の設定が完了していないため、審査ができません。<br/><br/>事業者情報の設定を進めてください。',
  'studio.business_info_redirect_btn': '事業者情報',
  'studio.prj_prod_mngmt.rating_build_review.self_review.prod_setting_not_completed_guide_popup':
    '商品設定が完了していないため、審査ができません。<br/><br/>商品設定を進めてください。',
  'studio.direct_prod_setting_pg_btn': '商品設定',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg3_duplicate':
    '同一の商品名があります。別の商品名を入力してください。多言語設定もご確認ください。',
  'studio.prj_prod.this_prod.home_product_setting_linked_product_exist_popup': 'すでに連携済みの商品があります。<br/>更新後、再度連携してください。',
  'studio.product_setting.under_review_info_genre_representative': 'メイン',
  'studio.prj_prod.this_prod.edit_gamepreview_import_this_media_alert1': '画像の横*縦サイズを確認してください。',
  'studio.pro_pg_edit.gamepreview_spotlights_video_thumbnail_required_msg': 'サムネイルを追加した後、動画URLを入力してください。',
  'studio.pro_pg_edit.gamepreview_spotlights_video_link_guide': '動画リンクはYouTubeのURLのみ使用できます！',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_video_thumbnail_file': 'サムネイル860x483px(選択)',
  'studio.prj_prod.this_prod.edit_additional_links_stove_cs': 'STOVEカスタマーサービス',
  'studio.rating_build_review.self_review_req.qtn1_guide8': 'プレイヤー同士の対戦要素',
  'studio.rating_build_review.self_review_req.qtn1_guide8_1': '単純なレベル：<br/>対決は可能だが損失がなく、財貨を失わない',
  'studio.rating_build_review.self_review_req.qtn1_guide8_2':
    '軽微なレベル：<br/>プレイヤー同士の対戦によって失われる報酬が軽微。ポイントを得たり失ったりする',
  'studio.rating_build_review.self_review_req.qtn1_guide8_3':
    '制限的なレベル：<br/>プレイヤー同士対戦が可能だが、別のPvPゾーン、または対戦時にレベル制限が条件に追加される',
  'studio.rating_build_review.self_review_req.qtn1_guide8_4':
    '過度なレベル：<br/>制限のないPvP環境となっており、他のプレイヤーに敗北したプレイヤーは経験値、アイテムを奪われたり、財貨を失う',
  'studio.rating_build_review.self_review_req.qtn3_guide2': 'その他の射幸性',
  'studio.rating_build_review.self_review_req.qtn3_guide2_1':
    '現金または現金に類似したキャッシュを使用して、オークションハウスや取引所などでユーザー間でアイテムや通貨の取引や売買ができる場所が存在する',
  'studio.rating_build_review.self_review_req.qtn6_guide': '麻薬類の表現',
  'studio.rating_build_review.self_review_req.qtn6_guide_1':
    '麻薬類、ボンド、ガス、幻覚剤および幻覚作用を含む<br/>麻薬取引を示唆する現場、文章、単語を含む',
  'studio.rating_build_review.self_review.under_review_stt_2_verifying': '審査中',
  'studio.rating_build_review.self_review.under_review_stt_3_verify_rejected': '審査リジェクト',
  'studio.rating_build_review.self_review.under_review_stt_4_verify_passed': '審査完了',
  'studio.rating_build_review.self_review.under_review_stt_5_reg_completed': '登録完了',
  'studio.prj_prod_mngmt.rating_build_review.edit_cf_msg1': 'すでにゲームがリリースされている場合は、変更したレーティング情報が即時に適用されます。',
  'studio.prj_prod_mngmt.rating_build_review.type_self_review': 'レーティング審査',
  'studio.prj_prod_mngmt.rating_build_review.type_direct_input': '大韓民国のレーティング番号',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_cancelled': '年齢制限取り消し',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_rejected': '年齢制限の拒否',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_revision_passed': '年齢制限の異議申し立て',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_revision_rejected': '年齢制限の異議申し立てリジェクト',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_register': '年齢制限登録',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_modify': '年齢制限修正',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_delete_msg': '年齢制限情報を削除しました。',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.global_rating_delete_msg': '国際レーティング分類番号を削除しました。',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_verify_rejected': '年齢制限リジェクト',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_revision_pass': '年齢制限の内容修正報告',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_revision_reject': '年齢制限の内容修正報告リジェクト',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_delete': '年齢制限の削除',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_reclassification_adjusted': '年齢制限の調整',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_reclassification_committee_adjusted': '年齢制限の職権による再分類',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.global_rating_register': '国際レーティング分類番号の登録',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.global_rating_modify': '国際レーティング分類番号の修正',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.global_rating_delete': '国際レーティング分類番号の削除',
  'studio.prj_prod.this_prod.product_data.build.home_guide1_1': 'アップロードが完了したらリストを更新してください。',
  'studio.build_mgmt.list_reload_btn': 'リストを更新する',
  'studio.build_mgmt.uploader_running_alert': 'Studioアップローダー実行中',
  'studio.build_mgmt.uploader_running_alert_msg1': 'アップローダーをインストールしていない場合、先にダウンロードおよびインストールを行ってください。',
  'studio.build_mgmt.uploader_running_alert_msg2': 'アップロード完了後、ビルドが表示されない場合は一度更新を行ってください。',
  'studio.build_mgmt.uploader_download_btn': 'アップローダーダウンロード',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_guide_title': 'STOVE Studio Uploaderのインストール案内',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_guide_msg':
    'STOVE Studio Uploaderがすでにインストールされています。既存のプログラムを削除して再インストールを行います。',
  'studio.common.btn_yes': 'はい',
  'studio.build_mgmt.uploader_update_guide_popup_msg':
    '新しいバージョンが更新されました。<br/>アップデートを完了しないと、アップローダーを実行できません。',
  'studio.build_mgmt.uploader_update_btn': '今すぐアップデート',
  'studio.build_mgmt.uploader_update_ver_check_msg':
    'アップローダーのバージョンを確認中です。<br/>最大5分ほどかかる場合があります。しばらくお待ちください！',
  'studio.build_mgmt.uploader_update_in_prog_msg': '更新中。。。',
  'studio.build_mgmt.uploader_update_error_msg':
    'アップデート中にエラーが発生しました。<br/>アップローダーを再度実行してください。<br/>※問題が続く場合は手動でインストールしてください。',
  'studio.build_mgmt.uploader_update_error.manual_run_btn': '手動インストール',
  'studio.build_mgmt.uploader_update_complete_msg': 'アップデートが完了しました。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_file_upload_guide4':
    'ビルドリストでアップロード完了したビルドが表示されない場合はリストを更新してください。',
  'studio.build_mgmt.uploader_build_no_change_msg':
    '現在リリースしたバージョンのビルドと変更事項が見つかりません。<br/>ファイルを確認してからもう一度お試しください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_file_transfer_completed_msg':
    'ファイルのアップロードが完了しました。<br/>審査が完了したらテストを進めてください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide1_1':
    'STOVEプラットフォームで提供するSTOVE PC SDKを連携すると、スタッツ、ランキング、チャレンジ、マッチメイキングなどのゲーム支援サービスを利用でき、ユーザーのプレイ時間を確認できます。',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide2_1':
    'ビルドアップロード後、リリース前にSTOVE PCクライアントを通じて商品(ゲーム)が正常に起動されるかご確認ください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide3_1':
    'スタッツは、プレイヤーの活動データを収集・数値化し、ランキングやチャレンジの提供、統計データとしての活用を可能にする機能です。',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide5_1':
    'ユーザーがどの地域から接続しても低遅延を提供し、快適な環境でゲームを楽しめるようにサポートするサービスです。',
  'studio.prj_prod.this_prod.product_data.build_msg': 'ビルドテストおよびリリース前に起動設定を完了してください。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_failed_pop_msg2':
    'アップロード中にエラーが発生しました。内訳を削除して再度アップロードを行ってください。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_failed_pop_msg3':
    'ユーザーによってキャンセルされました。内訳を削除して再度アップロードを行ってください。',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_msg1':
    'STOVE PC SDKを連携していない場合、ゲーム著作権保護のためにDRM Makerをリリース前に適用してください。<br/>すでにSTOVE PC SDKに連携されている場合、DRM Makerを適用しなくてもよく、SDK連携された状態でDRM Makerを適用すると正常にゲームがインストールされない場合があります。',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_msg2':
    'DRM Makerの適用は完了まで1〜3分かかります。適用に失敗した場合は解除後に再度適用してください。',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_msg3': '起動の検証によるタイムアウトが発生する場合はデータを修正してください。',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_msg4':
    'DRM Makerが適用後、インストール時にエラーが発生した場合は再度DRM Makerを適用してから実行してください。',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_msg5': 'DRM Makerを適用するためにexeファイルを選択して保存してください。',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_timeout_sec': '秒',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.run_option_invalid_msg':
    '起動オプションを新たに入力し、<br/>テスト後にビルドアップデートを進めてください。',
  'studio.run_setting_pg_redirect_btn': '起動オプションに移動',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date_required_msg': '規約の適用日を設定してください。',
  'studio.prj_prod_mngmt.prod_home.create_term.type1_detailed_guide':
    '入力したソフトウェアユーザー同意規約(EULA)の内容は、商品インストール時にクライアントでユーザーに以下のように表示されます。',
  'studio.member_manage.history_status_declined_details': '{nickName}さんが加入を拒否しました',
  'studio.member_manage.history_status_edit_depth_details_added_msg1': '{roleName}の役割が付与されました。',
  'studio.member_manage.history_status_edit_depth_details_added_msg2': '{perName}が追加されました。',
  'studio.member_manage.history_status_edit_depth_details_added_msg2_2': '{perName1}, {perName2}が追加されました。',
  'studio.member_manage.history_status_edit_depth_details_removed_msg1': '{roleName}の役割が削除されました。',
  'studio.member_manage.history_status_edit_depth_details_removed_msg2': '{perName}が削除されました。',
  'studio.member_manage.history_status_edit_depth_details_removed_msg2_2': '{perName1}, {perName2}が削除されました。',
  'studio.prj_prod.this_prod.home_search_recent': '最近の検索キーワード',
  'studio.client_exe_in_prog.popup_title': 'PCクライアント起動中',
  'studio.client_exe_in_prog.popup_msg': 'クライアントをインストールしていない場合、<br/>ダウンロードおよびインストール後に進めてください。',
  'studio.client_download_btn': 'クライアントダウンロード',
  'studio.prj_prod.this_prod.release_stt_filter_none_check_guide': '選択必要',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_page_required_msg': '商品ページを選択してください。',
  'studio.prj_prod.this_prod.release_details_with_build_title': '商品ページとビルドをまとめて正式リリースします。',
  'studio.prj_prod.this_prod.review_status_pbar_msg2': '現在審査リクエスト中です。運営者が審査する前に審査リクエストをキャンセルできます。',
  'studio.prj_prod.this_prod.release_details_release_plan_product_page_open_msg':
    '商品ページオープン日は審査期間を考慮して1週間以降から設定可能です。商品ページオープン前まで自由に変更できます。',
  'studio.release_details.period_settings.end_before_start_val_msg1':
    '終了日時は開始日時より後に設定してください。開始日時と終了日時を再度設定してください。',
  'studio.release_details.period_settings.end_date_input_n_val_msg3': '終了日時を設定してください。',
  'studio.release_details.period_settings.end_date_after_official_release_val_msg4': '終了日時は正式リリース日時以前に設定してください。',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_y_guide': 'ゲーム内ショップが登録されました。',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_n_guide': 'ゲーム内ショップが登録されていません。',
  'studio.release_details.build_prep.no_build_list_display_guide': '起動設定でWebプラットフォームを適用するとビルドリストが表示されません。',
  'studio.event_period_settings.limit_sale_end_before_release_val_msg': '限定販売終了日時を正式リリース日時以降に設定してください。',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_release_date_msg':
    'ユーザーがゲームを購入またはダウンロードしてプレイできる正式リリース日を入力してください。正式リリース日はリリース前まで自由に変更できます。',
  'studio.event_period_settings.case_pp_open_after_official_release': '正式リリース日時を商品ページオープン日時より早くすることはできません。',
  'studio.release_info_settings.cannot_set_pre_purchase_msg': '商品ページオープン日時と正式リリース日時が同じの場合、事前購入を設定できません。',
  'studio.release_info_settings.cannot_set_early_access_msg':
    '商品ページオープン日時と正式リリース日時が同じの場合、早期アクセスの文言を設定できません。',
  'studio.home.release_timeline.prod_pg_item.release_plan_download_install_allow_n': 'ダウンロードおよびインストールを許可しない',
  'studio.home.release_timeline.prod_pg_item.release_plan_exe_allow_n': '起動を許可しない',
  'studio.member_manage.member_details_group_owner_menu_permission_title': 'グループメニュー権限選択',
  'studio.member_manage.member_details_owner_product_permission_title': '商品権限選択',
  'studio.grp_prj_transfer.transfer_apply.receiver_email_required_msg': '移管対象者のメールアドレスを入力してください。',
  'studio.grp_prj_transfer.transfer_apply.receiver_email_not_added_msg': '移管対象者のメールアドレスを追加してください。',
  'studio.prod_home.pur_cond.pur_cond_prod_none': 'リリース後に購入条件商品に追加できます。',
  'studio.common.tutorial_video.tooltip': 'チュートリアル',
  'studio.common.tutorial_video.first_entry_guide1': 'Studioのチュートリアル動画',
  'studio.common.tutorial_video.first_entry_guide2': 'メニューごとのチュートリアル動画を見ながら<br />ゲームを簡単に素早く登録してください！',
  'studio.brand_page.mobile_app_sign_up_alert': 'PC環境で登録してください。',
  'studio.brand_page.feature1_main_title': 'Studioの全機能をリニューアル',
  'studio.brand_page.feature1_sub_title': 'Studioの全機能がより使いやすくなりました。',
  'studio.brand_page.feature2_main_title': '登録して、プロジェクトと商品を作成しましょう',
  'studio.brand_page.feature2_sub_title': '登録して、プロジェクトと商品を作成',
  'studio.brand_page.feature3_main_title': '商品ホーム、商品の設定',
  'studio.brand_page.feature3_sub_title': '商品ホームの機能や商品設定方法をご確認ください。',
  'studio.brand_page.feature4_main_title': '商品ページ公開',
  'studio.brand_page.feature4_sub_title': 'まずは商品ページを公開して、ユーザーの皆様と交流を始めましょう。',
  'studio.brand_page.feature5_main_title': 'ビルドアップロードと商品の起動設定',
  'studio.brand_page.feature5_sub_title': 'ビルドアップロード後、商品の起動設定とPCクライアントの起動テストまでご案内いたします。',
  'studio.brand_page.feature6_main_title': '事業者・銀行情報登録とレーティング審査',
  'studio.brand_page.feature6_sub_title': '事業者・銀行情報を登録して、無料でレーティング審査を受ける方法をご案内いたします。',
  'studio.brand_page.feature7_main_title': '正式リリース前に商品の価格と規約の設定',
  'studio.brand_page.feature7_sub_title': '商品の販売価格を設定して、サービスに必要な規約の設定方法をご案内いたします。',
  'studio.brand_page.feature8_main_title': '登録したビルドを正式リリースに',
  'studio.brand_page.feature8_sub_title': 'リリース準備を完了させ、正式にビルドをリリースしてみましょう。',
  'studio.brand_page.feature9_main_title': '正式リリース後の割引設定および各機能のアップデート',
  'studio.brand_page.feature9_sub_title': '正式リリース後、商品ページ、割引などのアップデート方法をご案内いたします。',
  'studio.discount.register_sales_quantity_req_msg': '販売数量を入力してください。',
  'studio.prj_prod.this_prod.edit_gamepreview_add_img_required msg': '画像を登録してください。',
  'studio.prod_pg_edit.additional_info_item_name_required_msg': '項目名を入力してください。 ',
  'studio.prod_pg_edit.additional_info_item_name_length_msg': '項目名は15文字以内で入力してください。',
  'studio.prod_pg_edit.additional_info_min_spec_length_msg': '最低動作環境は80文字以内で入力してください。',
  'studio.prod_pg_edit.additional_info_recommended_spec_length_msg': '推奨動作環境は80文字以内で入力してください。',
  'studio.prj_prod.this_proj.this_prod.registered_edited_date_tooltip': '登録日(編集日)',
  'studio.build_run_test.operator_review_pg.select_group': 'グループ選択',
  'studio.build_run_test.operator_review_pg.pre_search_def_guide': '商品No.またはビルドNo.を検索してください。',
  'studio.prj_prod.this_prod.execution_setting_basic_option_title': '基本起動オプション',
  'studio.prj_prod.this_prod.execution_setting.option_change_guide':
    'Webプラットフォームに保存すると、登録されたビルドとレーティング審査結果が削除されます。<br/>選択したオプションに変更しますか？',
  'studio.common.popup_case_change_short_btn': '変更',
  'studio.prj_prod.this_prod.execution_setting.option_change_to_pc_guide': 'PCプラットフォームに保存すると、<br/>ビルドをアップロードできます。',
  'studio.prj_prod.this_prod.execution_setting.build_not_uploaded_msg':
    'アップロード完了したビルドがありません。<br/>ビルドをアップロードしてから再度お試しください。',
  'studio.build_upload_btn': '変更',
  'studio.prj_prod.this_prod.execution_setting_option_final_run_file': '最終実行ファイル',
  'studio.prj_prod.this_prod.execution_setting_option_final_run_file_place_holder': '最終実行ファイルを入力してください。',
  'studio.prj_prod.execution_setting_option_delete_pop_msg': '削除後に保存すると復元できなくなります。<br/>選択したオプションを削除しますか？',
  'studio.prj_prod.execution_install_set_enabled_guide2_1':
    '商品リリース前には自由にインストールフォルダ名を変更できます。入力したインストールフォルダ名はユーザーが商品をインストールする場合、C:\\Program Files\\Smilegate\\Games\\(インストール先のフォルダ名)にインストールされます。',
  'studio.prj_prod.execution_install_set_enabled_guide2_2':
    '商品リリース後、インストールフォルダ名を変更した場合、すでにインストールを完了したユーザーには適用されず、新しくインストールするユーザーにのみ変更したインストールフォルダ名にインストールが適用されます。',
  'studio.prj_prod.execution_exe_opt_enabled_guide4': 'PCプラットフォーム',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_1_2':
    '－アップロードしたビルドのゲーム、あるいはユーティリティを起動するためのexeファイル名を入力してください。同一の名前ではない場合は起動しないため、ご注意ください！',
  'studio.prj_prod.execution_exe_opt_enabled_guide5': 'Webプラットフォーム',
  'studio.prj_prod.execution_exe_opt_enabled_guide6': 'モバイルプラットフォーム',
  'studio.prj_prod.execution_exe_opt_enabled_guide_opt_name': '起動オプション名',
  'studio.prj_prod.execution_exe_opt_enabled_guide_opt_name_content':
    '- 2つ以上のオプションがある場合、ユーザーが起動オプションを選択できるように内容を詳しく入力してください。',
  'studio.prj_prod.execution_exe_opt_enabled_guide_final_run_file': '最終実行ファイル',
  'studio.prj_prod.execution_exe_opt_enabled_guide_final_run_file_content':
    '- 実行ファイルと実際のプレイを提供する最終実行ファイルが異なる場合、実際にプレイできるEXEファイル名(下位パスを含む)を入力してください。',
  'studio.prj_prod.execution_exe_opt_enabled_guide_web_opt_name': '起動オプション名',
  'studio.prj_prod.execution_exe_opt_enabled_guide_web_opt_name_content':
    '- 2つ以上のオプションがある場合、ユーザーが起動オプションを選択できるように内容を詳しく入力してください。',
  'studio.build_mgmt_pg_redirect_btn': 'ビルド管理移動',
  'studio.build_run_test.search_place_holder': 'キーワード入力',
  'studio.build_run_test.no_build_uploaded_msg2':
    'アップロード完了したビルドが表示されない場合、Studioの起動設定でPC起動オプションが登録されているか確認してください。',
  'studio.build_run_test.dlc_guide_1': '選択したDLCはインストールが完了するとゲーム本編の起動時に含まれます。',
  'studio.build_run_test.dlc_guide_2': '各商品ごとに1つのビルドIDのみ選択できます。(DLCは必須選択ではありません)',
  'studio.build_run_test.dlc_list_filter.header1_select': '選択',
  'studio.build_run_test.dlc_list_filter.header2_prod_name': '商品名',
  'studio.build_run_test.dlc_list_filter.header3_build_no': 'ビルドNo',
  'studio.build_run_test.dlc_list_filter.header4_install_yn': 'インストール状態',
  'studio.build_run_test.dlc_intall_y': 'インストール完了',
  'studio.build_run_test.dlc_intall_n': '未インストール',
  'studio.build_run_test.dlc_select_completed': '選択完了',
  'studio.build_run_test.dlc_run_option': '起動オプション',
  'studio.build_run_test.dlc_run_option_num': '計{totalOptNum}個',
  'studio.build_run_test.dlc_run_option_set_def_checkbox': '常時このオプションでプレイ',
  'studio.build_run_test.dlc_run_option_set_def_guide1': 'この設定を維持すると、次回からこの画面は表示されません。',
  'studio.build_run_test.dlc_run_option_set_def_guide2': 'この設定は後からゲーム内設定で変更可能です。',
  'studio.play_btn': 'プレイ',
  'studio.prj_prod.execution_install_set_enabled_guide1': 'インストール設定',
  'studio.prj_prod.execution_install_set_enabled_guide1_1':
    'STOVE PCクライアントで商品をダウンロードする際に、<br/>インストールされるパスを設定してください。',
  'studio.lnb.prj_prod_mgmt.view_all_btn': 'すべての商品を見る',
  'studio.ai_translation.guide1':
    "商品をリリースする際、<span class='text-[#1355FF]'> 全世界のユーザーが閲覧できるように、必ずAI翻訳を実施</span>する必要があります。<br/>ただし、AI翻訳では一部のテキストが抜け落ちたり、正確に翻訳されない可能性があるため、タブごとに分けられた各翻訳結果を確認し、保存してください！",
  'studio.stu_logged_in.pre_grp_join.guide': 'クリエイターさん、<br/>Studioを始めましょう！',
  'studio.stu_logged_in.pre_grp_join.create_grp_msg3':
    'Studioを初めて使用する場合、グループを作成する必要があります。<br/>グループはクリエイトスペースであり、ゲームのリリース準備を行う場所です。<br/>代表者であれば、グループを作成してメンバーを招待しましょう！',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_save_storage_btn_toast': 'ストレージへの保存が完了しました！',
  'studio.prj_prod.execution_exe_opt_enabled_guide2_1':
    '選択したプラットフォームに応じて、STOVE PCクライアントおよびストア内にあるストアページに適用されます。<br />リリース後、基本起動設定されたプラットフォームは変更できませんが、詳細設定の変更は可能です。誤った情報をLIVEに適用すると正常に実行されない可能性があるため、ご注意ください。<br />すべての必須項目を入力したら、STOVE PCクライアントで正常に実行されるかテストを行ってください。',
  'studio.prj_prod.execution_exe_opt_enabled_guide2_2':
    '※ PCプラットフォームの場合は、基本実行オプションに追加してください。Webプラットフォームのみが入力されている場合、GRACレーティングを登録する必要があります。',
  'studio.prj_prod.this_prod.execution_setting_option_msg1':
    'プラットフォームがPCの場合、STOVE PCクライアントでのテスト時にビルド一覧に表示されるよう、基本実行オプションの必須項目を正確に入力する必要があります。',
  'studio.prj_prod.this_prod.home_in_app_pur_cond_type_pc_set_n_to_go': '起動設定に移動',
  'studio.prj_prod_mngmt.rating_build_review.self_review.execution_setting_not_completed_guide_popup':
    '起動設定が完了していないため、審査を行うことができません。<br/><br/>起動設定を進めてください。',
  'studio.direct_Execution_setting_pg_btn': '起動設定',
  'studio.prj_prod_mngmt.rating_build_review.self_review.parent_game_exe_setting_not_completed_guide_popup':
    '本編ゲームの起動設定が完了していないため、審査ができません。<br/><br/>起動設定を進めてください。',
  'studio.redirect_build_mgmt_btn': 'ビルド管理に行く',
  'studio.prj_prod_mngmt.rating_build_review.content_modify_completed_guide_msg': '審査が完了しました。<br/>ビルド管理でビルドを更新してください。',
  'studio.prj_prod.this_prod.home_in_app_pur_cond_type_pc_set_n':
    '起動設定の基本起動オプションが <br/>PCプラットフォームの場合に、サポートされるメニューです。',
  'studio.prj_prod.execution_install_new_guide_title1': '起動設定',
  'studio.prj_prod.execution_install_new_guide_main_des': 'StudioはPC、Webの各プラットフォームに対応しています。 ',
  'studio.prj_prod.execution_install_new_guide_sub_des1_1': 'PC ',
  'studio.prj_prod.execution_install_new_guide_sub_des2_1': 'Web ',
  'studio.prj_prod.execution_install_new_guide_sub_des3_1': 'Mobile ',
  'studio.prj_prod.execution_install_new_guide_sub_des4_1': 'クロスプラットフォーム ',
  'studio.prj_prod.execution_install_new_guide_sub_des1_2': 'STOVE PCクライアントと互換性のある、ビルド起動オプションを設定してください。',
  'studio.prj_prod.execution_install_new_guide_sub_des2_2': 'Webを選択する場合、Webゲームに接続してプレイできる<br/>URLを入力してください',
  'studio.prj_prod.execution_install_new_guide_sub_des3_2': 'Google PlayまたはApp Storeで、ダウンロード可能なURLを入力してください。',
  'studio.prj_prod.execution_install_new_guide_sub_des4_2': '基本プラットフォームをPCに設定後、オプション追加をクリックして、Webを含めてください',
  'studio.prj_prod.execution_install_new_guide_pc_title': 'プラットフォーム：PC',
  'studio.prj_prod.execution_install_new_guide_pc_main_title1': '実行ファイル',
  'studio.prj_prod.execution_install_new_guide_pc_sub_des1':
    'PCクライアントでビルドを実行するために、exeファイル名を入力してください。(例：実行ファイル.exe)',
  'studio.prj_prod.execution_install_new_guide_pc_sub_des2':
    'サブディレクトリに実行ファイルがある場合、フォルダのパスも含めて正確に入力してください。',
  'studio.prj_prod.execution_install_new_guide_pc_sub_des3': '例：上位フォルダ\\実行ファイル.exe',
  'studio.prj_prod.execution_install_new_guide_pc_main_title2': '最終実行ファイル',
  'studio.prj_prod.execution_install_new_guide_pc_sub1_des1':
    'PCクライアントの実行ファイルとビルドの基本実行ファイルが異なる場合、最終的に実行されるファイル名を入力してください。',
  'studio.prj_prod.execution_install_new_guide_pc_sub1_des2': '基本実行ファイルと同様に、実行ファイル名やサブディレクトリを含めて入力してください。',
  'studio.prj_prod.execution_install_new_guide_pc_main_title3': '引数',
  'studio.prj_prod.execution_install_new_guide_pc_sub2_des1':
    '実行ファイルをコマンドラインで起動する際に、渡す必要がある引数が存在する場合は入力してください。',
  'studio.prj_prod.execution_install_new_guide_pc_main_title4': '作業ディレクトリ',
  'studio.prj_prod.execution_install_new_guide_pc_sub3_des1':
    '実行ファイルを起動するために必要なファイルの場所が異なる場合は、そのファイルのパスを入力してください。',
  'studio.prj_prod.execution_install_new_guide_pc_main_title5': 'プロセスファイル',
  'studio.prj_prod.execution_install_new_guide_pc_sub4_des1':
    'インストールファイルと実行ファイルが別々になっているビルドの場合、実際に起動する実行ファイル名を入力してください。',
  'studio.prj_prod.execution_install_new_guide_pc_main_title6': '必須プログラム',
  'studio.prj_prod.execution_install_new_guide_pc_sub5_des1': 'PCクライアントでゲームを実行する際に必要となる、必須プログラムを選択してください。 ',
  'studio.prj_prod.execution_install_new_guide_pc_sub5_des2': '必須プログラムが選択されていない場合、ビルドが正常に動作しない可能性があります。',
  'studio.prj_prod.execution_install_new_guide_set_title': 'インストール設定',
  'studio.prj_prod.execution_install_new_guide_set_main_title1': 'インストールフォルダ',
  'studio.prj_prod.execution_install_new_guide_set_sub_des1':
    'STOVE PCクライアントでビルドをダウンロード後、ユーザーのPCにインストールされるパスを入力してください。',
  'studio.prj_prod.execution_install_new_guide_set_sub_des2':
    'デフォルトのインストールパス<br/>C:\\Program Files\\Smilegate\\Games\\(インストールフォルダ名)です。インストールフォルダ名のみ入力してください。',
  'studio.prj_prod.execution_install_new_guide_client_title': 'STOVE PCクライアントの設定',
  'studio.prj_prod.execution_install_new_guide_client_main_title1': 'インストール後のWindowsショートカットアイコン」',
  'studio.prj_prod.execution_install_new_guide_client_sub_des1':
    'ユーザーがゲームをインストールした際に、Windowsデスクトップに表示されるアイコン画像です。',
  'studio.prj_prod.execution_install_new_guide_client_sub_des2': 'ICO形式のアイコンについては、下記のガイドを参照してください。',
  'studio.prj_prod.execution_install_new_guide_client_main_title2': 'PCクライアント商品のサムネイル画像',
  'studio.prj_prod.execution_install_new_guide_client_sub1_des1':
    'STOVE PCクライアントの左側にある「STOVEゲーム」メニューや、お気に入りメニューで表示される商品のロゴです。',
  'studio.prj_prod.execution_install_new_guide_client_main_title3': 'STOVE PCクライアントのメイン推薦画像',
  'studio.prj_prod.execution_install_new_guide_client_sub2_des1':
    'ストア運営者がクリエイターのゲームを選定し、メイン画面で宣伝する場合に表示される画像です。 ',
  'studio.prj_prod.execution_install_new_guide_web_title': 'プラットフォーム：Web',
  'studio.prj_prod.execution_install_new_guide_web_main_title1': '実行URL ',
  'studio.prj_prod.execution_install_new_guide_web_sub_des1': 'Webゲームを起動できるURL、またはWebゲームの公式サイトのURLを入力してください。',
  'studio.prj_prod.execution_install_new_guide_web_sub_des2':
    'STOVE PCクライアントの下部パネルで「プレイ」ボタンを押すと、WebブラウザでWebゲームが起動されます。',
  'studio.prj_prod.execution_install_new_guide_mobile_title': 'プラットフォーム：Mobile',
  'studio.prj_prod.execution_install_new_guide_mobile_main_title1': '実行URL',
  'studio.prj_prod.execution_install_new_guide_mobile_sub_des1': 'Webゲームを起動できるURL、またはWebゲームの公式サイトのURLを入力してください。',
  'studio.prj_prod.execution_install_new_guide_mobile_sub_des2':
    '商品ページでマーケットの画像が表示され、クリックすると、入力されたゲームのダウンロードページに移動します。',
  'studio.prj_prod.execution_install_new_guide_pc_2_opt_name':
    '基本実行オプションをPCに設定し、PC実行オプションを追加で設定した場合、「プレイ」ボタンを押して実行するファイルを選択するための、実行オプション名を入力してください。',
  'studio.prj_prod_mngmt.guide1': '商品をリリースする際には、プロジェクトと商品をまず作成する必要があります。',
  'studio.prj_prod_mngmt.guide2': 'プロジェクトは、複数の商品を管理するためのもので、契約や精算時に使用されます。',
  'studio.prj_prod_mngmt.guide3': "商品はタイプを選択して登録すると、<span class='text-brand-primary font-medium'>商品ホームが作成</span>されます。",
  'studio.prj_prod_mngmt.guide4': 'プロジェクトおよび商品の登録後、商品ホームから販売準備を始めましょう！',
  'studio.prj_prod.this_prod.home_sales_title_type_msg': 'デモには価格や割引の設定はありません。',
  'studio.prj_prod.this_prod.stt_build_live': 'ビルドのLIVE適用 ',
  'studio.prj_prod.restriction_criteria_operation_error': '動作エラー',
  'studio.prj_prod.restriction_criteria_other': 'その他',
  'studio.prod_home.release_option_select_guide': 'リリース方法を選択してください。',
  'studio.prod_home.release_option1_official_rel':
    "<span class='text-brand-primary font-bold'>商品ページとビルド</span><span class='text-on-surface-elevation-1 font-bold'>を同時に正式リリースします。</span>",
  'studio.prod_home.release_option1_descr':
    'リリースに必要なすべての内容は準備できていますか？<br/> 事前リリースやアーリーアクセスなどの計画を立てて、商品を販売できます。',
  'studio.prod_home.release_option2_prod_pg_only':
    "<span class='text-brand-primary font-bold'>商品ページ</span><span class='text-on-surface-elevation-1 font-bold'>のみ公開します。</span>",
  'studio.prod_home.release_option2_descr': 'リリース予定として公開し、事前に宣伝したり、コミュニティを通じてユーザーと交流することができます。',
  'studio.release_status.view_btn': 'リリース状況を確認',
  'studio.release_status.release_prep_btn': 'リリース準備を進める',
  'studio.prod_page.immediate_apply_msg': '商品ページをすぐに適用しますか？',
  'studio.prod_page.scheduled_apply_msg': '商品ページの公開予約を適用しますか？',
  'studio.prod_page.live_page_duplicate_completed_alert':
    '商品ページがコピーされました。<br/>修正が必要な項目を編集し、開始日を入力して保存ボタンを押し、LIVE適用してください。',
  'studio.prod_page.under_review_page_edit_alert_msg': '審査中の商品ページをコピーして編集できます。<br/>コピーされた商品ページで編集を進めますか？',
  'studio.prod_page.suspended_page_edit_alert_msg': '終了した商品ページをコピーして編集可能です。<br/>コピーされた商品ページで編集を進めますか？',
  'studio.business_bank_setting.account.btn_save_alert3': 'すでに銀行情報の審査を申請中です。<br/>申請した内容をもう一度確認してください。',
  'studio.reject_type.product_setting': '商品設定',
  'studio.reject_type.product_page': '商品ページ',
  'studio.reject_type.price': '価格',
  'studio.reject_type.build_rating': 'ビルド/利用等級',
  'studio.reject_type.etc': 'その他',
  'studio.rating_review.included_content_none': 'なし',
  'studio.rating_build_review.rating_teenager_restricted': '青少年利用不可',
  'studio.prod_home.release_price_info.discount_plan': 'リリース時の割引予定',
  'studio.grp_home.direct_prj_reg_page': 'プロジェクトを登録する',
  'studio.prj_prod_mngmt.product_reg_tooltip_title': '商品を登録してください！',
  'studio.prj_prod_mngmt.product_reg_tooltip_msg1': '商品が登録されると、該当商品のホームが作成されます。',
  'studio.prj_prod_mngmt.product_reg_tooltip_msg2': '商品ホームから、リリース準備を進めることができます。',
  'studio.prj_prod_mngmt.product_reg_completed_tooltip_title': '商品が作成されました！',
  'studio.prj_prod_mngmt.product_reg_completed_tooltip_msg1': '作成された商品をクリックすると、商品ホームへ移動します。',
  'studio.prj_prod_mngmt.product_reg_completed_tooltip_msg2': '商品ホームから、リリース準備を進めることができます。',
  'studio.prj_prod_mngmt.storage_header_limit_guide':
    "<p class='text-center'>提供容量を超えると、ファイルのアップロードが制限されます。<br>使用しないファイルを削除してください。</p>",
  'studio.file_upload.name_max_length_exceed_msg': 'ファイル名を50文字(拡張子を除く)未満に設定しないと、アップロードできません。',
  'studio.prod_page.live_page_edit_guide': '{releaseStatus}状態の商品ページです。編集ボタンを押すと、コピーされた商品ページを編集できます。',
  'studio.edit.btn': '編集',
  'studio.prod_page.live_page_edit_alert_msg': '審査中の商品ページを複製して編集できます。<br/>コピーされた商品ページで編集を進めますか？',
  'studio.release_list.no_record_msg1': 'カレンダーで、リリース時の審査状況と履歴をまとめて確認できます。',
  'studio.release_list.no_record_msg2': '正式リリース後は、割引やビルドなどのアップデートスケジュールが自動的に反映され、簡単に確認できます！',
  'studio.release_details_product_page_community_opened_msg': 'コミュニティがオープンされました。',
  'studio.prj_prod.this_prod.stt_pre_release': 'リリース前',
  'studio.release_case_parent_product_verify_pass_n.cannot_request_review_msg':
    'この商品は審査を通過しませんでした。<br/>まずはこの商品の審査を通過させた後、下位の関連商品(DLC、Utility、Demo)のリクエストを実行してください。',
  'studio.event_period_settings.case_a_child_before_parent_pre_purchase_alert':
    '上位商品(Game)は、下位商品({prodName})の事前購入日時({prePurchaseStartTime})よりも、同一か早い日時に設定してください。',
  'studio.event_period_settings.case_a_child_before_parent_official_release_alert':
    '上位商品(Game)は、下位商品({prodName})の正式リリース日時({releaseStartTime})よりも、同一か早い日時に設定してください。',
  'studio.event_period_settings.case_b_child_before_parent_pre_purchase_alert':
    '上位商品({prodName})の事前購入日時({prePurchaseStartTime})よりも、同一か早い日時に設定してください。',
  'studio.event_period_settings.case_b_child_before_parent_official_release_alert':
    '上位商品({prodName})の正式リリース日時({releaseStartTime})よりも、同じか遅い日時に設定してください。',
  'studio.release_stt_pbar.sale_suspended_guide.case_page_build':
    '販売が中断されました。販売を再開するか、プロジェクトおよび商品管理から削除することができます。',
  'studio.release_stt_pbar.release_info_del_requested': 'STOVE運営者の削除承認後、リリース情報が削除される予定です。',
  'studio.release_stt_pbar.user_report_release_suspended_msg': '<span>{reportedReason}</span>の理由により、リリースが中断されました。',
  'studio.release_stt_pbar.restrict_case_cs_contact_guide':
    'ペナルティの理由を確認し、該当機能を修正後に、LIVE適用ボタンを押してアップデートしてください！<br/>ストアに反映された後、<a class="underline" href="https://cs.onstove.com/service/STOVE_INDIE_CS/contact" target="_blank">カスタマーサポートセンター(クリック)</a><a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。',
  'studio.release_stt_pbar.operator_restrict_release_suspended_msg': '<span>운영자 {restrictType}</span>の理由により、リリースが中断されました。',
  'studio.release_details.build_prep.rating_input_n_guide':
    '実行設定でプラットフォームをWebに登録した場合は、レーティングおよびビルド審査メニューでレーティング番号を照会したうえで、登録してください。',
  'studio.prj_prod_mngmt.case_transfer_in_progress.cannot_delete_alert': 'グループが移管中の状態では、<br/>プロジェクトや商品を削除できません。',
  'studio.transfer.mgmt_history.case_transfer_in_progress_alert': 'グループ移管が進行中です。<br/>移管申請はできません。',
  'studio.early_access.popup_case_lang_setting_input_required':
    'アーリーアクセスの案内を入力後、多言語設定が可能です。<br/>内容を入力し、再度試してください。',
  'studio.file_upload.case_unsupported_format_msg': '対応していないファイル形式です。ファイル拡張子をご確認の上、アップロードしてください。',
  'studio.group.collection.register_plan_official_release_date_guide':
    'ユーザーがゲームを購入、またはダウンロードしてプレイできる正式リリース日を入力してください。<br/>正式リリース日はリリース前まで自由に変更できます。',
  'studio.prj_prod_mngmt.del_req_x_on_sale_guide2':
    '<span class="text-[3B3D45] font-bold">販売中断</span>と<span class="text-[3B3D45] font-bold">商品ページオープン中断</span>状態に変更した後、削除リクエストを行ってください！',
  'studio.prj_prod_mngmt.prod_stt_page_and_sale_suspended': '商品ページオープン中断<br/>販売中断',
  'studio.prj_prod_mngmt.suspend_to_delete_guide_msg':
    "<span class = 'text-on-surface-elevation-2 font-medium'>商品ページオープン中断</span>状態に<br/>変更してから削除をリクエストしてください。",
  'studio.prj_prod_mngmt.rating_product_review.content_modify_completed_guide_msg': '審査が完了しました。<br/>商品情報が更新されました。',
  'studio.group.home.board_metrics_no data_msg': 'まだ商品データがありません。',
  'studio.file_upload.count': '{fileName}の他{remainingFileNum}件',
  'studio.early_access.no_change_msg': '早期アクセスの文言がそのままです。<br/>修正後、保存を押してください。',
  'studio.build_rating_review.details_edit_btn': '修正',
  'studio.rating_build_review.self_review.appeal_rating_request_not_equal_expected_msg1':
    "<span class = 'text-on-surface-elevation-1 font-bold'>{changRequestRating}を選択しましたが、<br/>アンケートの回答結果</span><span class = 'text-tint-red-a400 font-bold'>{surveyExpectedRating}</span><span class = 'text-on-surface-elevation-1 font-bold'>と予想されます。</span>",
  'studio.rating_build_review.self_review.appeal_rating_request_not_equal_expected_msg2':
    'リクエストしたレーティングと予想レーティングが異なると審査リクエストが行えませんので<br/>アンケートを確認した上で、リクエストを行ってください。',
  'studio.prj_prod.this_prod.release_details_product_page_option_store_community_msg3': 'コミュニティがオープンされました。',
  'studio.rating_build_review.case_launch_setting_web.cannot_request_self_review_msg':
    '起動設定がWEBの場合、社内レーティング審査を行えません。<br/>詳細情報でレーティング情報を修正してください。',
  'studio.group.collection.apply_prod_info_to_collection_popup': 'この商品の商品ページ情報をコレクションに適用しますか？',
  'studio.transfer.mgmt_history.case_no_product_registered_alert': '1つ以上の商品をオープンしてから<br/>グループおよびプロジェクトを移管できます。',
  'studio.prj_prod_mngmt.child_prod_exist_cannot_del': '関連する下位商品があります。<br/>下位商品の連携を解除してから進めてください！  ',
  'studio.prj_prod_mngmt.popup_suspend_sale_guide':
    '販売を中断するには「SUSPEND」と入力してください。<br/>中断後、ストアでは販売中断状態で表示されます。',
  'studio.prj_prod.this_prod.stt_release_sale_suspended_guide':
    '販売を中断するには「SUSPEND」と入力してください。<br/>中断後、ストアでは販売中断状態で表示されます。',
  'studio.prj_prod_mngmt.page_open_cannot_del_msg':
    '<span class="text-[3B3D45] font-bold">商品ページオープン中断</span>状態に変更した後、削除リクエストを行ってください！',
  'studio.prj_prod_mngmt.on_sale_cannot_del_msg':
    '商品がまだ販売中です。<br/><span class="text-[3B3D45] font-bold">販売中断</span>状態に変更した後、削除リクエストを行ってください！',
  'studio.prj_prod_mngmt.transfer_in_progress_cannot_del_msg':
    '現在移管中の商品があるため<br/>販売中断状態となっています。<br/>移管を完了してから、再度お試しください。',
  'studio.group.home.select_product.guide':
    '商品ページのオープンまたは正式リリースした商品を選択してダッシュボードに適用できます。<br/>選択した商品はドラッグで表示順序を自由に変更できます！',
  'studio.group.home.board_type3_no_data1': '正式リリース後、商品の累計販売数と購入転換率を確認できます！',
  'studio.group.home.board_type6_no_data1_before': '正式リリース後、商品を購入したユーザーのレビューとコメントを確認できます！',
  'studio.group.home.board_type7_no_data1_before': ' 商品リリース後、コミュニティに書き込まれた投稿やコメントを確認できます！',
  'studio.group.home.board_type8_no_data1_before': 'Loungeでリリース中の商品名の代表タグが付いている投稿を確認できます！',
  'studio.group.home.board_type9_no_data1_before': '商品リリース後、ストアで登録されたお気に入りの数を確認できます！',
  'studio.group.home.board_type10_no_data1': '商品配信後、商品ページの訪問者数とゲームにアクセスしたユーザー数を確認できます！',
  'studio.group.home.board_type5_no_data1': '商品リリース後、',
  'studio.group.home.board_type5_no_data2': 'リリースプランに応じたスケジュールが表示されます！',
  'studio.prod_page.ready_page_edit_alert_msg': '適用予定の商品ページをコピーして編集できます。<br/>コピーした商品ページを編集しますか？',
  'studio.group_transfer_in_progress.no_action_allowed_msg':
    'グループ移管中は、すべての機能がご利用いただけません。<br/>グループ代表者にお問い合わせください。',
  'login.studio-login-title': 'STOVE Studioログイン',
  'login.studio-login-contents': 'STOVE StudioへのログインにはSTOVEアカウントが必要です。<br/>初めての方は、STOVEの会員登録からお進みください。',
  'login.studio-login-id-placeholder': 'メールアドレスを入力してください。',
  'login.studio-login-pw-placeholder': 'パスワードを入力してください。',
  'login.studio-login-signup': 'STOVEの会員登録はこちら',
  'verification.need-check-age-title': '年齢確認が必要なサービスです。',
  'verification.start-verify-age': '年齢確認のため、本人認証を行ってください。',
  'verification.use-studio-verification': 'Studioサービスは本人認証が完了しているアカウントのみご利用いただけます。',
  'verification.enter-birth-date': '生年月日を入力してください。',
  'verification.service-limit-for-age': '生年月日を入力後、年齢によってはサービスの利用が制限されることがあります。',
  'studio.not-use-service': 'サービスを利用できません。',
  'login.no-stove-account': 'STOVEのアカウント情報が見つかりません。<br/>STOVEの会員登録ページに移動してアカウントを作成後、ログインしてください。',
  'login.incorrect-stove-account': 'STOVEのアカウント情報が一致しません。 <br/>メールアドレスまたはパスワードを確認してください。',
  'login.cancel-studio-signup': 'このままStudioの会員登録をキャンセルしますか？<br/>キャンセルすると、入力した内容はすべて消滅されます。',
  'verification.age-restriction': '申し訳ございません。<br/>13未満を方はStudioサービスをご利用いただけません。',
  'login.already-studio-account':
    'すでにStudioに登録されているアカウントがあります。<br/>メールアドレスまたはかんたんログインなどで再度ログインしてください。',
  'studio.page.index.transfer_member.invalid_member_email_contents':
    '他のアカウントでのログインが感知されました。<br><br>移管申請を受けたメールアドレスとは、異なるアカウントでログインしています。<br>ログアウト後、移管申請を受けたメールアドレスでログインし直してください。 ',
  'studio.page.index.transfer_member.invalid_link':
    '有効ではないメールです。<br><br>受信されたメールは<br>すでにメールの有効期間が満了しているか、<br>すでに認証が完了されているため、お探しのページが見つかりません。<br>もう一度ご確認ください。',
  'studio.build_rating_review.awaiting_rating_info_exist_msg1': '待機中の年齢制限情報です。',
  'studio.build_rating_review.awaiting_rating_info_exist_msg2': '内容修正報告を続行する場合、待機中の年齢制限は削除されます。',
  'studio.group_transfer.transfer_impossible_items_exist_msg': '移管できないプロジェクトや商品が存在するため、移管を申請できません。',
  'studio.group_transfer.transfer_requested_prj_exist_msg':
    '現在、移管検討申請を受けているプロジェクトがあります。<br/>移管完了または移管拒否後に、チームの移管を申請できます。',
  'studio.group_transfer.prj_transfer_in_progress_4958_msg':
    'プロジェクト移管中はすべての機能を使用できません。<br/>グループ代表者にお問い合わせください。',
  'studio.release_stt_pbar.operator_review_restrict':
    '運営者の<span>{restrictionType}</span>により、リリースが中断されました。レーティングおよびビルド審査に移動して詳しい内容を確認し、審査リクエストを行ってください。',
  'studio.release_checklist.early_access_setting': '早期アクセス文言の表示',
  'studio.common.preview_btn': 'アーリーアクセスの文言表示有無',
  'studio.release_info.discount_setting_title': '割引設定',
  'studio.release_info.discount_setting_guide':
    '正式リリースの審査が完了すると、割引メニューが有効になります。リリースプランで事前購入を設定している場合、同じ期間内に登録された割引が適用されます。',
  'studio.pre_purchase_settings.case_child_used_parent_set_unused_msg':
    '上位商品(Game)に関連する商品が、事前購入に設定されています。<br/>関連商品の事前購入設定を未使用に変更すると、修正が可能になります！',
  'studio.pre_purchase_settings.case_parent_unused_child_set_used_msg':
    '上位商品(Game)が事前購入を有効にしている場合にのみ、関連商品も事前購入に設定できます！',
  'studio.release_info_del_requested.cannot_resume_sale_msg':
    '商品削除をリクエストしている間は、この機能を使用できません。<br/>削除リクエストをキャンセル後にご利用ください！',
  'studio.product_page.gamepreview_my_home': 'MYホーム',
  'studio.product_page.gamepreview_my_home_game_list': '保有しているゲーム',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_other': '商品情報',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.bug_fix': 'バグ修正',
  'studio.discount.verify_not_passed.cannot_access_msg': 'ビルドとともに正式リリースした後、運営者の審査が完了すると、割引メニューを利用できます。',
  'studio.grp_home.release_step1_prj_prod_reg': 'プロジェクトおよび商品を登録してください。',
  'studio.grp_home.release_step2_release_prep': 'ストアにリリースする商品ページを作ってみましょう。',
  'studio.grp_home.release_step3_build_upload': '作成したビルドをアップロードしてください。',
  'studio.grp_home.release_step4_release': '商品をリリースして販売してみましょう。',
  'studio.prj_prod_mngmt.rating_build_review.edit_no_change_msg': '変更事項はありません。<br/>現在の内容が保存されました。',
  'studio.registration.close': '続ける',
  'studio.registration.do-later': 'キャンセルする',
  'studio.prj_prod.this_prod.home_build_case_web_mobile_msg': 'Webでは、ビルドは提供されません。',
  'studio.build_rating_review.revision_already_in_progress_msg':
    '内容修正報告や異議申し立ての審査中、または職権による再分類やレーティング調整措置が進行中の場合、リクエストを送信できません。<br/>手続きが完了した後に、再度リクエストを送信してください！',
  'studio.prj_prod.execution_setting_option_requirements_title': 'ビルド実行時の必須プログラム',
  'studio.event_period_settings.case_earlier_than_current_time_msg':
    'リリースプランのスケジュールが、現在時刻より過去に設定されています。<br/>現在時刻以降に変更してから保存してください！',
  'studio.prj_prod_mngmt.review_restricted_case_display': '審議ペナルティ(展示)',
  'studio.prj_prod_mngmt.review_restricted_case_run': '審議ペナルティ(実行)',
  'studio.post_release_exe_opt_update.drm_not_applied_msg': 'DRMが適用されていません。<br/>該当ビルドの詳細でDRMを適用してください！',
  'studio.post_release_exe_opt_update.invalid_exe_file_msg':
    '実行ファイル(または最終実行ファイル)は、DRMリストに含まれているEXEファイルのパスを入力してください！',
  'studio.home_early_access_cs_contact_alert':
    '正式リリース後は、「早期アクセス」のテキストを表示できません。<br/>表示するには、<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Studio運営者のDiscord</a>にお問い合わせください。',
  'studio.group.home.label_group_mem_count': 'グループメンバー {grMemCount}',
  'studio.execution_setting_option.exe_file_invalid_msg': 'DRMリストに含まれているEXEファイルのパスを入力してください。 ',
  'studio.group.collection.register_product_config_guide':
    "リリース後にコレクション商品を追加すると、<span class='text-on-surface-elevation-2'>ストアに反映されるまで10分程度かかり</span>ます。",
  'studio.prod_page.once.language_sample_tooltip_box': '各言語設定に合わせた画像を登録してみましょう！',
  'studio.prj_prod_mngmt.rating_build_review.tooltipbox_info': 'PC SDK連携のため、商品キーをご確認ください！',
  'studio.transfer_not_available.admin_contact_guide_msg':
    "現在移管機能は準備中です。<br/>移管が必要な場合は stove.support{'@'}smilegate.comにお問い合わせください。",
  'studio.transfer_in_progress.all_features_unavailable_msg':
    "移管中はすべての機能を使用できなくなります。<br/>次の日の0時(UTC+9)にもう一度ご確認ください！<br/>ご不明な点等ございましたらstove.support{'@'}smilegate.comにお問い合わせください。",
  'studio.product_page.page_display_date_duplicate_msg': 'すでに登録された予約日です。日付をもう一度選択してください。',
  'studio.prod_home.pur_cond.pur_cond_type2_tooltip': 'OR条件タイプ機能は現在準備中です。',
  'studio.prj_prod.this_prod.product_data.build.home_build_storage': 'グループ保存容量',
  'studio.prj_prod.this_prod.product_data.build.home_build_storage_tooltip': '前のビルドから変更されたファイルのみアップロードされます！',
  'studio.build_run_option.exe_file_invalid_msg':
    'DRM Makerを設定しましたが、実行ファイル名が一致しません。<br/>実行設定でDRMリストに含まれる実行ファイル名を入力してください！',
  'studio.release_plan.drm_not_applied_msg':
    'ゲームの著作権保護のために、ビルド詳細でDRMの適用を推奨します。<br/>実行ファイル名や最終実行ファイル名を入力した場合は、DRM Makerと同じに設定するのが望ましいです！',
  'studio.release_plan.drm_applied_exe_not_matched_msg':
    'DRMが適用されています。実行設定で実行ファイル名や最終実行ファイル名を入力した場合は、<br/>著作権保護のためにDRM Makerリストの適用済みファイルと一致する必要があります。',
  'studio.prod_page.one_page_only.cannot_del_msg': '適用予定の製品ページが1つしかない場合、削除できません。',
  'studio.prod_page.tooltip_go_to_store_page': 'ストアページへ移動。',
  'studio.storage.no_folder_available.cannot_move_file_msg': 'ファイルを移動できるフォルダが存在しません。',
  'studio.uploader.launching_in_progress_msg': '最大5分ほどかかる場合があります。少々お待ちください！',
  'studio.event_period_settings.sel_discount_immediate_apply.possible_delay_msg':
    '割引を「即時」適用に選択すると、ストアに反映されるまで約1～5分かかります。',
  'studio.execution_setting.review_in_progress.cannot_edit_msg':
    '検収が進行中の状態では修正できません。<br/>検収結果を確認した後、再度お試しください。',
  'studio.live_test_page.guide_title': '新しいSTOVE Studioを準備中です。',
  'studio.live_test_page.guide_msg': 'アップデート完了後、STOVE Studioを利用できます。<br/><br/>もう少々お待ちください！',
  'studio.live_test_page.guide_info_service_name': 'サービス名',
  'studio.live_test_page.guide_info_test_period': '点検時間',
  'studio.live_test_page.guide_info_test_details': '点検内容',
  'studio.product_page.save_complete_popup': '保存完了。<br/>次に、商品ホームで発売準備をしてください。',
  'studio.supported_lang.ms': 'マレー語',
  'studio.supported_lang.ar': 'アラビア語',
  'studio.supported_lang.nl': 'オランダ語',
  'studio.supported_lang.pl': 'ポーランド語',
  'studio.supported_lang.cs': 'チェコ語',
  'studio.supported_lang.tr': 'トルコ語',
  'studio.supported_lang.etc': 'その他',
  'studio.member_manage.invite_link_activate_guide': '招待リンクを有効にすると、リンクが表示されます！',
  'studio.product_page_resumed_msg': '商品ページが再び公開されました。<br/>商品ホーム > 商品ページメニューで表示設定をONに変更してください。',
  'studio.prj_prod.this_prod.product_data.build.uploader_file_failed_dll_msg':
    '"DRMChecker.dll または DRMCheckerV3.dll が含まれているため、アップロードが中断されました。 該当ファイルを削除し、再度アップロードを行ってください。<br/>[%ErrorCode%]',
  'studio.discount.discount_rate_min_payment_range_val_msg':
    '支払い金額は、USD 0 または 0.99 以上、または KRW 0 または 10 ウォン以上の割引価格として保存できます。',
  'studio.build_test.guide_popup.client_latest_ver_download_msg':
    'Studio ビルドのテストのために、STOVE PCクライアント を終了し、再起動して最新バージョンに更新してください。',
  'studio.verification_code.check_btn': '認証コードを確認',
  'studio.prj_prod.this_prod.edit_gamepreview_lang_setting_not': '登録されていない言語を確認してください。',
  'studio.prj_prod.this_prod.edit_gamepreview_file_register_guide':
    '最大20枚まで画像を追加できます！<br/>画像を追加しない場合、基準言語に登録された画像が表示されます！',
  'studio.drm_intergrity_check.not_available_for_v2_build_msg':
    '2025年3月27日以前に登録されたビルドには、DRMメーカーと整合性チェックのオプションを適用できません。<br/>更新するには、新しいビルドを登録した後に該当オプションを修正してください。',
  'studio.game_build_upload_complete.one_time_popup_msg':
    'DRMメイカーと整合性チェックに対応したファイルが含まれている場合、自動で適用されます。<br/>ビルドをアップロードした後、ページを更新するとDRMと整合性設定を変更できます。<br/><br/>ビルドの起動設定を確認しますか？',
  'studio.run_settings_dir_btn': '起動設定へ',
  'studio.dlc_build_upload_complete.one_time_popup_msg':
    '整合性チェックに対応したファイルが含まれている場合、自動で適用されます。<br/>ビルドをアップロードした後、ページを更新すると整合性設定を変更できます。',
  'studio.build_manage.execution_settings_not_entered.cannot_revise_popup':
    '実行設定が入力されていないため、内容修正報告を提出できません。<br/><br/>実行設定を入力してから保存してください。',
  'studio.post_release_build_upd.requirements_by_change_category_guide1':
    '現在適用されているビルドと比較して、選択したビルドにはどのような変更がありますか？',
  'studio.post_release_build_upd.requirements_by_change_category_guide2':
    'バグ修正のみを行う場合、特別な報告なしでビルドを更新できます。<br/>その他の変更には内容修正報告が必要です。',
  'studio.back_to_previous_page_btn': '前のページ',
  'studio.build_upd_review_not_required.set_live_schedule_guide':
    '更新情報が保存されました。<br/>起動設定メニューでLIVE適用日時を設定してください。<br/>LIVE適用を完了しないと、ビルドが実際に反映されません。<br/>適用しない場合、反映されないのでご注意ください。',
  'studio.build_rating_review_dir_btn.go_to_submit_request': 'レーティングおよびビルド審査を進める',
  'studio.build_review_complete.set_live_schedule_guide':
    'ビルド審査が完了しました。<br/>次に、実行設定メニューに移動し、LIVE適用日時を設定してください。<br/>LIVE適用を完了しないと、ビルドと実行設定が反映されません。',
  'studio.build_rating_review_dir_btn.go_to_view_result': '利用等級およびビルド審査を見る',
  'studio.execution_setting.page_title': 'PCクライアント実行設定',
  'studio.execution_setting.settings_saved_no_build_guide':
    '実行設定が保存されました。<br/>ビルドをアップロードすると、対応する実行設定が適用され、PCクライアントで実行テストができます。',
  'studio.build_mgmt_dir_btn': 'ビルドアップロード',
  'studio.execution_setting.test_package_tab_tooltip_title': '<b>実行設定が作成されました。</b>',
  'studio.execution_setting.test_package_tab_tooltip_msg':
    '追加でアップロードしたビルドは、ここで実行設定を変更できます。<br/>変更した設定は、LIVEビルドや審査中のビルドにも適用して更新できます。',
  'studio.execution_setting.test_package_guide1':
    '<span class="text-brand-primary font-medium">これは、</span> <span class="text-on-surface-elevation-2 font-medium">LIVE状態、内容修正報告、異議申し立て、職権による再分類、または評価調整措置中のビルドを除くすべてのテストビルドに適用されます。</span>',
  'studio.execution_setting.test_package_guide2':
    '新しく作成された設定で実行オプションを変更し、テストしてみてください。<br/>保存後、LIVE適用ボタンをクリックすると、その設定がLIVEビルドに適用されます。',
  'studio.execution_setting.fetch_live_package_data_btn': 'LIVE実行設定を読み込む',
  'studio.execution_setting.fetch_live_data_confirm_popup': 'LIVE実行設定を自動で読み込みますか？<br/>読み込むと、設定値を修正してテストできます。',
  'studio.execution_setting.fetch_live_data_cf_btn': '読み込む',
  'studio.common.case_save_btn': '保存',
  'studio.execution_setting.test_package_added.save_tooltip':
    'LIVEまたは審査完了したビルドを除いたビルドに<br/>実行設定を適用できます。<br/>保存後、スタジオテストを実施してください。',
  'studio.execution_setting.test_package_added.live_apply_tooltip':
    'LIVEまたは審査完了したビルドに<br/>実行設定を適用できます。<br/>十分にテストを行った後、LIVEに適用してください。',
  'studio.execution_setting.live_apply_popup_title': 'LIVE適用',
  'studio.execution_setting.live_apply_popup_select_build': 'ビルド選択',
  'studio.execution_setting.live_apply_popup_build_required_msg': '適用するビルドを選択してください。',
  'studio.execution_setting.live_apply_date_title': 'LIVE適用日',
  'studio.execution_setting.live_apply_popup_immediate': '即時',
  'studio.execution_setting.live_apply_popup_scheduled': '予約',
  'studio.event_period_settings.execution_setting.before_current_time_invalid_msg': '現在の日時以降を選択してください。',
  'studio.execution_setting.select_build.build_category_live': '[LIVE適用中]',
  'studio.execution_setting.select_build.build_category_under_review': '[審査中]',
  'studio.execution_setting.select_build.build_category_review_passed': '[審査完了]',
  'studio.execution_setting.select_build.build_category_fix_bug': '[バグ修正]',
  'studio.execution_setting.select_build.build_category_direct_input': '[利用等級直接入力]',
  'studio.execution_setting.select_build.build_scheduled': '[予約]',
  'studio.execution_setting.test_tab': '起動設定',
  'studio.execution_setting.scheduled_tab': '起動設定予約',
  'studio.execution_setting.live_tab': 'LIVE起動設定',
  'studio.execution_setting.scheduled_info_guide': 'ビルドと実行設定がLIVEに適用される予定です。',
  'studio.execution_setting.build_info': 'ビルド情報',
  'studio.build_exe_test_ok.popup_title': 'テスト確認',
  'studio.build_exe_test_ok.popup_guide':
    'テストが完了した場合は「TESTOK」と入力してください。<br/>テストを行わずに進めると、ゲーム実行中に問題が発生する可能性があります。',
  'studio.common.popup_case_next_btn': '次へ ',
  'studio.execution_setting.scheduled_pack_cancel_btn': 'スケジュールのキャンセル',
  'studio.execution_setting.scheduled_pack_cancel_confirm_popup':
    'LIVE起動設定がスケジュールされています。キャンセルすると、再設定が必要になります。<br/>続行しますか？',
  'studio.brand_page.feature2-1_main_title': 'メンバーを招待して、役割を管理してみましょう',
  'studio.brand_page.feature2-1_sub_title': 'メンバーをグループに招待して、役割を割り当ててみましょう。',
  'studio.execution_setting.select_scheduled_build.warning_msg': '既にスケジュールされたビルドはキャンセルされ、新しいものが適用されます。',
  'studio.execution_setting.exe_file_extension_required_msg': '実行ファイル名には「.exe」まで入力してください。',
  'studio.execution_setting.final_exe_entered.exe_file_required_msg': '最終実行ファイルを入力した場合は、実行ファイルも一緒に入力してください。',
  'studio.prj_prod.execution_install_new_guide_pc_sub_des4':
    'ユーティリティは実行ファイルなしで登録可能で、その場合はSTOVE PCクライアントでインストールフォルダが開きます。',
  'studio.member_manage.new_join_request_guide':
    '{requestNum}人のメンバーが参加を申請しています。<br/>下の［参加待ち］ボタンをクリックして確認してください！',
  'studio.business_bank_setting.checkbox_use_representative_info': '代表者情報と同じです。',
  'studio.business_bank_setting.non_kr_postal_code_place_holder': '郵便番号（任意）',
  'studio.business_bank_setting.jp_address_place_holder': '住所を入力してください（任意）',
  'studio.business_bank_setting.non_kr_detailed_address_place_holder': '住所の詳細を入力してください（任意）',
  'studio.business_bank_setting.usa_building_name_place_holder': '建物名を入力してください（任意）',
  'studio.business_bank_setting.usa_street_name_place_holder': '通りの名前を入力してください（任意）',
  'studio.business_bank_setting.usa_city_name_place_holder': '都市名を入力してください（任意）',
  'studio.business_bank_setting.usa_district_name_place_holder': '道・市・郡を入力してください（任意）',
  'studio.build_manage.upload_description_required_msg': 'ビルドの説明を入力してください。',
  'studio.common.def_key.emoji_n': '絵文字は使用しないでください。'
};
